(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireda0c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireda0c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1a2vA", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $0d88abba6c4195de$export$a7c73072b1a182ae; }, function (v) { return $0d88abba6c4195de$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $0d88abba6c4195de$export$9f27bc3417b4524d; }, function (v) { return $0d88abba6c4195de$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $0d88abba6c4195de$export$db77ccec0bb4ccac; }, function (v) { return $0d88abba6c4195de$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $0d88abba6c4195de$export$8392c0c9d3dcbd35; }, function (v) { return $0d88abba6c4195de$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0d88abba6c4195de$export$ffb0004e005737fa; }, function (v) { return $0d88abba6c4195de$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $0d88abba6c4195de$export$b624eff549462981; }, function (v) { return $0d88abba6c4195de$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $0d88abba6c4195de$export$7897aa7841a5380c; }, function (v) { return $0d88abba6c4195de$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $0d88abba6c4195de$export$602eac185826482c; }, function (v) { return $0d88abba6c4195de$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $0d88abba6c4195de$export$e2c29f18771995cb; }, function (v) { return $0d88abba6c4195de$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0d88abba6c4195de$export$5f8d39834fd61797; }, function (v) { return $0d88abba6c4195de$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0d88abba6c4195de$export$74bf444e3cd11ea5; }, function (v) { return $0d88abba6c4195de$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $0d88abba6c4195de$export$998bcd577473dd93; }, function (v) { return $0d88abba6c4195de$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $0d88abba6c4195de$export$b706b080d889d2c9; }, function (v) { return $0d88abba6c4195de$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $0d88abba6c4195de$export$5be5a87408f70ddc; }, function (v) { return $0d88abba6c4195de$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $0d88abba6c4195de$export$45a5e7f76e0caa8d; }, function (v) { return $0d88abba6c4195de$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $0d88abba6c4195de$export$455c2e768291efa6; }, function (v) { return $0d88abba6c4195de$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $0d88abba6c4195de$export$9522e17588c12572; }, function (v) { return $0d88abba6c4195de$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $0d88abba6c4195de$export$2110ac352bb060b9; }, function (v) { return $0d88abba6c4195de$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $0d88abba6c4195de$export$56885ab8b9c456ab; }, function (v) { return $0d88abba6c4195de$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $0d88abba6c4195de$export$d927fcb6adf8f9de; }, function (v) { return $0d88abba6c4195de$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $0d88abba6c4195de$export$b82d16f27459e05a; }, function (v) { return $0d88abba6c4195de$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $0d88abba6c4195de$export$522c17b4f5e123e8; }, function (v) { return $0d88abba6c4195de$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $0d88abba6c4195de$export$1aabd8a0274ecfd6; }, function (v) { return $0d88abba6c4195de$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $0d88abba6c4195de$export$3d6c20d97e46b957; }, function (v) { return $0d88abba6c4195de$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $0d88abba6c4195de$export$9b621391a187a31a; }, function (v) { return $0d88abba6c4195de$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $0d88abba6c4195de$export$f5bbd400c2f4426f; }, function (v) { return $0d88abba6c4195de$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $8Bufz = parcelRequire("8Bufz");
var $0d88abba6c4195de$export$a7c73072b1a182ae;
var $0d88abba6c4195de$export$9f27bc3417b4524d;
var $0d88abba6c4195de$export$db77ccec0bb4ccac;
var $0d88abba6c4195de$export$8392c0c9d3dcbd35;
var $0d88abba6c4195de$export$ffb0004e005737fa;
var $0d88abba6c4195de$export$b624eff549462981;
var $0d88abba6c4195de$export$7897aa7841a5380c;
var $0d88abba6c4195de$export$602eac185826482c;
var $0d88abba6c4195de$export$e2c29f18771995cb;
var $0d88abba6c4195de$export$5f8d39834fd61797;
var $0d88abba6c4195de$export$74bf444e3cd11ea5;
var $0d88abba6c4195de$export$998bcd577473dd93;
var $0d88abba6c4195de$export$b706b080d889d2c9;
var $0d88abba6c4195de$export$5be5a87408f70ddc;
var $0d88abba6c4195de$export$45a5e7f76e0caa8d;
var $0d88abba6c4195de$export$455c2e768291efa6;
var $0d88abba6c4195de$export$9522e17588c12572;
var $0d88abba6c4195de$export$2110ac352bb060b9;
var $0d88abba6c4195de$export$56885ab8b9c456ab;
var $0d88abba6c4195de$export$d927fcb6adf8f9de;
var $0d88abba6c4195de$export$b82d16f27459e05a;
var $0d88abba6c4195de$export$522c17b4f5e123e8;
var $0d88abba6c4195de$export$1aabd8a0274ecfd6;
var $0d88abba6c4195de$export$3d6c20d97e46b957;
var $0d88abba6c4195de$export$9b621391a187a31a;
var $0d88abba6c4195de$export$f5bbd400c2f4426f;
"use strict";
var $0d88abba6c4195de$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $0d88abba6c4195de$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $0d88abba6c4195de$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $0d88abba6c4195de$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $0d88abba6c4195de$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $0d88abba6c4195de$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $0d88abba6c4195de$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $0d88abba6c4195de$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $0d88abba6c4195de$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $0d88abba6c4195de$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $0d88abba6c4195de$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $0d88abba6c4195de$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $0d88abba6c4195de$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $0d88abba6c4195de$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $0d88abba6c4195de$var$typeOf(object) {
    if ("object" === (typeof object === "undefined" ? "undefined" : (0, $8Bufz._)(object)) && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $0d88abba6c4195de$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $0d88abba6c4195de$var$REACT_FRAGMENT_TYPE:
                    case $0d88abba6c4195de$var$REACT_PROFILER_TYPE:
                    case $0d88abba6c4195de$var$REACT_STRICT_MODE_TYPE:
                    case $0d88abba6c4195de$var$REACT_SUSPENSE_TYPE:
                    case $0d88abba6c4195de$var$REACT_SUSPENSE_LIST_TYPE:
                    case $0d88abba6c4195de$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $0d88abba6c4195de$var$REACT_CONTEXT_TYPE:
                            case $0d88abba6c4195de$var$REACT_FORWARD_REF_TYPE:
                            case $0d88abba6c4195de$var$REACT_LAZY_TYPE:
                            case $0d88abba6c4195de$var$REACT_MEMO_TYPE:
                                return object;
                            case $0d88abba6c4195de$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $0d88abba6c4195de$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$0d88abba6c4195de$export$a7c73072b1a182ae = $0d88abba6c4195de$var$REACT_CONSUMER_TYPE;
$0d88abba6c4195de$export$9f27bc3417b4524d = $0d88abba6c4195de$var$REACT_CONTEXT_TYPE;
$0d88abba6c4195de$export$db77ccec0bb4ccac = $0d88abba6c4195de$var$REACT_ELEMENT_TYPE;
$0d88abba6c4195de$export$8392c0c9d3dcbd35 = $0d88abba6c4195de$var$REACT_FORWARD_REF_TYPE;
$0d88abba6c4195de$export$ffb0004e005737fa = $0d88abba6c4195de$var$REACT_FRAGMENT_TYPE;
$0d88abba6c4195de$export$b624eff549462981 = $0d88abba6c4195de$var$REACT_LAZY_TYPE;
$0d88abba6c4195de$export$7897aa7841a5380c = $0d88abba6c4195de$var$REACT_MEMO_TYPE;
$0d88abba6c4195de$export$602eac185826482c = $0d88abba6c4195de$var$REACT_PORTAL_TYPE;
$0d88abba6c4195de$export$e2c29f18771995cb = $0d88abba6c4195de$var$REACT_PROFILER_TYPE;
$0d88abba6c4195de$export$5f8d39834fd61797 = $0d88abba6c4195de$var$REACT_STRICT_MODE_TYPE;
$0d88abba6c4195de$export$74bf444e3cd11ea5 = $0d88abba6c4195de$var$REACT_SUSPENSE_TYPE;
$0d88abba6c4195de$export$998bcd577473dd93 = $0d88abba6c4195de$var$REACT_SUSPENSE_LIST_TYPE;
$0d88abba6c4195de$export$b706b080d889d2c9 = function(object) {
    return $0d88abba6c4195de$var$typeOf(object) === $0d88abba6c4195de$var$REACT_CONSUMER_TYPE;
};
$0d88abba6c4195de$export$5be5a87408f70ddc = function(object) {
    return $0d88abba6c4195de$var$typeOf(object) === $0d88abba6c4195de$var$REACT_CONTEXT_TYPE;
};
$0d88abba6c4195de$export$45a5e7f76e0caa8d = function(object) {
    return "object" === (typeof object === "undefined" ? "undefined" : (0, $8Bufz._)(object)) && null !== object && object.$$typeof === $0d88abba6c4195de$var$REACT_ELEMENT_TYPE;
};
$0d88abba6c4195de$export$455c2e768291efa6 = function(object) {
    return $0d88abba6c4195de$var$typeOf(object) === $0d88abba6c4195de$var$REACT_FORWARD_REF_TYPE;
};
$0d88abba6c4195de$export$9522e17588c12572 = function(object) {
    return $0d88abba6c4195de$var$typeOf(object) === $0d88abba6c4195de$var$REACT_FRAGMENT_TYPE;
};
$0d88abba6c4195de$export$2110ac352bb060b9 = function(object) {
    return $0d88abba6c4195de$var$typeOf(object) === $0d88abba6c4195de$var$REACT_LAZY_TYPE;
};
$0d88abba6c4195de$export$56885ab8b9c456ab = function(object) {
    return $0d88abba6c4195de$var$typeOf(object) === $0d88abba6c4195de$var$REACT_MEMO_TYPE;
};
$0d88abba6c4195de$export$d927fcb6adf8f9de = function(object) {
    return $0d88abba6c4195de$var$typeOf(object) === $0d88abba6c4195de$var$REACT_PORTAL_TYPE;
};
$0d88abba6c4195de$export$b82d16f27459e05a = function(object) {
    return $0d88abba6c4195de$var$typeOf(object) === $0d88abba6c4195de$var$REACT_PROFILER_TYPE;
};
$0d88abba6c4195de$export$522c17b4f5e123e8 = function(object) {
    return $0d88abba6c4195de$var$typeOf(object) === $0d88abba6c4195de$var$REACT_STRICT_MODE_TYPE;
};
$0d88abba6c4195de$export$1aabd8a0274ecfd6 = function(object) {
    return $0d88abba6c4195de$var$typeOf(object) === $0d88abba6c4195de$var$REACT_SUSPENSE_TYPE;
};
$0d88abba6c4195de$export$3d6c20d97e46b957 = function(object) {
    return $0d88abba6c4195de$var$typeOf(object) === $0d88abba6c4195de$var$REACT_SUSPENSE_LIST_TYPE;
};
$0d88abba6c4195de$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $0d88abba6c4195de$var$REACT_FRAGMENT_TYPE || type === $0d88abba6c4195de$var$REACT_PROFILER_TYPE || type === $0d88abba6c4195de$var$REACT_STRICT_MODE_TYPE || type === $0d88abba6c4195de$var$REACT_SUSPENSE_TYPE || type === $0d88abba6c4195de$var$REACT_SUSPENSE_LIST_TYPE || "object" === (typeof type === "undefined" ? "undefined" : (0, $8Bufz._)(type)) && null !== type && (type.$$typeof === $0d88abba6c4195de$var$REACT_LAZY_TYPE || type.$$typeof === $0d88abba6c4195de$var$REACT_MEMO_TYPE || type.$$typeof === $0d88abba6c4195de$var$REACT_CONTEXT_TYPE || type.$$typeof === $0d88abba6c4195de$var$REACT_CONSUMER_TYPE || type.$$typeof === $0d88abba6c4195de$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $0d88abba6c4195de$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$0d88abba6c4195de$export$f5bbd400c2f4426f = $0d88abba6c4195de$var$typeOf;

});
parcelRegister("8Bufz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $64393e80df487c00$export$71511d61b312f219; });
function $64393e80df487c00$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("8332w", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $5dc0f6286f036557$export$2b8d127b894957b9; }, function (v) { return $5dc0f6286f036557$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $5dc0f6286f036557$export$cea3a54a6425200c; }, function (v) { return $5dc0f6286f036557$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $5dc0f6286f036557$export$a7c73072b1a182ae; }, function (v) { return $5dc0f6286f036557$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $5dc0f6286f036557$export$9f27bc3417b4524d; }, function (v) { return $5dc0f6286f036557$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $5dc0f6286f036557$export$db77ccec0bb4ccac; }, function (v) { return $5dc0f6286f036557$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $5dc0f6286f036557$export$8392c0c9d3dcbd35; }, function (v) { return $5dc0f6286f036557$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $5dc0f6286f036557$export$ffb0004e005737fa; }, function (v) { return $5dc0f6286f036557$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $5dc0f6286f036557$export$b624eff549462981; }, function (v) { return $5dc0f6286f036557$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $5dc0f6286f036557$export$7897aa7841a5380c; }, function (v) { return $5dc0f6286f036557$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $5dc0f6286f036557$export$602eac185826482c; }, function (v) { return $5dc0f6286f036557$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $5dc0f6286f036557$export$e2c29f18771995cb; }, function (v) { return $5dc0f6286f036557$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5dc0f6286f036557$export$5f8d39834fd61797; }, function (v) { return $5dc0f6286f036557$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $5dc0f6286f036557$export$74bf444e3cd11ea5; }, function (v) { return $5dc0f6286f036557$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $5dc0f6286f036557$export$92387174baf9b227; }, function (v) { return $5dc0f6286f036557$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $5dc0f6286f036557$export$ec112efeb987d9c6; }, function (v) { return $5dc0f6286f036557$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $5dc0f6286f036557$export$b706b080d889d2c9; }, function (v) { return $5dc0f6286f036557$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $5dc0f6286f036557$export$5be5a87408f70ddc; }, function (v) { return $5dc0f6286f036557$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $5dc0f6286f036557$export$45a5e7f76e0caa8d; }, function (v) { return $5dc0f6286f036557$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $5dc0f6286f036557$export$455c2e768291efa6; }, function (v) { return $5dc0f6286f036557$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $5dc0f6286f036557$export$9522e17588c12572; }, function (v) { return $5dc0f6286f036557$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $5dc0f6286f036557$export$2110ac352bb060b9; }, function (v) { return $5dc0f6286f036557$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $5dc0f6286f036557$export$56885ab8b9c456ab; }, function (v) { return $5dc0f6286f036557$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $5dc0f6286f036557$export$d927fcb6adf8f9de; }, function (v) { return $5dc0f6286f036557$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $5dc0f6286f036557$export$b82d16f27459e05a; }, function (v) { return $5dc0f6286f036557$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $5dc0f6286f036557$export$522c17b4f5e123e8; }, function (v) { return $5dc0f6286f036557$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $5dc0f6286f036557$export$1aabd8a0274ecfd6; }, function (v) { return $5dc0f6286f036557$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $5dc0f6286f036557$export$9b621391a187a31a; }, function (v) { return $5dc0f6286f036557$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $5dc0f6286f036557$export$f5bbd400c2f4426f; }, function (v) { return $5dc0f6286f036557$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $8Bufz = parcelRequire("8Bufz");
var $5dc0f6286f036557$export$2b8d127b894957b9;
var $5dc0f6286f036557$export$cea3a54a6425200c;
var $5dc0f6286f036557$export$a7c73072b1a182ae;
var $5dc0f6286f036557$export$9f27bc3417b4524d;
var $5dc0f6286f036557$export$db77ccec0bb4ccac;
var $5dc0f6286f036557$export$8392c0c9d3dcbd35;
var $5dc0f6286f036557$export$ffb0004e005737fa;
var $5dc0f6286f036557$export$b624eff549462981;
var $5dc0f6286f036557$export$7897aa7841a5380c;
var $5dc0f6286f036557$export$602eac185826482c;
var $5dc0f6286f036557$export$e2c29f18771995cb;
var $5dc0f6286f036557$export$5f8d39834fd61797;
var $5dc0f6286f036557$export$74bf444e3cd11ea5;
var $5dc0f6286f036557$export$92387174baf9b227;
var $5dc0f6286f036557$export$ec112efeb987d9c6;
var $5dc0f6286f036557$export$b706b080d889d2c9;
var $5dc0f6286f036557$export$5be5a87408f70ddc;
var $5dc0f6286f036557$export$45a5e7f76e0caa8d;
var $5dc0f6286f036557$export$455c2e768291efa6;
var $5dc0f6286f036557$export$9522e17588c12572;
var $5dc0f6286f036557$export$2110ac352bb060b9;
var $5dc0f6286f036557$export$56885ab8b9c456ab;
var $5dc0f6286f036557$export$d927fcb6adf8f9de;
var $5dc0f6286f036557$export$b82d16f27459e05a;
var $5dc0f6286f036557$export$522c17b4f5e123e8;
var $5dc0f6286f036557$export$1aabd8a0274ecfd6;
var $5dc0f6286f036557$export$9b621391a187a31a;
var $5dc0f6286f036557$export$f5bbd400c2f4426f;
'use strict';
var $5dc0f6286f036557$var$b = "function" === typeof Symbol && Symbol.for, $5dc0f6286f036557$var$c = $5dc0f6286f036557$var$b ? Symbol.for("react.element") : 60103, $5dc0f6286f036557$var$d = $5dc0f6286f036557$var$b ? Symbol.for("react.portal") : 60106, $5dc0f6286f036557$var$e = $5dc0f6286f036557$var$b ? Symbol.for("react.fragment") : 60107, $5dc0f6286f036557$var$f = $5dc0f6286f036557$var$b ? Symbol.for("react.strict_mode") : 60108, $5dc0f6286f036557$var$g = $5dc0f6286f036557$var$b ? Symbol.for("react.profiler") : 60114, $5dc0f6286f036557$var$h = $5dc0f6286f036557$var$b ? Symbol.for("react.provider") : 60109, $5dc0f6286f036557$var$k = $5dc0f6286f036557$var$b ? Symbol.for("react.context") : 60110, $5dc0f6286f036557$var$l = $5dc0f6286f036557$var$b ? Symbol.for("react.async_mode") : 60111, $5dc0f6286f036557$var$m = $5dc0f6286f036557$var$b ? Symbol.for("react.concurrent_mode") : 60111, $5dc0f6286f036557$var$n = $5dc0f6286f036557$var$b ? Symbol.for("react.forward_ref") : 60112, $5dc0f6286f036557$var$p = $5dc0f6286f036557$var$b ? Symbol.for("react.suspense") : 60113, $5dc0f6286f036557$var$q = $5dc0f6286f036557$var$b ? Symbol.for("react.suspense_list") : 60120, $5dc0f6286f036557$var$r = $5dc0f6286f036557$var$b ? Symbol.for("react.memo") : 60115, $5dc0f6286f036557$var$t = $5dc0f6286f036557$var$b ? Symbol.for("react.lazy") : 60116, $5dc0f6286f036557$var$v = $5dc0f6286f036557$var$b ? Symbol.for("react.block") : 60121, $5dc0f6286f036557$var$w = $5dc0f6286f036557$var$b ? Symbol.for("react.fundamental") : 60117, $5dc0f6286f036557$var$x = $5dc0f6286f036557$var$b ? Symbol.for("react.responder") : 60118, $5dc0f6286f036557$var$y = $5dc0f6286f036557$var$b ? Symbol.for("react.scope") : 60119;
function $5dc0f6286f036557$var$z(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $8Bufz._)(a)) && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $5dc0f6286f036557$var$c:
                switch(a = a.type, a){
                    case $5dc0f6286f036557$var$l:
                    case $5dc0f6286f036557$var$m:
                    case $5dc0f6286f036557$var$e:
                    case $5dc0f6286f036557$var$g:
                    case $5dc0f6286f036557$var$f:
                    case $5dc0f6286f036557$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $5dc0f6286f036557$var$k:
                            case $5dc0f6286f036557$var$n:
                            case $5dc0f6286f036557$var$t:
                            case $5dc0f6286f036557$var$r:
                            case $5dc0f6286f036557$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $5dc0f6286f036557$var$d:
                return u;
        }
    }
}
function $5dc0f6286f036557$var$A(a) {
    return $5dc0f6286f036557$var$z(a) === $5dc0f6286f036557$var$m;
}
$5dc0f6286f036557$export$2b8d127b894957b9 = $5dc0f6286f036557$var$l;
$5dc0f6286f036557$export$cea3a54a6425200c = $5dc0f6286f036557$var$m;
$5dc0f6286f036557$export$a7c73072b1a182ae = $5dc0f6286f036557$var$k;
$5dc0f6286f036557$export$9f27bc3417b4524d = $5dc0f6286f036557$var$h;
$5dc0f6286f036557$export$db77ccec0bb4ccac = $5dc0f6286f036557$var$c;
$5dc0f6286f036557$export$8392c0c9d3dcbd35 = $5dc0f6286f036557$var$n;
$5dc0f6286f036557$export$ffb0004e005737fa = $5dc0f6286f036557$var$e;
$5dc0f6286f036557$export$b624eff549462981 = $5dc0f6286f036557$var$t;
$5dc0f6286f036557$export$7897aa7841a5380c = $5dc0f6286f036557$var$r;
$5dc0f6286f036557$export$602eac185826482c = $5dc0f6286f036557$var$d;
$5dc0f6286f036557$export$e2c29f18771995cb = $5dc0f6286f036557$var$g;
$5dc0f6286f036557$export$5f8d39834fd61797 = $5dc0f6286f036557$var$f;
$5dc0f6286f036557$export$74bf444e3cd11ea5 = $5dc0f6286f036557$var$p;
$5dc0f6286f036557$export$92387174baf9b227 = function(a) {
    return $5dc0f6286f036557$var$A(a) || $5dc0f6286f036557$var$z(a) === $5dc0f6286f036557$var$l;
};
$5dc0f6286f036557$export$ec112efeb987d9c6 = $5dc0f6286f036557$var$A;
$5dc0f6286f036557$export$b706b080d889d2c9 = function(a) {
    return $5dc0f6286f036557$var$z(a) === $5dc0f6286f036557$var$k;
};
$5dc0f6286f036557$export$5be5a87408f70ddc = function(a) {
    return $5dc0f6286f036557$var$z(a) === $5dc0f6286f036557$var$h;
};
$5dc0f6286f036557$export$45a5e7f76e0caa8d = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $8Bufz._)(a)) && null !== a && a.$$typeof === $5dc0f6286f036557$var$c;
};
$5dc0f6286f036557$export$455c2e768291efa6 = function(a) {
    return $5dc0f6286f036557$var$z(a) === $5dc0f6286f036557$var$n;
};
$5dc0f6286f036557$export$9522e17588c12572 = function(a) {
    return $5dc0f6286f036557$var$z(a) === $5dc0f6286f036557$var$e;
};
$5dc0f6286f036557$export$2110ac352bb060b9 = function(a) {
    return $5dc0f6286f036557$var$z(a) === $5dc0f6286f036557$var$t;
};
$5dc0f6286f036557$export$56885ab8b9c456ab = function(a) {
    return $5dc0f6286f036557$var$z(a) === $5dc0f6286f036557$var$r;
};
$5dc0f6286f036557$export$d927fcb6adf8f9de = function(a) {
    return $5dc0f6286f036557$var$z(a) === $5dc0f6286f036557$var$d;
};
$5dc0f6286f036557$export$b82d16f27459e05a = function(a) {
    return $5dc0f6286f036557$var$z(a) === $5dc0f6286f036557$var$g;
};
$5dc0f6286f036557$export$522c17b4f5e123e8 = function(a) {
    return $5dc0f6286f036557$var$z(a) === $5dc0f6286f036557$var$f;
};
$5dc0f6286f036557$export$1aabd8a0274ecfd6 = function(a) {
    return $5dc0f6286f036557$var$z(a) === $5dc0f6286f036557$var$p;
};
$5dc0f6286f036557$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $5dc0f6286f036557$var$e || a === $5dc0f6286f036557$var$m || a === $5dc0f6286f036557$var$g || a === $5dc0f6286f036557$var$f || a === $5dc0f6286f036557$var$p || a === $5dc0f6286f036557$var$q || "object" === (typeof a === "undefined" ? "undefined" : (0, $8Bufz._)(a)) && null !== a && (a.$$typeof === $5dc0f6286f036557$var$t || a.$$typeof === $5dc0f6286f036557$var$r || a.$$typeof === $5dc0f6286f036557$var$h || a.$$typeof === $5dc0f6286f036557$var$k || a.$$typeof === $5dc0f6286f036557$var$n || a.$$typeof === $5dc0f6286f036557$var$w || a.$$typeof === $5dc0f6286f036557$var$x || a.$$typeof === $5dc0f6286f036557$var$y || a.$$typeof === $5dc0f6286f036557$var$v);
};
$5dc0f6286f036557$export$f5bbd400c2f4426f = $5dc0f6286f036557$var$z;

});

parcelRegister("40Ck8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $ahiA0 = parcelRequire("ahiA0");
function $2eb4e3d5690b454c$var$emptyFunction() {}
function $2eb4e3d5690b454c$var$emptyFunctionWithReset() {}
$2eb4e3d5690b454c$var$emptyFunctionWithReset.resetWarningCache = $2eb4e3d5690b454c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $ahiA0) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $2eb4e3d5690b454c$var$emptyFunctionWithReset,
        resetWarningCache: $2eb4e3d5690b454c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("ahiA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $77b9e77a3af825a7$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $77b9e77a3af825a7$var$ReactPropTypesSecret;

});


var $e8e54559db53494b$exports = {};
$parcel$extendImportMap({
    "7kW4z": "preview-bg.25389d40.svg",
    "dTpI4": "app.4549d57d.svg",
    "dVjnx": "link.478635e8.svg",
    "bPGQk": "usercentrics-logo.f58d5ee9.svg",
    "dFYO4": "web.08b05ae1.svg",
    "fgQ4j": "bg_fingerprint.daa36fb2.png"
});

var $3b0ae1a0b4bd1181$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $8Bufz = parcelRequire("8Bufz");
var $3b0ae1a0b4bd1181$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && (typeof value === "undefined" ? "undefined" : (0, $8Bufz._)(value)) === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $3b0ae1a0b4bd1181$exports));
try {
    regeneratorRuntime = $3b0ae1a0b4bd1181$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if ((typeof globalThis === "undefined" ? "undefined" : (0, $8Bufz._)(globalThis)) === "object") globalThis.regeneratorRuntime = $3b0ae1a0b4bd1181$var$runtime;
    else Function("r", "regeneratorRuntime = r")($3b0ae1a0b4bd1181$var$runtime);
}


var $3f23f3a8e36491d9$exports = {};

$parcel$export($3f23f3a8e36491d9$exports, "palette", function () { return $12674995b3f54524$export$ffb5f4729a158638; });
$parcel$export($3f23f3a8e36491d9$exports, "useRoleProps", function () { return $a2d13842c0550e3b$export$892580369e97d8b9; });
$parcel$export($3f23f3a8e36491d9$exports, "useButtonOptions", function () { return $48bcc42c0cfaa183$export$66b442cf1b67c420; });
$parcel$export($3f23f3a8e36491d9$exports, "useButtonProps", function () { return $48bcc42c0cfaa183$export$a0ee72f2c720a5c3; });
$parcel$export($3f23f3a8e36491d9$exports, "useCompositeItemOptions", function () { return $231d87b613381e1c$export$a9b64cf6834a191d; });
$parcel$export($3f23f3a8e36491d9$exports, "useCompositeItemProps", function () { return $231d87b613381e1c$export$2652450ebff132c5; });
$parcel$export($3f23f3a8e36491d9$exports, "useDialogBackdropProps", function () { return $1d43db460869e11f$export$39bcff29cb67f86c; });
$parcel$export($3f23f3a8e36491d9$exports, "useDialogOptions", function () { return $1d43db460869e11f$export$fe43c47ea4463c8e; });
$parcel$export($3f23f3a8e36491d9$exports, "useDialogProps", function () { return $1d43db460869e11f$export$4259f8849f04d8f2; });
$parcel$export($3f23f3a8e36491d9$exports, "useFormGroupOptions", function () { return $1f7d9d37a0e245c1$export$661ac08c7a0b48e0; });
$parcel$export($3f23f3a8e36491d9$exports, "useFormGroupProps", function () { return $1f7d9d37a0e245c1$export$9c135d04c11b2679; });
$parcel$export($3f23f3a8e36491d9$exports, "useFormInputOptions", function () { return $1f7d9d37a0e245c1$export$eaf45e66faff44df; });
$parcel$export($3f23f3a8e36491d9$exports, "useFormLabelProps", function () { return $1f7d9d37a0e245c1$export$69cd1433de1021d0; });
$parcel$export($3f23f3a8e36491d9$exports, "useFormMessageOptions", function () { return $1f7d9d37a0e245c1$export$e698c42d2016aaac; });
$parcel$export($3f23f3a8e36491d9$exports, "useFormMessageProps", function () { return $1f7d9d37a0e245c1$export$f96f7191998f58fb; });
$parcel$export($3f23f3a8e36491d9$exports, "useFormProps", function () { return $1f7d9d37a0e245c1$export$a6b5be5c6b451665; });
$parcel$export($3f23f3a8e36491d9$exports, "useFormRemoveButtonOptions", function () { return $1f7d9d37a0e245c1$export$25a25f6a01b3b77d; });
$parcel$export($3f23f3a8e36491d9$exports, "useGroupProps", function () { return $35d6d3803122956e$export$595c47cf910ca4b5; });
$parcel$export($3f23f3a8e36491d9$exports, "useInputProps", function () { return $0e2d01dcc4bfab6c$export$434ed5c8d5bb7eb5; });
$parcel$export($3f23f3a8e36491d9$exports, "useMenuBarProps", function () { return $22146f72899927a4$export$dbdbead553fa0beb; });
$parcel$export($3f23f3a8e36491d9$exports, "useMenuButtonProps", function () { return $22146f72899927a4$export$ea8b283fe2916b5; });
$parcel$export($3f23f3a8e36491d9$exports, "useMenuGroupProps", function () { return $22146f72899927a4$export$11dce7ee08b8d827; });
$parcel$export($3f23f3a8e36491d9$exports, "useMenuItemCheckboxProps", function () { return $22146f72899927a4$export$11c2aa43dc65207e; });
$parcel$export($3f23f3a8e36491d9$exports, "useMenuItemProps", function () { return $22146f72899927a4$export$db7a925804c71a46; });
$parcel$export($3f23f3a8e36491d9$exports, "useMenuItemRadioProps", function () { return $22146f72899927a4$export$d0c391992b4eae04; });
$parcel$export($3f23f3a8e36491d9$exports, "useMenuOptions", function () { return $22146f72899927a4$export$2ce5e940c4008526; });
$parcel$export($3f23f3a8e36491d9$exports, "useMenuProps", function () { return $22146f72899927a4$export$b153111b71479593; });
$parcel$export($3f23f3a8e36491d9$exports, "usePopoverArrowProps", function () { return $82fc757264dcd41d$export$96a4bfbe89c45e2f; });
$parcel$export($3f23f3a8e36491d9$exports, "usePopoverOptions", function () { return $82fc757264dcd41d$export$6d6848c8bd243768; });
$parcel$export($3f23f3a8e36491d9$exports, "usePopoverProps", function () { return $82fc757264dcd41d$export$9894a48da7e080d3; });
$parcel$export($3f23f3a8e36491d9$exports, "useSeparatorProps", function () { return $6fb5260fbfc1a327$export$3b44d1c2c69cb7f5; });
$parcel$export($3f23f3a8e36491d9$exports, "useTabListProps", function () { return $6d8e0bbb9c45995a$export$2bb4e085cbcbb486; });
$parcel$export($3f23f3a8e36491d9$exports, "useTabProps", function () { return $6d8e0bbb9c45995a$export$ce8ed76f6a6f3a9c; });
$parcel$export($3f23f3a8e36491d9$exports, "useTabbableProps", function () { return $3526031a374f7053$export$c1e480d26196c039; });
$parcel$export($3f23f3a8e36491d9$exports, "useToolbarProps", function () { return $17ba52db41bbd2db$export$96559db3560d1ff9; });
$parcel$export($3f23f3a8e36491d9$exports, "useTooltipOptions", function () { return $3f5b87f04d8aee83$export$c73063dc147944c8; });
$parcel$export($3f23f3a8e36491d9$exports, "useTooltipProps", function () { return $3f5b87f04d8aee83$export$abe748937894d745; });
var $bdfb41ef79315c14$exports = {};

$parcel$defineInteropFlag($bdfb41ef79315c14$exports);

$parcel$export($bdfb41ef79315c14$exports, "useSyncExternalStore", function () { return $bdfb41ef79315c14$export$306c0aa65ff9ec16; });
$parcel$export($bdfb41ef79315c14$exports, "startTransition", function () { return $bdfb41ef79315c14$export$7568632d0d33d16d; });
$parcel$export($bdfb41ef79315c14$exports, "useDeferredValue", function () { return $bdfb41ef79315c14$export$6a7bc4e911dc01cf; });
$parcel$export($bdfb41ef79315c14$exports, "useTransition", function () { return $bdfb41ef79315c14$export$7b286972b8d8ccbf; });
$parcel$export($bdfb41ef79315c14$exports, "useInsertionEffect", function () { return $bdfb41ef79315c14$export$aaabe4eda9ed9969; });
$parcel$export($bdfb41ef79315c14$exports, "PureComponent", function () { return $bdfb41ef79315c14$export$221d75b3f55bb0bd; });
$parcel$export($bdfb41ef79315c14$exports, "memo", function () { return $bdfb41ef79315c14$export$7c73462e0d25e514; });
$parcel$export($bdfb41ef79315c14$exports, "forwardRef", function () { return $bdfb41ef79315c14$export$257a8862b851cb5b; });
$parcel$export($bdfb41ef79315c14$exports, "Children", function () { return $bdfb41ef79315c14$export$dca3b0875bd9a954; });
$parcel$export($bdfb41ef79315c14$exports, "Suspense", function () { return $bdfb41ef79315c14$export$74bf444e3cd11ea5; });
$parcel$export($bdfb41ef79315c14$exports, "lazy", function () { return $bdfb41ef79315c14$export$488013bae63b21da; });
$parcel$export($bdfb41ef79315c14$exports, "SuspenseList", function () { return $bdfb41ef79315c14$export$998bcd577473dd93; });
$parcel$export($bdfb41ef79315c14$exports, "createPortal", function () { return $bdfb41ef79315c14$export$d39a5bbd09211389; });
$parcel$export($bdfb41ef79315c14$exports, "render", function () { return $bdfb41ef79315c14$export$b3890eb0ae9dca99; });
$parcel$export($bdfb41ef79315c14$exports, "hydrate", function () { return $bdfb41ef79315c14$export$fa8d919ba61d84db; });
$parcel$export($bdfb41ef79315c14$exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bdfb41ef79315c14$export$ae55be85d98224ed; });
$parcel$export($bdfb41ef79315c14$exports, "version", function () { return $bdfb41ef79315c14$export$83d89fbfd8236492; });
$parcel$export($bdfb41ef79315c14$exports, "createFactory", function () { return $bdfb41ef79315c14$export$d38cd72104c1f0e9; });
$parcel$export($bdfb41ef79315c14$exports, "isValidElement", function () { return $bdfb41ef79315c14$export$a8257692ac88316c; });
$parcel$export($bdfb41ef79315c14$exports, "isFragment", function () { return $bdfb41ef79315c14$export$9522e17588c12572; });
$parcel$export($bdfb41ef79315c14$exports, "isMemo", function () { return $bdfb41ef79315c14$export$56885ab8b9c456ab; });
$parcel$export($bdfb41ef79315c14$exports, "cloneElement", function () { return $bdfb41ef79315c14$export$e530037191fcd5d7; });
$parcel$export($bdfb41ef79315c14$exports, "unmountComponentAtNode", function () { return $bdfb41ef79315c14$export$502457920280e6be; });
$parcel$export($bdfb41ef79315c14$exports, "findDOMNode", function () { return $bdfb41ef79315c14$export$466bfc07425424d5; });
$parcel$export($bdfb41ef79315c14$exports, "unstable_batchedUpdates", function () { return $bdfb41ef79315c14$export$c78a37762a8d58e1; });
$parcel$export($bdfb41ef79315c14$exports, "flushSync", function () { return $bdfb41ef79315c14$export$cd75ccfd720a3cd4; });
$parcel$export($bdfb41ef79315c14$exports, "StrictMode", function () { return $bdfb41ef79315c14$export$5f8d39834fd61797; });
$parcel$export($bdfb41ef79315c14$exports, "isElement", function () { return $bdfb41ef79315c14$export$45a5e7f76e0caa8d; });
$parcel$export($bdfb41ef79315c14$exports, "default", function () { return $bdfb41ef79315c14$export$2e2bcd8739ae039; });
$parcel$export($bdfb41ef79315c14$exports, "Component", function () { return $ea42db622452d33d$export$16fa2f45be04daa8; });
$parcel$export($bdfb41ef79315c14$exports, "Fragment", function () { return $ea42db622452d33d$export$ffb0004e005737fa; });
$parcel$export($bdfb41ef79315c14$exports, "createContext", function () { return $ea42db622452d33d$export$fd42f52fd3ae1109; });
$parcel$export($bdfb41ef79315c14$exports, "createElement", function () { return $ea42db622452d33d$export$c8a8987d4410bf2d; });
$parcel$export($bdfb41ef79315c14$exports, "createRef", function () { return $ea42db622452d33d$export$7d1e3a5e95ceca43; });

var $8Bufz = parcelRequire("8Bufz");

var $8Bufz = parcelRequire("8Bufz");
var $ea42db622452d33d$var$n, $ea42db622452d33d$export$41c562ebe57d11e2, $ea42db622452d33d$var$u, $ea42db622452d33d$export$a8257692ac88316c, $ea42db622452d33d$var$i, $ea42db622452d33d$var$r, $ea42db622452d33d$var$o, $ea42db622452d33d$var$e, $ea42db622452d33d$var$f, $ea42db622452d33d$var$c, $ea42db622452d33d$var$s, $ea42db622452d33d$var$a, $ea42db622452d33d$var$h, $ea42db622452d33d$var$p = {}, $ea42db622452d33d$var$v = [], $ea42db622452d33d$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $ea42db622452d33d$var$d = Array.isArray;
function $ea42db622452d33d$var$w(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $ea42db622452d33d$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $ea42db622452d33d$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $ea42db622452d33d$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $ea42db622452d33d$var$m(l, e, i, r, null);
}
function $ea42db622452d33d$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$ea42db622452d33d$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $ea42db622452d33d$export$41c562ebe57d11e2.vnode && $ea42db622452d33d$export$41c562ebe57d11e2.vnode(e), e;
}
function $ea42db622452d33d$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $ea42db622452d33d$export$ffb0004e005737fa(n) {
    return n.children;
}
function $ea42db622452d33d$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $ea42db622452d33d$var$S(n, l) {
    if (null == l) return n.__ ? $ea42db622452d33d$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $ea42db622452d33d$var$S(n) : null;
}
function $ea42db622452d33d$var$C(n) {
    if (n.__P && n.__d) {
        var u = n.__v, t = u.__e, i = [], r = [], o = $ea42db622452d33d$var$w({}, u);
        o.__v = u.__v + 1, $ea42db622452d33d$export$41c562ebe57d11e2.vnode && $ea42db622452d33d$export$41c562ebe57d11e2.vnode(o), $ea42db622452d33d$var$z(n.__P, o, u, n.__n, n.__P.namespaceURI, 32 & u.__u ? [
            t
        ] : null, i, null == t ? $ea42db622452d33d$var$S(u) : t, !!(32 & u.__u), r), o.__v = u.__v, o.__.__k[o.__i] = o, $ea42db622452d33d$var$V(i, o, r), u.__e = u.__ = null, o.__e != t && $ea42db622452d33d$var$M(o);
    }
}
function $ea42db622452d33d$var$M(n) {
    if (null != (n = n.__) && null != n.__c) return n.__e = n.__c.base = null, n.__k.some(function(l) {
        if (null != l && null != l.__e) return n.__e = n.__c.base = l.__e;
    }), $ea42db622452d33d$var$M(n);
}
function $ea42db622452d33d$var$$(n) {
    (!n.__d && (n.__d = !0) && $ea42db622452d33d$var$i.push(n) && !$ea42db622452d33d$var$I.__r++ || $ea42db622452d33d$var$r != $ea42db622452d33d$export$41c562ebe57d11e2.debounceRendering) && (($ea42db622452d33d$var$r = $ea42db622452d33d$export$41c562ebe57d11e2.debounceRendering) || $ea42db622452d33d$var$o)($ea42db622452d33d$var$I);
}
function $ea42db622452d33d$var$I() {
    for(var n, l = 1; $ea42db622452d33d$var$i.length;)$ea42db622452d33d$var$i.length > l && $ea42db622452d33d$var$i.sort($ea42db622452d33d$var$e), n = $ea42db622452d33d$var$i.shift(), l = $ea42db622452d33d$var$i.length, $ea42db622452d33d$var$C(n);
    $ea42db622452d33d$var$I.__r = 0;
}
function $ea42db622452d33d$var$P(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, d, w, g, _, m = t && t.__k || $ea42db622452d33d$var$v, b = l.length;
    for(f = $ea42db622452d33d$var$A(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 != y.__i && m[y.__i] || $ea42db622452d33d$var$p, y.__i = a, g = $ea42db622452d33d$var$z(n, y, h, i, r, o, e, f, c, s), d = y.__e, y.ref && h.ref != y.ref && (h.ref && $ea42db622452d33d$var$D(h.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $ea42db622452d33d$var$H(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : d && (f = d.nextSibling), y.__u &= -7);
    return u.__e = w, f;
}
function $ea42db622452d33d$var$A(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? ("string" == typeof o || "number" == typeof o || "bigint" == (typeof o === "undefined" ? "undefined" : (0, $8Bufz._)(o)) || o.constructor == String ? o = n.__k[r] = $ea42db622452d33d$var$m(null, o, null, null, null) : $ea42db622452d33d$var$d(o) ? o = n.__k[r] = $ea42db622452d33d$var$m($ea42db622452d33d$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : void 0 === o.constructor && o.__b > 0 ? o = n.__k[r] = $ea42db622452d33d$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : n.__k[r] = o, f = r + h, o.__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $ea42db622452d33d$var$T(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $ea42db622452d33d$var$S(e)), $ea42db622452d33d$var$E(e, e));
    return t;
}
function $ea42db622452d33d$var$H(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $ea42db622452d33d$var$H(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $ea42db622452d33d$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $ea42db622452d33d$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($ea42db622452d33d$var$d(n) ? n.some(function(n) {
        $ea42db622452d33d$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $ea42db622452d33d$var$T(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $ea42db622452d33d$var$j(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $ea42db622452d33d$var$y.test(l) ? u : u + "px";
}
function $ea42db622452d33d$var$F(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $ea42db622452d33d$var$j(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $ea42db622452d33d$var$j(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($ea42db622452d33d$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $ea42db622452d33d$var$c, n.addEventListener(l, r ? $ea42db622452d33d$var$a : $ea42db622452d33d$var$s, r)) : n.removeEventListener(l, r ? $ea42db622452d33d$var$a : $ea42db622452d33d$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $ea42db622452d33d$var$O(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $ea42db622452d33d$var$c++;
            else if (u.t < t.u) return;
            return t($ea42db622452d33d$export$41c562ebe57d11e2.event ? $ea42db622452d33d$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $ea42db622452d33d$var$z(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, y, _, m, b, S, C, M, $, _$I, A, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $ea42db622452d33d$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (S = u.props, C = "prototype" in T && T.prototype.render, M = (a = T.contextType) && i[a.__c], $ = a ? M ? M.props.value : a.__ : i, t.__c ? b = (h = u.__c = t.__c).__ = h.__E : (C ? u.__c = h = new T(S, $) : (u.__c = h = new $ea42db622452d33d$export$16fa2f45be04daa8(S, $), h.constructor = T, h.render = $ea42db622452d33d$var$G), M && M.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), C && null == h.__s && (h.__s = h.state), C && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $ea42db622452d33d$var$w({}, h.__s)), $ea42db622452d33d$var$w(h.__s, T.getDerivedStateFromProps(S, h.__s))), y = h.props, _ = h.state, h.__v = u, p) C && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), C && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (C && null == T.getDerivedStateFromProps && S !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(S, $), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(S, h.__s, $)) {
                u.__v != t.__v && (h.props = S, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ea42db622452d33d$var$v.push.apply(h.__h, h._sb), h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(S, h.__s, $), C && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(y, _, m);
            });
        }
        if (h.context = $, h.props = S, h.__P = n, h.__e = !1, _$I = $ea42db622452d33d$export$41c562ebe57d11e2.__r, A = 0, C) h.state = h.__s, h.__d = !1, _$I && _$I(u), a = h.render(h.props, h.state, h.context), $ea42db622452d33d$var$v.push.apply(h.__h, h._sb), h._sb = [];
        else do h.__d = !1, _$I && _$I(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $ea42db622452d33d$var$w($ea42db622452d33d$var$w({}, i), h.getChildContext())), C && !p && null != h.getSnapshotBeforeUpdate && (m = h.getSnapshotBeforeUpdate(y, _)), H = null != a && a.type === $ea42db622452d33d$export$ffb0004e005737fa && null == a.key ? $ea42db622452d33d$var$q(a.props.children) : a, f = $ea42db622452d33d$var$P(n, $ea42db622452d33d$var$d(H) ? H : [
            H
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), b && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(L = o.length; L--;)$ea42db622452d33d$var$g(o[L]);
                $ea42db622452d33d$var$N(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $ea42db622452d33d$var$N(u);
        $ea42db622452d33d$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $ea42db622452d33d$var$B(t.__e, u, t, i, r, o, e, c, s);
    return (a = $ea42db622452d33d$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $ea42db622452d33d$var$N(n) {
    n && (n.__c && (n.__c.__e = !0), n.__k && n.__k.some($ea42db622452d33d$var$N));
}
function $ea42db622452d33d$var$V(n, u, t) {
    for(var i = 0; i < t.length; i++)$ea42db622452d33d$var$D(t[i], t[++i], t[++i]);
    $ea42db622452d33d$export$41c562ebe57d11e2.__c && $ea42db622452d33d$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $ea42db622452d33d$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $ea42db622452d33d$var$q(n) {
    return "object" != (typeof n === "undefined" ? "undefined" : (0, $8Bufz._)(n)) || null == n || n.__b > 0 ? n : $ea42db622452d33d$var$d(n) ? n.map($ea42db622452d33d$var$q) : $ea42db622452d33d$var$w({}, n);
}
function $ea42db622452d33d$var$B(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, w, _, m, b = i.props || $ea42db622452d33d$var$p, _$k = t.props, _$x = t.type;
    if ("svg" == _$x ? o = "http://www.w3.org/2000/svg" : "math" == _$x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((w = e[a]) && "setAttribute" in w == !!_$x && (_$x ? w.localName == _$x : 3 == w.nodeType)) {
            u = w, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == _$x) return document.createTextNode(_$k);
        u = document.createElementNS(o, _$x, _$k.is && _$k), c && ($ea42db622452d33d$export$41c562ebe57d11e2.__m && $ea42db622452d33d$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == _$x) b === _$k || c && u.data == _$k || (u.data = _$k);
    else {
        if (e = e && $ea42db622452d33d$var$n.call(u.childNodes), !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(w = u.attributes[a]).name] = w.value;
        for(a in b)w = b[a], "dangerouslySetInnerHTML" == a ? v = w : "children" == a || a in _$k || "value" == a && "defaultValue" in _$k || "checked" == a && "defaultChecked" in _$k || $ea42db622452d33d$var$F(u, a, null, w, o);
        for(a in _$k)w = _$k[a], "children" == a ? y = w : "dangerouslySetInnerHTML" == a ? h = w : "value" == a ? _ = w : "checked" == a ? m = w : c && "function" != typeof w || b[a] === w || $ea42db622452d33d$var$F(u, a, w, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $ea42db622452d33d$var$P("template" == t.type ? u.content : u, $ea42db622452d33d$var$d(y) ? y : [
            y
        ], t, i, r, "foreignObject" == _$x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $ea42db622452d33d$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$ea42db622452d33d$var$g(e[a]);
        c || (a = "value", "progress" == _$x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == _$x && !_ || "option" == _$x && _ != b[a]) && $ea42db622452d33d$var$F(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $ea42db622452d33d$var$F(u, a, m, b[a], o));
    }
    return u;
}
function $ea42db622452d33d$var$D(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $ea42db622452d33d$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $ea42db622452d33d$var$E(n, u, t) {
    var i, r;
    if ($ea42db622452d33d$export$41c562ebe57d11e2.unmount && $ea42db622452d33d$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $ea42db622452d33d$var$D(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $ea42db622452d33d$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $ea42db622452d33d$var$E(i[r], u, t || "function" != typeof n.type);
    t || $ea42db622452d33d$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $ea42db622452d33d$var$G(n, l, u) {
    return this.constructor(n, u);
}
function $ea42db622452d33d$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $ea42db622452d33d$export$41c562ebe57d11e2.__ && $ea42db622452d33d$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $ea42db622452d33d$var$z(t, u = (!r && i || t).__k = $ea42db622452d33d$export$c8a8987d4410bf2d($ea42db622452d33d$export$ffb0004e005737fa, null, [
        u
    ]), o || $ea42db622452d33d$var$p, $ea42db622452d33d$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $ea42db622452d33d$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $ea42db622452d33d$var$V(e, u, f);
}
function $ea42db622452d33d$export$fa8d919ba61d84db(n, l) {
    $ea42db622452d33d$export$b3890eb0ae9dca99(n, l, $ea42db622452d33d$export$fa8d919ba61d84db);
}
function $ea42db622452d33d$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $ea42db622452d33d$var$w({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $ea42db622452d33d$var$n.call(arguments, 2) : t), $ea42db622452d33d$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $ea42db622452d33d$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $ea42db622452d33d$var$$(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var _$l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), _$l && _$l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $ea42db622452d33d$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$ea42db622452d33d$var$n = $ea42db622452d33d$var$v.slice, $ea42db622452d33d$export$41c562ebe57d11e2 = {
    __e: function __e(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $ea42db622452d33d$var$u = 0, $ea42db622452d33d$export$a8257692ac88316c = function t(n) {
    return null != n && void 0 === n.constructor;
}, $ea42db622452d33d$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $ea42db622452d33d$var$w({}, this.state), "function" == typeof n && (n = n($ea42db622452d33d$var$w({}, u), this.props)), n && $ea42db622452d33d$var$w(u, n), null != n && this.__v && (l && this._sb.push(l), $ea42db622452d33d$var$$(this));
}, $ea42db622452d33d$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $ea42db622452d33d$var$$(this));
}, $ea42db622452d33d$export$16fa2f45be04daa8.prototype.render = $ea42db622452d33d$export$ffb0004e005737fa, $ea42db622452d33d$var$i = [], $ea42db622452d33d$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $ea42db622452d33d$var$e = function e(n, l) {
    return n.__v.__b - l.__v.__b;
}, $ea42db622452d33d$var$I.__r = 0, $ea42db622452d33d$var$f = /(PointerCapture)$|Capture$/i, $ea42db622452d33d$var$c = 0, $ea42db622452d33d$var$s = $ea42db622452d33d$var$O(!1), $ea42db622452d33d$var$a = $ea42db622452d33d$var$O(!0), $ea42db622452d33d$var$h = 0;


var $57da6a40a504e45b$exports = {};

$parcel$export($57da6a40a504e45b$exports, "useState", function () { return $57da6a40a504e45b$export$60241385465d0a34; });
$parcel$export($57da6a40a504e45b$exports, "useReducer", function () { return $57da6a40a504e45b$export$13e3392192263954; });
$parcel$export($57da6a40a504e45b$exports, "useEffect", function () { return $57da6a40a504e45b$export$6d9c69b0de29b591; });
$parcel$export($57da6a40a504e45b$exports, "useLayoutEffect", function () { return $57da6a40a504e45b$export$e5c5a5f917a5871c; });
$parcel$export($57da6a40a504e45b$exports, "useRef", function () { return $57da6a40a504e45b$export$b8f5890fc79d6aca; });
$parcel$export($57da6a40a504e45b$exports, "useMemo", function () { return $57da6a40a504e45b$export$1538c33de8887b59; });
$parcel$export($57da6a40a504e45b$exports, "useImperativeHandle", function () { return $57da6a40a504e45b$export$d5a552a76deda3c2; });
$parcel$export($57da6a40a504e45b$exports, "useCallback", function () { return $57da6a40a504e45b$export$35808ee640e87ca7; });
$parcel$export($57da6a40a504e45b$exports, "useContext", function () { return $57da6a40a504e45b$export$fae74005e78b1a27; });
$parcel$export($57da6a40a504e45b$exports, "useDebugValue", function () { return $57da6a40a504e45b$export$dc8fbce3eb94dc1e; });
$parcel$export($57da6a40a504e45b$exports, "useErrorBoundary", function () { return $57da6a40a504e45b$export$c052f6604b7d51fe; });
$parcel$export($57da6a40a504e45b$exports, "useId", function () { return $57da6a40a504e45b$export$f680877a34711e37; });

var $57da6a40a504e45b$var$t, $57da6a40a504e45b$var$r, $57da6a40a504e45b$var$u, $57da6a40a504e45b$var$i, $57da6a40a504e45b$var$o = 0, $57da6a40a504e45b$var$f = [], $57da6a40a504e45b$var$c = (0, $ea42db622452d33d$export$41c562ebe57d11e2), $57da6a40a504e45b$var$e = $57da6a40a504e45b$var$c.__b, $57da6a40a504e45b$var$a = $57da6a40a504e45b$var$c.__r, $57da6a40a504e45b$var$v = $57da6a40a504e45b$var$c.diffed, $57da6a40a504e45b$var$l = $57da6a40a504e45b$var$c.__c, $57da6a40a504e45b$var$m = $57da6a40a504e45b$var$c.unmount, $57da6a40a504e45b$var$s = $57da6a40a504e45b$var$c.__;
function $57da6a40a504e45b$var$p(n, t) {
    $57da6a40a504e45b$var$c.__h && $57da6a40a504e45b$var$c.__h($57da6a40a504e45b$var$r, n, $57da6a40a504e45b$var$o || t), $57da6a40a504e45b$var$o = 0;
    var u = $57da6a40a504e45b$var$r.__H || ($57da6a40a504e45b$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $57da6a40a504e45b$export$60241385465d0a34(n) {
    return $57da6a40a504e45b$var$o = 1, $57da6a40a504e45b$export$13e3392192263954($57da6a40a504e45b$var$D, n);
}
function $57da6a40a504e45b$export$13e3392192263954(n, u, i) {
    var o = $57da6a40a504e45b$var$p($57da6a40a504e45b$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $57da6a40a504e45b$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $57da6a40a504e45b$var$r, !$57da6a40a504e45b$var$r.__f)) {
        var f = function f(n, t, r) {
            if (!o.__c.__H) return !0;
            var _$u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (_$u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var _$i = o.__c.props !== n;
            return _$u.some(function(n) {
                if (n.__N) {
                    var _$t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, _$t !== n.__[0] && (_$i = !0);
                }
            }), c && c.call(this, n, t, r) || _$i;
        };
        $57da6a40a504e45b$var$r.__f = !0;
        var c = $57da6a40a504e45b$var$r.shouldComponentUpdate, e = $57da6a40a504e45b$var$r.componentWillUpdate;
        $57da6a40a504e45b$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var _$u = c;
                c = void 0, f(n, t, r), c = _$u;
            }
            e && e.call(this, n, t, r);
        }, $57da6a40a504e45b$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $57da6a40a504e45b$export$6d9c69b0de29b591(n, u) {
    var i = $57da6a40a504e45b$var$p($57da6a40a504e45b$var$t++, 3);
    !$57da6a40a504e45b$var$c.__s && $57da6a40a504e45b$var$C(i.__H, u) && (i.__ = n, i.u = u, $57da6a40a504e45b$var$r.__H.__h.push(i));
}
function $57da6a40a504e45b$export$e5c5a5f917a5871c(n, u) {
    var i = $57da6a40a504e45b$var$p($57da6a40a504e45b$var$t++, 4);
    !$57da6a40a504e45b$var$c.__s && $57da6a40a504e45b$var$C(i.__H, u) && (i.__ = n, i.u = u, $57da6a40a504e45b$var$r.__h.push(i));
}
function $57da6a40a504e45b$export$b8f5890fc79d6aca(n) {
    return $57da6a40a504e45b$var$o = 5, $57da6a40a504e45b$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $57da6a40a504e45b$export$d5a552a76deda3c2(n, t, r) {
    $57da6a40a504e45b$var$o = 6, $57da6a40a504e45b$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var _$r = n(t());
            return function() {
                n(null), _$r && "function" == typeof _$r && _$r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $57da6a40a504e45b$export$1538c33de8887b59(n, r) {
    var u = $57da6a40a504e45b$var$p($57da6a40a504e45b$var$t++, 7);
    return $57da6a40a504e45b$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $57da6a40a504e45b$export$35808ee640e87ca7(n, t) {
    return $57da6a40a504e45b$var$o = 8, $57da6a40a504e45b$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $57da6a40a504e45b$export$fae74005e78b1a27(n) {
    var u = $57da6a40a504e45b$var$r.context[n.__c], i = $57da6a40a504e45b$var$p($57da6a40a504e45b$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($57da6a40a504e45b$var$r)), u.props.value) : n.__;
}
function $57da6a40a504e45b$export$dc8fbce3eb94dc1e(n, t) {
    $57da6a40a504e45b$var$c.useDebugValue && $57da6a40a504e45b$var$c.useDebugValue(t ? t(n) : n);
}
function $57da6a40a504e45b$export$c052f6604b7d51fe(n) {
    var u = $57da6a40a504e45b$var$p($57da6a40a504e45b$var$t++, 10), i = $57da6a40a504e45b$export$60241385465d0a34();
    return u.__ = n, $57da6a40a504e45b$var$r.componentDidCatch || ($57da6a40a504e45b$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $57da6a40a504e45b$export$f680877a34711e37() {
    var _$n = $57da6a40a504e45b$var$p($57da6a40a504e45b$var$t++, 11);
    if (!_$n.__) {
        for(var u = $57da6a40a504e45b$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        _$n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return _$n.__;
}
function $57da6a40a504e45b$var$j() {
    for(var _$n; _$n = $57da6a40a504e45b$var$f.shift();){
        var t = _$n.__H;
        if (_$n.__P && t) try {
            t.__h.some($57da6a40a504e45b$var$z), t.__h.some($57da6a40a504e45b$var$B), t.__h = [];
        } catch (r) {
            t.__h = [], $57da6a40a504e45b$var$c.__e(r, _$n.__v);
        }
    }
}
$57da6a40a504e45b$var$c.__b = function(n) {
    $57da6a40a504e45b$var$r = null, $57da6a40a504e45b$var$e && $57da6a40a504e45b$var$e(n);
}, $57da6a40a504e45b$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $57da6a40a504e45b$var$s && $57da6a40a504e45b$var$s(n, t);
}, $57da6a40a504e45b$var$c.__r = function(n) {
    $57da6a40a504e45b$var$a && $57da6a40a504e45b$var$a(n), $57da6a40a504e45b$var$t = 0;
    var i = ($57da6a40a504e45b$var$r = n.__c).__H;
    i && ($57da6a40a504e45b$var$u === $57da6a40a504e45b$var$r ? (i.__h = [], $57da6a40a504e45b$var$r.__h = [], i.__.some(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.some($57da6a40a504e45b$var$z), i.__h.some($57da6a40a504e45b$var$B), i.__h = [], $57da6a40a504e45b$var$t = 0)), $57da6a40a504e45b$var$u = $57da6a40a504e45b$var$r;
}, $57da6a40a504e45b$var$c.diffed = function(n) {
    $57da6a40a504e45b$var$v && $57da6a40a504e45b$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $57da6a40a504e45b$var$f.push(t) && $57da6a40a504e45b$var$i === $57da6a40a504e45b$var$c.requestAnimationFrame || (($57da6a40a504e45b$var$i = $57da6a40a504e45b$var$c.requestAnimationFrame) || $57da6a40a504e45b$var$w)($57da6a40a504e45b$var$j)), t.__H.__.some(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $57da6a40a504e45b$var$u = $57da6a40a504e45b$var$r = null;
}, $57da6a40a504e45b$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.some($57da6a40a504e45b$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $57da6a40a504e45b$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $57da6a40a504e45b$var$c.__e(r, n.__v);
        }
    }), $57da6a40a504e45b$var$l && $57da6a40a504e45b$var$l(n, t);
}, $57da6a40a504e45b$var$c.unmount = function(n) {
    $57da6a40a504e45b$var$m && $57da6a40a504e45b$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.some(function(n) {
        try {
            $57da6a40a504e45b$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $57da6a40a504e45b$var$c.__e(t, r.__v));
};
var $57da6a40a504e45b$var$k = "function" == typeof requestAnimationFrame;
function $57da6a40a504e45b$var$w(n) {
    var t, r = function r() {
        clearTimeout(u), $57da6a40a504e45b$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $57da6a40a504e45b$var$k && (t = requestAnimationFrame(r));
}
function $57da6a40a504e45b$var$z(n) {
    var t = $57da6a40a504e45b$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $57da6a40a504e45b$var$r = t;
}
function $57da6a40a504e45b$var$B(n) {
    var t = $57da6a40a504e45b$var$r;
    n.__c = n.__(), $57da6a40a504e45b$var$r = t;
}
function $57da6a40a504e45b$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $57da6a40a504e45b$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $bdfb41ef79315c14$var$g(n, t) {
    for(var _$e in t)n[_$e] = t[_$e];
    return n;
}
function $bdfb41ef79315c14$var$E(n, t) {
    for(var _$e in n)if ("__source" !== _$e && !(_$e in t)) return !0;
    for(var _$r in t)if ("__source" !== _$r && n[_$r] !== t[_$r]) return !0;
    return !1;
}
function $bdfb41ef79315c14$export$306c0aa65ff9ec16(n, t) {
    var _$e = t(), _$r = (0, $57da6a40a504e45b$export$60241385465d0a34)({
        t: {
            __: _$e,
            u: t
        }
    }), _$u = _$r[0].t, o = _$r[1];
    return (0, $57da6a40a504e45b$export$e5c5a5f917a5871c)(function() {
        _$u.__ = _$e, _$u.u = t, $bdfb41ef79315c14$var$R(_$u) && o({
            t: _$u
        });
    }, [
        n,
        _$e,
        t
    ]), (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        return $bdfb41ef79315c14$var$R(_$u) && o({
            t: _$u
        }), n(function() {
            $bdfb41ef79315c14$var$R(_$u) && o({
                t: _$u
            });
        });
    }, [
        n
    ]), _$e;
}
function $bdfb41ef79315c14$var$R(n) {
    try {
        return !((_$t = n.__) === (_$e = n.u()) && (0 !== _$t || 1 / _$t == 1 / _$e) || _$t != _$t && _$e != _$e);
    } catch (n) {
        return !0;
    }
    var _$t, _$e;
}
function $bdfb41ef79315c14$export$7568632d0d33d16d(n) {
    n();
}
function $bdfb41ef79315c14$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $bdfb41ef79315c14$export$7b286972b8d8ccbf() {
    return [
        !1,
        $bdfb41ef79315c14$export$7568632d0d33d16d
    ];
}
var $bdfb41ef79315c14$export$aaabe4eda9ed9969 = (0, $57da6a40a504e45b$export$e5c5a5f917a5871c);
function $bdfb41ef79315c14$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $bdfb41ef79315c14$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var _$t = this.props.ref, _$r = _$t == n.ref;
        return !_$r && _$t && (_$t.call ? _$t(null) : _$t.current = null), e ? !e(this.props, n) || !_$r : $bdfb41ef79315c14$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $ea42db622452d33d$export$c8a8987d4410bf2d)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u.type = n, u;
}
($bdfb41ef79315c14$export$221d75b3f55bb0bd.prototype = new (0, $ea42db622452d33d$export$16fa2f45be04daa8)).isPureReactComponent = !0, $bdfb41ef79315c14$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $bdfb41ef79315c14$var$E(this.props, n) || $bdfb41ef79315c14$var$E(this.state, t);
};
var $bdfb41ef79315c14$var$T = (0, $ea42db622452d33d$export$41c562ebe57d11e2).__b;
(0, $ea42db622452d33d$export$41c562ebe57d11e2).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $bdfb41ef79315c14$var$T && $bdfb41ef79315c14$var$T(n);
};
var $bdfb41ef79315c14$var$A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $bdfb41ef79315c14$export$257a8862b851cb5b(n) {
    function t(t) {
        var _$e = $bdfb41ef79315c14$var$g({}, t);
        return delete _$e.ref, n(_$e, t.ref || null);
    }
    return t.$$typeof = $bdfb41ef79315c14$var$A, t.render = n, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $bdfb41ef79315c14$var$L = function L(n, t) {
    return null == n ? null : (0, $ea42db622452d33d$export$47e4c5b300681277)((0, $ea42db622452d33d$export$47e4c5b300681277)(n).map(t));
}, $bdfb41ef79315c14$export$dca3b0875bd9a954 = {
    map: $bdfb41ef79315c14$var$L,
    forEach: $bdfb41ef79315c14$var$L,
    count: function count(n) {
        return n ? (0, $ea42db622452d33d$export$47e4c5b300681277)(n).length : 0;
    },
    only: function only(n) {
        var _$t = (0, $ea42db622452d33d$export$47e4c5b300681277)(n);
        if (1 !== _$t.length) throw "Children.only";
        return _$t[0];
    },
    toArray: (0, $ea42db622452d33d$export$47e4c5b300681277)
}, $bdfb41ef79315c14$var$U = (0, $ea42db622452d33d$export$41c562ebe57d11e2).__e;
(0, $ea42db622452d33d$export$41c562ebe57d11e2).__e = function(n, t, e, r) {
    if (n.then) {
        for(var _$u, o = t; o = o.__;)if ((_$u = o.__c) && _$u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), _$u.__c(n, t);
    }
    $bdfb41ef79315c14$var$U(n, t, e, r);
};
var $bdfb41ef79315c14$var$F = (0, $ea42db622452d33d$export$41c562ebe57d11e2).unmount;
function $bdfb41ef79315c14$var$V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $bdfb41ef79315c14$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $bdfb41ef79315c14$var$V(n, t, e);
    })), n;
}
function $bdfb41ef79315c14$var$W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $bdfb41ef79315c14$var$W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $bdfb41ef79315c14$export$74bf444e3cd11ea5() {
    this.__u = 0, this.o = null, this.__b = null;
}
function $bdfb41ef79315c14$var$j(n) {
    if (!n.__) return null;
    var _$t = n.__.__c;
    return _$t && _$t.__a && _$t.__a(n);
}
function $bdfb41ef79315c14$export$488013bae63b21da(n) {
    var _$e, _$r, _$u, o = null;
    function i(i) {
        if (_$e || (_$e = n()).then(function(n) {
            n && (o = n.default || n), _$u = !0;
        }, function(n) {
            _$r = n, _$u = !0;
        }), _$r) throw _$r;
        if (!_$u) throw _$e;
        return o ? (0, $ea42db622452d33d$export$c8a8987d4410bf2d)(o, i) : null;
    }
    return i.displayName = "Lazy", i.__f = !0, i;
}
function $bdfb41ef79315c14$export$998bcd577473dd93() {
    this.i = null, this.l = null;
}
(0, $ea42db622452d33d$export$41c562ebe57d11e2).unmount = function(n) {
    var _$t = n.__c;
    _$t && (_$t.__z = !0), _$t && _$t.__R && _$t.__R(), _$t && 32 & n.__u && (n.type = null), $bdfb41ef79315c14$var$F && $bdfb41ef79315c14$var$F(n);
}, ($bdfb41ef79315c14$export$74bf444e3cd11ea5.prototype = new (0, $ea42db622452d33d$export$16fa2f45be04daa8)).__c = function(n, t) {
    var _$e = t.__c, _$r = this;
    null == _$r.o && (_$r.o = []), _$r.o.push(_$e);
    var _$u = $bdfb41ef79315c14$var$j(_$r.__v), o = !1, i = function i() {
        o || _$r.__z || (o = !0, _$e.__R = null, _$u ? _$u(_$c) : _$c());
    };
    _$e.__R = i;
    var _$l = _$e.__P;
    _$e.__P = null;
    var _$c = function c() {
        if (!--_$r.__u) {
            if (_$r.state.__a) {
                var _$n = _$r.state.__a;
                _$r.__v.__k[0] = $bdfb41ef79315c14$var$W(_$n, _$n.__c.__P, _$n.__c.__O);
            }
            var _$t;
            for(_$r.setState({
                __a: _$r.__b = null
            }); _$t = _$r.o.pop();)_$t.__P = _$l, _$t.forceUpdate();
        }
    };
    _$r.__u++ || 32 & t.__u || _$r.setState({
        __a: _$r.__b = _$r.__v.__k[0]
    }), n.then(i, i);
}, $bdfb41ef79315c14$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.o = [];
}, $bdfb41ef79315c14$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var _$r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $bdfb41ef79315c14$var$V(this.__b, _$r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $ea42db622452d33d$export$c8a8987d4410bf2d)((0, $ea42db622452d33d$export$ffb0004e005737fa), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $ea42db622452d33d$export$c8a8987d4410bf2d)((0, $ea42db622452d33d$export$ffb0004e005737fa), null, e.__a ? null : n.children),
        i
    ];
};
var $bdfb41ef79315c14$var$H = function H(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function $bdfb41ef79315c14$var$Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $bdfb41ef79315c14$var$Y(n) {
    var _$e = this, _$r = n.h;
    if (_$e.componentWillUnmount = function() {
        (0, $ea42db622452d33d$export$b3890eb0ae9dca99)(null, _$e.v), _$e.v = null, _$e.h = null;
    }, _$e.h && _$e.h !== _$r && _$e.componentWillUnmount(), !_$e.v) {
        for(var _$u = _$e.__v; null !== _$u && !_$u.__m && null !== _$u.__;)_$u = _$u.__;
        _$e.h = _$r, _$e.v = {
            nodeType: 1,
            parentNode: _$r,
            childNodes: [],
            __k: {
                __m: _$u.__m
            },
            contains: function contains() {
                return !0;
            },
            namespaceURI: _$r.namespaceURI,
            insertBefore: function insertBefore(n, t) {
                this.childNodes.push(n), _$e.h.insertBefore(n, t);
            },
            removeChild: function removeChild(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), _$e.h.removeChild(n);
            }
        };
    }
    (0, $ea42db622452d33d$export$b3890eb0ae9dca99)((0, $ea42db622452d33d$export$c8a8987d4410bf2d)($bdfb41ef79315c14$var$Z, {
        context: _$e.context
    }, n.__v), _$e.v);
}
function $bdfb41ef79315c14$export$d39a5bbd09211389(n, e) {
    var _$r = (0, $ea42db622452d33d$export$c8a8987d4410bf2d)($bdfb41ef79315c14$var$Y, {
        __v: n,
        h: e
    });
    return _$r.containerInfo = e, _$r;
}
($bdfb41ef79315c14$export$998bcd577473dd93.prototype = new (0, $ea42db622452d33d$export$16fa2f45be04daa8)).__a = function(n) {
    var _$t = this, _$e = $bdfb41ef79315c14$var$j(_$t.__v), _$r = _$t.l.get(n);
    return _$r[0]++, function(u) {
        var o = function o() {
            _$t.props.revealOrder ? (_$r.push(u), $bdfb41ef79315c14$var$H(_$t, n, _$r)) : u();
        };
        _$e ? _$e(o) : o();
    };
}, $bdfb41ef79315c14$export$998bcd577473dd93.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var _$t = (0, $ea42db622452d33d$export$47e4c5b300681277)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && _$t.reverse();
    for(var _$e = _$t.length; _$e--;)this.l.set(_$t[_$e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, $bdfb41ef79315c14$export$998bcd577473dd93.prototype.componentDidUpdate = $bdfb41ef79315c14$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var _$n = this;
    this.l.forEach(function(t, e) {
        $bdfb41ef79315c14$var$H(_$n, e, t);
    });
};
var $bdfb41ef79315c14$var$q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $bdfb41ef79315c14$var$G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $bdfb41ef79315c14$var$J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $bdfb41ef79315c14$var$K = /[A-Z0-9]/g, $bdfb41ef79315c14$var$Q = "undefined" != typeof document, $bdfb41ef79315c14$var$X = function X(n) {
    return ("undefined" != typeof Symbol && "symbol" == (0, $8Bufz._)(Symbol()) ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $bdfb41ef79315c14$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $ea42db622452d33d$export$b3890eb0ae9dca99)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $bdfb41ef79315c14$export$fa8d919ba61d84db(n, t, e) {
    return (0, $ea42db622452d33d$export$fa8d919ba61d84db)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $ea42db622452d33d$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $ea42db622452d33d$export$16fa2f45be04daa8).prototype, t, {
        configurable: !0,
        get: function get() {
            return this["UNSAFE_" + t];
        },
        set: function set(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $bdfb41ef79315c14$var$en = (0, $ea42db622452d33d$export$41c562ebe57d11e2).event;
function $bdfb41ef79315c14$var$rn() {}
function $bdfb41ef79315c14$var$un() {
    return this.cancelBubble;
}
function $bdfb41ef79315c14$var$on() {
    return this.defaultPrevented;
}
(0, $ea42db622452d33d$export$41c562ebe57d11e2).event = function(n) {
    return $bdfb41ef79315c14$var$en && (n = $bdfb41ef79315c14$var$en(n)), n.persist = $bdfb41ef79315c14$var$rn, n.isPropagationStopped = $bdfb41ef79315c14$var$un, n.isDefaultPrevented = $bdfb41ef79315c14$var$on, n.nativeEvent = n;
};
var $bdfb41ef79315c14$var$ln, $bdfb41ef79315c14$var$cn = {
    enumerable: !1,
    configurable: !0,
    get: function get() {
        return this.class;
    }
}, $bdfb41ef79315c14$var$fn = (0, $ea42db622452d33d$export$41c562ebe57d11e2).vnode;
(0, $ea42db622452d33d$export$41c562ebe57d11e2).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var _$t = n.props, _$e = n.type, _$u = {}, o = -1 === _$e.indexOf("-");
        for(var i in _$t){
            var _$l = _$t[i];
            if (!("value" === i && "defaultValue" in _$t && null == _$l || $bdfb41ef79315c14$var$Q && "children" === i && "noscript" === _$e || "class" === i || "className" === i)) {
                var _$c = i.toLowerCase();
                "defaultValue" === i && "value" in _$t && null == _$t.value ? i = "value" : "download" === i && !0 === _$l ? _$l = "" : "translate" === _$c && "no" === _$l ? _$l = !1 : "o" === _$c[0] && "n" === _$c[1] ? "ondoubleclick" === _$c ? i = "ondblclick" : "onchange" !== _$c || "input" !== _$e && "textarea" !== _$e || $bdfb41ef79315c14$var$X(_$t.type) ? "onfocus" === _$c ? i = "onfocusin" : "onblur" === _$c ? i = "onfocusout" : $bdfb41ef79315c14$var$J.test(i) && (i = _$c) : _$c = i = "oninput" : o && $bdfb41ef79315c14$var$G.test(i) ? i = i.replace($bdfb41ef79315c14$var$K, "-$&").toLowerCase() : null === _$l && (_$l = void 0), "oninput" === _$c && _$u[i = _$c] && (i = "oninputCapture"), _$u[i] = _$l;
            }
        }
        "select" == _$e && _$u.multiple && Array.isArray(_$u.value) && (_$u.value = (0, $ea42db622452d33d$export$47e4c5b300681277)(_$t.children).forEach(function(n) {
            n.props.selected = -1 != _$u.value.indexOf(n.props.value);
        })), "select" == _$e && null != _$u.defaultValue && (_$u.value = (0, $ea42db622452d33d$export$47e4c5b300681277)(_$t.children).forEach(function(n) {
            n.props.selected = _$u.multiple ? -1 != _$u.defaultValue.indexOf(n.props.value) : _$u.defaultValue == n.props.value;
        })), _$t.class && !_$t.className ? (_$u.class = _$t.class, Object.defineProperty(_$u, "className", $bdfb41ef79315c14$var$cn)) : _$t.className && (_$u.class = _$u.className = _$t.className), n.props = _$u;
    }(n), n.$$typeof = $bdfb41ef79315c14$var$q, $bdfb41ef79315c14$var$fn && $bdfb41ef79315c14$var$fn(n);
};
var $bdfb41ef79315c14$var$an = (0, $ea42db622452d33d$export$41c562ebe57d11e2).__r;
(0, $ea42db622452d33d$export$41c562ebe57d11e2).__r = function(n) {
    $bdfb41ef79315c14$var$an && $bdfb41ef79315c14$var$an(n), $bdfb41ef79315c14$var$ln = n.__c;
};
var $bdfb41ef79315c14$var$sn = (0, $ea42db622452d33d$export$41c562ebe57d11e2).diffed;
(0, $ea42db622452d33d$export$41c562ebe57d11e2).diffed = function(n) {
    $bdfb41ef79315c14$var$sn && $bdfb41ef79315c14$var$sn(n);
    var _$t = n.props, _$e = n.__e;
    null != _$e && "textarea" === n.type && "value" in _$t && _$t.value !== _$e.value && (_$e.value = null == _$t.value ? "" : _$t.value), $bdfb41ef79315c14$var$ln = null;
};
var $bdfb41ef79315c14$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function readContext(n) {
                return $bdfb41ef79315c14$var$ln.__n[n.__c].props.value;
            },
            useCallback: (0, $57da6a40a504e45b$export$35808ee640e87ca7),
            useContext: (0, $57da6a40a504e45b$export$fae74005e78b1a27),
            useDebugValue: (0, $57da6a40a504e45b$export$dc8fbce3eb94dc1e),
            useDeferredValue: $bdfb41ef79315c14$export$6a7bc4e911dc01cf,
            useEffect: (0, $57da6a40a504e45b$export$6d9c69b0de29b591),
            useId: (0, $57da6a40a504e45b$export$f680877a34711e37),
            useImperativeHandle: (0, $57da6a40a504e45b$export$d5a552a76deda3c2),
            useInsertionEffect: $bdfb41ef79315c14$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $57da6a40a504e45b$export$e5c5a5f917a5871c),
            useMemo: (0, $57da6a40a504e45b$export$1538c33de8887b59),
            useReducer: (0, $57da6a40a504e45b$export$13e3392192263954),
            useRef: (0, $57da6a40a504e45b$export$b8f5890fc79d6aca),
            useState: (0, $57da6a40a504e45b$export$60241385465d0a34),
            useSyncExternalStore: $bdfb41ef79315c14$export$306c0aa65ff9ec16,
            useTransition: $bdfb41ef79315c14$export$7b286972b8d8ccbf
        }
    }
}, $bdfb41ef79315c14$export$83d89fbfd8236492 = "18.3.1";
function $bdfb41ef79315c14$export$d38cd72104c1f0e9(n) {
    return (0, $ea42db622452d33d$export$c8a8987d4410bf2d).bind(null, n);
}
function $bdfb41ef79315c14$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $bdfb41ef79315c14$var$q;
}
function $bdfb41ef79315c14$export$9522e17588c12572(n) {
    return $bdfb41ef79315c14$export$a8257692ac88316c(n) && n.type === (0, $ea42db622452d33d$export$ffb0004e005737fa);
}
function $bdfb41ef79315c14$export$56885ab8b9c456ab(n) {
    return !!n && "string" == typeof n.displayName && n.displayName.startsWith("Memo(");
}
function $bdfb41ef79315c14$export$e530037191fcd5d7(n) {
    return $bdfb41ef79315c14$export$a8257692ac88316c(n) ? (0, $ea42db622452d33d$export$e530037191fcd5d7).apply(null, arguments) : n;
}
function $bdfb41ef79315c14$export$502457920280e6be(n) {
    return !!n.__k && ((0, $ea42db622452d33d$export$b3890eb0ae9dca99)(null, n), !0);
}
function $bdfb41ef79315c14$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $bdfb41ef79315c14$export$c78a37762a8d58e1 = function gn(n, t) {
    return n(t);
}, $bdfb41ef79315c14$export$cd75ccfd720a3cd4 = function En(n, t) {
    return n(t);
}, $bdfb41ef79315c14$export$5f8d39834fd61797 = (0, $ea42db622452d33d$export$ffb0004e005737fa), $bdfb41ef79315c14$export$45a5e7f76e0caa8d = $bdfb41ef79315c14$export$a8257692ac88316c, $bdfb41ef79315c14$export$2e2bcd8739ae039 = {
    useState: (0, $57da6a40a504e45b$export$60241385465d0a34),
    useId: (0, $57da6a40a504e45b$export$f680877a34711e37),
    useReducer: (0, $57da6a40a504e45b$export$13e3392192263954),
    useEffect: (0, $57da6a40a504e45b$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $57da6a40a504e45b$export$e5c5a5f917a5871c),
    useInsertionEffect: $bdfb41ef79315c14$export$aaabe4eda9ed9969,
    useTransition: $bdfb41ef79315c14$export$7b286972b8d8ccbf,
    useDeferredValue: $bdfb41ef79315c14$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $bdfb41ef79315c14$export$306c0aa65ff9ec16,
    startTransition: $bdfb41ef79315c14$export$7568632d0d33d16d,
    useRef: (0, $57da6a40a504e45b$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $57da6a40a504e45b$export$d5a552a76deda3c2),
    useMemo: (0, $57da6a40a504e45b$export$1538c33de8887b59),
    useCallback: (0, $57da6a40a504e45b$export$35808ee640e87ca7),
    useContext: (0, $57da6a40a504e45b$export$fae74005e78b1a27),
    useDebugValue: (0, $57da6a40a504e45b$export$dc8fbce3eb94dc1e),
    version: "18.3.1",
    Children: $bdfb41ef79315c14$export$dca3b0875bd9a954,
    render: $bdfb41ef79315c14$export$b3890eb0ae9dca99,
    hydrate: $bdfb41ef79315c14$export$fa8d919ba61d84db,
    unmountComponentAtNode: $bdfb41ef79315c14$export$502457920280e6be,
    createPortal: $bdfb41ef79315c14$export$d39a5bbd09211389,
    createElement: (0, $ea42db622452d33d$export$c8a8987d4410bf2d),
    createContext: (0, $ea42db622452d33d$export$fd42f52fd3ae1109),
    createFactory: $bdfb41ef79315c14$export$d38cd72104c1f0e9,
    cloneElement: $bdfb41ef79315c14$export$e530037191fcd5d7,
    createRef: (0, $ea42db622452d33d$export$7d1e3a5e95ceca43),
    Fragment: (0, $ea42db622452d33d$export$ffb0004e005737fa),
    isValidElement: $bdfb41ef79315c14$export$a8257692ac88316c,
    isElement: $bdfb41ef79315c14$export$45a5e7f76e0caa8d,
    isFragment: $bdfb41ef79315c14$export$9522e17588c12572,
    isMemo: $bdfb41ef79315c14$export$56885ab8b9c456ab,
    findDOMNode: $bdfb41ef79315c14$export$466bfc07425424d5,
    Component: (0, $ea42db622452d33d$export$16fa2f45be04daa8),
    PureComponent: $bdfb41ef79315c14$export$221d75b3f55bb0bd,
    memo: $bdfb41ef79315c14$export$7c73462e0d25e514,
    forwardRef: $bdfb41ef79315c14$export$257a8862b851cb5b,
    flushSync: $bdfb41ef79315c14$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $bdfb41ef79315c14$export$c78a37762a8d58e1,
    StrictMode: $bdfb41ef79315c14$export$5f8d39834fd61797,
    Suspense: $bdfb41ef79315c14$export$74bf444e3cd11ea5,
    SuspenseList: $bdfb41ef79315c14$export$998bcd577473dd93,
    lazy: $bdfb41ef79315c14$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $bdfb41ef79315c14$export$ae55be85d98224ed
};
$parcel$exportWildcard($bdfb41ef79315c14$exports, $57da6a40a504e45b$exports);




var $3baa482d3c4e6797$export$dc3d8cb49dcee267 = /*#__PURE__*/ (0, $ea42db622452d33d$export$fd42f52fd3ae1109)({});


/**
 * React custom hook that returns the value of any token defined in the
 * SystemContext. It's mainly used internally in [`useOptions`](#useoptions)
 * and [`useProps`](#useprops).
 *
 * @example
 * import { SystemProvider, useToken } from "reakit-system";
 *
 * const system = {
 *   token: "value",
 * };
 *
 * function Component(props) {
 *   const token = useToken("token", "default value");
 *   return <div {...props}>{token}</div>;
 * }
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <Component />
 *     </SystemProvider>
 *   );
 * }
 */ function $58154d52375e8c2e$export$31dcd79391e423fe(token, defaultValue) {
    (0, $57da6a40a504e45b$export$dc8fbce3eb94dc1e)(token);
    var context = (0, $57da6a40a504e45b$export$fae74005e78b1a27)((0, $3baa482d3c4e6797$export$dc3d8cb49dcee267));
    return context[token] != null ? context[token] : defaultValue;
}


var $ce81eebcfd1372bc$exports = {};

var $8Bufz = parcelRequire("8Bufz");
'use strict';
var $874a68f2f0f40342$exports = {};
/* MIT license */ var $1977c9af53ea65bc$exports = {};
'use strict';
$1977c9af53ea65bc$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $0706e369d5a30208$exports = {};
'use strict';
var $bac99323dcd283da$exports = {};
$bac99323dcd283da$exports = function isArrayish(obj) {
    if (!obj || typeof obj === 'string') return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
};


var $0706e369d5a30208$var$concat = Array.prototype.concat;
var $0706e369d5a30208$var$slice = Array.prototype.slice;
var $0706e369d5a30208$var$swizzle = $0706e369d5a30208$exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($bac99323dcd283da$exports(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $0706e369d5a30208$var$concat.call(results, $0706e369d5a30208$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$0706e369d5a30208$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($0706e369d5a30208$var$swizzle(arguments));
    };
};


var $874a68f2f0f40342$var$hasOwnProperty = Object.hasOwnProperty;
var $874a68f2f0f40342$var$reverseNames = Object.create(null);
// create a list of reverse color names
for(var $874a68f2f0f40342$var$name in $1977c9af53ea65bc$exports)if ($874a68f2f0f40342$var$hasOwnProperty.call($1977c9af53ea65bc$exports, $874a68f2f0f40342$var$name)) $874a68f2f0f40342$var$reverseNames[$1977c9af53ea65bc$exports[$874a68f2f0f40342$var$name]] = $874a68f2f0f40342$var$name;
var $874a68f2f0f40342$var$cs = $874a68f2f0f40342$exports = {
    to: {},
    get: {}
};
$874a68f2f0f40342$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case 'hsl':
            val = $874a68f2f0f40342$var$cs.get.hsl(string);
            model = 'hsl';
            break;
        case 'hwb':
            val = $874a68f2f0f40342$var$cs.get.hwb(string);
            model = 'hwb';
            break;
        default:
            val = $874a68f2f0f40342$var$cs.get.rgb(string);
            model = 'rgb';
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$874a68f2f0f40342$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === 'transparent') return [
            0,
            0,
            0,
            0
        ];
        if (!$874a68f2f0f40342$var$hasOwnProperty.call($1977c9af53ea65bc$exports, match[1])) return null;
        rgb = $1977c9af53ea65bc$exports[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $874a68f2f0f40342$var$clamp(rgb[i], 0, 255);
    rgb[3] = $874a68f2f0f40342$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$874a68f2f0f40342$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = $874a68f2f0f40342$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $874a68f2f0f40342$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $874a68f2f0f40342$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$874a68f2f0f40342$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $874a68f2f0f40342$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $874a68f2f0f40342$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $874a68f2f0f40342$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$874a68f2f0f40342$var$cs.to.hex = function() {
    var rgba = $0706e369d5a30208$exports(arguments);
    return '#' + $874a68f2f0f40342$var$hexDouble(rgba[0]) + $874a68f2f0f40342$var$hexDouble(rgba[1]) + $874a68f2f0f40342$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $874a68f2f0f40342$var$hexDouble(Math.round(rgba[3] * 255)) : '');
};
$874a68f2f0f40342$var$cs.to.rgb = function() {
    var rgba = $0706e369d5a30208$exports(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};
$874a68f2f0f40342$var$cs.to.rgb.percent = function() {
    var rgba = $0706e369d5a30208$exports(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};
$874a68f2f0f40342$var$cs.to.hsl = function() {
    var hsla = $0706e369d5a30208$exports(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$874a68f2f0f40342$var$cs.to.hwb = function() {
    var hwba = $0706e369d5a30208$exports(arguments);
    var a = '';
    if (hwba.length >= 4 && hwba[3] !== 1) a = ', ' + hwba[3];
    return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};
$874a68f2f0f40342$var$cs.to.keyword = function(rgb) {
    return $874a68f2f0f40342$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $874a68f2f0f40342$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $874a68f2f0f40342$var$hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? '0' + str : str;
}


var $852f2f374f293896$exports = {};

var $8Bufz = parcelRequire("8Bufz");
var $8599991b9fca6590$exports = {};
/* MIT license */ var $a813f8f86fac7eac$exports = {};
'use strict';
$a813f8f86fac7eac$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
var $8599991b9fca6590$var$reverseKeywords = {};
for(var $8599991b9fca6590$var$key in $a813f8f86fac7eac$exports)if ($a813f8f86fac7eac$exports.hasOwnProperty($8599991b9fca6590$var$key)) $8599991b9fca6590$var$reverseKeywords[$a813f8f86fac7eac$exports[$8599991b9fca6590$var$key]] = $8599991b9fca6590$var$key;
var $8599991b9fca6590$var$convert = $8599991b9fca6590$exports = {
    rgb: {
        channels: 3,
        labels: 'rgb'
    },
    hsl: {
        channels: 3,
        labels: 'hsl'
    },
    hsv: {
        channels: 3,
        labels: 'hsv'
    },
    hwb: {
        channels: 3,
        labels: 'hwb'
    },
    cmyk: {
        channels: 4,
        labels: 'cmyk'
    },
    xyz: {
        channels: 3,
        labels: 'xyz'
    },
    lab: {
        channels: 3,
        labels: 'lab'
    },
    lch: {
        channels: 3,
        labels: 'lch'
    },
    hex: {
        channels: 1,
        labels: [
            'hex'
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            'keyword'
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            'ansi16'
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            'ansi256'
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            'h',
            'c',
            'g'
        ]
    },
    apple: {
        channels: 3,
        labels: [
            'r16',
            'g16',
            'b16'
        ]
    },
    gray: {
        channels: 1,
        labels: [
            'gray'
        ]
    }
};
// hide .channels and .labels properties
for(var $8599991b9fca6590$var$model in $8599991b9fca6590$var$convert)if ($8599991b9fca6590$var$convert.hasOwnProperty($8599991b9fca6590$var$model)) {
    if (!('channels' in $8599991b9fca6590$var$convert[$8599991b9fca6590$var$model])) throw new Error('missing channels property: ' + $8599991b9fca6590$var$model);
    if (!('labels' in $8599991b9fca6590$var$convert[$8599991b9fca6590$var$model])) throw new Error('missing channel labels property: ' + $8599991b9fca6590$var$model);
    if ($8599991b9fca6590$var$convert[$8599991b9fca6590$var$model].labels.length !== $8599991b9fca6590$var$convert[$8599991b9fca6590$var$model].channels) throw new Error('channel and label counts mismatch: ' + $8599991b9fca6590$var$model);
    var $8599991b9fca6590$var$channels = $8599991b9fca6590$var$convert[$8599991b9fca6590$var$model].channels;
    var $8599991b9fca6590$var$labels = $8599991b9fca6590$var$convert[$8599991b9fca6590$var$model].labels;
    delete $8599991b9fca6590$var$convert[$8599991b9fca6590$var$model].channels;
    delete $8599991b9fca6590$var$convert[$8599991b9fca6590$var$model].labels;
    Object.defineProperty($8599991b9fca6590$var$convert[$8599991b9fca6590$var$model], 'channels', {
        value: $8599991b9fca6590$var$channels
    });
    Object.defineProperty($8599991b9fca6590$var$convert[$8599991b9fca6590$var$model], 'labels', {
        value: $8599991b9fca6590$var$labels
    });
}
$8599991b9fca6590$var$convert.rgb.hsl = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    var l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$8599991b9fca6590$var$convert.rgb.hsv = function(rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);
    var diffc = function diffc(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) h = s = 0;
    else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$8599991b9fca6590$var$convert.rgb.hwb = function(rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = $8599991b9fca6590$var$convert.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$8599991b9fca6590$var$convert.rgb.cmyk = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var c;
    var m;
    var y;
    var k;
    k = Math.min(1 - r, 1 - g, 1 - b);
    c = (1 - r - k) / (1 - k) || 0;
    m = (1 - g - k) / (1 - k) || 0;
    y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function $8599991b9fca6590$var$comparativeDistance(x, y) {
    return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}
$8599991b9fca6590$var$convert.rgb.keyword = function(rgb) {
    var reversed = $8599991b9fca6590$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    var currentClosestDistance = Infinity;
    var currentClosestKeyword;
    for(var keyword in $a813f8f86fac7eac$exports)if ($a813f8f86fac7eac$exports.hasOwnProperty(keyword)) {
        var value = $a813f8f86fac7eac$exports[keyword];
        // Compute comparative distance
        var distance = $8599991b9fca6590$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$8599991b9fca6590$var$convert.keyword.rgb = function(keyword) {
    return $a813f8f86fac7eac$exports[keyword];
};
$8599991b9fca6590$var$convert.rgb.xyz = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$8599991b9fca6590$var$convert.rgb.lab = function(rgb) {
    var xyz = $8599991b9fca6590$var$convert.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$8599991b9fca6590$var$convert.hsl.rgb = function(hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t1;
    var t2;
    var t3;
    var rgb;
    var val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    t1 = 2 * l - t2;
    rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$8599991b9fca6590$var$convert.hsl.hsv = function(hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    var sv;
    var v;
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    v = (l + s) / 2;
    sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$8599991b9fca6590$var$convert.hsv.rgb = function(hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$8599991b9fca6590$var$convert.hsv.hsl = function(hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var lmin;
    var sl;
    var l;
    l = (2 - s) * v;
    lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$8599991b9fca6590$var$convert.hwb.rgb = function(hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var i;
    var v;
    var f;
    var n;
    // wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    i = Math.floor(6 * h);
    v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    n = wh + f * (v - wh); // linear interpolation
    var r;
    var g;
    var b;
    switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$8599991b9fca6590$var$convert.cmyk.rgb = function(cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r;
    var g;
    var b;
    r = 1 - Math.min(1, c * (1 - k) + k);
    g = 1 - Math.min(1, m * (1 - k) + k);
    b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$8599991b9fca6590$var$convert.xyz.rgb = function(xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // assume sRGB
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$8599991b9fca6590$var$convert.xyz.lab = function(xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$8599991b9fca6590$var$convert.lab.xyz = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$8599991b9fca6590$var$convert.lab.lch = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var hr;
    var h;
    var c;
    hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$8599991b9fca6590$var$convert.lch.lab = function(lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var a;
    var b;
    var hr;
    hr = h / 360 * 2 * Math.PI;
    a = c * Math.cos(hr);
    b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$8599991b9fca6590$var$convert.rgb.ansi16 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    var value = 1 in arguments ? arguments[1] : $8599991b9fca6590$var$convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$8599991b9fca6590$var$convert.hsv.ansi16 = function(args) {
    // optimization here; we already know the value and don't need to get
    // it converted for us.
    return $8599991b9fca6590$var$convert.rgb.ansi16($8599991b9fca6590$var$convert.hsv.rgb(args), args[2]);
};
$8599991b9fca6590$var$convert.rgb.ansi256 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    // we use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$8599991b9fca6590$var$convert.ansi16.rgb = function(args) {
    var color = args % 10;
    // handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$8599991b9fca6590$var$convert.ansi256.rgb = function(args) {
    // handle greyscale
    if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$8599991b9fca6590$var$convert.rgb.hex = function(args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
$8599991b9fca6590$var$convert.hex.rgb = function(args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    var colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split('').map(function(char) {
        return char + char;
    }).join('');
    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$8599991b9fca6590$var$convert.rgb.hcg = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma + 4;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$8599991b9fca6590$var$convert.hsl.hcg = function(hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = 1;
    var f = 0;
    if (l < 0.5) c = 2.0 * s * l;
    else c = 2.0 * s * (1.0 - l);
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$8599991b9fca6590$var$convert.hsv.hcg = function(hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$8599991b9fca6590$var$convert.hcg.rgb = function(hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    var pure = [
        0,
        0,
        0
    ];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;
    switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$8599991b9fca6590$var$convert.hcg.hsv = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$8599991b9fca6590$var$convert.hcg.hsl = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$8599991b9fca6590$var$convert.hcg.hwb = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$8599991b9fca6590$var$convert.hwb.hcg = function(hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$8599991b9fca6590$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$8599991b9fca6590$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$8599991b9fca6590$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$8599991b9fca6590$var$convert.gray.hsl = $8599991b9fca6590$var$convert.gray.hsv = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$8599991b9fca6590$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$8599991b9fca6590$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$8599991b9fca6590$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$8599991b9fca6590$var$convert.gray.hex = function(gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
$8599991b9fca6590$var$convert.rgb.gray = function(rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};


var $47af530c1dc4b984$exports = {};

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $47af530c1dc4b984$var$buildGraph() {
    var graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    var models = Object.keys($8599991b9fca6590$exports);
    for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $47af530c1dc4b984$var$deriveBFS(fromModel) {
    var graph = $47af530c1dc4b984$var$buildGraph();
    var queue = [
        fromModel
    ]; // unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        var current = queue.pop();
        var adjacents = Object.keys($8599991b9fca6590$exports[current]);
        for(var len = adjacents.length, i = 0; i < len; i++){
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $47af530c1dc4b984$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $47af530c1dc4b984$var$wrapConversion(toModel, graph) {
    var path = [
        graph[toModel].parent,
        toModel
    ];
    var fn = $8599991b9fca6590$exports[graph[toModel].parent][toModel];
    var cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $47af530c1dc4b984$var$link($8599991b9fca6590$exports[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
$47af530c1dc4b984$exports = function(fromModel) {
    var graph = $47af530c1dc4b984$var$deriveBFS(fromModel);
    var conversion = {};
    var models = Object.keys(graph);
    for(var len = models.length, i = 0; i < len; i++){
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $47af530c1dc4b984$var$wrapConversion(toModel, graph);
    }
    return conversion;
};


var $852f2f374f293896$var$convert = {};
var $852f2f374f293896$var$models = Object.keys($8599991b9fca6590$exports);
function $852f2f374f293896$var$wrapRaw(fn) {
    var wrappedFn = function wrappedFn(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        return fn(args);
    };
    // preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $852f2f374f293896$var$wrapRounded(fn) {
    var wrappedFn = function wrappedFn(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        var result = fn(args);
        // we're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if ((typeof result === "undefined" ? "undefined" : (0, $8Bufz._)(result)) === 'object') for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$852f2f374f293896$var$models.forEach(function(fromModel) {
    $852f2f374f293896$var$convert[fromModel] = {};
    Object.defineProperty($852f2f374f293896$var$convert[fromModel], 'channels', {
        value: $8599991b9fca6590$exports[fromModel].channels
    });
    Object.defineProperty($852f2f374f293896$var$convert[fromModel], 'labels', {
        value: $8599991b9fca6590$exports[fromModel].labels
    });
    var routes = $47af530c1dc4b984$exports(fromModel);
    var routeModels = Object.keys(routes);
    routeModels.forEach(function(toModel) {
        var fn = routes[toModel];
        $852f2f374f293896$var$convert[fromModel][toModel] = $852f2f374f293896$var$wrapRounded(fn);
        $852f2f374f293896$var$convert[fromModel][toModel].raw = $852f2f374f293896$var$wrapRaw(fn);
    });
});
$852f2f374f293896$exports = $852f2f374f293896$var$convert;


var $ce81eebcfd1372bc$var$_slice = [].slice;
var $ce81eebcfd1372bc$var$skippedModels = [
    // to be honest, I don't really feel like keyword belongs in color convert, but eh.
    'keyword',
    // gray conflicts with some method names, and has its own method defined.
    'gray',
    // shouldn't really be in color-convert either...
    'hex'
];
var $ce81eebcfd1372bc$var$hashedModelKeys = {};
Object.keys($852f2f374f293896$exports).forEach(function(model) {
    $ce81eebcfd1372bc$var$hashedModelKeys[$ce81eebcfd1372bc$var$_slice.call($852f2f374f293896$exports[model].labels).sort().join('')] = model;
});
var $ce81eebcfd1372bc$var$limiters = {};
function $ce81eebcfd1372bc$var$Color(obj, model) {
    if (!(this instanceof $ce81eebcfd1372bc$var$Color)) return new $ce81eebcfd1372bc$var$Color(obj, model);
    if (model && model in $ce81eebcfd1372bc$var$skippedModels) model = null;
    if (model && !(model in $852f2f374f293896$exports)) throw new Error('Unknown model: ' + model);
    var i;
    var channels;
    if (obj == null) {
        this.model = 'rgb';
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (obj instanceof $ce81eebcfd1372bc$var$Color) {
        this.model = obj.model;
        this.color = obj.color.slice();
        this.valpha = obj.valpha;
    } else if (typeof obj === 'string') {
        var result = $874a68f2f0f40342$exports.get(obj);
        if (result === null) throw new Error('Unable to parse color from string: ' + obj);
        this.model = result.model;
        channels = $852f2f374f293896$exports[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
    } else if (obj.length) {
        this.model = model || 'rgb';
        channels = $852f2f374f293896$exports[this.model].channels;
        var newArr = $ce81eebcfd1372bc$var$_slice.call(obj, 0, channels);
        this.color = $ce81eebcfd1372bc$var$zeroArray(newArr, channels);
        this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
    } else if (typeof obj === 'number') {
        // this is always RGB - can be converted later on.
        obj &= 0xFFFFFF;
        this.model = 'rgb';
        this.color = [
            obj >> 16 & 0xFF,
            obj >> 8 & 0xFF,
            obj & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        var keys = Object.keys(obj);
        if ('alpha' in obj) {
            keys.splice(keys.indexOf('alpha'), 1);
            this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
        }
        var hashedKeys = keys.sort().join('');
        if (!(hashedKeys in $ce81eebcfd1372bc$var$hashedModelKeys)) throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
        this.model = $ce81eebcfd1372bc$var$hashedModelKeys[hashedKeys];
        var labels = $852f2f374f293896$exports[this.model].labels;
        var color = [];
        for(i = 0; i < labels.length; i++)color.push(obj[labels[i]]);
        this.color = $ce81eebcfd1372bc$var$zeroArray(color);
    }
    // perform limitations (clamping, etc.)
    if ($ce81eebcfd1372bc$var$limiters[this.model]) {
        channels = $852f2f374f293896$exports[this.model].channels;
        for(i = 0; i < channels; i++){
            var limit = $ce81eebcfd1372bc$var$limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
$ce81eebcfd1372bc$var$Color.prototype = {
    toString: function toString() {
        return this.string();
    },
    toJSON: function toJSON() {
        return this[this.model]();
    },
    string: function string(places) {
        var self = this.model in $874a68f2f0f40342$exports.to ? this : this.rgb();
        self = self.round(typeof places === 'number' ? places : 1);
        var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
        return $874a68f2f0f40342$exports.to[self.model](args);
    },
    percentString: function percentString(places) {
        var self = this.rgb().round(typeof places === 'number' ? places : 1);
        var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
        return $874a68f2f0f40342$exports.to.rgb.percent(args);
    },
    array: function array() {
        return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function object() {
        var result = {};
        var channels = $852f2f374f293896$exports[this.model].channels;
        var labels = $852f2f374f293896$exports[this.model].labels;
        for(var i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray: function unitArray() {
        var rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject: function unitObject() {
        var rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round: function round(places) {
        places = Math.max(places || 0, 0);
        return new $ce81eebcfd1372bc$var$Color(this.color.map($ce81eebcfd1372bc$var$roundToPlace(places)).concat(this.valpha), this.model);
    },
    alpha: function alpha(val) {
        if (arguments.length) return new $ce81eebcfd1372bc$var$Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
        return this.valpha;
    },
    // rgb
    red: $ce81eebcfd1372bc$var$getset('rgb', 0, $ce81eebcfd1372bc$var$maxfn(255)),
    green: $ce81eebcfd1372bc$var$getset('rgb', 1, $ce81eebcfd1372bc$var$maxfn(255)),
    blue: $ce81eebcfd1372bc$var$getset('rgb', 2, $ce81eebcfd1372bc$var$maxfn(255)),
    hue: $ce81eebcfd1372bc$var$getset([
        'hsl',
        'hsv',
        'hsl',
        'hwb',
        'hcg'
    ], 0, function(val) {
        return (val % 360 + 360) % 360;
    }),
    saturationl: $ce81eebcfd1372bc$var$getset('hsl', 1, $ce81eebcfd1372bc$var$maxfn(100)),
    lightness: $ce81eebcfd1372bc$var$getset('hsl', 2, $ce81eebcfd1372bc$var$maxfn(100)),
    saturationv: $ce81eebcfd1372bc$var$getset('hsv', 1, $ce81eebcfd1372bc$var$maxfn(100)),
    value: $ce81eebcfd1372bc$var$getset('hsv', 2, $ce81eebcfd1372bc$var$maxfn(100)),
    chroma: $ce81eebcfd1372bc$var$getset('hcg', 1, $ce81eebcfd1372bc$var$maxfn(100)),
    gray: $ce81eebcfd1372bc$var$getset('hcg', 2, $ce81eebcfd1372bc$var$maxfn(100)),
    white: $ce81eebcfd1372bc$var$getset('hwb', 1, $ce81eebcfd1372bc$var$maxfn(100)),
    wblack: $ce81eebcfd1372bc$var$getset('hwb', 2, $ce81eebcfd1372bc$var$maxfn(100)),
    cyan: $ce81eebcfd1372bc$var$getset('cmyk', 0, $ce81eebcfd1372bc$var$maxfn(100)),
    magenta: $ce81eebcfd1372bc$var$getset('cmyk', 1, $ce81eebcfd1372bc$var$maxfn(100)),
    yellow: $ce81eebcfd1372bc$var$getset('cmyk', 2, $ce81eebcfd1372bc$var$maxfn(100)),
    black: $ce81eebcfd1372bc$var$getset('cmyk', 3, $ce81eebcfd1372bc$var$maxfn(100)),
    x: $ce81eebcfd1372bc$var$getset('xyz', 0, $ce81eebcfd1372bc$var$maxfn(100)),
    y: $ce81eebcfd1372bc$var$getset('xyz', 1, $ce81eebcfd1372bc$var$maxfn(100)),
    z: $ce81eebcfd1372bc$var$getset('xyz', 2, $ce81eebcfd1372bc$var$maxfn(100)),
    l: $ce81eebcfd1372bc$var$getset('lab', 0, $ce81eebcfd1372bc$var$maxfn(100)),
    a: $ce81eebcfd1372bc$var$getset('lab', 1),
    b: $ce81eebcfd1372bc$var$getset('lab', 2),
    keyword: function keyword(val) {
        if (arguments.length) return new $ce81eebcfd1372bc$var$Color(val);
        return $852f2f374f293896$exports[this.model].keyword(this.color);
    },
    hex: function hex(val) {
        if (arguments.length) return new $ce81eebcfd1372bc$var$Color(val);
        return $874a68f2f0f40342$exports.to.hex(this.rgb().round().color);
    },
    rgbNumber: function rgbNumber() {
        var rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity: function luminosity() {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        var rgb = this.rgb().color;
        var lum = [];
        for(var i = 0; i < rgb.length; i++){
            var chan = rgb[i] / 255;
            lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast: function contrast(color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level: function level(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) return 'AAA';
        return contrastRatio >= 4.5 ? 'AA' : '';
    },
    isDark: function isDark() {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        var rgb = this.rgb().color;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    negate: function negate() {
        var rgb = this.rgb();
        for(var i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten: function lighten(ratio) {
        var hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken: function darken(ratio) {
        var hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate: function saturate(ratio) {
        var hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate: function desaturate(ratio) {
        var hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten: function whiten(ratio) {
        var hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken: function blacken(ratio) {
        var hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale: function grayscale() {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        var rgb = this.rgb().color;
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return $ce81eebcfd1372bc$var$Color.rgb(val, val, val);
    },
    fade: function fade(ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer: function opaquer(ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate: function rotate(degrees) {
        var hsl = this.hsl();
        var hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix: function mix(mixinColor, weight) {
        // ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + (typeof mixinColor === "undefined" ? "undefined" : (0, $8Bufz._)(mixinColor)));
        var color1 = mixinColor.rgb();
        var color2 = this.rgb();
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return $ce81eebcfd1372bc$var$Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// model conversion methods and static constructors
Object.keys($852f2f374f293896$exports).forEach(function(model) {
    if ($ce81eebcfd1372bc$var$skippedModels.indexOf(model) !== -1) return;
    var channels = $852f2f374f293896$exports[model].channels;
    // conversion methods
    $ce81eebcfd1372bc$var$Color.prototype[model] = function() {
        if (this.model === model) return new $ce81eebcfd1372bc$var$Color(this);
        if (arguments.length) return new $ce81eebcfd1372bc$var$Color(arguments, model);
        var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
        return new $ce81eebcfd1372bc$var$Color($ce81eebcfd1372bc$var$assertArray($852f2f374f293896$exports[this.model][model].raw(this.color)).concat(newAlpha), model);
    };
    // 'static' construction methods
    $ce81eebcfd1372bc$var$Color[model] = function(color) {
        if (typeof color === 'number') color = $ce81eebcfd1372bc$var$zeroArray($ce81eebcfd1372bc$var$_slice.call(arguments), channels);
        return new $ce81eebcfd1372bc$var$Color(color, model);
    };
});
function $ce81eebcfd1372bc$var$roundTo(num, places) {
    return Number(num.toFixed(places));
}
function $ce81eebcfd1372bc$var$roundToPlace(places) {
    return function(num) {
        return $ce81eebcfd1372bc$var$roundTo(num, places);
    };
}
function $ce81eebcfd1372bc$var$getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    model.forEach(function(m) {
        ($ce81eebcfd1372bc$var$limiters[m] || ($ce81eebcfd1372bc$var$limiters[m] = []))[channel] = modifier;
    });
    model = model[0];
    return function(val) {
        var result;
        if (arguments.length) {
            if (modifier) val = modifier(val);
            result = this[model]();
            result.color[channel] = val;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function $ce81eebcfd1372bc$var$maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function $ce81eebcfd1372bc$var$assertArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $ce81eebcfd1372bc$var$zeroArray(arr, length) {
    for(var i = 0; i < length; i++)if (typeof arr[i] !== 'number') arr[i] = 0;
    return arr;
}
$ce81eebcfd1372bc$exports = $ce81eebcfd1372bc$var$Color;




function $57f8d1a499533103$export$44af652f4cca9039(color) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ce81eebcfd1372bc$exports)))(color).isLight();
}
function $57f8d1a499533103$export$a61f0bf17cb3496d(color) {
    (0, $57da6a40a504e45b$export$dc8fbce3eb94dc1e)(color);
    return (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        return $57f8d1a499533103$export$44af652f4cca9039(color);
    }, [
        color
    ]);
}


function $12674995b3f54524$export$db3b6bfb95261072(color1, color2) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ce81eebcfd1372bc$exports)))(color1).contrast((0, (/*@__PURE__*/$parcel$interopDefault($ce81eebcfd1372bc$exports)))(color2));
}
function $12674995b3f54524$export$3b14a55fb2447963(color1, color2) {
    (0, $57da6a40a504e45b$export$dc8fbce3eb94dc1e)(color1 + " - " + color2);
    return (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        return $12674995b3f54524$export$db3b6bfb95261072(color1, color2);
    }, [
        color1,
        color2
    ]);
}
function $12674995b3f54524$export$407448d2b89b1813(color) {
    if (!color) return function() {
        return undefined;
    };
    if (typeof color === "function") return function(palette) {
        return $12674995b3f54524$export$407448d2b89b1813(color(palette))(palette);
    };
    var colorIsLight = (0, $57f8d1a499533103$export$44af652f4cca9039)(color);
    return function(palette) {
        if (colorIsLight) return $12674995b3f54524$export$39b482c5e57630a8(palette, "black") || "black";
        return $12674995b3f54524$export$39b482c5e57630a8(palette, "white") || "white";
    };
}
function $12674995b3f54524$export$8b22cf2602fb60ce(color) {
    (0, $57da6a40a504e45b$export$dc8fbce3eb94dc1e)(color);
    var palette = (0, $58154d52375e8c2e$export$31dcd79391e423fe)("palette");
    return (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        return $12674995b3f54524$export$407448d2b89b1813(color)(palette);
    }, [
        color,
        palette
    ]);
}
var $12674995b3f54524$export$ffb5f4729a158638 = {
    white: "#ffffff",
    black: "#212121",
    light: "#f8f9fa",
    dark: "#343a40",
    primary: "#006DFF",
    secondary: "#6C757D",
    success: "#28A745",
    info: "#17A2B8",
    warning: "#FFC107",
    danger: "#DC3545",
    background: $12674995b3f54524$export$43caf9889c228507("white", "#ffffff"),
    foreground: $12674995b3f54524$export$407448d2b89b1813($12674995b3f54524$export$43caf9889c228507("background", "#ffffff"))
};
function $12674995b3f54524$export$39b482c5e57630a8(palette$1, name) {
    if (palette$1 === void 0) palette$1 = $12674995b3f54524$export$ffb5f4729a158638;
    if (!name) return undefined;
    var color = palette$1[name];
    while(typeof color === "function")color = color(palette$1);
    return color;
}
function $12674995b3f54524$export$4368d992c4eafac0(name) {
    (0, $57da6a40a504e45b$export$dc8fbce3eb94dc1e)(name);
    var palette = (0, $58154d52375e8c2e$export$31dcd79391e423fe)("palette");
    return $12674995b3f54524$export$39b482c5e57630a8(palette, name);
}
function $12674995b3f54524$export$43caf9889c228507(name, fallback) {
    return function(palette) {
        return $12674995b3f54524$export$39b482c5e57630a8(palette, name) || fallback;
    };
}


function $02cc76477a676705$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $02cc76477a676705$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $02cc76477a676705$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $02cc76477a676705$var$ownKeys(Object(source), true).forEach(function(key) {
            $02cc76477a676705$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $02cc76477a676705$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $02cc76477a676705$export$8b22cf2602fb60ce(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $02cc76477a676705$export$407448d2b89b1813(strings, raw) {
    if (!raw) raw = strings.slice(0);
    strings.raw = raw;
    return strings;
}



var $8Bufz = parcelRequire("8Bufz");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $a444c6611a9a82f4$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $a444c6611a9a82f4$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $a444c6611a9a82f4$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $a444c6611a9a82f4$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $a444c6611a9a82f4$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();



var $8Bufz = parcelRequire("8Bufz");
function $a7cf5c93424be209$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, _$B = e.length, J = _$B - 1, y, f = '', p = '', F = '', G = '', C; l < _$B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, _$B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < _$B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === (typeof d === "undefined" ? "undefined" : (0, $8Bufz._)(d))) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $a7cf5c93424be209$export$2e2bcd8739ae039 = $a7cf5c93424be209$var$stylis_min;


var $788b05f6144aac29$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $788b05f6144aac29$export$2e2bcd8739ae039 = $788b05f6144aac29$var$weakMemoize;


// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $f06224c3933f90b8$var$delimiter = '/*|*/';
var $f06224c3933f90b8$var$needle = $f06224c3933f90b8$var$delimiter + '}';
function $f06224c3933f90b8$var$toSheet(block) {
    if (block) $f06224c3933f90b8$var$Sheet.current.insert(block + '}');
}
var $f06224c3933f90b8$var$Sheet = {
    current: null
};
var $f06224c3933f90b8$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $f06224c3933f90b8$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $f06224c3933f90b8$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $f06224c3933f90b8$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $f06224c3933f90b8$var$delimiter : '');
            }
        case -2:
            content.split($f06224c3933f90b8$var$needle).forEach($f06224c3933f90b8$var$toSheet);
    }
};
var $f06224c3933f90b8$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $a7cf5c93424be209$export$2e2bcd8739ae039)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($f06224c3933f90b8$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $f06224c3933f90b8$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $a444c6611a9a82f4$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $f06224c3933f90b8$export$2e2bcd8739ae039 = $f06224c3933f90b8$var$createCache;



var $8Bufz = parcelRequire("8Bufz");
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $4c21e29495c20de2$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $4c21e29495c20de2$export$2e2bcd8739ae039 = $4c21e29495c20de2$var$murmur2;


var $e35f33dfb22639f5$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $e35f33dfb22639f5$export$2e2bcd8739ae039 = $e35f33dfb22639f5$var$unitlessKeys;


function $ff3d5b9b5f5c8517$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $ff3d5b9b5f5c8517$export$2e2bcd8739ae039 = $ff3d5b9b5f5c8517$var$memoize;


var $d4dc1bf3a946bea7$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $d4dc1bf3a946bea7$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $d4dc1bf3a946bea7$var$hyphenateRegex = /[A-Z]|^ms/g;
var $d4dc1bf3a946bea7$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $d4dc1bf3a946bea7$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $d4dc1bf3a946bea7$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $d4dc1bf3a946bea7$var$processStyleName = (0, $ff3d5b9b5f5c8517$export$2e2bcd8739ae039)(function(styleName) {
    return $d4dc1bf3a946bea7$var$isCustomProperty(styleName) ? styleName : styleName.replace($d4dc1bf3a946bea7$var$hyphenateRegex, '-$&').toLowerCase();
});
var $d4dc1bf3a946bea7$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($d4dc1bf3a946bea7$var$animationRegex, function(match, p1, p2) {
                $d4dc1bf3a946bea7$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $d4dc1bf3a946bea7$var$cursor
                };
                return p1;
            });
    }
    if ((0, $e35f33dfb22639f5$export$2e2bcd8739ae039)[key] !== 1 && !$d4dc1bf3a946bea7$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $d4dc1bf3a946bea7$var$contentValuePattern, $d4dc1bf3a946bea7$var$contentValues, $d4dc1bf3a946bea7$var$oldProcessStyleValue, $d4dc1bf3a946bea7$var$msPattern, $d4dc1bf3a946bea7$var$hyphenPattern, $d4dc1bf3a946bea7$var$hyphenatedCache;
var $d4dc1bf3a946bea7$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $d4dc1bf3a946bea7$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation === "undefined" ? "undefined" : (0, $8Bufz._)(interpolation)){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $d4dc1bf3a946bea7$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $d4dc1bf3a946bea7$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $d4dc1bf3a946bea7$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $d4dc1bf3a946bea7$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $d4dc1bf3a946bea7$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $d4dc1bf3a946bea7$var$cursor;
                var result = interpolation(mergedProps);
                $d4dc1bf3a946bea7$var$cursor = previousCursor;
                return $d4dc1bf3a946bea7$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $d4dc1bf3a946bea7$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $d4dc1bf3a946bea7$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if ((typeof value === "undefined" ? "undefined" : (0, $8Bufz._)(value)) !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($d4dc1bf3a946bea7$var$isProcessableValue(value)) string += $d4dc1bf3a946bea7$var$processStyleName(_key) + ":" + $d4dc1bf3a946bea7$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($d4dc1bf3a946bea7$var$isProcessableValue(value[_i])) string += $d4dc1bf3a946bea7$var$processStyleName(_key) + ":" + $d4dc1bf3a946bea7$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $d4dc1bf3a946bea7$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $d4dc1bf3a946bea7$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $d4dc1bf3a946bea7$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $d4dc1bf3a946bea7$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $d4dc1bf3a946bea7$var$cursor;
var $d4dc1bf3a946bea7$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && (0, $8Bufz._)(args[0]) === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $d4dc1bf3a946bea7$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $d4dc1bf3a946bea7$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $d4dc1bf3a946bea7$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $d4dc1bf3a946bea7$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $d4dc1bf3a946bea7$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $4c21e29495c20de2$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $d4dc1bf3a946bea7$var$cursor
    };
};


var $def1aaf6bec3c82c$var$isBrowser = true;
function $def1aaf6bec3c82c$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $def1aaf6bec3c82c$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $def1aaf6bec3c82c$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


function $c74d8c75089d3134$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function $c74d8c75089d3134$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $def1aaf6bec3c82c$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $c74d8c75089d3134$var$createEmotion = function createEmotion(options) {
    var cache = (0, $f06224c3933f90b8$export$2e2bcd8739ae039)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $d4dc1bf3a946bea7$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $def1aaf6bec3c82c$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $d4dc1bf3a946bea7$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $c74d8c75089d3134$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $d4dc1bf3a946bea7$export$6321afa313b251b5)(args, cache.registered);
        $c74d8c75089d3134$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $c74d8c75089d3134$var$merge(cache.registered, css, $c74d8c75089d3134$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $def1aaf6bec3c82c$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $c74d8c75089d3134$var$merge.bind(null, cache.registered, css)
    };
};
var $c74d8c75089d3134$var$classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg === "undefined" ? "undefined" : (0, $8Bufz._)(arg)){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
var $c74d8c75089d3134$export$2e2bcd8739ae039 = $c74d8c75089d3134$var$createEmotion;


var $8111161d651b62d7$var$_createEmotion = (0, $c74d8c75089d3134$export$2e2bcd8739ae039)(), $8111161d651b62d7$export$4909b86c8034bf73 = $8111161d651b62d7$var$_createEmotion.flush, $8111161d651b62d7$export$fa8d919ba61d84db = $8111161d651b62d7$var$_createEmotion.hydrate, $8111161d651b62d7$export$a274e22fb40f762e = $8111161d651b62d7$var$_createEmotion.cx, $8111161d651b62d7$export$4950aa0f605343fb = $8111161d651b62d7$var$_createEmotion.merge, $8111161d651b62d7$export$95d99596f328fd52 = $8111161d651b62d7$var$_createEmotion.getRegisteredStyles, $8111161d651b62d7$export$efb9f5caaa2ca0c7 = $8111161d651b62d7$var$_createEmotion.injectGlobal, $8111161d651b62d7$export$d25ddfdf17c3ad3e = $8111161d651b62d7$var$_createEmotion.keyframes, $8111161d651b62d7$export$dbf350e5966cf602 = $8111161d651b62d7$var$_createEmotion.css, $8111161d651b62d7$export$995990c5c04c46f0 = $8111161d651b62d7$var$_createEmotion.sheet, $8111161d651b62d7$export$69a3209f1a06c04d = $8111161d651b62d7$var$_createEmotion.cache;










function $7e95edc6721571aa$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7e95edc6721571aa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7e95edc6721571aa$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7e95edc6721571aa$var$ownKeys(Object(source), true).forEach(function(key) {
            $7e95edc6721571aa$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7e95edc6721571aa$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7e95edc6721571aa$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7e95edc6721571aa$export$892580369e97d8b9(_ref2, _ref) {
    var _ref2$unstable_system = _ref2.unstable_system, system = _ref2$unstable_system === void 0 ? {} : _ref2$unstable_system;
    if (_ref === void 0) _ref = {};
    var _ref3 = _ref, htmlStyle = _ref3.style, htmlProps = $7e95edc6721571aa$var$_objectWithoutPropertiesLoose(_ref3, [
        "style"
    ]);
    var color = (0, $12674995b3f54524$export$4368d992c4eafac0)(system.palette);
    var contrast = (0, $12674995b3f54524$export$8b22cf2602fb60ce)(color);
    var textColor = system.fill === "opaque" ? contrast : color;
    var backgroundColor = system.fill === "opaque" ? color : undefined;
    var borderColor = system.fill === "outline" ? color : undefined;
    var style = {};
    if (textColor) style.color = textColor;
    if (backgroundColor) style.backgroundColor = backgroundColor;
    if (borderColor) {
        style.border = "1px solid " + borderColor;
        style.borderColor = borderColor;
    }
    return $7e95edc6721571aa$var$_objectSpread2({
        style: $7e95edc6721571aa$var$_objectSpread2($7e95edc6721571aa$var$_objectSpread2({}, style), htmlStyle)
    }, htmlProps);
}


function $a2d13842c0550e3b$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\",\n      \"Helvetica Neue\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n\n    ",
        "\n  "
    ]);
    $a2d13842c0550e3b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $a2d13842c0550e3b$export$892580369e97d8b9(_ref, htmlProps) {
    var unstable_system = _ref.unstable_system;
    if (htmlProps === void 0) htmlProps = {};
    var _usePaletteRoleProps = (0, $7e95edc6721571aa$export$892580369e97d8b9)({
        unstable_system: unstable_system
    }), style = _usePaletteRoleProps.style;
    var role = (0, $8111161d651b62d7$export$dbf350e5966cf602)($a2d13842c0550e3b$var$_templateObject(), style);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(role, htmlProps.className)
    });
}









function $f4ac79dbc80dea1e$export$4b073707ff63303(color, ratio) {
    if (!ratio) return color;
    if (!color) return undefined;
    if (typeof color === "function") return function(palette) {
        return $f4ac79dbc80dea1e$export$4b073707ff63303(color(palette), ratio);
    };
    var _color = (0, (/*@__PURE__*/$parcel$interopDefault($ce81eebcfd1372bc$exports)))(color);
    var lightness = _color.lightness();
    return _color.lightness(lightness - lightness * ratio).hex().toString();
}
function $f4ac79dbc80dea1e$export$93a74b4058f261f6(color, ratio) {
    (0, $57da6a40a504e45b$export$dc8fbce3eb94dc1e)(color + "*" + ratio);
    return (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        return $f4ac79dbc80dea1e$export$4b073707ff63303(color, ratio);
    }, [
        color,
        ratio
    ]);
}



function $48bcc42c0cfaa183$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    display: inline-flex;\n    font-weight: 400;\n    align-items: center;\n    justify-content: center;\n    user-select: none;\n    padding: 0.375em 0.75em;\n    line-height: 1.5;\n    border-radius: 0.25rem;\n    text-decoration: none;\n    border: 1px solid ",
        ";\n    cursor: pointer;\n    white-space: nowrap;\n    color: ",
        ";\n    background-color: ",
        ";\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    font-size: 100%;\n\n    &[aria-disabled=\"true\"] {\n      cursor: auto;\n    }\n\n    &:not([aria-disabled=\"true\"]) {\n      &:hover {\n        color: ",
        ";\n        border-color: ",
        ";\n        background-color: ",
        ";\n      }\n      &:active,\n      &[data-active],\n      &[aria-expanded=\"true\"] {\n        color: ",
        ";\n        border-color: ",
        ";\n        background-color: ",
        ";\n      }\n    }\n  "
    ]);
    $48bcc42c0cfaa183$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $48bcc42c0cfaa183$export$66b442cf1b67c420(_ref) {
    var _ref$unstable_system = _ref.unstable_system;
    _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;
    var _ref$unstable_system$ = _ref$unstable_system.fill, fill = _ref$unstable_system$ === void 0 ? "opaque" : _ref$unstable_system$, _ref$unstable_system$2 = _ref$unstable_system.palette, palette = _ref$unstable_system$2 === void 0 ? "primary" : _ref$unstable_system$2, system = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref$unstable_system, [
        "fill",
        "palette"
    ]), options = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref, [
        "unstable_system"
    ]);
    return (0, $02cc76477a676705$export$71511d61b312f219)({
        unstable_system: (0, $02cc76477a676705$export$71511d61b312f219)({
            fill: fill,
            palette: palette
        }, system)
    }, options);
}
function $48bcc42c0cfaa183$export$a0ee72f2c720a5c3(_ref2, htmlProps) {
    var unstable_system = _ref2.unstable_system;
    if (htmlProps === void 0) htmlProps = {};
    var _usePaletteRoleProps = (0, $7e95edc6721571aa$export$892580369e97d8b9)({
        unstable_system: unstable_system
    }), _usePaletteRoleProps$ = _usePaletteRoleProps.style, color = _usePaletteRoleProps$.color, backgroundColor = _usePaletteRoleProps$.backgroundColor, _usePaletteRoleProps$2 = _usePaletteRoleProps$.borderColor, borderColor = _usePaletteRoleProps$2 === void 0 ? "transparent" : _usePaletteRoleProps$2;
    var hoverBackgroundColor = (0, $f4ac79dbc80dea1e$export$93a74b4058f261f6)(backgroundColor || color, unstable_system.fill !== "opaque" ? 0 : 0.1);
    var activeBackgroundColor = (0, $f4ac79dbc80dea1e$export$93a74b4058f261f6)(hoverBackgroundColor, 0.1);
    var hoverBorderColor = (0, $f4ac79dbc80dea1e$export$93a74b4058f261f6)(backgroundColor || color, 0.2);
    var activeBorderColor = (0, $f4ac79dbc80dea1e$export$93a74b4058f261f6)(hoverBorderColor, 0.1);
    var hoverColor = (0, $12674995b3f54524$export$8b22cf2602fb60ce)(hoverBackgroundColor);
    var activeColor = (0, $12674995b3f54524$export$8b22cf2602fb60ce)(activeBackgroundColor);
    var button = (0, $8111161d651b62d7$export$dbf350e5966cf602)($48bcc42c0cfaa183$var$_templateObject(), borderColor, color, backgroundColor || "transparent", hoverColor, hoverBorderColor, hoverBackgroundColor, activeColor, activeBorderColor, activeBackgroundColor);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(button, htmlProps.className)
    });
}





function $231d87b613381e1c$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    align-items: center;\n    justify-content: center;\n    padding: 0.375em 0.75em;\n    font-size: 100%;\n    border: 0;\n    color: inherit;\n    background-color: inherit;\n\n    &:not([aria-selected=\"true\"]) {\n      color: inherit;\n      background-color: inherit;\n    }\n\n    [aria-activedescendant=\"",
        "\"]:focus &[aria-selected=\"true\"],\n    [aria-activedescendant=\"",
        "\"]:focus ~ * &[aria-selected=\"true\"] {\n      color: ",
        ";\n      background-color ",
        ";\n    }\n  "
    ]);
    $231d87b613381e1c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $231d87b613381e1c$export$a9b64cf6834a191d(_ref) {
    var _ref$unstable_system = _ref.unstable_system;
    _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;
    var _ref$unstable_system$ = _ref$unstable_system.fill, fill = _ref$unstable_system$ === void 0 ? "opaque" : _ref$unstable_system$, _ref$unstable_system$2 = _ref$unstable_system.palette, palette = _ref$unstable_system$2 === void 0 ? "primary" : _ref$unstable_system$2, system = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref$unstable_system, [
        "fill",
        "palette"
    ]), options = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref, [
        "unstable_system"
    ]);
    return (0, $02cc76477a676705$export$71511d61b312f219)({
        unstable_system: (0, $02cc76477a676705$export$71511d61b312f219)({
            fill: fill,
            palette: palette
        }, system)
    }, options);
}
function $231d87b613381e1c$export$2652450ebff132c5(_ref2, htmlProps) {
    var unstable_system = _ref2.unstable_system, id = _ref2.id;
    if (htmlProps === void 0) htmlProps = {};
    var _usePaletteRoleProps = (0, $7e95edc6721571aa$export$892580369e97d8b9)({
        unstable_system: unstable_system
    }), _usePaletteRoleProps$ = _usePaletteRoleProps.style, color = _usePaletteRoleProps$.color, backgroundColor = _usePaletteRoleProps$.backgroundColor;
    var compositeItem = (0, $8111161d651b62d7$export$dbf350e5966cf602)($231d87b613381e1c$var$_templateObject(), id, id, color, backgroundColor);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(compositeItem, htmlProps.className)
    });
}










function $3498394efd2ba855$export$cbea29d068a2e18f(color, ratio) {
    if (!ratio) return color;
    if (!color) return undefined;
    if (typeof color === "function") return function(palette) {
        return $3498394efd2ba855$export$cbea29d068a2e18f(color(palette), ratio);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($ce81eebcfd1372bc$exports)))(color).fade(ratio).rgb().toString();
}
function $3498394efd2ba855$export$e715bdb8257bb45a(color, ratio) {
    (0, $57da6a40a504e45b$export$dc8fbce3eb94dc1e)(color + "*" + ratio);
    return (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        return $3498394efd2ba855$export$cbea29d068a2e18f(color, ratio);
    }, [
        color,
        ratio
    ]);
}



function $1d43db460869e11f$var$_templateObject2() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    background-color: rgba(0, 0, 0, 0.5);\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 999;\n  "
    ]);
    $1d43db460869e11f$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $1d43db460869e11f$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    position: fixed;\n    top: 28px;\n    left: 50%;\n    transform: translateX(-50%);\n    border-radius: 0.25rem;\n    padding: 1em;\n    max-height: calc(100vh - 56px);\n    outline: 0;\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    z-index: 999;\n\n    &:focus {\n      box-shadow: 0 0 0 0.2em ",
        ";\n    }\n  "
    ]);
    $1d43db460869e11f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $1d43db460869e11f$export$fe43c47ea4463c8e(_ref) {
    var _ref$unstable_system = _ref.unstable_system;
    _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;
    var _ref$unstable_system$ = _ref$unstable_system.palette, palette = _ref$unstable_system$ === void 0 ? "background" : _ref$unstable_system$, _ref$unstable_system$2 = _ref$unstable_system.fill, fill = _ref$unstable_system$2 === void 0 ? "opaque" : _ref$unstable_system$2, system = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref$unstable_system, [
        "palette",
        "fill"
    ]), options = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref, [
        "unstable_system"
    ]);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, options), {}, {
        unstable_system: (0, $02cc76477a676705$export$71511d61b312f219)({
            palette: palette,
            fill: fill
        }, system)
    });
}
function $1d43db460869e11f$export$4259f8849f04d8f2(_ref2, htmlProps) {
    var unstable_system = _ref2.unstable_system;
    if (htmlProps === void 0) htmlProps = {};
    var _usePaletteRoleProps = (0, $7e95edc6721571aa$export$892580369e97d8b9)({
        unstable_system: unstable_system
    }), _usePaletteRoleProps$ = _usePaletteRoleProps.style, color = _usePaletteRoleProps$.color, backgroundColor = _usePaletteRoleProps$.backgroundColor;
    var foreground = (0, $12674995b3f54524$export$8b22cf2602fb60ce)(backgroundColor) || "black";
    var primaryColor = (0, $12674995b3f54524$export$4368d992c4eafac0)("primary");
    var borderColor = (0, $3498394efd2ba855$export$e715bdb8257bb45a)(foreground, 0.75);
    var boxShadowColor = (0, $3498394efd2ba855$export$e715bdb8257bb45a)(primaryColor || color || foreground, 0.5);
    var dialog = (0, $8111161d651b62d7$export$dbf350e5966cf602)($1d43db460869e11f$var$_templateObject(), borderColor, color, boxShadowColor);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(dialog, htmlProps.className)
    });
}
function $1d43db460869e11f$export$39bcff29cb67f86c(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var dialogBackdrop = (0, $8111161d651b62d7$export$dbf350e5966cf602)($1d43db460869e11f$var$_templateObject2());
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(dialogBackdrop, htmlProps.className)
    });
}









function $d71074b92e18808d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d71074b92e18808d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d71074b92e18808d$export$407448d2b89b1813(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d71074b92e18808d$var$ownKeys(Object(source), true).forEach(function(key) {
            $d71074b92e18808d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d71074b92e18808d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d71074b92e18808d$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d71074b92e18808d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d71074b92e18808d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d71074b92e18808d$var$_arrayLikeToArray(o, minLen);
}
function $d71074b92e18808d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d71074b92e18808d$export$8b22cf2602fb60ce(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $d71074b92e18808d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}


function $4aa4076f2e516f16$export$f1c84c16470d56ed(object, path, defaultValue) {
    if (typeof path === "string") return object[path] == null ? defaultValue : object[path];
    var result = object;
    for(var _iterator = (0, $d71074b92e18808d$export$8b22cf2602fb60ce)(path), _step; !(_step = _iterator()).done;){
        var key = _step.value;
        if (!(key in result)) return defaultValue;
        result = result[key];
    }
    if (result == null) return defaultValue;
    return result;
}




function $551d7d5382e08dca$export$c0816ed86df316af(color, ratio) {
    if (!ratio) return color;
    if (!color) return undefined;
    if (typeof color === "function") return function(palette) {
        return $551d7d5382e08dca$export$c0816ed86df316af(color(palette), ratio);
    };
    var _color = (0, (/*@__PURE__*/$parcel$interopDefault($ce81eebcfd1372bc$exports)))(color);
    var lightness = _color.lightness();
    return _color.lightness(lightness + (100 - lightness) * ratio).hex().toString();
}
function $551d7d5382e08dca$export$15228a9d7f479658(color, ratio) {
    (0, $57da6a40a504e45b$export$dc8fbce3eb94dc1e)(color + "*" + ratio);
    return (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        return $551d7d5382e08dca$export$c0816ed86df316af(color, ratio);
    }, [
        color,
        ratio
    ]);
}


function $1f7d9d37a0e245c1$var$_templateObject4() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    display: block;\n    color: ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: 0.25rem;\n    padding: 0.5rem 1rem 1rem;\n    & > * {\n      display: block;\n    }\n  "
    ]);
    $1f7d9d37a0e245c1$var$_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function $1f7d9d37a0e245c1$var$_templateObject3() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    display: block;\n    margin: 0 0 0.5rem 0 !important;\n\n    input[type=\"checkbox\"] + &,\n    input[type=\"radio\"] + & {\n      display: inline-block;\n      margin: 0 0 0 0.5rem !important;\n    }\n  "
    ]);
    $1f7d9d37a0e245c1$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $1f7d9d37a0e245c1$var$_templateObject2() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    font-size: 0.8em;\n    margin-top: 0.5rem !important;\n  "
    ]);
    $1f7d9d37a0e245c1$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $1f7d9d37a0e245c1$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    > *:not(:first-child) {\n      margin-top: 1rem;\n    }\n  "
    ]);
    $1f7d9d37a0e245c1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $1f7d9d37a0e245c1$export$a6b5be5c6b451665(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var form = (0, $8111161d651b62d7$export$dbf350e5966cf602)($1f7d9d37a0e245c1$var$_templateObject());
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(form, htmlProps.className)
    });
}
function $1f7d9d37a0e245c1$export$eaf45e66faff44df(_ref) {
    var _ref$unstable_system = _ref.unstable_system;
    _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;
    var _ref$unstable_system$ = _ref$unstable_system.fill, fill = _ref$unstable_system$ === void 0 ? "outline" : _ref$unstable_system$, system = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref$unstable_system, [
        "fill"
    ]), options = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref, [
        "unstable_system"
    ]);
    var isInvalid = Boolean((0, $4aa4076f2e516f16$export$f1c84c16470d56ed)(options.touched, options.name) && (0, $4aa4076f2e516f16$export$f1c84c16470d56ed)(options.errors, options.name));
    return (0, $02cc76477a676705$export$71511d61b312f219)({
        unstable_system: (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({
            fill: fill
        }, system), {}, {
            palette: isInvalid ? "danger" : system.palette
        })
    }, options);
}
function $1f7d9d37a0e245c1$export$e698c42d2016aaac(_ref2) {
    var _ref2$unstable_system = _ref2.unstable_system, system = _ref2$unstable_system === void 0 ? {} : _ref2$unstable_system, options = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref2, [
        "unstable_system"
    ]);
    var isInvalid = Boolean((0, $4aa4076f2e516f16$export$f1c84c16470d56ed)(options.errors, options.name));
    return (0, $02cc76477a676705$export$71511d61b312f219)({
        unstable_system: (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, system), {}, {
            palette: isInvalid ? "danger" : system.palette || "success"
        })
    }, options);
}
function $1f7d9d37a0e245c1$export$f96f7191998f58fb(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var formMessage = (0, $8111161d651b62d7$export$dbf350e5966cf602)($1f7d9d37a0e245c1$var$_templateObject2());
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(formMessage, htmlProps.className)
    });
}
function $1f7d9d37a0e245c1$export$69cd1433de1021d0(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var formLabel = (0, $8111161d651b62d7$export$dbf350e5966cf602)($1f7d9d37a0e245c1$var$_templateObject3());
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(formLabel, htmlProps.className)
    });
}
function $1f7d9d37a0e245c1$export$661ac08c7a0b48e0(_ref3) {
    var _ref3$unstable_system = _ref3.unstable_system;
    _ref3$unstable_system = _ref3$unstable_system === void 0 ? {} : _ref3$unstable_system;
    var _ref3$unstable_system2 = _ref3$unstable_system.fill, fill = _ref3$unstable_system2 === void 0 ? "outline" : _ref3$unstable_system2, system = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref3$unstable_system, [
        "fill"
    ]), options = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref3, [
        "unstable_system"
    ]);
    var isInvalid = Boolean((0, $4aa4076f2e516f16$export$f1c84c16470d56ed)(options.touched, options.name) && (0, $4aa4076f2e516f16$export$f1c84c16470d56ed)(options.errors, options.name));
    return (0, $02cc76477a676705$export$71511d61b312f219)({
        unstable_system: (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({
            fill: fill
        }, system), {}, {
            palette: isInvalid ? "danger" : system.palette
        })
    }, options);
}
function $1f7d9d37a0e245c1$export$9c135d04c11b2679(_ref4, htmlProps) {
    var unstable_system = _ref4.unstable_system;
    if (htmlProps === void 0) htmlProps = {};
    var _usePaletteRoleProps = (0, $7e95edc6721571aa$export$892580369e97d8b9)({
        unstable_system: unstable_system
    }), _usePaletteRoleProps$ = _usePaletteRoleProps.style, backgroundColor = _usePaletteRoleProps$.backgroundColor, originalBorderColor = _usePaletteRoleProps$.borderColor;
    var foreground = (0, $12674995b3f54524$export$8b22cf2602fb60ce)(backgroundColor) || "black";
    var color = (0, $551d7d5382e08dca$export$15228a9d7f479658)(foreground, 0.3);
    var borderColor = (0, $3498394efd2ba855$export$e715bdb8257bb45a)(foreground, 0.75);
    var formGroup = (0, $8111161d651b62d7$export$dbf350e5966cf602)($1f7d9d37a0e245c1$var$_templateObject4(), color, originalBorderColor || borderColor);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(formGroup, htmlProps.className)
    });
}
function $1f7d9d37a0e245c1$export$25a25f6a01b3b77d(_ref5) {
    var _ref5$unstable_system = _ref5.unstable_system;
    _ref5$unstable_system = _ref5$unstable_system === void 0 ? {} : _ref5$unstable_system;
    var _ref5$unstable_system2 = _ref5$unstable_system.palette, palette = _ref5$unstable_system2 === void 0 ? "danger" : _ref5$unstable_system2, system = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref5$unstable_system, [
        "palette"
    ]), options = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref5, [
        "unstable_system"
    ]);
    return (0, $02cc76477a676705$export$71511d61b312f219)({
        unstable_system: (0, $02cc76477a676705$export$71511d61b312f219)({
            palette: palette
        }, system)
    }, options);
}




function $35d6d3803122956e$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    display: flex;\n\n    & > :not(:first-child) {\n      margin-left: -1px;\n    }\n\n    & > :not(:first-child):not(:last-child):not(.first-child):not(.last-child) {\n      border-radius: 0;\n    }\n\n    & > :first-child:not(:last-child),\n    & > .first-child {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n\n    & > :last-child:not(:first-child),\n    & > .last-child {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n  "
    ]);
    $35d6d3803122956e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $35d6d3803122956e$export$595c47cf910ca4b5(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var group = (0, $8111161d651b62d7$export$dbf350e5966cf602)($35d6d3803122956e$var$_templateObject());
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(group, htmlProps.className)
    });
}









function $0e2d01dcc4bfab6c$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    display: block;\n    width: 100%;\n    border-radius: 0.2rem;\n    padding: 0.5em 0.75em;\n    font-size: 100%;\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    margin: 0 !important;\n\n    &:focus {\n      border-color: ",
        ";\n    }\n  "
    ]);
    $0e2d01dcc4bfab6c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0e2d01dcc4bfab6c$export$434ed5c8d5bb7eb5(_ref, htmlProps) {
    var unstable_system = _ref.unstable_system;
    if (htmlProps === void 0) htmlProps = {};
    var _usePaletteRoleProps = (0, $7e95edc6721571aa$export$892580369e97d8b9)({
        unstable_system: unstable_system
    }), _usePaletteRoleProps$ = _usePaletteRoleProps.style, backgroundColor = _usePaletteRoleProps$.backgroundColor, originalBorderColor = _usePaletteRoleProps$.borderColor;
    var foreground = (0, $12674995b3f54524$export$8b22cf2602fb60ce)(backgroundColor) || "black";
    var color = (0, $551d7d5382e08dca$export$15228a9d7f479658)(foreground, 0.3);
    var primary = (0, $12674995b3f54524$export$4368d992c4eafac0)("primary");
    var borderColor = (0, $3498394efd2ba855$export$e715bdb8257bb45a)(foreground, 0.75);
    var focusBorderColor = (0, $551d7d5382e08dca$export$15228a9d7f479658)(primary, 0.4);
    var formInput = (0, $8111161d651b62d7$export$dbf350e5966cf602)($0e2d01dcc4bfab6c$var$_templateObject(), originalBorderColor || borderColor, color, originalBorderColor || focusBorderColor);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(formInput, htmlProps.className)
    });
}









function $22146f72899927a4$var$_templateObject9() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    display: inherit;\n    flex-direction: inherit;\n  "
    ]);
    $22146f72899927a4$var$_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function $22146f72899927a4$var$_templateObject8() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    position: relative;\n    outline: 0;\n\n    &[aria-checked=\"true\"] {\n      &:before {\n        content: \"\u2022\";\n        position: absolute;\n        font-size: 1.4em;\n        top: -0.25em;\n        left: 0.35em;\n        width: 0.7142857143em;\n        height: 0.7142857143em;\n      }\n    }\n  "
    ]);
    $22146f72899927a4$var$_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function $22146f72899927a4$var$_templateObject7() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    position: relative;\n    outline: 0;\n\n    &[aria-checked=\"true\"] {\n      &:before {\n        content: \"\u2713\";\n        position: absolute;\n        top: 0;\n        left: 0.4em;\n        width: 1em;\n        height: 1em;\n      }\n    }\n  "
    ]);
    $22146f72899927a4$var$_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function $22146f72899927a4$var$_templateObject6() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n          margin-",
        ": 0.5em;\n        "
    ]);
    $22146f72899927a4$var$_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function $22146f72899927a4$var$_templateObject5() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n        padding-right: 2em !important;\n      "
    ]);
    $22146f72899927a4$var$_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function $22146f72899927a4$var$_templateObject4() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    position: relative;\n\n    [role=\"menu\"] > & {\n      ",
        "\n    }\n\n    svg {\n      fill: currentColor;\n      width: 0.65em;\n      height: 0.65em;\n\n      [role=\"menu\"] > & {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        ",
        ": 0.5em;\n      }\n\n      [role=\"menubar\"] > & {\n        display: none;\n      }\n\n      ",
        "\n    }\n  "
    ]);
    $22146f72899927a4$var$_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function $22146f72899927a4$var$_templateObject3() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    display: flex;\n    border-radius: 0;\n  "
    ]);
    $22146f72899927a4$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $22146f72899927a4$var$_templateObject2() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    &&& {\n      line-height: 1.5;\n      padding: 0 ",
        ";\n      text-align: left;\n      justify-content: flex-start;\n      border: 0;\n      border-radius: 0;\n      font-size: 100%;\n      background: transparent;\n      color: ",
        ";\n      margin: 0;\n      user-select: none;\n      cursor: default;\n      text-decoration: none;\n\n      &:focus,\n      &[aria-expanded=\"true\"] {\n        background-color: ",
        ";\n        color: ",
        ";\n        box-shadow: none !important;\n      }\n\n      &:active,\n      &[data-active] {\n        background-color: ",
        " !important;\n      }\n    }\n  "
    ]);
    $22146f72899927a4$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $22146f72899927a4$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    position: relative;\n    display: flex;\n    flex-direction: ",
        ";\n    white-space: nowrap;\n    box-shadow: none !important;\n\n    &[aria-orientation=\"vertical\"] {\n      padding: 0.25em 0;\n    }\n\n    &[aria-orientation=\"horizontal\"] {\n      padding: 0;\n    }\n  "
    ]);
    $22146f72899927a4$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $22146f72899927a4$export$dbdbead553fa0beb(options, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var isHorizontal = options.orientation === "horizontal";
    var menuBar = (0, $8111161d651b62d7$export$dbf350e5966cf602)($22146f72899927a4$var$_templateObject(), isHorizontal ? "row" : "column");
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(menuBar, htmlProps.className)
    });
}
function $22146f72899927a4$export$db7a925804c71a46(_ref, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var unstable_system = _ref.unstable_system, options = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref, [
        "unstable_system"
    ]);
    var foreground = (0, $12674995b3f54524$export$4368d992c4eafac0)("foreground") || "black";
    var primary = (0, $12674995b3f54524$export$4368d992c4eafac0)("primary") || "blue";
    var primaryContrast = (0, $12674995b3f54524$export$8b22cf2602fb60ce)(primary);
    var darkPrimary = (0, $f4ac79dbc80dea1e$export$93a74b4058f261f6)(primary, 0.2);
    var isHorizontal = options.orientation === "horizontal";
    var menuItem = (0, $8111161d651b62d7$export$dbf350e5966cf602)($22146f72899927a4$var$_templateObject2(), isHorizontal ? "0.5em" : "1.5em", foreground, primary, primaryContrast, darkPrimary);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(menuItem, htmlProps.className)
    });
}
var $22146f72899927a4$var$OrientationContext = /*#__PURE__*/ (0, $ea42db622452d33d$export$fd42f52fd3ae1109)(undefined);
function $22146f72899927a4$export$2ce5e940c4008526(_ref2) {
    var _options$unstable_pop;
    var _ref2$unstable_system = _ref2.unstable_system;
    _ref2$unstable_system = _ref2$unstable_system === void 0 ? {} : _ref2$unstable_system;
    var _ref2$unstable_system2 = _ref2$unstable_system.palette, palette = _ref2$unstable_system2 === void 0 ? "background" : _ref2$unstable_system2, _ref2$unstable_system3 = _ref2$unstable_system.fill, fill = _ref2$unstable_system3 === void 0 ? "opaque" : _ref2$unstable_system3, system = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref2$unstable_system, [
        "palette",
        "fill"
    ]), options = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref2, [
        "unstable_system"
    ]);
    var parentOrientation = (0, $57da6a40a504e45b$export$fae74005e78b1a27)($22146f72899927a4$var$OrientationContext);
    var unstable_system = (0, $02cc76477a676705$export$71511d61b312f219)({
        palette: palette,
        fill: fill
    }, system);
    var transform = ((_options$unstable_pop = options.unstable_popoverStyles) === null || _options$unstable_pop === void 0 ? void 0 : _options$unstable_pop.transform) || "";
    if (parentOrientation === "vertical" && options.orientation === "vertical") return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, options), {}, {
        unstable_system: unstable_system,
        unstable_popoverStyles: (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, options.unstable_popoverStyles), {}, {
            transform: transform + " translate3d(0px, -0.3em, 0px)"
        })
    });
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, options), {}, {
        unstable_system: unstable_system
    });
}
function $22146f72899927a4$export$b153111b71479593(options, _ref3) {
    if (_ref3 === void 0) _ref3 = {};
    var _ref4 = _ref3, htmlWrapElement = _ref4.wrapElement, htmlProps = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref4, [
        "wrapElement"
    ]);
    var menu = (0, $8111161d651b62d7$export$dbf350e5966cf602)($22146f72899927a4$var$_templateObject3());
    var wrapElement = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(element) {
        if (htmlWrapElement) element = htmlWrapElement(element);
        return /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)($22146f72899927a4$var$OrientationContext.Provider, {
            value: options.orientation
        }, element);
    }, [
        htmlWrapElement,
        options.orientation
    ]);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        wrapElement: wrapElement,
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(menu, htmlProps.className)
    });
}
function $22146f72899927a4$export$ea8b283fe2916b5(options, _ref5) {
    if (_ref5 === void 0) _ref5 = {};
    var _ref6 = _ref5, children = _ref6.children, htmlProps = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref6, [
        "children"
    ]);
    var placement = options.unstable_originalPlacement || options.placement;
    var dir = placement ? placement.split("-")[0] : undefined;
    var svg = dir ? ({
        top: /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)("svg", {
            viewBox: "0 0 50 43.3"
        }, /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)("polygon", {
            points: "25 0 0 43.3 50 43.3 25 0"
        })),
        bottom: /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)("svg", {
            viewBox: "0 0 50 43.3"
        }, /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)("polygon", {
            points: "25 43.3 50 0 0 0 25 43.3"
        })),
        right: /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)("svg", {
            viewBox: "0 0 43.3 50"
        }, /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)("polygon", {
            points: "43.3 25 0 0 0 50 43.3 25"
        })),
        left: /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)("svg", {
            viewBox: "0 0 43.3 50"
        }, /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)("polygon", {
            points: "0 25 43.3 50 43.3 0 0 25"
        }))
    })[dir] : null;
    var menuButton = (0, $8111161d651b62d7$export$dbf350e5966cf602)($22146f72899927a4$var$_templateObject4(), children && dir !== "left" && (0, $8111161d651b62d7$export$dbf350e5966cf602)($22146f72899927a4$var$_templateObject5()), dir === "left" ? "left" : "right", children && (0, $8111161d651b62d7$export$dbf350e5966cf602)($22146f72899927a4$var$_templateObject6(), dir === "left" ? "right" : "left"));
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        children: typeof children === "function" ? function(props) {
            var child = children(props);
            return /*#__PURE__*/ (0, $bdfb41ef79315c14$export$e530037191fcd5d7)(child, {
                children: /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)((0, $ea42db622452d33d$export$ffb0004e005737fa), null, child.props.children, svg)
            });
        } : /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)((0, $ea42db622452d33d$export$ffb0004e005737fa), null, children, svg),
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(menuButton, htmlProps.className)
    });
}
function $22146f72899927a4$export$11c2aa43dc65207e(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var menuItemCheckbox = (0, $8111161d651b62d7$export$dbf350e5966cf602)($22146f72899927a4$var$_templateObject7());
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(menuItemCheckbox, htmlProps.className)
    });
}
function $22146f72899927a4$export$d0c391992b4eae04(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var menuItemRadio = (0, $8111161d651b62d7$export$dbf350e5966cf602)($22146f72899927a4$var$_templateObject8());
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(menuItemRadio, htmlProps.className)
    });
}
function $22146f72899927a4$export$11dce7ee08b8d827(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var menuGroup = (0, $8111161d651b62d7$export$dbf350e5966cf602)($22146f72899927a4$var$_templateObject9());
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(menuGroup, htmlProps.className)
    });
}







function $82fc757264dcd41d$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    [data-arrow] {\n      background-color: transparent;\n      & .stroke {\n        fill: ",
        ";\n      }\n      & .fill {\n        fill: ",
        ";\n      }\n    }\n  "
    ]);
    $82fc757264dcd41d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $82fc757264dcd41d$export$6d6848c8bd243768(_ref) {
    var _ref$unstable_system = _ref.unstable_system;
    _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;
    var _ref$unstable_system$ = _ref$unstable_system.palette, palette = _ref$unstable_system$ === void 0 ? "background" : _ref$unstable_system$, _ref$unstable_system$2 = _ref$unstable_system.fill, fill = _ref$unstable_system$2 === void 0 ? "opaque" : _ref$unstable_system$2, system = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref$unstable_system, [
        "palette",
        "fill"
    ]), options = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref, [
        "unstable_system"
    ]);
    return (0, $02cc76477a676705$export$71511d61b312f219)({
        unstable_system: (0, $02cc76477a676705$export$71511d61b312f219)({
            palette: palette,
            fill: fill
        }, system)
    }, options);
}
function $82fc757264dcd41d$export$9894a48da7e080d3(_ref2, htmlProps) {
    var unstable_system = _ref2.unstable_system;
    if (htmlProps === void 0) htmlProps = {};
    var _usePaletteRoleProps = (0, $7e95edc6721571aa$export$892580369e97d8b9)({
        unstable_system: unstable_system
    }), backgroundColor = _usePaletteRoleProps.style.backgroundColor;
    var foreground = (0, $12674995b3f54524$export$8b22cf2602fb60ce)(backgroundColor) || "black";
    var borderColor = (0, $3498394efd2ba855$export$e715bdb8257bb45a)(foreground, 0.75);
    var popover = (0, $8111161d651b62d7$export$dbf350e5966cf602)($82fc757264dcd41d$var$_templateObject(), borderColor, backgroundColor);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(popover, htmlProps.className)
    });
}
function $82fc757264dcd41d$export$96a4bfbe89c45e2f(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    return (0, $02cc76477a676705$export$71511d61b312f219)({
        "data-arrow": ""
    }, htmlProps);
}






function $6fb5260fbfc1a327$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    border: 1px solid ",
        ";\n    border-width: 0 1px 0 0;\n    margin: 0 0.5em;\n    padding: 0;\n    width: 0;\n    height: auto;\n\n    &[aria-orientation=\"horizontal\"] {\n      border-width: 0 0 1px 0;\n      margin: 0.5em 0;\n      width: auto;\n      height: 0;\n    }\n  "
    ]);
    $6fb5260fbfc1a327$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6fb5260fbfc1a327$export$3b44d1c2c69cb7f5(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var foreground = (0, $12674995b3f54524$export$4368d992c4eafac0)("foreground") || "black";
    var borderColor = (0, $3498394efd2ba855$export$e715bdb8257bb45a)(foreground, 0.75);
    var separator = (0, $8111161d651b62d7$export$dbf350e5966cf602)($6fb5260fbfc1a327$var$_templateObject(), borderColor);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(separator, htmlProps.className)
    });
}






function $6d8e0bbb9c45995a$var$_templateObject2() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    display: flex;\n    flex-direction: row;\n    border: 1px solid ",
        ";\n    border-width: 0 0 1px 0;\n    margin: 0 0 1em 0;\n\n    &[aria-orientation=\"vertical\"] {\n      flex-direction: column;\n      border-width: 0 1px 0 0;\n      margin: 0 1em 0 0;\n    }\n  "
    ]);
    $6d8e0bbb9c45995a$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $6d8e0bbb9c45995a$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    background-color: transparent;\n    border: 1px solid transparent;\n    border-width: 1px 1px 0 1px;\n    border-radius: 0.25rem 0.25rem 0 0;\n    font-size: 100%;\n    padding: 0.5em 1em;\n    margin: 0 0 -1px 0;\n\n    &[aria-selected=\"true\"] {\n      background-color: ",
        ";\n      border-color: ",
        ";\n    }\n\n    [aria-orientation=\"vertical\"] & {\n      border-width: 1px 0 1px 1px;\n      border-radius: 0.2em 0 0 0.2em;\n      margin: 0 -1px 0 0;\n    }\n  "
    ]);
    $6d8e0bbb9c45995a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6d8e0bbb9c45995a$export$ce8ed76f6a6f3a9c(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var background = (0, $12674995b3f54524$export$4368d992c4eafac0)("background") || "white";
    var foreground = (0, $12674995b3f54524$export$4368d992c4eafac0)("foreground") || "black";
    var borderColor = (0, $3498394efd2ba855$export$e715bdb8257bb45a)(foreground, 0.75);
    var tab = (0, $8111161d651b62d7$export$dbf350e5966cf602)($6d8e0bbb9c45995a$var$_templateObject(), background, borderColor);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(tab, htmlProps.className)
    });
}
function $6d8e0bbb9c45995a$export$2bb4e085cbcbb486(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var foreground = (0, $12674995b3f54524$export$4368d992c4eafac0)("foreground") || "black";
    var borderColor = (0, $3498394efd2ba855$export$e715bdb8257bb45a)(foreground, 0.75);
    var tabList = (0, $8111161d651b62d7$export$dbf350e5966cf602)($6d8e0bbb9c45995a$var$_templateObject2(), borderColor);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(tabList, htmlProps.className)
    });
}












function $3526031a374f7053$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    &:not([type=\"checkbox\"]):not([type=\"radio\"]) {\n      transition: box-shadow 0.15s ease-in-out;\n      outline: 0;\n\n      &:focus {\n        box-shadow: 0 0 0 0.2em ",
        ";\n        position: relative;\n        z-index: 2;\n      }\n\n      &:hover {\n        z-index: 2;\n      }\n    }\n\n    &[aria-disabled=\"true\"] {\n      opacity: 0.5;\n    }\n  "
    ]);
    $3526031a374f7053$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3526031a374f7053$export$c1e480d26196c039(_ref, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var _ref$unstable_system = _ref.unstable_system;
    _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;
    var _ref$unstable_system$ = _ref$unstable_system.palette, palette = _ref$unstable_system$ === void 0 ? "primary" : _ref$unstable_system$, system = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref$unstable_system, [
        "palette"
    ]);
    var _usePaletteRoleProps = (0, $7e95edc6721571aa$export$892580369e97d8b9)({
        unstable_system: (0, $02cc76477a676705$export$71511d61b312f219)({
            palette: palette
        }, system)
    }), _usePaletteRoleProps$ = _usePaletteRoleProps.style, color = _usePaletteRoleProps$.color, backgroundColor = _usePaletteRoleProps$.backgroundColor;
    var dark = (0, $12674995b3f54524$export$4368d992c4eafac0)("dark") || "black";
    var background = (0, $12674995b3f54524$export$4368d992c4eafac0)("background") || "white";
    var backgroundIsLight = (0, $57f8d1a499533103$export$a61f0bf17cb3496d)(background);
    var strokeColor = backgroundColor || color || dark;
    var contrastRatio = (0, $12674995b3f54524$export$3b14a55fb2447963)(background, strokeColor);
    var darker = (0, $f4ac79dbc80dea1e$export$93a74b4058f261f6)(strokeColor, contrastRatio < 1.2 ? 0.25 : 0);
    var lighter = (0, $551d7d5382e08dca$export$15228a9d7f479658)(strokeColor, contrastRatio < 1.2 ? 0.25 : 0);
    var boxShadowColor = (0, $3498394efd2ba855$export$e715bdb8257bb45a)(backgroundIsLight ? darker : lighter, 0.6);
    var tabbable = (0, $8111161d651b62d7$export$dbf350e5966cf602)($3526031a374f7053$var$_templateObject(), boxShadowColor);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(tabbable, htmlProps.className)
    });
}




function $17ba52db41bbd2db$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    display: flex;\n    flex-direction: row;\n\n    & > *:not(:first-child) {\n      margin: 0 0 0 0.5em;\n    }\n\n    &[aria-orientation=\"vertical\"] {\n      display: inline-flex;\n      flex-direction: column;\n\n      & > *:not(:first-child) {\n        margin: 0.5em 0 0;\n      }\n    }\n  "
    ]);
    $17ba52db41bbd2db$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $17ba52db41bbd2db$export$96559db3560d1ff9(_, htmlProps) {
    if (htmlProps === void 0) htmlProps = {};
    var toolbar = (0, $8111161d651b62d7$export$dbf350e5966cf602)($17ba52db41bbd2db$var$_templateObject());
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(toolbar, htmlProps.className)
    });
}






function $3f5b87f04d8aee83$var$_templateObject() {
    var data = (0, $02cc76477a676705$export$407448d2b89b1813)([
        "\n    background-color: ",
        ";\n    font-size: 0.8em;\n    padding: 0.5rem;\n    border-radius: 0.25rem;\n    z-index: 999;\n\n    [data-arrow] {\n      background-color: transparent;\n      & .stroke {\n        fill: transparent;\n      }\n      & .fill {\n        fill: ",
        ";\n      }\n    }\n  "
    ]);
    $3f5b87f04d8aee83$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3f5b87f04d8aee83$export$c73063dc147944c8(_ref) {
    var _ref$unstable_system = _ref.unstable_system;
    _ref$unstable_system = _ref$unstable_system === void 0 ? {} : _ref$unstable_system;
    var _ref$unstable_system$ = _ref$unstable_system.palette, palette = _ref$unstable_system$ === void 0 ? "foreground" : _ref$unstable_system$, _ref$unstable_system$2 = _ref$unstable_system.fill, fill = _ref$unstable_system$2 === void 0 ? "opaque" : _ref$unstable_system$2, system = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref$unstable_system, [
        "palette",
        "fill"
    ]), options = (0, $02cc76477a676705$export$8b22cf2602fb60ce)(_ref, [
        "unstable_system"
    ]);
    return (0, $02cc76477a676705$export$71511d61b312f219)({
        unstable_system: (0, $02cc76477a676705$export$71511d61b312f219)({
            palette: palette,
            fill: fill
        }, system)
    }, options);
}
function $3f5b87f04d8aee83$export$abe748937894d745(_ref2, htmlProps) {
    var unstable_system = _ref2.unstable_system;
    if (htmlProps === void 0) htmlProps = {};
    var _usePaletteRoleProps = (0, $7e95edc6721571aa$export$892580369e97d8b9)({
        unstable_system: unstable_system
    }), backgroundColor = _usePaletteRoleProps.style.backgroundColor;
    var fadeBackgroundColor = (0, $3498394efd2ba855$export$e715bdb8257bb45a)(backgroundColor || "black", 0.1);
    var tooltip = (0, $8111161d651b62d7$export$dbf350e5966cf602)($3f5b87f04d8aee83$var$_templateObject(), fadeBackgroundColor, fadeBackgroundColor);
    return (0, $02cc76477a676705$export$71511d61b312f219)((0, $02cc76477a676705$export$71511d61b312f219)({}, htmlProps), {}, {
        className: (0, $8111161d651b62d7$export$a274e22fb40f762e)(tooltip, htmlProps.className)
    });
}






var $8Bufz = parcelRequire("8Bufz");
var $b9019a197d43f8d7$exports = {};
'use strict';

$b9019a197d43f8d7$exports = (parcelRequire("1a2vA"));



var $749ac39b276f781f$exports = {};
//

var $8Bufz = parcelRequire("8Bufz");
$749ac39b276f781f$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $8Bufz._)(objA)) !== "object" || !objA || (typeof objB === "undefined" ? "undefined" : (0, $8Bufz._)(objB)) !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};




function $f51e10bc7a82bf32$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $6395322bac4d15d7$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $6395322bac4d15d7$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $f51e10bc7a82bf32$export$2e2bcd8739ae039)(function(prop) {
    return $6395322bac4d15d7$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $99581c72c41376f4$exports = {};
'use strict';
var $1666c0917e5f8222$exports = {};
'use strict';

$1666c0917e5f8222$exports = (parcelRequire("8332w"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $99581c72c41376f4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $99581c72c41376f4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $99581c72c41376f4$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $99581c72c41376f4$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $99581c72c41376f4$var$TYPE_STATICS = {};
$99581c72c41376f4$var$TYPE_STATICS[$1666c0917e5f8222$exports.ForwardRef] = $99581c72c41376f4$var$FORWARD_REF_STATICS;
$99581c72c41376f4$var$TYPE_STATICS[$1666c0917e5f8222$exports.Memo] = $99581c72c41376f4$var$MEMO_STATICS;
function $99581c72c41376f4$var$getStatics(component) {
    // React v16.11 and below
    if ($1666c0917e5f8222$exports.isMemo(component)) return $99581c72c41376f4$var$MEMO_STATICS;
     // React v16.12 and above
    return $99581c72c41376f4$var$TYPE_STATICS[component['$$typeof']] || $99581c72c41376f4$var$REACT_STATICS;
}
var $99581c72c41376f4$var$defineProperty = Object.defineProperty;
var $99581c72c41376f4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $99581c72c41376f4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $99581c72c41376f4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $99581c72c41376f4$var$getPrototypeOf = Object.getPrototypeOf;
var $99581c72c41376f4$var$objectPrototype = Object.prototype;
function $99581c72c41376f4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($99581c72c41376f4$var$objectPrototype) {
            var inheritedComponent = $99581c72c41376f4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $99581c72c41376f4$var$objectPrototype) $99581c72c41376f4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $99581c72c41376f4$var$getOwnPropertyNames(sourceComponent);
        if ($99581c72c41376f4$var$getOwnPropertySymbols) keys = keys.concat($99581c72c41376f4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $99581c72c41376f4$var$getStatics(targetComponent);
        var sourceStatics = $99581c72c41376f4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$99581c72c41376f4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $99581c72c41376f4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $99581c72c41376f4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$99581c72c41376f4$exports = $99581c72c41376f4$var$hoistNonReactStatics;


function $65d8fecb296fd70d$var$y() {
    return ($65d8fecb296fd70d$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var _$r in n)Object.prototype.hasOwnProperty.call(n, _$r) && (e[_$r] = n[_$r]);
        }
        return e;
    }).apply(this, arguments);
}
var $65d8fecb296fd70d$var$v = function v(e, t) {
    for(var n = [
        e[0]
    ], _$r = 0, o = t.length; _$r < o; _$r += 1)n.push(t[_$r], e[_$r + 1]);
    return n;
}, $65d8fecb296fd70d$var$g = function g(t) {
    return null !== t && "object" == (typeof t === "undefined" ? "undefined" : (0, $8Bufz._)(t)) && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $b9019a197d43f8d7$exports.typeOf)(t);
}, $65d8fecb296fd70d$var$S = Object.freeze([]), $65d8fecb296fd70d$var$w = Object.freeze({});
function $65d8fecb296fd70d$var$E(e) {
    return "function" == typeof e;
}
function $65d8fecb296fd70d$var$b(e) {
    return e.displayName || e.name || "Component";
}
function $65d8fecb296fd70d$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $65d8fecb296fd70d$var$N = "data-styled", $65d8fecb296fd70d$export$83d89fbfd8236492 = "5.3.11", $65d8fecb296fd70d$var$C = "undefined" != typeof window && "HTMLElement" in window, $65d8fecb296fd70d$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $65d8fecb296fd70d$var$P = {}, $65d8fecb296fd70d$var$O = {};
function $65d8fecb296fd70d$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, _$r = arguments.length; n < _$r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $65d8fecb296fd70d$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), _$r = 1; _$r < t; _$r++)n[_$r - 1] = arguments[_$r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $65d8fecb296fd70d$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, _$r = n.length, o = _$r; e >= o;)(o <<= 1) < 0 && $65d8fecb296fd70d$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = _$r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), _$r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < _$r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], _$r = this.indexOfGroup(e), o = _$r + n, s = _$r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $65d8fecb296fd70d$var$T = new Map, $65d8fecb296fd70d$var$x = new Map, $65d8fecb296fd70d$var$k = 1, $65d8fecb296fd70d$var$V = function V(e) {
    if ($65d8fecb296fd70d$var$T.has(e)) return $65d8fecb296fd70d$var$T.get(e);
    for(; $65d8fecb296fd70d$var$x.has($65d8fecb296fd70d$var$k);)$65d8fecb296fd70d$var$k++;
    var t = $65d8fecb296fd70d$var$k++;
    return $65d8fecb296fd70d$var$T.set(e, t), $65d8fecb296fd70d$var$x.set(t, e), t;
}, $65d8fecb296fd70d$var$B = function B(e) {
    return $65d8fecb296fd70d$var$x.get(e);
}, $65d8fecb296fd70d$var$z = function z(e, t) {
    t >= $65d8fecb296fd70d$var$k && ($65d8fecb296fd70d$var$k = t + 1), $65d8fecb296fd70d$var$T.set(e, t), $65d8fecb296fd70d$var$x.set(t, e);
}, $65d8fecb296fd70d$var$M = "style[" + $65d8fecb296fd70d$var$N + '][data-styled-version="5.3.11"]', $65d8fecb296fd70d$var$G = new RegExp("^" + $65d8fecb296fd70d$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $65d8fecb296fd70d$var$L = function L(e, t, n) {
    for(var _$r, o = n.split(","), s = 0, i = o.length; s < i; s++)(_$r = o[s]) && e.registerName(t, _$r);
}, $65d8fecb296fd70d$var$F = function F(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), _$r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($65d8fecb296fd70d$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($65d8fecb296fd70d$var$z(u, c), $65d8fecb296fd70d$var$L(e, u, a[3]), e.getTag().insertRules(c, _$r)), _$r.length = 0;
            } else _$r.push(i);
        }
    }
}, $65d8fecb296fd70d$var$Y = function Y() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $65d8fecb296fd70d$var$q = function q(e) {
    var t = document.head, n = e || t, _$r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var _$r = t[n];
            if (_$r && 1 === _$r.nodeType && _$r.hasAttribute($65d8fecb296fd70d$var$N)) return _$r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    _$r.setAttribute($65d8fecb296fd70d$var$N, "active"), _$r.setAttribute("data-styled-version", "5.3.11");
    var i = $65d8fecb296fd70d$var$Y();
    return i && _$r.setAttribute("nonce", i), n.insertBefore(_$r, s), _$r;
}, $65d8fecb296fd70d$var$H = function() {
    function e(e) {
        var t = this.element = $65d8fecb296fd70d$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, _$r = t.length; n < _$r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $65d8fecb296fd70d$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $65d8fecb296fd70d$var$$ = function() {
    function e(e) {
        var t = this.element = $65d8fecb296fd70d$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), _$r = this.nodes[e];
            return this.element.insertBefore(n, _$r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $65d8fecb296fd70d$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $65d8fecb296fd70d$var$U = $65d8fecb296fd70d$var$C, $65d8fecb296fd70d$var$J = {
    isServer: !$65d8fecb296fd70d$var$C,
    useCSSOMInjection: !$65d8fecb296fd70d$var$I
}, $65d8fecb296fd70d$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $65d8fecb296fd70d$var$w), void 0 === t && (t = {}), this.options = $65d8fecb296fd70d$var$y({}, $65d8fecb296fd70d$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $65d8fecb296fd70d$var$C && $65d8fecb296fd70d$var$U && ($65d8fecb296fd70d$var$U = !1, function(e) {
            for(var _$t = document.querySelectorAll($65d8fecb296fd70d$var$M), _$n = 0, _$r = _$t.length; _$n < _$r; _$n++){
                var o = _$t[_$n];
                o && "active" !== o.getAttribute($65d8fecb296fd70d$var$N) && ($65d8fecb296fd70d$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $65d8fecb296fd70d$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($65d8fecb296fd70d$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var _$e, t, n, _$r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, _$r = t.useCSSOMInjection, o = t.target, _$e = n ? new $65d8fecb296fd70d$var$W(o) : _$r ? new $65d8fecb296fd70d$var$H(o) : new $65d8fecb296fd70d$var$$(o), new $65d8fecb296fd70d$var$j(_$e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($65d8fecb296fd70d$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($65d8fecb296fd70d$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($65d8fecb296fd70d$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, _$r = "", o = 0; o < n; o++){
                var s = $65d8fecb296fd70d$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $65d8fecb296fd70d$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), _$r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return _$r;
        }(this);
    }, e;
}(), $65d8fecb296fd70d$var$Z = /(a)(d)/gi, $65d8fecb296fd70d$var$K = function K(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $65d8fecb296fd70d$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $65d8fecb296fd70d$var$K(t % 52) + n;
    return ($65d8fecb296fd70d$var$K(t % 52) + n).replace($65d8fecb296fd70d$var$Z, "$1-$2");
}
var $65d8fecb296fd70d$var$ee = function ee(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $65d8fecb296fd70d$var$te = function te(e) {
    return $65d8fecb296fd70d$var$ee(5381, e);
};
function $65d8fecb296fd70d$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($65d8fecb296fd70d$var$E(n) && !$65d8fecb296fd70d$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $65d8fecb296fd70d$var$re = $65d8fecb296fd70d$var$te("5.3.11"), $65d8fecb296fd70d$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $65d8fecb296fd70d$var$ne(e), this.componentId = t, this.baseHash = $65d8fecb296fd70d$var$ee($65d8fecb296fd70d$var$re, t), this.baseStyle = n, $65d8fecb296fd70d$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var _$r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(_$r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $65d8fecb296fd70d$var$_e(this.rules, e, t, n).join(""), i = $65d8fecb296fd70d$var$Q($65d8fecb296fd70d$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(_$r, i)) {
                    var a = n(s, "." + i, void 0, _$r);
                    t.insertRules(_$r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $65d8fecb296fd70d$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $65d8fecb296fd70d$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $65d8fecb296fd70d$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $65d8fecb296fd70d$var$Q(u >>> 0);
                if (!t.hasNameForId(_$r, m)) {
                    var y = n(l, "." + m, void 0, _$r);
                    t.insertRules(_$r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $65d8fecb296fd70d$var$se = /^\s*\/\/.*$/gm, $65d8fecb296fd70d$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $65d8fecb296fd70d$var$ae(e) {
    var t, n, _$r, o, s = void 0 === e ? $65d8fecb296fd70d$var$w : e, i = s.options, a = void 0 === i ? $65d8fecb296fd70d$var$w : i, c = s.plugins, u = void 0 === c ? $65d8fecb296fd70d$var$S : c, l = new (0, $a7cf5c93424be209$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function f(e, r, s) {
        return 0 === r && -1 !== $65d8fecb296fd70d$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($65d8fecb296fd70d$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, _$r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(_$r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $65d8fecb296fd70d$var$D(15), $65d8fecb296fd70d$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $65d8fecb296fd70d$export$8c190ef828af4c86 = (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).createContext(), $65d8fecb296fd70d$export$91317688fc694efa = $65d8fecb296fd70d$export$8c190ef828af4c86.Consumer, $65d8fecb296fd70d$var$le = (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).createContext(), $65d8fecb296fd70d$var$de = ($65d8fecb296fd70d$var$le.Consumer, new $65d8fecb296fd70d$var$X), $65d8fecb296fd70d$var$he = $65d8fecb296fd70d$var$ae();
function $65d8fecb296fd70d$var$pe() {
    return (0, $57da6a40a504e45b$export$fae74005e78b1a27)($65d8fecb296fd70d$export$8c190ef828af4c86) || $65d8fecb296fd70d$var$de;
}
function $65d8fecb296fd70d$var$fe() {
    return (0, $57da6a40a504e45b$export$fae74005e78b1a27)($65d8fecb296fd70d$var$le) || $65d8fecb296fd70d$var$he;
}
function $65d8fecb296fd70d$export$a473771da2f0ff7c(e) {
    var t = (0, $57da6a40a504e45b$export$60241385465d0a34)(e.stylisPlugins), n = t[0], s = t[1], c = $65d8fecb296fd70d$var$pe(), u = (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        return $65d8fecb296fd70d$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($749ac39b276f781f$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).createElement($65d8fecb296fd70d$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).createElement($65d8fecb296fd70d$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $65d8fecb296fd70d$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $65d8fecb296fd70d$var$he);
            var _$r = n.name + t.hash;
            e.hasNameForId(n.id, _$r) || e.insertRules(n.id, _$r, t(n.rules, _$r, "@keyframes"));
        }, this.toString = function() {
            return $65d8fecb296fd70d$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $65d8fecb296fd70d$var$he), this.name + e.hash;
    }, e;
}(), $65d8fecb296fd70d$var$ve = /([A-Z])/, $65d8fecb296fd70d$var$ge = /([A-Z])/g, $65d8fecb296fd70d$var$Se = /^ms-/, $65d8fecb296fd70d$var$we = function we(e) {
    return "-" + e.toLowerCase();
};
function $65d8fecb296fd70d$var$Ee(e) {
    return $65d8fecb296fd70d$var$ve.test(e) ? e.replace($65d8fecb296fd70d$var$ge, $65d8fecb296fd70d$var$we).replace($65d8fecb296fd70d$var$Se, "-ms-") : e;
}
var $65d8fecb296fd70d$var$be = function be(e) {
    return null == e || !1 === e || "" === e;
};
function $65d8fecb296fd70d$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $65d8fecb296fd70d$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($65d8fecb296fd70d$var$be(e)) return "";
    if ($65d8fecb296fd70d$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($65d8fecb296fd70d$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $65d8fecb296fd70d$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $65d8fecb296fd70d$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $65d8fecb296fd70d$var$g(e) ? function e(t, n) {
        var _$r, _$o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$65d8fecb296fd70d$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $65d8fecb296fd70d$var$E(t[i]) ? s.push($65d8fecb296fd70d$var$Ee(i) + ":", t[i], ";") : $65d8fecb296fd70d$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($65d8fecb296fd70d$var$Ee(i) + ": " + (_$r = i, null == (_$o = t[i]) || "boolean" == typeof _$o || "" === _$o ? "" : "number" != typeof _$o || 0 === _$o || _$r in (0, $e35f33dfb22639f5$export$2e2bcd8739ae039) || _$r.startsWith("--") ? String(_$o).trim() : _$o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $65d8fecb296fd70d$var$Ne = function Ne(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $65d8fecb296fd70d$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), _$r = 1; _$r < t; _$r++)n[_$r - 1] = arguments[_$r];
    return $65d8fecb296fd70d$var$E(e) || $65d8fecb296fd70d$var$g(e) ? $65d8fecb296fd70d$var$Ne($65d8fecb296fd70d$var$_e($65d8fecb296fd70d$var$v($65d8fecb296fd70d$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $65d8fecb296fd70d$var$Ne($65d8fecb296fd70d$var$_e($65d8fecb296fd70d$var$v(e, n)));
}
var $65d8fecb296fd70d$var$Ce = /invalid hook call/i, $65d8fecb296fd70d$var$Ie = new Set, $65d8fecb296fd70d$var$Pe = function Pe(e, t) {
    var n, _$r, o, e1;
}, $65d8fecb296fd70d$var$Oe = function Oe(e, t, n) {
    return void 0 === n && (n = $65d8fecb296fd70d$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $65d8fecb296fd70d$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $65d8fecb296fd70d$var$De = /(^-|-$)/g;
function $65d8fecb296fd70d$var$je(e) {
    return e.replace($65d8fecb296fd70d$var$Re, "-").replace($65d8fecb296fd70d$var$De, "");
}
var $65d8fecb296fd70d$var$Te = function Te(e) {
    return $65d8fecb296fd70d$var$Q($65d8fecb296fd70d$var$te(e) >>> 0);
};
function $65d8fecb296fd70d$var$xe(e) {
    return "string" == typeof e && true;
}
var $65d8fecb296fd70d$var$ke = function ke(e) {
    return "function" == typeof e || "object" == (typeof e === "undefined" ? "undefined" : (0, $8Bufz._)(e)) && null !== e && !Array.isArray(e);
}, $65d8fecb296fd70d$var$Ve = function Ve(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $65d8fecb296fd70d$var$Be(e, t, n) {
    var _$r = e[n];
    $65d8fecb296fd70d$var$ke(t) && $65d8fecb296fd70d$var$ke(_$r) ? $65d8fecb296fd70d$var$ze(_$r, t) : e[n] = t;
}
function $65d8fecb296fd70d$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), _$r = 1; _$r < t; _$r++)n[_$r - 1] = arguments[_$r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($65d8fecb296fd70d$var$ke(i)) for(var a in i)$65d8fecb296fd70d$var$Ve(a) && $65d8fecb296fd70d$var$Be(e, i[a], a);
    }
    return e;
}
var $65d8fecb296fd70d$export$2c657da244d00bd6 = (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).createContext(), $65d8fecb296fd70d$export$b631efc24e9d5e2f = $65d8fecb296fd70d$export$2c657da244d00bd6.Consumer;
function $65d8fecb296fd70d$export$d8964aec282183a3(e) {
    var t = (0, $57da6a40a504e45b$export$fae74005e78b1a27)($65d8fecb296fd70d$export$2c657da244d00bd6), n = (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        return function(e, t) {
            if (!e) return $65d8fecb296fd70d$var$D(14);
            if ($65d8fecb296fd70d$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != (typeof e === "undefined" ? "undefined" : (0, $8Bufz._)(e)) ? $65d8fecb296fd70d$var$D(8) : t ? $65d8fecb296fd70d$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).createElement($65d8fecb296fd70d$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $65d8fecb296fd70d$var$Fe = {};
function $65d8fecb296fd70d$var$Ye(e, t, n) {
    var o = $65d8fecb296fd70d$export$7ba318d8d2f06c76(e), i = !$65d8fecb296fd70d$var$xe(e), a = t.attrs, c = void 0 === a ? $65d8fecb296fd70d$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var _$n = "string" != typeof e ? "sc" : $65d8fecb296fd70d$var$je(e);
        $65d8fecb296fd70d$var$Fe[_$n] = ($65d8fecb296fd70d$var$Fe[_$n] || 0) + 1;
        var _$r = _$n + "-" + $65d8fecb296fd70d$var$Te("5.3.11" + _$n + $65d8fecb296fd70d$var$Fe[_$n]);
        return t ? t + "-" + _$r : _$r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $65d8fecb296fd70d$var$xe(e) ? "styled." + e : "Styled(" + $65d8fecb296fd70d$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $65d8fecb296fd70d$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function N(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $65d8fecb296fd70d$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function P(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $65d8fecb296fd70d$var$w);
                var _$r = $65d8fecb296fd70d$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var _$t, _$n, _$s, i = e;
                    for(_$t in $65d8fecb296fd70d$var$E(i) && (i = i(_$r)), i)_$r[_$t] = o[_$t] = "className" === _$t ? (_$n = o[_$t], _$s = i[_$t], _$n && _$s ? _$n + " " + _$s : _$n || _$s) : i[_$t];
                }), [
                    _$r,
                    o
                ];
            }($65d8fecb296fd70d$var$Oe(t, (0, $57da6a40a504e45b$export$fae74005e78b1a27)($65d8fecb296fd70d$export$2c657da244d00bd6), a) || $65d8fecb296fd70d$var$w, t, o), _$m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $65d8fecb296fd70d$var$pe(), _$s = $65d8fecb296fd70d$var$fe(), i = t ? e.generateAndInjectStyles($65d8fecb296fd70d$var$w, o, _$s) : e.generateAndInjectStyles(n, o, _$s);
                return i;
            }(i, r, _$m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _$_ = $65d8fecb296fd70d$var$xe(b), N = v !== t ? $65d8fecb296fd70d$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $6395322bac4d15d7$export$2e2bcd8739ae039), b) : !_$_ || (0, $6395322bac4d15d7$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $65d8fecb296fd70d$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $ea42db622452d33d$export$c8a8987d4410bf2d)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $65d8fecb296fd70d$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var _$r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var _$n, _$r, o = {}, s = Object.keys(e);
            for(_$r = 0; _$r < s.length; _$r++)_$n = s[_$r], t.indexOf(_$n) >= 0 || (o[_$n] = e[_$n]);
            return o;
        }(t, [
            "componentId"
        ]), s = _$r && _$r + "-" + ($65d8fecb296fd70d$var$xe(e) ? e : $65d8fecb296fd70d$var$je($65d8fecb296fd70d$var$b(e)));
        return $65d8fecb296fd70d$var$Ye(e, $65d8fecb296fd70d$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function get() {
            return this._foldedDefaultProps;
        },
        set: function set(t) {
            this._foldedDefaultProps = o ? $65d8fecb296fd70d$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function value() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($99581c72c41376f4$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $65d8fecb296fd70d$var$qe = function qe(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $65d8fecb296fd70d$var$w), !(0, $b9019a197d43f8d7$exports.isValidElementType)(r)) return $65d8fecb296fd70d$var$D(1, String(r));
        var s = function s() {
            return t(r, o, $65d8fecb296fd70d$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $65d8fecb296fd70d$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $65d8fecb296fd70d$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($65d8fecb296fd70d$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $65d8fecb296fd70d$var$qe[e] = $65d8fecb296fd70d$var$qe(e);
});
var $65d8fecb296fd70d$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $65d8fecb296fd70d$var$ne(e), $65d8fecb296fd70d$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($65d8fecb296fd70d$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $65d8fecb296fd70d$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $65d8fecb296fd70d$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $65d8fecb296fd70d$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $65d8fecb296fd70d$var$Te(JSON.stringify(i)), u = new $65d8fecb296fd70d$var$He(i, a);
    function d(e) {
        var t = $65d8fecb296fd70d$var$pe(), n = $65d8fecb296fd70d$var$fe(), o = (0, $57da6a40a504e45b$export$fae74005e78b1a27)($65d8fecb296fd70d$export$2c657da244d00bd6), _$d = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(t.allocateGSInstance(a)).current;
        return t.server && h(_$d, e, t, o, n), (0, $57da6a40a504e45b$export$e5c5a5f917a5871c)(function() {
            if (!t.server) return h(_$d, e, t, o, n), function() {
                return u.removeStyles(_$d, t);
            };
        }, [
            _$d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $65d8fecb296fd70d$var$P, n, o);
        else {
            var s = $65d8fecb296fd70d$var$y({}, t, {
                theme: $65d8fecb296fd70d$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).memo(d);
}
function $65d8fecb296fd70d$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), _$r = 1; _$r < t; _$r++)n[_$r - 1] = arguments[_$r];
    var o = $65d8fecb296fd70d$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $65d8fecb296fd70d$var$Te(o);
    return new $65d8fecb296fd70d$var$ye(s, o);
}
var $65d8fecb296fd70d$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var _$e = this;
        this._emitSheetCSS = function() {
            var t = _$e.instance.toString();
            if (!t) return "";
            var n = $65d8fecb296fd70d$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $65d8fecb296fd70d$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return _$e.sealed ? $65d8fecb296fd70d$var$D(2) : _$e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (_$e.sealed) return $65d8fecb296fd70d$var$D(2);
            var n = ((t = {})[$65d8fecb296fd70d$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: _$e.instance.toString()
            }, t), o = $65d8fecb296fd70d$var$Y();
            return o && (n.nonce = o), [
                (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).createElement("style", $65d8fecb296fd70d$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            _$e.sealed = !0;
        }, this.instance = new $65d8fecb296fd70d$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $65d8fecb296fd70d$var$D(2) : (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).createElement($65d8fecb296fd70d$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $65d8fecb296fd70d$var$D(3);
    }, e;
}(), $65d8fecb296fd70d$export$e8748c6a27b910dc = function Je(e) {
    var t = (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).forwardRef(function(t, n) {
        var o = (0, $57da6a40a504e45b$export$fae74005e78b1a27)($65d8fecb296fd70d$export$2c657da244d00bd6), i = e.defaultProps, a = $65d8fecb296fd70d$var$Oe(t, o, i);
        return (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).createElement(e, $65d8fecb296fd70d$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($99581c72c41376f4$exports)))(t, e), t.displayName = "WithTheme(" + $65d8fecb296fd70d$var$b(e) + ")", t;
}, $65d8fecb296fd70d$export$93d4e7f90805808f = function Xe() {
    return (0, $57da6a40a504e45b$export$fae74005e78b1a27)($65d8fecb296fd70d$export$2c657da244d00bd6);
}, $65d8fecb296fd70d$export$5c87cfe6c475f500 = {
    StyleSheet: $65d8fecb296fd70d$var$X,
    masterSheet: $65d8fecb296fd70d$var$de
};
var $65d8fecb296fd70d$export$2e2bcd8739ae039 = $65d8fecb296fd70d$var$qe;


var $1c0ec2afc2d69abf$export$2e2bcd8739ae039 = (0, $65d8fecb296fd70d$export$f0f03736edb61697)([
    "*,*:after,*:before{box-sizing:border-box;}[hidden]{display:none;}button,[type='button'],[type='reset'],[type='submit']{cursor:pointer;font-family:inherit;line-height:inherit;transition:background-color 0.2s ease-in-out;}img{border-style:none;}html,body{border:0;color:#303030;height:100%;font:inherit;font-size:100%;font-weight:400;line-height:1.15;margin:0;padding:0;-webkit-text-size-adjust:100%;}body{font-family:Montserrat;line-height:1;}button,button:active,button:focus{outline:none;}"
]);



var $8Bufz = parcelRequire("8Bufz");
var $9789429064ccdb9f$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9789429064ccdb9f$var$ReactIs, $9789429064ccdb9f$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$9789429064ccdb9f$exports = (parcelRequire("40Ck8"))();


var $6f994d488ff986c5$exports = {};

var $8Bufz = parcelRequire("8Bufz");
'use strict';
function $6f994d488ff986c5$var$_interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, $8Bufz._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $6f994d488ff986c5$var$React__default = $6f994d488ff986c5$var$_interopDefault($bdfb41ef79315c14$exports);
function $6f994d488ff986c5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6f994d488ff986c5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $6f994d488ff986c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $6f994d488ff986c5$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $6f994d488ff986c5$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $6f994d488ff986c5$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($bdfb41ef79315c14$exports.PureComponent);
        $6f994d488ff986c5$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $6f994d488ff986c5$var$_defineProperty(SideEffect, "canUseDOM", $6f994d488ff986c5$var$canUseDOM);
        return SideEffect;
    };
}
$6f994d488ff986c5$exports = $6f994d488ff986c5$var$withSideEffect;


var $cacd35a915e2ff57$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ 
var $8Bufz = parcelRequire("8Bufz");
var $cacd35a915e2ff57$var$hasElementType = typeof Element !== 'undefined';
var $cacd35a915e2ff57$var$hasMap = typeof Map === 'function';
var $cacd35a915e2ff57$var$hasSet = typeof Set === 'function';
var $cacd35a915e2ff57$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $cacd35a915e2ff57$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && (typeof a === "undefined" ? "undefined" : (0, $8Bufz._)(a)) == 'object' && (typeof b === "undefined" ? "undefined" : (0, $8Bufz._)(b)) == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$cacd35a915e2ff57$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($cacd35a915e2ff57$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$cacd35a915e2ff57$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($cacd35a915e2ff57$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($cacd35a915e2ff57$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($cacd35a915e2ff57$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$cacd35a915e2ff57$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$cacd35a915e2ff57$exports = function isEqual(a, b) {
    try {
        return $cacd35a915e2ff57$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $2729e5cb7b48bd36$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $2729e5cb7b48bd36$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $2729e5cb7b48bd36$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $2729e5cb7b48bd36$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $2729e5cb7b48bd36$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $2729e5cb7b48bd36$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$2729e5cb7b48bd36$exports = $2729e5cb7b48bd36$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $2729e5cb7b48bd36$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($2729e5cb7b48bd36$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($2729e5cb7b48bd36$var$getOwnPropertySymbols) {
            symbols = $2729e5cb7b48bd36$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($2729e5cb7b48bd36$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $482592a00a451062$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $482592a00a451062$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $482592a00a451062$var$VALID_TAG_NAMES = Object.keys($482592a00a451062$var$TAG_NAMES).map(function(name) {
    return $482592a00a451062$var$TAG_NAMES[name];
});
var $482592a00a451062$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $482592a00a451062$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $482592a00a451062$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $482592a00a451062$var$HTML_TAG_MAP = Object.keys($482592a00a451062$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$482592a00a451062$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $482592a00a451062$var$SELF_CLOSING_TAGS = [
    $482592a00a451062$var$TAG_NAMES.NOSCRIPT,
    $482592a00a451062$var$TAG_NAMES.SCRIPT,
    $482592a00a451062$var$TAG_NAMES.STYLE
];
var $482592a00a451062$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $482592a00a451062$var$_typeof = typeof Symbol === "function" && (0, $8Bufz._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
    return typeof obj === "undefined" ? "undefined" : (0, $8Bufz._)(obj);
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $8Bufz._)(obj);
};
var $482592a00a451062$var$classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $482592a00a451062$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $482592a00a451062$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $482592a00a451062$var$inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $8Bufz._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $482592a00a451062$var$objectWithoutProperties = function objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $482592a00a451062$var$possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $8Bufz._)(call)) === "object" || typeof call === "function") ? call : self;
};
var $482592a00a451062$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $482592a00a451062$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $482592a00a451062$var$getInnermostProperty(propsList, $482592a00a451062$var$TAG_NAMES.TITLE);
    var innermostTemplate = $482592a00a451062$var$getInnermostProperty(propsList, $482592a00a451062$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $482592a00a451062$var$getInnermostProperty(propsList, $482592a00a451062$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $482592a00a451062$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $482592a00a451062$var$getInnermostProperty(propsList, $482592a00a451062$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $482592a00a451062$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $482592a00a451062$var$_extends({}, tagAttrs, current);
    }, {});
};
var $482592a00a451062$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$482592a00a451062$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$482592a00a451062$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $482592a00a451062$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $482592a00a451062$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $482592a00a451062$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $482592a00a451062$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $482592a00a451062$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $482592a00a451062$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $482592a00a451062$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $482592a00a451062$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($2729e5cb7b48bd36$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $482592a00a451062$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $482592a00a451062$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $482592a00a451062$var$getBaseTagFromPropsList([
            $482592a00a451062$var$TAG_PROPERTIES.HREF,
            $482592a00a451062$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $482592a00a451062$var$getAttributesFromPropsList($482592a00a451062$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $482592a00a451062$var$getInnermostProperty(propsList, $482592a00a451062$var$HELMET_PROPS.DEFER),
        encode: $482592a00a451062$var$getInnermostProperty(propsList, $482592a00a451062$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $482592a00a451062$var$getAttributesFromPropsList($482592a00a451062$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $482592a00a451062$var$getTagsFromPropsList($482592a00a451062$var$TAG_NAMES.LINK, [
            $482592a00a451062$var$TAG_PROPERTIES.REL,
            $482592a00a451062$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $482592a00a451062$var$getTagsFromPropsList($482592a00a451062$var$TAG_NAMES.META, [
            $482592a00a451062$var$TAG_PROPERTIES.NAME,
            $482592a00a451062$var$TAG_PROPERTIES.CHARSET,
            $482592a00a451062$var$TAG_PROPERTIES.HTTPEQUIV,
            $482592a00a451062$var$TAG_PROPERTIES.PROPERTY,
            $482592a00a451062$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $482592a00a451062$var$getTagsFromPropsList($482592a00a451062$var$TAG_NAMES.NOSCRIPT, [
            $482592a00a451062$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $482592a00a451062$var$getOnChangeClientState(propsList),
        scriptTags: $482592a00a451062$var$getTagsFromPropsList($482592a00a451062$var$TAG_NAMES.SCRIPT, [
            $482592a00a451062$var$TAG_PROPERTIES.SRC,
            $482592a00a451062$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $482592a00a451062$var$getTagsFromPropsList($482592a00a451062$var$TAG_NAMES.STYLE, [
            $482592a00a451062$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $482592a00a451062$var$getTitleFromPropsList(propsList),
        titleAttributes: $482592a00a451062$var$getAttributesFromPropsList($482592a00a451062$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $482592a00a451062$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $482592a00a451062$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $482592a00a451062$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $482592a00a451062$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $482592a00a451062$var$rafPolyfill : $parcel$global.requestAnimationFrame || $482592a00a451062$var$rafPolyfill;
var $482592a00a451062$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $482592a00a451062$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $482592a00a451062$var$cafPolyfill;
var $482592a00a451062$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $482592a00a451062$var$_helmetCallback = null;
var $482592a00a451062$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($482592a00a451062$var$_helmetCallback) $482592a00a451062$var$cancelAnimationFrame($482592a00a451062$var$_helmetCallback);
    if (newState.defer) $482592a00a451062$var$_helmetCallback = $482592a00a451062$var$requestAnimationFrame(function() {
        $482592a00a451062$var$commitTagChanges(newState, function() {
            $482592a00a451062$var$_helmetCallback = null;
        });
    });
    else {
        $482592a00a451062$var$commitTagChanges(newState);
        $482592a00a451062$var$_helmetCallback = null;
    }
};
var $482592a00a451062$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $482592a00a451062$var$updateAttributes($482592a00a451062$var$TAG_NAMES.BODY, bodyAttributes);
    $482592a00a451062$var$updateAttributes($482592a00a451062$var$TAG_NAMES.HTML, htmlAttributes);
    $482592a00a451062$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $482592a00a451062$var$updateTags($482592a00a451062$var$TAG_NAMES.BASE, baseTag),
        linkTags: $482592a00a451062$var$updateTags($482592a00a451062$var$TAG_NAMES.LINK, linkTags),
        metaTags: $482592a00a451062$var$updateTags($482592a00a451062$var$TAG_NAMES.META, metaTags),
        noscriptTags: $482592a00a451062$var$updateTags($482592a00a451062$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $482592a00a451062$var$updateTags($482592a00a451062$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $482592a00a451062$var$updateTags($482592a00a451062$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $482592a00a451062$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $482592a00a451062$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $482592a00a451062$var$flattenArray(title);
    $482592a00a451062$var$updateAttributes($482592a00a451062$var$TAG_NAMES.TITLE, attributes);
};
var $482592a00a451062$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($482592a00a451062$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($482592a00a451062$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($482592a00a451062$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($482592a00a451062$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $482592a00a451062$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($482592a00a451062$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $482592a00a451062$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $482592a00a451062$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $482592a00a451062$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($482592a00a451062$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $482592a00a451062$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $482592a00a451062$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $482592a00a451062$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $482592a00a451062$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $482592a00a451062$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $482592a00a451062$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $482592a00a451062$var$HELMET_ATTRIBUTE + "=\"true\">" + $482592a00a451062$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $482592a00a451062$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $482592a00a451062$var$TAG_PROPERTIES.INNER_HTML || attribute === $482592a00a451062$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $482592a00a451062$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $482592a00a451062$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $482592a00a451062$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $482592a00a451062$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$482592a00a451062$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $482592a00a451062$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$482592a00a451062$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $482592a00a451062$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$482592a00a451062$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $482592a00a451062$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).createElement($482592a00a451062$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $482592a00a451062$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$482592a00a451062$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $482592a00a451062$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $482592a00a451062$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $482592a00a451062$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).createElement(type, mappedTag);
    });
};
var $482592a00a451062$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $482592a00a451062$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $482592a00a451062$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $482592a00a451062$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $482592a00a451062$var$ATTRIBUTE_NAMES.BODY:
        case $482592a00a451062$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $482592a00a451062$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $482592a00a451062$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $482592a00a451062$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $482592a00a451062$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $482592a00a451062$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $482592a00a451062$var$getMethodsForTag($482592a00a451062$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $482592a00a451062$var$getMethodsForTag($482592a00a451062$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $482592a00a451062$var$getMethodsForTag($482592a00a451062$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $482592a00a451062$var$getMethodsForTag($482592a00a451062$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $482592a00a451062$var$getMethodsForTag($482592a00a451062$var$TAG_NAMES.META, metaTags, encode),
        noscript: $482592a00a451062$var$getMethodsForTag($482592a00a451062$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $482592a00a451062$var$getMethodsForTag($482592a00a451062$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $482592a00a451062$var$getMethodsForTag($482592a00a451062$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $482592a00a451062$var$getMethodsForTag($482592a00a451062$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $482592a00a451062$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $482592a00a451062$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $482592a00a451062$var$classCallCheck(this, HelmetWrapper);
            return $482592a00a451062$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($cacd35a915e2ff57$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $482592a00a451062$var$TAG_NAMES.SCRIPT:
                case $482592a00a451062$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $482592a00a451062$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $482592a00a451062$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $482592a00a451062$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $482592a00a451062$var$TAG_NAMES.TITLE:
                    return $482592a00a451062$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $482592a00a451062$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $482592a00a451062$var$TAG_NAMES.BODY:
                    return $482592a00a451062$var$_extends({}, newProps, {
                        bodyAttributes: $482592a00a451062$var$_extends({}, newChildProps)
                    });
                case $482592a00a451062$var$TAG_NAMES.HTML:
                    return $482592a00a451062$var$_extends({}, newProps, {
                        htmlAttributes: $482592a00a451062$var$_extends({}, newChildProps)
                    });
            }
            return $482592a00a451062$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $482592a00a451062$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $482592a00a451062$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $482592a00a451062$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $482592a00a451062$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $482592a00a451062$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $482592a00a451062$var$TAG_NAMES.LINK:
                    case $482592a00a451062$var$TAG_NAMES.META:
                    case $482592a00a451062$var$TAG_NAMES.NOSCRIPT:
                    case $482592a00a451062$var$TAG_NAMES.SCRIPT:
                    case $482592a00a451062$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $482592a00a451062$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $482592a00a451062$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, $bdfb41ef79315c14$export$2e2bcd8739ae039).createElement(Component, newProps);
        };
        $482592a00a451062$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, $bdfb41ef79315c14$export$2e2bcd8739ae039).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($9789429064ccdb9f$exports))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $482592a00a451062$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $482592a00a451062$var$NullComponent = function NullComponent() {
    return null;
};
var $482592a00a451062$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($6f994d488ff986c5$exports)))($482592a00a451062$var$reducePropsToState, $482592a00a451062$var$handleClientStateChange, $482592a00a451062$var$mapStateOnServer)($482592a00a451062$var$NullComponent);
var $482592a00a451062$export$dcef8f9bb9a41431 = $482592a00a451062$var$Helmet($482592a00a451062$var$HelmetSideEffects);
$482592a00a451062$export$dcef8f9bb9a41431.renderStatic = $482592a00a451062$export$dcef8f9bb9a41431.rewind;
var $482592a00a451062$export$2e2bcd8739ae039 = $482592a00a451062$export$dcef8f9bb9a41431;



var $8Bufz = parcelRequire("8Bufz");

var $9c980878b5c974fe$var$t = /["&<]/;
function $9c980878b5c974fe$var$n(r) {
    if (0 === r.length || !1 === $9c980878b5c974fe$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $9c980878b5c974fe$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $9c980878b5c974fe$var$f = 0, $9c980878b5c974fe$var$i = Array.isArray;
function $9c980878b5c974fe$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$9c980878b5c974fe$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $ea42db622452d33d$export$41c562ebe57d11e2).vnode && (0, $ea42db622452d33d$export$41c562ebe57d11e2).vnode(l), l;
}
function $9c980878b5c974fe$export$45700d561b2268ac(r) {
    var t = $9c980878b5c974fe$export$34b9dba7ce09269b((0, $ea42db622452d33d$export$ffb0004e005737fa), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $9c980878b5c974fe$var$c = {}, $9c980878b5c974fe$var$p = /[A-Z]/g;
function $9c980878b5c974fe$export$991f6ffe102e5bac(e, t) {
    if ((0, $ea42db622452d33d$export$41c562ebe57d11e2).attr) {
        var f = (0, $ea42db622452d33d$export$41c562ebe57d11e2).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == (typeof r === "undefined" ? "undefined" : (0, $8Bufz._)(r)) && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == (typeof t === "undefined" ? "undefined" : (0, $8Bufz._)(t))) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $9c980878b5c974fe$var$c[u] || ($9c980878b5c974fe$var$c[u] = u.replace($9c980878b5c974fe$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $9c980878b5c974fe$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + $9c980878b5c974fe$var$n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == (typeof t === "undefined" ? "undefined" : (0, $8Bufz._)(t)) ? "" : !0 === t ? e : e + '="' + $9c980878b5c974fe$var$n("" + t) + '"';
}
function $9c980878b5c974fe$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == (typeof r === "undefined" ? "undefined" : (0, $8Bufz._)(r))) {
        if (void 0 === r.constructor) return r;
        if ($9c980878b5c974fe$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $9c980878b5c974fe$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $9c980878b5c974fe$var$n("" + r);
}


var $2e9ef8b5d0fd4f80$var$NotFound = function(param) {
    var type = param.type, _param_url = param.url, url = _param_url === void 0 ? '' : _param_url;
    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("section", {
        children: [
            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("h2", {
                children: [
                    "Error",
                    type
                ]
            }),
            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("p", {
                children: "It looks like we hit a snag."
            }),
            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("pre", {
                children: url
            })
        ]
    });
};
var $2e9ef8b5d0fd4f80$export$2e2bcd8739ae039 = $2e9ef8b5d0fd4f80$var$NotFound;


function $04b844fceb04b9e9$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $04b844fceb04b9e9$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $04b844fceb04b9e9$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $04b844fceb04b9e9$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $43d7bafd4ea38317$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $785ab81358d75c36$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $43d7bafd4ea38317$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $e7d079e776b18396$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $dd9dc63ecb5af6b5$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $af23daf94ea8b0c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $7d7b70eef872fe62$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $801a8583b3f04ffa$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7d7b70eef872fe62$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7d7b70eef872fe62$export$71511d61b312f219)(o, minLen);
}


function $eb67fc0d0f63c453$export$71511d61b312f219(arr, i) {
    return (0, $e7d079e776b18396$export$71511d61b312f219)(arr) || (0, $dd9dc63ecb5af6b5$export$71511d61b312f219)(arr, i) || (0, $801a8583b3f04ffa$export$71511d61b312f219)(arr, i) || (0, $af23daf94ea8b0c4$export$71511d61b312f219)();
}


function $5412342bd99c3e4e$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}






var $8e6349c485e59683$var$getDataFromResponse = function(response) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $04b844fceb04b9e9$export$71511d61b312f219)(function() {
        var text, data;
        return (0, $5412342bd99c3e4e$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        response.text()
                    ];
                case 1:
                    text = _state.sent();
                    data = text === '' ? {} : JSON.parse(text);
                    return [
                        2,
                        data.data || data
                    ];
            }
        });
    })();
};
var $8e6349c485e59683$export$b93ad78d273bf598 = function(id, version, language, useSandbox) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $04b844fceb04b9e9$export$71511d61b312f219)(function() {
        var basePath, url, response;
        return (0, $5412342bd99c3e4e$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    basePath = useSandbox ? 'https://api.usercentrics-sandbox.eu' : 'https://api.usercentrics.eu';
                    url = "".concat(basePath, "/settings/").concat(id, "/").concat(version, "/").concat(language, ".json");
                    return [
                        4,
                        fetch(url)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        $8e6349c485e59683$var$getDataFromResponse(response)
                    ];
            }
        });
    })();
};
var $8e6349c485e59683$export$80f8884b65d948e1 = function(data) {
    if (data.enabled) try {
        return Object.keys(JSON.parse(data.experiments));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Invalid JSON string");
    }
    return [];
};
var $8e6349c485e59683$var$AppId = /*#__PURE__*/ function(AppId) {
    AppId["ios"] = "9bkd1jjcweqk0cxcx2c7hvthtc";
    AppId["android"] = "b_536zsm5xhhrslpeiyf46d6owni";
    return AppId;
}($8e6349c485e59683$var$AppId || {});
var $8e6349c485e59683$var$SandboxAppId = /*#__PURE__*/ function(SandboxAppId) {
    SandboxAppId["ios"] = "f4q0j1mugzug6yefcktucwxyj0";
    SandboxAppId["android"] = "b_zppl2nm6ancjoel7oc47ystuee";
    return SandboxAppId;
}($8e6349c485e59683$var$SandboxAppId || {});
var $8e6349c485e59683$var$MobileModel = /*#__PURE__*/ function(MobileModel) {
    MobileModel["ios"] = "iphone17pro";
    MobileModel["android"] = "pixel7";
    return MobileModel;
}($8e6349c485e59683$var$MobileModel || {});
var $8e6349c485e59683$var$OsVersion = /*#__PURE__*/ function(OsVersion) {
    OsVersion["ios"] = "26.0";
    OsVersion["android"] = "15.0";
    return OsVersion;
}($8e6349c485e59683$var$OsVersion || {});
var $8e6349c485e59683$export$c9f1b5f3243eb744 = function(device, urlParams, useSandbox) {
    var appType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'embed';
    var androidId = useSandbox ? "b_zppl2nm6ancjoel7oc47ystuee" : "b_536zsm5xhhrslpeiyf46d6owni";
    var iosId = useSandbox ? "f4q0j1mugzug6yefcktucwxyj0" : "9bkd1jjcweqk0cxcx2c7hvthtc";
    var appId = device === (0, $507cba0b3ff2a038$export$c03ebfdd78bca91c).IOS ? iosId : androidId;
    var mobileModel = device === (0, $507cba0b3ff2a038$export$c03ebfdd78bca91c).IOS ? "iphone17pro" : "pixel7";
    var osVersion = device === (0, $507cba0b3ff2a038$export$c03ebfdd78bca91c).IOS ? "26.0" : "15.0";
    return "https://appetize.io/".concat(appType, "/").concat(appId, "?device=").concat(mobileModel, "&scale=75&orientation=portrait&osVersion=").concat(osVersion, "&deviceColor=black&params=").concat(encodeURI(JSON.stringify(urlParams))).concat(device === (0, $507cba0b3ff2a038$export$c03ebfdd78bca91c).ANDROID ? "&launchUrl=".concat(encodeURI('usercentrics://preview')) : '');
};


var $0bb72fe6210266cc$exports = {};
$0bb72fe6210266cc$exports = $parcel$resolve("7kW4z");



function $e9407c6bafa4dcc7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e9407c6bafa4dcc7$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $e9407c6bafa4dcc7$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}




function $529ec2bee950d799$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $7d7b70eef872fe62$export$71511d61b312f219)(arr);
}


function $2d168682689bf05d$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $acd31d31bd1513c0$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $cded5aad1f5c707c$export$71511d61b312f219(arr) {
    return (0, $529ec2bee950d799$export$71511d61b312f219)(arr) || (0, $2d168682689bf05d$export$71511d61b312f219)(arr) || (0, $801a8583b3f04ffa$export$71511d61b312f219)(arr) || (0, $acd31d31bd1513c0$export$71511d61b312f219)();
}







function $39faa513ba8920b6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $39faa513ba8920b6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $39faa513ba8920b6$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $39faa513ba8920b6$var$ownKeys(Object(source), true).forEach(function(key) {
            $39faa513ba8920b6$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $39faa513ba8920b6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $39faa513ba8920b6$export$407448d2b89b1813(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $39faa513ba8920b6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $39faa513ba8920b6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $39faa513ba8920b6$var$_arrayLikeToArray(o, minLen);
}
function $39faa513ba8920b6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $39faa513ba8920b6$export$8b22cf2602fb60ce(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $39faa513ba8920b6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}





function $1ab3ad06070c6ba8$var$isRenderProp(children) {
    return typeof children === "function";
}
/**
 * Custom hook that will call `children` if it's a function. If
 * `useCreateElement` has been passed to the context, it'll be used instead.
 *
 * @example
 * import React from "react";
 * import { SystemProvider, useCreateElement } from "reakit-system";
 *
 * const system = {
 *   useCreateElement(type, props, children = props.children) {
 *     // very similar to what `useCreateElement` does already
 *     if (typeof children === "function") {
 *       const { children: _, ...rest } = props;
 *       return children(rest);
 *     }
 *     return React.createElement(type, props, children);
 *   },
 * };
 *
 * function Component(props) {
 *   return useCreateElement("div", props);
 * }
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <Component url="url">{({ url }) => <a href={url}>link</a>}</Component>
 *     </SystemProvider>
 *   );
 * }
 */ var $1ab3ad06070c6ba8$export$cfb2bb2ead21514 = function useCreateElement(type, props, children) {
    if (children === void 0) children = props.children;
    var context = (0, $57da6a40a504e45b$export$fae74005e78b1a27)((0, $3baa482d3c4e6797$export$dc3d8cb49dcee267));
    if (context.useCreateElement) return context.useCreateElement(type, props, children);
    if (typeof type === "string" && $1ab3ad06070c6ba8$var$isRenderProp(children)) {
        var _ = props.children, rest = (0, $39faa513ba8920b6$export$407448d2b89b1813)(props, [
            "children"
        ]);
        return children(rest);
    }
    return /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)(type, props, children);
};


function $59a074d174b882e5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $59a074d174b882e5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $59a074d174b882e5$export$407448d2b89b1813(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $59a074d174b882e5$var$ownKeys(Object(source), true).forEach(function(key) {
            $59a074d174b882e5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $59a074d174b882e5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $59a074d174b882e5$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $59a074d174b882e5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $59a074d174b882e5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $59a074d174b882e5$var$_arrayLikeToArray(o, minLen);
}
function $59a074d174b882e5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $59a074d174b882e5$export$8b22cf2602fb60ce(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $59a074d174b882e5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}



/**
 * Checks whether `arg` is an object or not.
 *
 * @returns {boolean}
 */ 
var $8Bufz = parcelRequire("8Bufz");
function $283dac164feaf821$export$a6cdc56e425d0d0a(arg) {
    return (typeof arg === "undefined" ? "undefined" : (0, $8Bufz._)(arg)) === "object" && arg != null;
}


/**
 * Checks whether `arg` is a plain object or not.
 *
 * @returns {boolean}
 */ function $d9929b4e879c1d7f$export$53b83ca8eaab0383(arg) {
    var _proto$constructor;
    if (!(0, $283dac164feaf821$export$a6cdc56e425d0d0a)(arg)) return false;
    var proto = Object.getPrototypeOf(arg);
    if (proto == null) return true;
    return ((_proto$constructor = proto.constructor) === null || _proto$constructor === void 0 ? void 0 : _proto$constructor.toString()) === Object.toString();
}


/**
 * Splits an object (`props`) into a tuple where the first item is an object
 * with the passed `keys`, and the second item is an object with these keys
 * omitted.
 *
 * @deprecated will be removed in version 2
 *
 * @example
 * import { splitProps } from "reakit-utils";
 *
 * splitProps({ a: "a", b: "b" }, ["a"]); // [{ a: "a" }, { b: "b" }]
 */ function $22fcffabd697eaca$var$__deprecatedSplitProps(props, keys) {
    var propsKeys = Object.keys(props);
    var picked = {};
    var omitted = {};
    for(var _i = 0, _propsKeys = propsKeys; _i < _propsKeys.length; _i++){
        var key = _propsKeys[_i];
        if (keys.indexOf(key) >= 0) picked[key] = props[key];
        else omitted[key] = props[key];
    }
    return [
        picked,
        omitted
    ];
}
/**
 * Splits an object (`props`) into a tuple where the first item
 * is the `state` property, and the second item is the rest of the properties.
 *
 * It is also backward compatible with version 1. If `keys` are passed then
 * splits an object (`props`) into a tuple where the first item is an object
 * with the passed `keys`, and the second item is an object with these keys
 * omitted.
 *
 * @example
 * import { splitProps } from "reakit-utils";
 *
 * splitProps({ a: "a", b: "b" }, ["a"]); // [{ a: "a" }, { b: "b" }]
 *
 * @example
 * import { splitProps } from "reakit-utils";
 *
 * splitProps({ state: { a: "a" }, b: "b" }); // [{ a: "a" }, { b: "b" }]
 */ function $22fcffabd697eaca$export$45029c61b0073d87(props, keys) {
    if (keys === void 0) keys = [];
    if (!(0, $d9929b4e879c1d7f$export$53b83ca8eaab0383)(props.state)) return $22fcffabd697eaca$var$__deprecatedSplitProps(props, keys);
    var _deprecatedSplitProp = $22fcffabd697eaca$var$__deprecatedSplitProps(props, [].concat(keys, [
        "state"
    ])), picked = _deprecatedSplitProp[0], omitted = _deprecatedSplitProp[1];
    var state = picked.state, restPicked = (0, $59a074d174b882e5$export$71511d61b312f219)(picked, [
        "state"
    ]);
    return [
        (0, $59a074d174b882e5$export$407448d2b89b1813)((0, $59a074d174b882e5$export$407448d2b89b1813)({}, state), restPicked),
        omitted
    ];
}


/**
 * Compares two objects.
 *
 * @example
 * import { shallowEqual } from "reakit-utils";
 *
 * shallowEqual({ a: "a" }, {}); // false
 * shallowEqual({ a: "a" }, { b: "b" }); // false
 * shallowEqual({ a: "a" }, { a: "a" }); // true
 * shallowEqual({ a: "a" }, { a: "a", b: "b" }); // false
 */ 
var $8Bufz = parcelRequire("8Bufz");
function $4d4017bd96518208$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA) return false;
    if (!objB) return false;
    if ((typeof objA === "undefined" ? "undefined" : (0, $8Bufz._)(objA)) !== "object") return false;
    if ((typeof objB === "undefined" ? "undefined" : (0, $8Bufz._)(objB)) !== "object") return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var length = aKeys.length;
    if (bKeys.length !== length) return false;
    for(var _i = 0, _aKeys = aKeys; _i < _aKeys.length; _i++){
        var key = _aKeys[_i];
        if (objA[key] !== objB[key]) return false;
    }
    return true;
}





/**
 * This higher order functions take `propsAreEqual` function and
 * returns a new function which normalizes the props.
 *
 * Normalizing in our case is making sure the `propsAreEqual` works with
 * both version 1 (object spreading) and version 2 (state object) state passing.
 *
 * To achieve this, the returned function in case of a state object
 * will spread the state object in both `prev` and `next props.
 *
 * Other case it just returns the function as is which makes sure
 * that we are still backward compatible
 */ function $29984bd81e62d8b4$export$8a62f34a018b435b(propsAreEqual) {
    if (propsAreEqual.name === "normalizePropsAreEqualInner") return propsAreEqual;
    return function normalizePropsAreEqualInner(prev, next) {
        if (!(0, $d9929b4e879c1d7f$export$53b83ca8eaab0383)(prev.state) || !(0, $d9929b4e879c1d7f$export$53b83ca8eaab0383)(next.state)) return propsAreEqual(prev, next);
        return propsAreEqual((0, $59a074d174b882e5$export$407448d2b89b1813)((0, $59a074d174b882e5$export$407448d2b89b1813)({}, prev.state), prev), (0, $59a074d174b882e5$export$407448d2b89b1813)((0, $59a074d174b882e5$export$407448d2b89b1813)({}, next.state), next));
    };
}


function $adedf304b009a45c$var$forwardRef(component) {
    return /*#__PURE__*/ (0, $bdfb41ef79315c14$export$257a8862b851cb5b)(component);
}
function $adedf304b009a45c$var$memo(component, propsAreEqual) {
    return /*#__PURE__*/ (0, $bdfb41ef79315c14$export$7c73462e0d25e514)(component, propsAreEqual);
}
/**
 * Creates a React component.
 *
 * @example
 * import { createComponent } from "reakit-system";
 *
 * const A = createComponent({ as: "a" });
 *
 * @param options
 */ function $adedf304b009a45c$export$60e54eaca7e7fb38(_ref) {
    var type = _ref.as, useHook = _ref.useHook, shouldMemo = _ref.memo, _ref$propsAreEqual = _ref.propsAreEqual, propsAreEqual = _ref$propsAreEqual === void 0 ? useHook === null || useHook === void 0 ? void 0 : useHook.unstable_propsAreEqual : _ref$propsAreEqual, _ref$keys = _ref.keys, keys = _ref$keys === void 0 ? (useHook === null || useHook === void 0 ? void 0 : useHook.__keys) || [] : _ref$keys, _ref$useCreateElement = _ref.useCreateElement, useCreateElement$1 = _ref$useCreateElement === void 0 ? (0, $1ab3ad06070c6ba8$export$cfb2bb2ead21514) : _ref$useCreateElement;
    var Comp = function Comp(_ref2, ref) {
        var _ref2$as = _ref2.as, as = _ref2$as === void 0 ? type : _ref2$as, props = (0, $39faa513ba8920b6$export$407448d2b89b1813)(_ref2, [
            "as"
        ]);
        if (useHook) {
            var _as$render;
            var _splitProps = (0, $22fcffabd697eaca$export$45029c61b0073d87)(props, keys), _options = _splitProps[0], htmlProps = _splitProps[1];
            var _useHook = useHook(_options, (0, $39faa513ba8920b6$export$71511d61b312f219)({
                ref: ref
            }, htmlProps)), wrapElement = _useHook.wrapElement, elementProps = (0, $39faa513ba8920b6$export$407448d2b89b1813)(_useHook, [
                "wrapElement"
            ]); // @ts-ignore
            var asKeys = ((_as$render = as.render) === null || _as$render === void 0 ? void 0 : _as$render.__keys) || as.__keys;
            var asOptions = asKeys && (0, $22fcffabd697eaca$export$45029c61b0073d87)(props, asKeys)[0];
            var allProps = asOptions ? (0, $39faa513ba8920b6$export$71511d61b312f219)((0, $39faa513ba8920b6$export$71511d61b312f219)({}, elementProps), asOptions) : elementProps;
            var _element = useCreateElement$1(as, allProps);
            if (wrapElement) return wrapElement(_element);
            return _element;
        }
        return useCreateElement$1(as, (0, $39faa513ba8920b6$export$71511d61b312f219)({
            ref: ref
        }, props));
    };
    Comp = $adedf304b009a45c$var$forwardRef(Comp);
    if (shouldMemo) Comp = $adedf304b009a45c$var$memo(Comp, propsAreEqual && (0, $29984bd81e62d8b4$export$8a62f34a018b435b)(propsAreEqual));
    Comp.__keys = keys;
    Comp.unstable_propsAreEqual = (0, $29984bd81e62d8b4$export$8a62f34a018b435b)(propsAreEqual || (0, $4d4017bd96518208$export$d36bdfa510afb180));
    return Comp;
}








/**
 * React custom hook that returns the props returned by a given
 * `use${name}Props` in the SystemContext.
 *
 * @example
 * import { SystemProvider, useProps } from "reakit-system";
 *
 * const system = {
 *   useAProps(options, htmlProps) {
 *     return {
 *       ...htmlProps,
 *       href: options.url,
 *     };
 *   },
 * };
 *
 * function A({ url, ...htmlProps }) {
 *   const props = useProps("A", { url }, htmlProps);
 *   return <a {...props} />;
 * }
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <A url="url">It will convert url into href in useAProps</A>
 *     </SystemProvider>
 *   );
 * }
 */ function $21f8605889669460$export$1f264be2c424fccf(name, options, htmlProps) {
    if (options === void 0) options = {};
    if (htmlProps === void 0) htmlProps = {};
    var hookName = "use" + name + "Props";
    (0, $57da6a40a504e45b$export$dc8fbce3eb94dc1e)(hookName);
    var useHook = (0, $58154d52375e8c2e$export$31dcd79391e423fe)(hookName);
    if (useHook) return useHook(options, htmlProps);
    return htmlProps;
}







/**
 * React custom hook that returns the options returned by a given
 * `use${name}Options` in the SystemContext.
 *
 * @example
 * import React from "react";
 * import { SystemProvider, useOptions } from "reakit-system";
 *
 * const system = {
 *   useAOptions(options, htmlProps) {
 *     return {
 *       ...options,
 *       url: htmlProps.href,
 *     };
 *   },
 * };
 *
 * function A({ url, ...htmlProps }) {
 *   const options = useOptions("A", { url }, htmlProps);
 *   return <a href={options.url} {...htmlProps} />;
 * }
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <A href="url">
 *         It will convert href into url in useAOptions and then url into href in A
 *       </A>
 *     </SystemProvider>
 *   );
 * }
 */ function $c0fb2bb3078314e1$export$b8ae39f344200a7d(name, options, htmlProps) {
    if (options === void 0) options = {};
    if (htmlProps === void 0) htmlProps = {};
    var hookName = "use" + name + "Options";
    (0, $57da6a40a504e45b$export$dc8fbce3eb94dc1e)(hookName);
    var useHook = (0, $58154d52375e8c2e$export$31dcd79391e423fe)(hookName);
    if (useHook) return (0, $39faa513ba8920b6$export$71511d61b312f219)((0, $39faa513ba8920b6$export$71511d61b312f219)({}, options), useHook(options, htmlProps));
    return options;
}



/**
 * Transforms `arg` into an array if it's not already.
 *
 * @example
 * import { toArray } from "reakit-utils";
 *
 * toArray("a"); // ["a"]
 * toArray(["a"]); // ["a"]
 */ function $51013def18aacf34$export$45b10814cc054894(arg) {
    if (Array.isArray(arg)) return arg;
    return typeof arg !== "undefined" ? [
        arg
    ] : [];
}


/**
 * Creates a React custom hook that will return component props.
 *
 * @example
 * import { createHook } from "reakit-system";
 *
 * const useA = createHook({
 *   name: "A",
 *   keys: ["url"], // custom props/options keys
 *   useProps(options, htmlProps) {
 *     return {
 *       ...htmlProps,
 *       href: options.url,
 *     };
 *   },
 * });
 *
 * function A({ url, ...htmlProps }) {
 *   const props = useA({ url }, htmlProps);
 *   return <a {...props} />;
 * }
 *
 * @param options
 */ function $7478c93f949c3a40$export$e7f733c8fc2b8a24(options) {
    var _options$useState, _composedHooks$;
    var composedHooks = (0, $51013def18aacf34$export$45b10814cc054894)(options.compose);
    var __useOptions = function __useOptions(hookOptions, htmlProps) {
        // Call the current hook's useOptions first
        if (options.useOptions) hookOptions = options.useOptions(hookOptions, htmlProps);
         // If there's name, call useOptions from the system context
        if (options.name) hookOptions = (0, $c0fb2bb3078314e1$export$b8ae39f344200a7d)(options.name, hookOptions, htmlProps);
         // Run composed hooks useOptions
        if (options.compose) for(var _iterator = (0, $39faa513ba8920b6$export$8b22cf2602fb60ce)(composedHooks), _step; !(_step = _iterator()).done;){
            var hook = _step.value;
            hookOptions = hook.__useOptions(hookOptions, htmlProps);
        }
        return hookOptions;
    };
    var useHook = function useHook(hookOptions, htmlProps, unstable_ignoreUseOptions) {
        if (hookOptions === void 0) hookOptions = {};
        if (htmlProps === void 0) htmlProps = {};
        if (unstable_ignoreUseOptions === void 0) unstable_ignoreUseOptions = false;
        // This won't execute when useHook was called from within another useHook
        if (!unstable_ignoreUseOptions) hookOptions = __useOptions(hookOptions, htmlProps);
         // Call the current hook's useProps
        if (options.useProps) htmlProps = options.useProps(hookOptions, htmlProps);
         // If there's name, call useProps from the system context
        if (options.name) htmlProps = (0, $21f8605889669460$export$1f264be2c424fccf)(options.name, hookOptions, htmlProps);
        if (options.compose) {
            if (options.useComposeOptions) hookOptions = options.useComposeOptions(hookOptions, htmlProps);
            if (options.useComposeProps) htmlProps = options.useComposeProps(hookOptions, htmlProps);
            else for(var _iterator2 = (0, $39faa513ba8920b6$export$8b22cf2602fb60ce)(composedHooks), _step2; !(_step2 = _iterator2()).done;){
                var hook = _step2.value;
                htmlProps = hook(hookOptions, htmlProps, true);
            }
        } // Remove undefined values from htmlProps
        var finalHTMLProps = {};
        var definedHTMLProps = htmlProps || {};
        for(var prop in definedHTMLProps)if (definedHTMLProps[prop] !== undefined) finalHTMLProps[prop] = definedHTMLProps[prop];
        return finalHTMLProps;
    };
    useHook.__useOptions = __useOptions;
    var composedKeys = composedHooks.reduce(function(keys, hook) {
        keys.push.apply(keys, hook.__keys || []);
        return keys;
    }, []); // It's used by createComponent to split option props (keys) and html props
    useHook.__keys = [].concat(composedKeys, ((_options$useState = options.useState) === null || _options$useState === void 0 ? void 0 : _options$useState.__keys) || [], options.keys || []);
    useHook.unstable_propsAreEqual = options.propsAreEqual || ((_composedHooks$ = composedHooks[0]) === null || _composedHooks$ === void 0 ? void 0 : _composedHooks$.unstable_propsAreEqual) || (0, $4d4017bd96518208$export$d36bdfa510afb180);
    return useHook;
}








/**
 * Logs `messages` to the console using `console.warn` based on a `condition`.
 *
 * @example
 * import { warning } from "reakit-warning";
 *
 * warning(true, "a", "b"); // console.warn("a", "\n", "b")
 * warning(false, "a", "b"); // does nothing
 */ function $cf973df7315a81cb$export$491112666e282270(condition) {
    var _console, _len, messages, _key, warns, x;
}








function $a340658c6d84e82e$var$isRefObject(ref) {
    return (0, $283dac164feaf821$export$a6cdc56e425d0d0a)(ref) && "current" in ref;
}
/**
 * Logs `messages` to the console using `console.warn` based on a `condition`.
 * This should be used inside components.
 */ function $a340658c6d84e82e$export$e22fd18e63c09d93(condition) {
    for(var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)messages[_key - 1] = arguments[_key];
}












/**
 * Returns `element.ownerDocument || document`.
 */ function $2e594f29f3297da7$export$f65ca476c09acec0(element) {
    return element ? element.ownerDocument || element : document;
}


// Thanks to Fluent UI for doing the [research on IE11 memory leak](https://github.com/microsoft/fluentui/pull/9010#issuecomment-490768427)
var $e2bcac3b3b53ce44$var$_window; // Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
// hits a memory leak, whereas aliasing it and calling "typeof _window" does not.
// Caching the window value at the file scope lets us minimize the impact.
try {
    $e2bcac3b3b53ce44$var$_window = window;
} catch (e) {
/* no-op */ }
/**
 * Returns `element.ownerDocument.defaultView || window`.
 */ function $e2bcac3b3b53ce44$export$38b2d434cce3ea22(element) {
    if (!element) return $e2bcac3b3b53ce44$var$_window;
    return (0, $2e594f29f3297da7$export$f65ca476c09acec0)(element).defaultView || $e2bcac3b3b53ce44$var$_window;
}


function $a20c9196f0a7adc9$var$checkIsBrowser() {
    var _window = (0, $e2bcac3b3b53ce44$export$38b2d434cce3ea22)();
    return Boolean(typeof _window !== "undefined" && _window.document && _window.document.createElement);
}
/**
 * It's `true` if it is running in a browser environment or `false` if it is not (SSR).
 *
 * @example
 * import { canUseDOM } from "reakit-utils";
 *
 * const title = canUseDOM ? document.title : "";
 */ var $a20c9196f0a7adc9$export$71594e8a50f746f4 = $a20c9196f0a7adc9$var$checkIsBrowser();


/**
 * `React.useLayoutEffect` that fallbacks to `React.useEffect` on server side
 * rendering.
 */ var $55d7e61099d95834$export$363c9f3eb56bbdbe = !(0, $a20c9196f0a7adc9$export$71594e8a50f746f4) ? (0, $57da6a40a504e45b$export$6d9c69b0de29b591) : (0, $57da6a40a504e45b$export$e5c5a5f917a5871c);


/**
 * A `React.Ref` that keeps track of the passed `value`.
 */ function $b40e9b06f925db37$export$43b4ce1c76a790d1(value) {
    var ref = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(value);
    (0, $55d7e61099d95834$export$363c9f3eb56bbdbe)(function() {
        ref.current = value;
    });
    return ref;
}





/**
 * Similar to `Element.prototype.contains`, but a little bit faster when
 * `element` is the same as `child`.
 *
 * @example
 * import { contains } from "reakit-utils";
 *
 * contains(document.getElementById("parent"), document.getElementById("child"));
 */ function $28e71a18d15190f3$export$2344b14b097df817(parent, child) {
    return parent === child || parent.contains(child);
}


/**
 * Returns `true` if `event` has been fired within a React Portal element.
 */ function $fb6a1f3bf7908434$export$af57ec5ec914349c(event) {
    return !(0, $28e71a18d15190f3$export$2344b14b097df817)(event.currentTarget, event.target);
}


























/**
 * Immutably removes an index from an array.
 *
 * @example
 * import { removeIndexFromArray } from "reakit-utils";
 *
 * removeIndexFromArray(["a", "b", "c"], 1); // ["a", "c"]
 *
 * @returns {Array} A new array without the item in the passed index.
 */ function $39295e1c3ba2ab2f$export$12703413633ff0fe(array, index) {
    if (index === -1) return array;
    return [].concat(array.slice(0, index), array.slice(index + 1));
}


/**
 * Immutably removes an item from an array.
 *
 * @example
 * import { removeItemFromArray } from "reakit-utils";
 *
 * removeItemFromArray(["a", "b", "c"], "b"); // ["a", "c"]
 *
 * // This only works by reference
 * const obj = {};
 * removeItemFromArray([obj], {}); // [obj]
 * removeItemFromArray([obj], obj); // []
 *
 * @returns {Array} A new array without the passed item.
 */ function $de6ff87616121ffa$export$b5a6009d2116a5b6(array, item) {
    var index = array.indexOf(item);
    return (0, $39295e1c3ba2ab2f$export$12703413633ff0fe)(array, index);
}


var $dfdde098fbc56812$export$3a1a48c8f6ef640e = /*#__PURE__*/ (0, $ea42db622452d33d$export$fd42f52fd3ae1109)(null);
function $dfdde098fbc56812$export$3b14a55fb2447963(menuRef, role, options) {
    var orphan = "unstable_orphan" in options && options.unstable_orphan;
    var parent = (0, $57da6a40a504e45b$export$fae74005e78b1a27)($dfdde098fbc56812$export$3a1a48c8f6ef640e);
    var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)([]), children = _React$useState[0], setChildren = _React$useState[1];
    var _ref = parent || {}, addChildToParent = _ref.addChild, removeChildFromParent = _ref.removeChild;
    var addChild = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(ref) {
        return setChildren(function(refs) {
            return [].concat(refs, [
                ref
            ]);
        });
    }, []);
    var removeChild = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(ref) {
        return setChildren(function(refs) {
            return (0, $de6ff87616121ffa$export$b5a6009d2116a5b6)(refs, ref);
        });
    }, []); // If it's a nested menu, add it to parent
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (!addChildToParent || orphan) return undefined;
        addChildToParent(menuRef);
        return function() {
            removeChildFromParent === null || removeChildFromParent === void 0 || removeChildFromParent(menuRef);
        };
    }, [
        menuRef,
        addChildToParent,
        removeChildFromParent,
        orphan
    ]);
    var providerValue = (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        return {
            orientation: options.orientation,
            next: options.next,
            previous: options.previous,
            ref: menuRef,
            role: role,
            parent: parent,
            children: children,
            addChild: addChild,
            removeChild: removeChild
        };
    }, [
        options.orientation,
        options.next,
        options.previous,
        menuRef,
        role,
        parent,
        children,
        addChild,
        removeChild
    ]);
    var wrapElement = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(element) {
        return /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)($dfdde098fbc56812$export$3a1a48c8f6ef640e.Provider, {
            value: providerValue
        }, element);
    }, [
        providerValue
    ]);
    return wrapElement;
}



function $20fc110fa38d0af9$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $20fc110fa38d0af9$var$hasPassiveEvents = false;
if (typeof window !== 'undefined') {
    var $20fc110fa38d0af9$var$passiveTestOptions = {
        get passive () {
            $20fc110fa38d0af9$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener('testPassive', null, $20fc110fa38d0af9$var$passiveTestOptions);
    window.removeEventListener('testPassive', null, $20fc110fa38d0af9$var$passiveTestOptions);
}
var $20fc110fa38d0af9$var$isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
var $20fc110fa38d0af9$var$locks = [];
var $20fc110fa38d0af9$var$documentListenerAdded = false;
var $20fc110fa38d0af9$var$initialClientY = -1;
var $20fc110fa38d0af9$var$previousBodyOverflowSetting = void 0;
var $20fc110fa38d0af9$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $20fc110fa38d0af9$var$allowTouchMove = function allowTouchMove(el) {
    return $20fc110fa38d0af9$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $20fc110fa38d0af9$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($20fc110fa38d0af9$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $20fc110fa38d0af9$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($20fc110fa38d0af9$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            $20fc110fa38d0af9$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = scrollBarGap + 'px';
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($20fc110fa38d0af9$var$previousBodyOverflowSetting === undefined) {
        $20fc110fa38d0af9$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }
};
var $20fc110fa38d0af9$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($20fc110fa38d0af9$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $20fc110fa38d0af9$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $20fc110fa38d0af9$var$previousBodyPaddingRight = undefined;
    }
    if ($20fc110fa38d0af9$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $20fc110fa38d0af9$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $20fc110fa38d0af9$var$previousBodyOverflowSetting = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $20fc110fa38d0af9$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $20fc110fa38d0af9$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $20fc110fa38d0af9$var$initialClientY;
    if ($20fc110fa38d0af9$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $20fc110fa38d0af9$var$preventDefault(event);
    if ($20fc110fa38d0af9$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $20fc110fa38d0af9$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $20fc110fa38d0af9$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($20fc110fa38d0af9$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $20fc110fa38d0af9$var$locks = [].concat($20fc110fa38d0af9$var$_toConsumableArray($20fc110fa38d0af9$var$locks), [
        lock
    ]);
    if ($20fc110fa38d0af9$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $20fc110fa38d0af9$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $20fc110fa38d0af9$var$handleScroll(event, targetElement);
        };
        if (!$20fc110fa38d0af9$var$documentListenerAdded) {
            document.addEventListener('touchmove', $20fc110fa38d0af9$var$preventDefault, $20fc110fa38d0af9$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $20fc110fa38d0af9$var$documentListenerAdded = true;
        }
    } else $20fc110fa38d0af9$var$setOverflowHidden(options);
};
var $20fc110fa38d0af9$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($20fc110fa38d0af9$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $20fc110fa38d0af9$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($20fc110fa38d0af9$var$documentListenerAdded) {
            document.removeEventListener('touchmove', $20fc110fa38d0af9$var$preventDefault, $20fc110fa38d0af9$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $20fc110fa38d0af9$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $20fc110fa38d0af9$var$initialClientY = -1;
    } else $20fc110fa38d0af9$var$restoreOverflowSetting();
    $20fc110fa38d0af9$var$locks = [];
};
var $20fc110fa38d0af9$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
        return;
    }
    $20fc110fa38d0af9$var$locks = $20fc110fa38d0af9$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($20fc110fa38d0af9$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($20fc110fa38d0af9$var$documentListenerAdded && $20fc110fa38d0af9$var$locks.length === 0) {
            document.removeEventListener('touchmove', $20fc110fa38d0af9$var$preventDefault, $20fc110fa38d0af9$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $20fc110fa38d0af9$var$documentListenerAdded = false;
        }
    } else if (!$20fc110fa38d0af9$var$locks.length) $20fc110fa38d0af9$var$restoreOverflowSetting();
};















// https://github.com/mui-org/material-ui/blob/2bcc874cf07b81202968f769cb9c2398c7c11311/packages/material-ui/src/utils/useForkRef.js
function $f08be812be5c38c7$var$setRef(ref, value) {
    if (value === void 0) value = null;
    if (!ref) return;
    if (typeof ref === "function") ref(value);
    else ref.current = value;
}
/**
 * Merges up to two React Refs into a single memoized function React Ref so you
 * can pass it to an element.
 *
 * @example
 * import React from "react";
 * import { useForkRef } from "reakit-utils";
 *
 * const Component = React.forwardRef((props, ref) => {
 *   const internalRef = React.useRef();
 *   return <div {...props} ref={useForkRef(internalRef, ref)} />;
 * });
 */ function $f08be812be5c38c7$export$ebc1e1560c2dffa5(refA, refB) {
    return (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        if (refA == null && refB == null) return null;
        return function(value) {
            $f08be812be5c38c7$var$setRef(refA, value);
            $f08be812be5c38c7$var$setRef(refB, value);
        };
    }, [
        refA,
        refB
    ]);
}




























var $62d22d716c62d21c$var$buttonInputTypes = [
    "button",
    "color",
    "file",
    "image",
    "reset",
    "submit"
];
/**
 * Checks whether `element` is a native HTML button element.
 *
 * @example
 * import { isButton } from "reakit-utils";
 *
 * isButton(document.querySelector("button")); // true
 * isButton(document.querySelector("input[type='button']")); // true
 * isButton(document.querySelector("div")); // false
 * isButton(document.querySelector("input[type='text']")); // false
 * isButton(document.querySelector("div[role='button']")); // false
 *
 * @returns {boolean}
 */ function $62d22d716c62d21c$export$35a0171ee384c875(element) {
    if (element.tagName === "BUTTON") return true;
    if (element.tagName === "INPUT") {
        var input = element;
        return $62d22d716c62d21c$var$buttonInputTypes.indexOf(input.type) !== -1;
    }
    return false;
}








/**
 * Returns `element.ownerDocument.activeElement`.
 */ function $555da54edda577d6$export$cd4e5573fbe2b576(element) {
    var _getDocument = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(element), activeElement = _getDocument.activeElement;
    if (!(activeElement !== null && activeElement !== void 0 && activeElement.nodeName)) // In IE11, activeElement might be an empty object if we're interacting
    // with elements inside of an iframe.
    return null;
    return activeElement;
}



/**
 * Checks if `element` has focus within. Elements that are referenced by
 * `aria-activedescendant` are also considered.
 *
 * @example
 * import { hasFocusWithin } from "reakit-utils";
 *
 * hasFocusWithin(document.getElementById("id"));
 */ function $1f8dcff49c1e0404$export$848589947316f680(element) {
    var activeElement = (0, $555da54edda577d6$export$cd4e5573fbe2b576)(element);
    if (!activeElement) return false;
    if ((0, $28e71a18d15190f3$export$2344b14b097df817)(element, activeElement)) return true;
    var activeDescendant = activeElement.getAttribute("aria-activedescendant");
    if (!activeDescendant) return false;
    if (activeDescendant === element.id) return true;
    return !!element.querySelector("#" + activeDescendant);
}



/**
 * Ponyfill for `Element.prototype.matches`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
 */ function $4331bc86e7dd1db0$export$de994efd351b291c(element, selectors) {
    if ("matches" in element) return element.matches(selectors);
    if ("msMatchesSelector" in element) return element.msMatchesSelector(selectors);
    return element.webkitMatchesSelector(selectors);
}



/**
 * Ponyfill for `Element.prototype.closest`
 *
 * @example
 * import { closest } from "reakit-utils";
 *
 * closest(document.getElementById("id"), "div");
 * // same as
 * document.getElementById("id").closest("div");
 */ function $0072e8bbe9b36c2e$export$ff7f7c97cdce86e(element, selectors) {
    if ("closest" in element) return element.closest(selectors);
    do {
        if ((0, $4331bc86e7dd1db0$export$de994efd351b291c)(element, selectors)) return element;
        element = element.parentElement || element.parentNode;
    }while (element !== null && element.nodeType === 1);
    return null;
}



/** @module tabbable */ var $0f37bdbc1405f89e$var$selector = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function $0f37bdbc1405f89e$var$isVisible(element) {
    var htmlElement = element;
    return htmlElement.offsetWidth > 0 || htmlElement.offsetHeight > 0 || element.getClientRects().length > 0;
}
function $0f37bdbc1405f89e$var$hasNegativeTabIndex(element) {
    var tabIndex = parseInt(element.getAttribute("tabindex") || "0", 10);
    return tabIndex < 0;
}
/**
 * Checks whether `element` is focusable or not.
 *
 * @memberof tabbable
 *
 * @example
 * import { isFocusable } from "reakit-utils";
 *
 * isFocusable(document.querySelector("input")); // true
 * isFocusable(document.querySelector("input[tabindex='-1']")); // true
 * isFocusable(document.querySelector("input[hidden]")); // false
 * isFocusable(document.querySelector("input:disabled")); // false
 */ function $0f37bdbc1405f89e$export$4c063cf1350e6fed(element) {
    return (0, $4331bc86e7dd1db0$export$de994efd351b291c)(element, $0f37bdbc1405f89e$var$selector) && $0f37bdbc1405f89e$var$isVisible(element);
}
/**
 * Checks whether `element` is tabbable or not.
 *
 * @memberof tabbable
 *
 * @example
 * import { isTabbable } from "reakit-utils";
 *
 * isTabbable(document.querySelector("input")); // true
 * isTabbable(document.querySelector("input[tabindex='-1']")); // false
 * isTabbable(document.querySelector("input[hidden]")); // false
 * isTabbable(document.querySelector("input:disabled")); // false
 */ function $0f37bdbc1405f89e$export$bebd5a1431fec25d(element) {
    return $0f37bdbc1405f89e$export$4c063cf1350e6fed(element) && !$0f37bdbc1405f89e$var$hasNegativeTabIndex(element);
}
/**
 * Returns all the focusable elements in `container`.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 *
 * @returns {Element[]}
 */ function $0f37bdbc1405f89e$export$18c9976582cbcf21(container) {
    var allFocusable = Array.from(container.querySelectorAll($0f37bdbc1405f89e$var$selector));
    allFocusable.unshift(container);
    return allFocusable.filter($0f37bdbc1405f89e$export$4c063cf1350e6fed);
}
/**
 * Returns the first focusable element in `container`.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 *
 * @returns {Element|null}
 */ function $0f37bdbc1405f89e$export$6e1340b0a5bf1aa4(container) {
    var _getAllFocusableIn = $0f37bdbc1405f89e$export$18c9976582cbcf21(container), first = _getAllFocusableIn[0];
    return first || null;
}
/**
 * Returns all the tabbable elements in `container`, including the container
 * itself.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return focusable elements if there are no tabbable ones.
 *
 * @returns {Element[]}
 */ function $0f37bdbc1405f89e$export$d9626276156787ce(container, fallbackToFocusable) {
    var allFocusable = Array.from(container.querySelectorAll($0f37bdbc1405f89e$var$selector));
    var allTabbable = allFocusable.filter($0f37bdbc1405f89e$export$bebd5a1431fec25d);
    if ($0f37bdbc1405f89e$export$bebd5a1431fec25d(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
/**
 * Returns the first tabbable element in `container`, including the container
 * itself if it's tabbable.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return the first focusable element if there are no tabbable ones.
 *
 * @returns {Element|null}
 */ function $0f37bdbc1405f89e$export$168b663469d4c75e(container, fallbackToFocusable) {
    var _getAllTabbableIn = $0f37bdbc1405f89e$export$d9626276156787ce(container, fallbackToFocusable), first = _getAllTabbableIn[0];
    return first || null;
}
/**
 * Returns the last tabbable element in `container`, including the container
 * itself if it's tabbable.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return the last focusable element if there are no tabbable ones.
 *
 * @returns {Element|null}
 */ function $0f37bdbc1405f89e$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    var allTabbable = $0f37bdbc1405f89e$export$d9626276156787ce(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
/**
 * Returns the next tabbable element in `container`.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return the next focusable element if there are no tabbable ones.
 *
 * @returns {Element|null}
 */ function $0f37bdbc1405f89e$export$5fadf5f648460a3d(container, fallbackToFocusable) {
    var activeElement = (0, $555da54edda577d6$export$cd4e5573fbe2b576)(container);
    var allFocusable = $0f37bdbc1405f89e$export$18c9976582cbcf21(container);
    var index = allFocusable.indexOf(activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find($0f37bdbc1405f89e$export$bebd5a1431fec25d) || allFocusable.find($0f37bdbc1405f89e$export$bebd5a1431fec25d) || (fallbackToFocusable ? slice[0] : null);
}
/**
 * Returns the previous tabbable element in `container`.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return the previous focusable element if there are no tabbable ones.
 *
 * @returns {Element|null}
 */ function $0f37bdbc1405f89e$export$55ee694b645bf31d(container, fallbackToFocusable) {
    var activeElement = (0, $555da54edda577d6$export$cd4e5573fbe2b576)(container);
    var allFocusable = $0f37bdbc1405f89e$export$18c9976582cbcf21(container).reverse();
    var index = allFocusable.indexOf(activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find($0f37bdbc1405f89e$export$bebd5a1431fec25d) || allFocusable.find($0f37bdbc1405f89e$export$bebd5a1431fec25d) || (fallbackToFocusable ? slice[0] : null);
}
/**
 * Returns the closest focusable element.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 *
 * @returns {Element|null}
 */ function $0f37bdbc1405f89e$export$ab9cdef57f65251f(element) {
    while(element && !$0f37bdbc1405f89e$export$4c063cf1350e6fed(element))element = (0, $0072e8bbe9b36c2e$export$ff7f7c97cdce86e)(element, $0f37bdbc1405f89e$var$selector);
    return element;
}




/**
 * A `React.useEffect` that will not run on the first render.
 */ function $f4e9b5aacaa1f234$export$496315a1608d9602(effect, deps) {
    var mounted = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(false);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (mounted.current) return effect();
        mounted.current = true;
        return undefined;
    }, deps);
}









var $b9e9b492c14d338e$var$isIE11 = (0, $a20c9196f0a7adc9$export$71594e8a50f746f4) && "msCrypto" in window;
/**
 * Cross-browser method that returns the next active element (the element that
 * is receiving focus) after a blur event is dispatched. It receives the blur
 * event object as the argument.
 *
 * @example
 * import { getNextActiveElementOnBlur } from "reakit-utils";
 *
 * const element = document.getElementById("id");
 * element.addEventListener("blur", (event) => {
 *   const nextActiveElement = getNextActiveElementOnBlur(event);
 * });
 */ function $b9e9b492c14d338e$export$e56b097fab4b0a4f(event) {
    // IE 11 doesn't support event.relatedTarget on blur.
    // document.activeElement points the the next active element.
    // On modern browsers, document.activeElement points to the current target.
    if ($b9e9b492c14d338e$var$isIE11) {
        var activeElement = (0, $555da54edda577d6$export$cd4e5573fbe2b576)(event.currentTarget);
        return activeElement;
    }
    return event.relatedTarget;
}






/**
 * Checks if `element` has focus. Elements that are referenced by
 * `aria-activedescendant` are also considered.
 *
 * @example
 * import { hasFocus } from "reakit-utils";
 *
 * hasFocus(document.getElementById("id"));
 */ function $67a3dcaed136bd87$export$1c89b7ce846c4ef6(element) {
    var activeElement = (0, $555da54edda577d6$export$cd4e5573fbe2b576)(element);
    if (!activeElement) return false;
    if (activeElement === element) return true;
    var activeDescendant = activeElement.getAttribute("aria-activedescendant");
    if (!activeDescendant) return false;
    return activeDescendant === element.id;
}


/**
 * Ensures `element` will receive focus if it's not already.
 *
 * @example
 * import { ensureFocus } from "reakit-utils";
 *
 * ensureFocus(document.activeElement); // does nothing
 *
 * const element = document.querySelector("input");
 *
 * ensureFocus(element); // focuses element
 * ensureFocus(element, { preventScroll: true }); // focuses element preventing scroll jump
 *
 * function isActive(el) {
 *   return el.dataset.active === "true";
 * }
 *
 * ensureFocus(document.querySelector("[data-active='true']"), { isActive }); // does nothing
 *
 * @returns {number} `requestAnimationFrame` call ID so it can be passed to `cancelAnimationFrame` if needed.
 */ function $2feaa9579ddfa1c6$export$f324b2d22fd95a05(element, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, preventScroll = _ref.preventScroll, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? (0, $67a3dcaed136bd87$export$1c89b7ce846c4ef6) : _ref$isActive;
    if (isActive(element)) return -1;
    element.focus({
        preventScroll: preventScroll
    });
    if (isActive(element)) return -1;
    return requestAnimationFrame(function() {
        element.focus({
            preventScroll: preventScroll
        });
    });
}









/**
 * Returns `true` if `event.target` and `event.currentTarget` are the same.
 */ function $71809a9b946920fa$export$7bced8f45c53f2f(event) {
    return event.target === event.currentTarget;
}






// Automatically generated
var $75cc27f4cc989769$var$ROLE_KEYS = [
    "unstable_system"
];
var $75cc27f4cc989769$export$f66572793fa256a1 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "Role",
    keys: $75cc27f4cc989769$var$ROLE_KEYS,
    propsAreEqual: function propsAreEqual(prev, next) {
        var prevSystem = prev.unstable_system, prevProps = (0, $d71074b92e18808d$export$71511d61b312f219)(prev, [
            "unstable_system"
        ]);
        var nextSystem = next.unstable_system, nextProps = (0, $d71074b92e18808d$export$71511d61b312f219)(next, [
            "unstable_system"
        ]);
        if (prevSystem !== nextSystem && !(0, $4d4017bd96518208$export$d36bdfa510afb180)(prevSystem, nextSystem)) return false;
        return (0, $4d4017bd96518208$export$d36bdfa510afb180)(prevProps, nextProps);
    }
});
var $75cc27f4cc989769$export$46919bad18fb2f76 = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "div",
    useHook: $75cc27f4cc989769$export$f66572793fa256a1
});


// Automatically generated
var $4458ff88a70db458$var$DISCLOSURE_STATE_KEYS = [
    "baseId",
    "unstable_idCountRef",
    "visible",
    "animated",
    "animating",
    "setBaseId",
    "show",
    "hide",
    "toggle",
    "setVisible",
    "setAnimated",
    "stopAnimation"
];
var $4458ff88a70db458$export$96f57966bedc81b4 = $4458ff88a70db458$var$DISCLOSURE_STATE_KEYS;
var $4458ff88a70db458$export$407448d2b89b1813 = $4458ff88a70db458$export$96f57966bedc81b4;


var $df4cab9289a261ec$export$dc9a78ed5f01f943 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "DisclosureContent",
    compose: (0, $75cc27f4cc989769$export$f66572793fa256a1),
    keys: (0, $4458ff88a70db458$export$407448d2b89b1813),
    useProps: function useProps(options, _ref) {
        var htmlOnTransitionEnd = _ref.onTransitionEnd, htmlOnAnimationEnd = _ref.onAnimationEnd, htmlStyle = _ref.style, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "onTransitionEnd",
            "onAnimationEnd",
            "style"
        ]);
        var animating = options.animated && options.animating;
        var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(null), transition = _React$useState[0], setTransition = _React$useState[1];
        var hidden = !options.visible && !animating;
        var style = hidden ? (0, $d71074b92e18808d$export$407448d2b89b1813)({
            display: "none"
        }, htmlStyle) : htmlStyle;
        var onTransitionEndRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnTransitionEnd);
        var onAnimationEndRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnAnimationEnd);
        var raf = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(0);
        (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
            if (!options.animated) return undefined; // Double RAF is needed so the browser has enough time to paint the
            // default styles before processing the `data-enter` attribute. Otherwise
            // it wouldn't be considered a transition.
            // See https://github.com/reakit/reakit/issues/643
            raf.current = window.requestAnimationFrame(function() {
                raf.current = window.requestAnimationFrame(function() {
                    if (options.visible) setTransition("enter");
                    else if (animating) setTransition("leave");
                    else setTransition(null);
                });
            });
            return function() {
                return window.cancelAnimationFrame(raf.current);
            };
        }, [
            options.animated,
            options.visible,
            animating
        ]);
        var onEnd = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            if (!(0, $71809a9b946920fa$export$7bced8f45c53f2f)(event)) return;
            if (!animating) return; // Ignores number animated
            if (options.animated === true) {
                var _options$stopAnimatio;
                (_options$stopAnimatio = options.stopAnimation) === null || _options$stopAnimatio === void 0 || _options$stopAnimatio.call(options);
            }
        }, [
            options.animated,
            animating,
            options.stopAnimation
        ]);
        var onTransitionEnd = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onTransitionEndRef$c;
            (_onTransitionEndRef$c = onTransitionEndRef.current) === null || _onTransitionEndRef$c === void 0 || _onTransitionEndRef$c.call(onTransitionEndRef, event);
            onEnd(event);
        }, [
            onEnd
        ]);
        var onAnimationEnd = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onAnimationEndRef$cu;
            (_onAnimationEndRef$cu = onAnimationEndRef.current) === null || _onAnimationEndRef$cu === void 0 || _onAnimationEndRef$cu.call(onAnimationEndRef, event);
            onEnd(event);
        }, [
            onEnd
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            id: options.baseId,
            "data-enter": transition === "enter" ? "" : undefined,
            "data-leave": transition === "leave" ? "" : undefined,
            onTransitionEnd: onTransitionEnd,
            onAnimationEnd: onAnimationEnd,
            hidden: hidden,
            style: style
        }, htmlProps);
    }
});
var $df4cab9289a261ec$export$18107fc5bf1b8a72 = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "div",
    useHook: $df4cab9289a261ec$export$dc9a78ed5f01f943
});







function $ad906d634a0d1c13$var$getBodyElement() {
    return (0, $a20c9196f0a7adc9$export$71594e8a50f746f4) ? document.body : null;
}
var $ad906d634a0d1c13$export$60d741e20e0aa309 = /*#__PURE__*/ (0, $ea42db622452d33d$export$fd42f52fd3ae1109)($ad906d634a0d1c13$var$getBodyElement());
function $ad906d634a0d1c13$export$602eac185826482c(_ref) {
    var children = _ref.children;
    // if it's a nested portal, context is the parent portal
    // otherwise it's document.body
    // https://github.com/reakit/reakit/issues/513
    var context = (0, $57da6a40a504e45b$export$fae74005e78b1a27)($ad906d634a0d1c13$export$60d741e20e0aa309) || $ad906d634a0d1c13$var$getBodyElement();
    var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(function() {
        if (0, $a20c9196f0a7adc9$export$71594e8a50f746f4) {
            var element = document.createElement("div");
            element.className = $ad906d634a0d1c13$export$602eac185826482c.__className;
            return element;
        } // ssr
        return null;
    }), hostNode = _React$useState[0];
    (0, $55d7e61099d95834$export$363c9f3eb56bbdbe)(function() {
        if (!hostNode || !context) return undefined;
        context.appendChild(hostNode);
        return function() {
            context.removeChild(hostNode);
        };
    }, [
        hostNode,
        context
    ]);
    if (hostNode) return /*#__PURE__*/ (0, $bdfb41ef79315c14$export$d39a5bbd09211389)(/*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)($ad906d634a0d1c13$export$60d741e20e0aa309.Provider, {
        value: hostNode
    }, children), hostNode);
     // ssr
    return null;
}
$ad906d634a0d1c13$export$602eac185826482c.__className = "__reakit-portal";
$ad906d634a0d1c13$export$602eac185826482c.__selector = "." + $ad906d634a0d1c13$export$602eac185826482c.__className;









var $9c72b489bb74538b$export$96f57966bedc81b4 = /*#__PURE__*/ (0, $ea42db622452d33d$export$fd42f52fd3ae1109)(undefined);



/**
 * Checks whether `arg` is empty or not.
 *
 * @example
 * import { isEmpty } from "reakit-utils";
 *
 * isEmpty([]); // true
 * isEmpty(["a"]); // false
 * isEmpty({}); // true
 * isEmpty({ a: "a" }); // false
 * isEmpty(); // true
 * isEmpty(null); // true
 * isEmpty(undefined); // true
 * isEmpty(""); // true
 */ function $69918c493af54a79$export$dd1bc94b04021eeb(arg) {
    if (Array.isArray(arg)) return !arg.length;
    if ((0, $283dac164feaf821$export$a6cdc56e425d0d0a)(arg)) return !Object.keys(arg).length;
    if (arg == null) return true;
    if (arg === "") return true;
    return false;
}


// Automatically generated
var $a5992b00ce79720a$var$DIALOG_STATE_KEYS = [
    "baseId",
    "unstable_idCountRef",
    "visible",
    "animated",
    "animating",
    "setBaseId",
    "show",
    "hide",
    "toggle",
    "setVisible",
    "setAnimated",
    "stopAnimation",
    "modal",
    "unstable_disclosureRef",
    "setModal"
];
var $a5992b00ce79720a$export$96f57966bedc81b4 = [].concat($a5992b00ce79720a$var$DIALOG_STATE_KEYS, [
    "hideOnEsc",
    "hideOnClickOutside",
    "preventBodyScroll",
    "unstable_initialFocusRef",
    "unstable_finalFocusRef",
    "unstable_orphan",
    "unstable_autoFocusOnShow",
    "unstable_autoFocusOnHide"
]);
var $a5992b00ce79720a$export$407448d2b89b1813 = $a5992b00ce79720a$var$DIALOG_STATE_KEYS;
var $a5992b00ce79720a$export$8b22cf2602fb60ce = $a5992b00ce79720a$export$407448d2b89b1813;


function $f2d0a7881eec4584$var$useDisclosureRef(dialogRef, options) {
    var ref = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    var animating = !!(options.animated && options.animating);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (options.visible || animating) return undefined; // We get the last focused element before the dialog opens, so we can move
        // focus back to it when the dialog closes.
        var onFocus = function onFocus(event) {
            var target = event.target;
            if ("focus" in target) {
                ref.current = target;
                if (options.unstable_disclosureRef) options.unstable_disclosureRef.current = target;
            }
        };
        var document = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(dialogRef.current);
        document.addEventListener("focusin", onFocus);
        return function() {
            return document.removeEventListener("focusin", onFocus);
        };
    }, [
        options.visible,
        animating,
        options.unstable_disclosureRef,
        dialogRef
    ]);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var _options$unstable_dis;
        if (!options.visible || animating) return undefined; // Safari and Firefox on MacOS don't focus on buttons on mouse down.
        // Instead, they focus on the closest focusable parent (ultimately, the
        // body element). This works around that by preventing that behavior and
        // forcing focus on the disclosure button. Otherwise, we wouldn't be able
        // to close the dialog by clicking again on the disclosure.
        var onMouseDown = function onMouseDown(event) {
            var element = event.currentTarget;
            if (!(0, $62d22d716c62d21c$export$35a0171ee384c875)(element)) return;
            event.preventDefault();
            element.focus();
        };
        var disclosure = ((_options$unstable_dis = options.unstable_disclosureRef) === null || _options$unstable_dis === void 0 ? void 0 : _options$unstable_dis.current) || ref.current;
        disclosure === null || disclosure === void 0 || disclosure.addEventListener("mousedown", onMouseDown);
        return function() {
            return disclosure === null || disclosure === void 0 ? void 0 : disclosure.removeEventListener("mousedown", onMouseDown);
        };
    }, [
        options.visible,
        animating,
        options.unstable_disclosureRef
    ]);
    return options.unstable_disclosureRef || ref;
}
function $f2d0a7881eec4584$var$usePreventBodyScroll(targetRef, options) {
    var shouldPrevent = Boolean(options.preventBodyScroll && options.visible);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var element = targetRef.current;
        if (!element || !shouldPrevent) return undefined;
        (0, $20fc110fa38d0af9$export$24fdf68abf432c44)(element, {
            reserveScrollBarGap: true
        });
        return function() {
            return (0, $20fc110fa38d0af9$export$e5d0524c3725571e)(element);
        };
    }, [
        targetRef,
        shouldPrevent
    ]);
}
function $f2d0a7881eec4584$var$useFocusOnShow(dialogRef, nestedDialogs, options) {
    var initialFocusRef = options.unstable_initialFocusRef;
    var shouldFocus = options.visible && options.unstable_autoFocusOnShow;
    var animating = !!(options.animated && options.animating);
    (0, $f4e9b5aacaa1f234$export$496315a1608d9602)(function() {
        var dialog = dialogRef.current;
        if (!shouldFocus) return;
        if (!dialog) return;
        if (animating) return; // If there're nested open dialogs, let them handle focus
        if (nestedDialogs.some(function(child) {
            return child.current && !child.current.hidden;
        })) return;
        if (initialFocusRef !== null && initialFocusRef !== void 0 && initialFocusRef.current) initialFocusRef.current.focus({
            preventScroll: true
        });
        else {
            var tabbable = (0, $0f37bdbc1405f89e$export$168b663469d4c75e)(dialog, true);
            var isActive = function isActive() {
                return (0, $1f8dcff49c1e0404$export$848589947316f680)(dialog);
            };
            if (tabbable) (0, $2feaa9579ddfa1c6$export$f324b2d22fd95a05)(tabbable, {
                preventScroll: true,
                isActive: isActive
            });
            else (0, $2feaa9579ddfa1c6$export$f324b2d22fd95a05)(dialog, {
                preventScroll: true,
                isActive: isActive
            });
        }
    }, [
        dialogRef,
        shouldFocus,
        animating,
        nestedDialogs,
        initialFocusRef
    ]);
}
function $f2d0a7881eec4584$var$usePortalRef(dialogRef, options) {
    var portalRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var dialog = dialogRef.current;
        if (!dialog || !options.visible) return;
        portalRef.current = (0, $0072e8bbe9b36c2e$export$ff7f7c97cdce86e)(dialog, (0, $ad906d634a0d1c13$export$602eac185826482c).__selector);
    }, [
        dialogRef,
        options.visible
    ]);
    return portalRef;
}
function $f2d0a7881eec4584$var$removeFromDOM(element) {
    if (element.parentNode == null) return;
    element.parentNode.removeChild(element);
}
var $f2d0a7881eec4584$var$focusTrapClassName = "__reakit-focus-trap";
function $f2d0a7881eec4584$var$isFocusTrap(element) {
    var _element$classList;
    return (_element$classList = element.classList) === null || _element$classList === void 0 ? void 0 : _element$classList.contains($f2d0a7881eec4584$var$focusTrapClassName);
}
function $f2d0a7881eec4584$var$useFocusTrap(dialogRef, visibleModals, options) {
    var portalRef = $f2d0a7881eec4584$var$usePortalRef(dialogRef, options);
    var shouldTrap = options.visible && options.modal;
    var beforeElement = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    var afterElement = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null); // Create before and after elements
    // https://github.com/w3c/aria-practices/issues/545
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (!shouldTrap) return undefined;
        var portal = portalRef.current;
        if (!portal) return undefined;
        if (!beforeElement.current) {
            var document = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(portal);
            beforeElement.current = document.createElement("div");
            beforeElement.current.className = $f2d0a7881eec4584$var$focusTrapClassName;
            beforeElement.current.tabIndex = 0;
            beforeElement.current.style.position = "fixed";
            beforeElement.current.setAttribute("aria-hidden", "true");
        }
        if (!afterElement.current) afterElement.current = beforeElement.current.cloneNode();
        portal.insertAdjacentElement("beforebegin", beforeElement.current);
        portal.insertAdjacentElement("afterend", afterElement.current);
        return function() {
            if (beforeElement.current) $f2d0a7881eec4584$var$removeFromDOM(beforeElement.current);
            if (afterElement.current) $f2d0a7881eec4584$var$removeFromDOM(afterElement.current);
        };
    }, [
        portalRef,
        shouldTrap
    ]); // Focus trap
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var before = beforeElement.current;
        var after = afterElement.current;
        if (!shouldTrap || !before || !after) return undefined;
        var handleFocus = function handleFocus(event) {
            var dialog = dialogRef.current;
            if (!dialog || visibleModals.length) return;
            event.preventDefault();
            var isAfter = event.target === after;
            var tabbable = isAfter ? (0, $0f37bdbc1405f89e$export$168b663469d4c75e)(dialog) : (0, $0f37bdbc1405f89e$export$a6fe3106a93f5f4b)(dialog);
            if (tabbable) tabbable.focus();
            else // fallback to dialog
            dialog.focus();
        };
        before.addEventListener("focus", handleFocus);
        after.addEventListener("focus", handleFocus);
        return function() {
            before.removeEventListener("focus", handleFocus);
            after.removeEventListener("focus", handleFocus);
        };
    }, [
        dialogRef,
        visibleModals,
        shouldTrap
    ]);
}
function $f2d0a7881eec4584$var$hidByFocusingAnotherElement(dialogRef) {
    var dialog = dialogRef.current;
    if (!dialog) return false;
    var activeElement = (0, $555da54edda577d6$export$cd4e5573fbe2b576)(dialog);
    if (!activeElement) return false;
    if ((0, $28e71a18d15190f3$export$2344b14b097df817)(dialog, activeElement)) return false;
    if ((0, $0f37bdbc1405f89e$export$bebd5a1431fec25d)(activeElement)) return true;
    if (activeElement.getAttribute("data-dialog") === "true") return true;
    return false;
}
function $f2d0a7881eec4584$var$useFocusOnHide(dialogRef, disclosureRef, options) {
    var shouldFocus = options.unstable_autoFocusOnHide && !options.visible;
    var animating = !!(options.animated && options.animating);
    (0, $f4e9b5aacaa1f234$export$496315a1608d9602)(function() {
        var _options$unstable_fin;
        if (!shouldFocus) return;
        if (animating) return; // Hide was triggered by a click/focus on a tabbable element outside
        // the dialog or on another dialog. We won't change focus then.
        if ($f2d0a7881eec4584$var$hidByFocusingAnotherElement(dialogRef)) return;
        var finalFocusEl = ((_options$unstable_fin = options.unstable_finalFocusRef) === null || _options$unstable_fin === void 0 ? void 0 : _options$unstable_fin.current) || disclosureRef.current;
        if (finalFocusEl) {
            if (finalFocusEl.id) {
                var document = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(finalFocusEl);
                var compositeElement = document.querySelector("[aria-activedescendant='" + finalFocusEl.id + "']");
                if (compositeElement) {
                    (0, $2feaa9579ddfa1c6$export$f324b2d22fd95a05)(compositeElement);
                    return;
                }
            }
            (0, $2feaa9579ddfa1c6$export$f324b2d22fd95a05)(finalFocusEl);
            return;
        }
    }, [
        shouldFocus,
        animating,
        dialogRef,
        disclosureRef
    ]);
}
var $f2d0a7881eec4584$var$DialogContext = /*#__PURE__*/ (0, $ea42db622452d33d$export$fd42f52fd3ae1109)({});
function $f2d0a7881eec4584$var$useNestedDialogs(dialogRef, options) {
    var context = (0, $57da6a40a504e45b$export$fae74005e78b1a27)($f2d0a7881eec4584$var$DialogContext);
    var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)([]), dialogs = _React$useState[0], setDialogs = _React$useState[1];
    var _React$useState2 = (0, $57da6a40a504e45b$export$60241385465d0a34)(dialogs), visibleModals = _React$useState2[0], setVisibleModals = _React$useState2[1];
    var addDialog = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(ref) {
        var _context$addDialog;
        (_context$addDialog = context.addDialog) === null || _context$addDialog === void 0 || _context$addDialog.call(context, ref);
        setDialogs(function(prevDialogs) {
            return [].concat(prevDialogs, [
                ref
            ]);
        });
    }, [
        context.addDialog
    ]);
    var removeDialog = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(ref) {
        var _context$removeDialog;
        (_context$removeDialog = context.removeDialog) === null || _context$removeDialog === void 0 || _context$removeDialog.call(context, ref);
        setDialogs(function(prevDialogs) {
            return (0, $de6ff87616121ffa$export$b5a6009d2116a5b6)(prevDialogs, ref);
        });
    }, [
        context.removeDialog
    ]);
    var showDialog = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(ref) {
        var _context$showDialog;
        (_context$showDialog = context.showDialog) === null || _context$showDialog === void 0 || _context$showDialog.call(context, ref);
        setVisibleModals(function(prevDialogs) {
            return [].concat(prevDialogs, [
                ref
            ]);
        });
    }, [
        context.showDialog
    ]);
    var hideDialog = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(ref) {
        var _context$hideDialog;
        (_context$hideDialog = context.hideDialog) === null || _context$hideDialog === void 0 || _context$hideDialog.call(context, ref);
        setVisibleModals(function(prevDialogs) {
            return (0, $de6ff87616121ffa$export$b5a6009d2116a5b6)(prevDialogs, ref);
        });
    }, [
        context.hideDialog
    ]); // If it's a nested dialog, add it to context
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var _context$addDialog2;
        if (options.unstable_orphan) return undefined;
        (_context$addDialog2 = context.addDialog) === null || _context$addDialog2 === void 0 || _context$addDialog2.call(context, dialogRef);
        return function() {
            var _context$removeDialog2;
            (_context$removeDialog2 = context.removeDialog) === null || _context$removeDialog2 === void 0 || _context$removeDialog2.call(context, dialogRef);
        };
    }, [
        options.unstable_orphan,
        context.addDialog,
        dialogRef,
        context.removeDialog
    ]);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var _context$showDialog2;
        if (options.unstable_orphan) return undefined;
        if (!options.modal) return undefined;
        if (!options.visible) return undefined;
        (_context$showDialog2 = context.showDialog) === null || _context$showDialog2 === void 0 || _context$showDialog2.call(context, dialogRef);
        return function() {
            var _context$hideDialog2;
            (_context$hideDialog2 = context.hideDialog) === null || _context$hideDialog2 === void 0 || _context$hideDialog2.call(context, dialogRef);
        };
    }, [
        options.unstable_orphan,
        options.modal,
        options.visible,
        context.showDialog,
        dialogRef,
        context.hideDialog
    ]); // Close all nested dialogs when parent dialog closes
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (context.visible === false && options.visible && !options.unstable_orphan) {
            var _options$hide;
            (_options$hide = options.hide) === null || _options$hide === void 0 || _options$hide.call(options);
        }
    }, [
        context.visible,
        options.visible,
        options.hide,
        options.unstable_orphan
    ]); // Provider
    var providerValue = (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        return {
            visible: options.visible,
            addDialog: addDialog,
            removeDialog: removeDialog,
            showDialog: showDialog,
            hideDialog: hideDialog
        };
    }, [
        options.visible,
        addDialog,
        removeDialog,
        showDialog,
        hideDialog
    ]);
    var wrap = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(element) {
        return /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)($f2d0a7881eec4584$var$DialogContext.Provider, {
            value: providerValue
        }, element);
    }, [
        providerValue
    ]);
    return {
        dialogs: dialogs,
        visibleModals: visibleModals,
        wrap: wrap
    };
}
function $f2d0a7881eec4584$var$dialogContains(target) {
    return function(dialogRef) {
        var dialog = dialogRef.current;
        if (!dialog) return false;
        if ((0, $28e71a18d15190f3$export$2344b14b097df817)(dialog, target)) return true;
        var document = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(dialog);
        var backdrop = document.querySelector("[data-dialog-ref=\"" + dialog.id + "\"]");
        if (backdrop) return (0, $28e71a18d15190f3$export$2344b14b097df817)(backdrop, target);
        return false;
    };
}
function $f2d0a7881eec4584$var$isDisclosure(target, disclosure) {
    return (0, $28e71a18d15190f3$export$2344b14b097df817)(disclosure, target);
}
function $f2d0a7881eec4584$var$isInDocument(target) {
    var document = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(target);
    if (target.tagName === "HTML") return true;
    return (0, $28e71a18d15190f3$export$2344b14b097df817)(document.body, target);
}
function $f2d0a7881eec4584$var$useEventListenerOutside(containerRef, disclosureRef, nestedDialogs, eventType, listener, shouldListen, capture) {
    var listenerRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(listener);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (!shouldListen) return undefined;
        var onEvent = function onEvent(event) {
            if (!listenerRef.current) return;
            var container = containerRef.current;
            var disclosure = disclosureRef.current;
            var target = event.target;
            if (!container) return;
             // When an element is unmounted right after it receives focus, the focus
            // event is triggered after that, when the element isn't part of the
            // current document anymore. So we ignore it.
            if (!$f2d0a7881eec4584$var$isInDocument(target)) return; // Event inside dialog
            if ((0, $28e71a18d15190f3$export$2344b14b097df817)(container, target)) return; // Event on disclosure
            if (disclosure && $f2d0a7881eec4584$var$isDisclosure(target, disclosure)) return; // Event inside a nested dialog or focus trap
            if ($f2d0a7881eec4584$var$isFocusTrap(target) || nestedDialogs.some($f2d0a7881eec4584$var$dialogContains(target))) return;
            listenerRef.current(event);
        };
        var document = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(containerRef.current);
        document.addEventListener(eventType, onEvent, capture);
        return function() {
            return document.removeEventListener(eventType, onEvent, capture);
        };
    }, [
        containerRef,
        disclosureRef,
        nestedDialogs,
        eventType,
        shouldListen,
        listenerRef
    ]);
}
function $f2d0a7881eec4584$var$useMouseDownRef(dialogRef, options) {
    var mouseDownRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)();
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (!options.visible) return undefined;
        if (!options.hideOnClickOutside) return undefined;
        var document = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(dialogRef.current);
        var onMouseDown = function onMouseDown(event) {
            mouseDownRef.current = event.target;
        };
        document.addEventListener("mousedown", onMouseDown);
        return function() {
            return document.removeEventListener("mousedown", onMouseDown);
        };
    }, [
        options.visible,
        options.hideOnClickOutside,
        dialogRef
    ]);
    return mouseDownRef;
}
function $f2d0a7881eec4584$var$useHideOnClickOutside(dialogRef, disclosureRef, nestedDialogs, options) {
    var mouseDownRef = $f2d0a7881eec4584$var$useMouseDownRef(dialogRef, options);
    $f2d0a7881eec4584$var$useEventListenerOutside(dialogRef, disclosureRef, nestedDialogs, "click", function(event) {
        // Make sure the element that has been clicked is the same that last
        // triggered the mousedown event. This prevents the dialog from closing
        // by dragging the cursor (for example, selecting some text inside the
        // dialog and releasing the mouse outside of it).
        if (mouseDownRef.current === event.target) {
            var _options$hide;
            (_options$hide = options.hide) === null || _options$hide === void 0 || _options$hide.call(options);
        }
    }, options.visible && options.hideOnClickOutside);
    $f2d0a7881eec4584$var$useEventListenerOutside(dialogRef, disclosureRef, nestedDialogs, "focusin", function(event) {
        var document = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(dialogRef.current); // Fix for https://github.com/reakit/reakit/issues/619
        // On IE11, calling element.blur() triggers the focus event on
        // document.body, so we make sure to ignore it as well.
        if (event.target !== document && event.target !== document.body) {
            var _options$hide2;
            (_options$hide2 = options.hide) === null || _options$hide2 === void 0 || _options$hide2.call(options);
        }
    }, options.visible && options.hideOnClickOutside);
}
function $f2d0a7881eec4584$var$useDisableHoverOutside(portalRef, nestedDialogs, options) {
    var useEvent = function useEvent(eventType) {
        return $f2d0a7881eec4584$var$useEventListenerOutside(portalRef, {
            current: null
        }, nestedDialogs, eventType, function(event) {
            event.stopPropagation();
            event.preventDefault();
        }, options.visible && options.modal, true);
    };
    useEvent("mouseover");
    useEvent("mousemove");
    useEvent("mouseout");
}
/**
 * When the focused child gets removed from the DOM, we make sure to move focus
 * to the dialog.
 */ function $f2d0a7881eec4584$var$useFocusOnChildUnmount(dialogRef, options) {
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var dialog = dialogRef.current;
        if (!options.visible || !dialog) return undefined;
        var observer = new MutationObserver(function(mutations) {
            var target = mutations[0].target; // If target is not this dialog, then this observer was triggered by a
            // nested dialog, so we just ignore it here and let the nested dialog
            // handle it there.
            if (target !== dialog) return;
            var document = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(dialog);
            var activeElement = (0, $555da54edda577d6$export$cd4e5573fbe2b576)(dialog); // We can check if the current focused element is the document body. On
            // IE 11, it's an empty object when the current document is in a frame or
            // iframe.
            if (activeElement === document.body || (0, $69918c493af54a79$export$dd1bc94b04021eeb)(activeElement)) dialog.focus();
        });
        observer.observe(dialog, {
            childList: true,
            subtree: true
        });
        return function() {
            observer.disconnect();
        };
    }, [
        options.visible,
        dialogRef
    ]);
}
function $f2d0a7881eec4584$var$isActualElement(element) {
    return element && element.tagName && element.tagName !== "HTML" && element !== (0, $2e594f29f3297da7$export$f65ca476c09acec0)(element).body;
}
function $f2d0a7881eec4584$var$useFocusOnBlur(dialogRef, options) {
    var _React$useReducer = (0, $57da6a40a504e45b$export$13e3392192263954)(function(n) {
        return n + 1;
    }, 0), blurred = _React$useReducer[0], scheduleFocus = _React$useReducer[1];
    (0, $55d7e61099d95834$export$363c9f3eb56bbdbe)(function() {
        var dialog = dialogRef.current;
        if (!options.visible) return;
        if (!blurred) return; // After blur, if the active element isn't an actual element, this probably
        // means that element.blur() was called on an element inside the dialog.
        // In this case, the browser will automatically focus the body element.
        // So we move focus back to the dialog.
        if (!$f2d0a7881eec4584$var$isActualElement((0, $555da54edda577d6$export$cd4e5573fbe2b576)(dialog))) dialog === null || dialog === void 0 || dialog.focus();
    }, [
        blurred,
        dialogRef
    ]);
    var onBlur = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
        if (!options.visible) return;
        var nextActiveElement = (0, $b9e9b492c14d338e$export$e56b097fab4b0a4f)(event);
        if (!$f2d0a7881eec4584$var$isActualElement(nextActiveElement)) scheduleFocus();
    }, [
        options.visible
    ]);
    return onBlur;
}
var $f2d0a7881eec4584$export$d55e7ee900f34e93 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "Dialog",
    compose: (0, $df4cab9289a261ec$export$dc9a78ed5f01f943),
    keys: (0, $a5992b00ce79720a$export$96f57966bedc81b4),
    useOptions: function useOptions(_ref) {
        var _ref$modal = _ref.modal, modal = _ref$modal === void 0 ? true : _ref$modal, _ref$hideOnEsc = _ref.hideOnEsc, hideOnEsc = _ref$hideOnEsc === void 0 ? true : _ref$hideOnEsc, _ref$hideOnClickOutsi = _ref.hideOnClickOutside, hideOnClickOutside = _ref$hideOnClickOutsi === void 0 ? true : _ref$hideOnClickOutsi, _ref$preventBodyScrol = _ref.preventBodyScroll, preventBodyScroll = _ref$preventBodyScrol === void 0 ? modal : _ref$preventBodyScrol, _ref$unstable_autoFoc = _ref.unstable_autoFocusOnShow, unstable_autoFocusOnShow = _ref$unstable_autoFoc === void 0 ? true : _ref$unstable_autoFoc, _ref$unstable_autoFoc2 = _ref.unstable_autoFocusOnHide, unstable_autoFocusOnHide = _ref$unstable_autoFoc2 === void 0 ? true : _ref$unstable_autoFoc2, unstable_orphan = _ref.unstable_orphan, options = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "modal",
            "hideOnEsc",
            "hideOnClickOutside",
            "preventBodyScroll",
            "unstable_autoFocusOnShow",
            "unstable_autoFocusOnHide",
            "unstable_orphan"
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            modal: modal,
            hideOnEsc: hideOnEsc,
            hideOnClickOutside: hideOnClickOutside,
            preventBodyScroll: modal && preventBodyScroll,
            unstable_autoFocusOnShow: unstable_autoFocusOnShow,
            unstable_autoFocusOnHide: unstable_autoFocusOnHide,
            unstable_orphan: modal && unstable_orphan
        }, options);
    },
    useProps: function useProps(options, _ref2) {
        var htmlRef = _ref2.ref, htmlOnKeyDown = _ref2.onKeyDown, htmlOnBlur = _ref2.onBlur, htmlWrapElement = _ref2.wrapElement, tabIndex = _ref2.tabIndex, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref2, [
            "ref",
            "onKeyDown",
            "onBlur",
            "wrapElement",
            "tabIndex"
        ]);
        var dialog = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
        var backdrop = (0, $57da6a40a504e45b$export$fae74005e78b1a27)((0, $9c72b489bb74538b$export$96f57966bedc81b4));
        var hasBackdrop = backdrop && backdrop === options.baseId;
        var disclosure = $f2d0a7881eec4584$var$useDisclosureRef(dialog, options);
        var onKeyDownRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnKeyDown);
        var onBlurRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnBlur);
        var focusOnBlur = $f2d0a7881eec4584$var$useFocusOnBlur(dialog, options);
        var _useNestedDialogs = $f2d0a7881eec4584$var$useNestedDialogs(dialog, options), dialogs = _useNestedDialogs.dialogs, visibleModals = _useNestedDialogs.visibleModals, wrap = _useNestedDialogs.wrap; // VoiceOver/Safari accepts only one `aria-modal` container, so if there
        // are visible child modals, then we don't want to set aria-modal on the
        // parent modal (this component).
        var modal = options.modal && !visibleModals.length ? true : undefined;
        $f2d0a7881eec4584$var$usePreventBodyScroll(dialog, options);
        $f2d0a7881eec4584$var$useFocusTrap(dialog, visibleModals, options);
        $f2d0a7881eec4584$var$useFocusOnChildUnmount(dialog, options);
        $f2d0a7881eec4584$var$useFocusOnShow(dialog, dialogs, options);
        $f2d0a7881eec4584$var$useFocusOnHide(dialog, disclosure, options);
        $f2d0a7881eec4584$var$useHideOnClickOutside(dialog, disclosure, dialogs, options);
        $f2d0a7881eec4584$var$useDisableHoverOutside(dialog, dialogs, options);
        var onKeyDown = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onKeyDownRef$current;
            (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 || _onKeyDownRef$current.call(onKeyDownRef, event);
            if (event.defaultPrevented) return;
            if (event.key !== "Escape") return;
            if (!options.hideOnEsc) return;
            if (!options.hide) return;
            event.stopPropagation();
            options.hide();
        }, [
            options.hideOnEsc,
            options.hide
        ]);
        var onBlur = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onBlurRef$current;
            (_onBlurRef$current = onBlurRef.current) === null || _onBlurRef$current === void 0 || _onBlurRef$current.call(onBlurRef, event);
            focusOnBlur(event);
        }, [
            focusOnBlur
        ]);
        var wrapElement = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(element) {
            element = wrap(element);
            if (options.modal && !hasBackdrop) element = /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)((0, $ad906d634a0d1c13$export$602eac185826482c), null, element);
            if (htmlWrapElement) element = htmlWrapElement(element);
            return(/*#__PURE__*/ // Prevents Menu > Dialog > Menu to behave as a sub menu
            (0, $ea42db622452d33d$export$c8a8987d4410bf2d)((0, $dfdde098fbc56812$export$3a1a48c8f6ef640e).Provider, {
                value: null
            }, element));
        }, [
            wrap,
            options.modal,
            hasBackdrop,
            htmlWrapElement
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            ref: (0, $f08be812be5c38c7$export$ebc1e1560c2dffa5)(dialog, htmlRef),
            role: "dialog",
            tabIndex: tabIndex != null ? tabIndex : -1,
            "aria-modal": modal,
            "data-dialog": true,
            onKeyDown: onKeyDown,
            onBlur: onBlur,
            wrapElement: wrapElement
        }, htmlProps);
    }
});
var $f2d0a7881eec4584$export$3ddf2d174ce01153 = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "div",
    useHook: $f2d0a7881eec4584$export$d55e7ee900f34e93,
    useCreateElement: function useCreateElement$1(type, props, children) {
        return (0, $1ab3ad06070c6ba8$export$cfb2bb2ead21514)(type, props, children);
    }
});









// Automatically generated
var $1e705df99b3c8b2e$var$POPOVER_STATE_KEYS = [
    "baseId",
    "unstable_idCountRef",
    "visible",
    "animated",
    "animating",
    "setBaseId",
    "show",
    "hide",
    "toggle",
    "setVisible",
    "setAnimated",
    "stopAnimation",
    "modal",
    "unstable_disclosureRef",
    "setModal",
    "unstable_referenceRef",
    "unstable_popoverRef",
    "unstable_arrowRef",
    "unstable_popoverStyles",
    "unstable_arrowStyles",
    "unstable_originalPlacement",
    "unstable_update",
    "placement",
    "place"
];
var $1e705df99b3c8b2e$export$56c0d5a1e737357d = $1e705df99b3c8b2e$var$POPOVER_STATE_KEYS;
var $1e705df99b3c8b2e$export$407448d2b89b1813 = [].concat($1e705df99b3c8b2e$export$56c0d5a1e737357d, [
    "size"
]);
var $1e705df99b3c8b2e$export$8b22cf2602fb60ce = $1e705df99b3c8b2e$export$56c0d5a1e737357d;
var $1e705df99b3c8b2e$export$db3b6bfb95261072 = $1e705df99b3c8b2e$export$8b22cf2602fb60ce;


var $d02f9b98b9975853$export$542a6fd13ac93354 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "Popover",
    compose: (0, $f2d0a7881eec4584$export$d55e7ee900f34e93),
    keys: (0, $1e705df99b3c8b2e$export$56c0d5a1e737357d),
    useOptions: function useOptions(_ref) {
        var _ref$modal = _ref.modal, modal = _ref$modal === void 0 ? false : _ref$modal, options = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "modal"
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            modal: modal
        }, options);
    },
    useProps: function useProps(options, _ref2) {
        var htmlRef = _ref2.ref, htmlStyle = _ref2.style, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref2, [
            "ref",
            "style"
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            ref: (0, $f08be812be5c38c7$export$ebc1e1560c2dffa5)(options.unstable_popoverRef, htmlRef),
            style: (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, options.unstable_popoverStyles), htmlStyle)
        }, htmlProps);
    }
});
var $d02f9b98b9975853$export$5b6b19405a83ff9d = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "div",
    useHook: $d02f9b98b9975853$export$542a6fd13ac93354,
    useCreateElement: function useCreateElement$1(type, props, children) {
        return (0, $1ab3ad06070c6ba8$export$cfb2bb2ead21514)(type, props, children);
    }
});





























































/**
 * Checks if a given string exists in the user agent string.
 */ function $bebe121caf466eee$export$c6c808688353c659(string) {
    if (!(0, $a20c9196f0a7adc9$export$71594e8a50f746f4)) return false;
    return window.navigator.userAgent.indexOf(string) !== -1;
}




// Automatically generated
var $d0165fcee407dc86$var$TABBABLE_KEYS = [
    "disabled",
    "focusable"
];
var $d0165fcee407dc86$var$isSafariOrFirefoxOnMac = (0, $bebe121caf466eee$export$c6c808688353c659)("Mac") && !(0, $bebe121caf466eee$export$c6c808688353c659)("Chrome") && ((0, $bebe121caf466eee$export$c6c808688353c659)("Safari") || (0, $bebe121caf466eee$export$c6c808688353c659)("Firefox"));
function $d0165fcee407dc86$var$focusIfNeeded(element) {
    if (!(0, $1f8dcff49c1e0404$export$848589947316f680)(element) && (0, $0f37bdbc1405f89e$export$4c063cf1350e6fed)(element)) element.focus();
}
function $d0165fcee407dc86$var$isNativeTabbable(element) {
    return [
        "BUTTON",
        "INPUT",
        "SELECT",
        "TEXTAREA",
        "A"
    ].includes(element.tagName);
}
function $d0165fcee407dc86$var$supportsDisabledAttribute(element) {
    return [
        "BUTTON",
        "INPUT",
        "SELECT",
        "TEXTAREA"
    ].includes(element.tagName);
}
function $d0165fcee407dc86$var$getTabIndex(trulyDisabled, nativeTabbable, supportsDisabled, htmlTabIndex) {
    if (trulyDisabled) {
        if (nativeTabbable && !supportsDisabled) // Anchor, audio and video tags don't support the `disabled` attribute.
        // We must pass tabIndex={-1} so they don't receive focus on tab.
        return -1;
         // Elements that support the `disabled` attribute don't need tabIndex.
        return undefined;
    }
    if (nativeTabbable) // If the element is enabled and it's natively tabbable, we don't need to
    // specify a tabIndex attribute unless it's explicitly set by the user.
    return htmlTabIndex;
     // If the element is enabled and is not natively tabbable, we have to
    // fallback tabIndex={0}.
    return htmlTabIndex || 0;
}
function $d0165fcee407dc86$var$useDisableEvent(htmlEventRef, disabled) {
    return (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
        var _htmlEventRef$current;
        (_htmlEventRef$current = htmlEventRef.current) === null || _htmlEventRef$current === void 0 || _htmlEventRef$current.call(htmlEventRef, event);
        if (event.defaultPrevented) return;
        if (disabled) {
            event.stopPropagation();
            event.preventDefault();
        }
    }, [
        htmlEventRef,
        disabled
    ]);
}
var $d0165fcee407dc86$export$1f2f0004dd086edb = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "Tabbable",
    compose: (0, $75cc27f4cc989769$export$f66572793fa256a1),
    keys: $d0165fcee407dc86$var$TABBABLE_KEYS,
    useOptions: function useOptions(options, _ref) {
        var disabled = _ref.disabled;
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            disabled: disabled
        }, options);
    },
    useProps: function useProps(options, _ref2) {
        var htmlRef = _ref2.ref, htmlTabIndex = _ref2.tabIndex, htmlOnClickCapture = _ref2.onClickCapture, htmlOnMouseDownCapture = _ref2.onMouseDownCapture, htmlOnMouseDown = _ref2.onMouseDown, htmlOnKeyPressCapture = _ref2.onKeyPressCapture, htmlStyle = _ref2.style, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref2, [
            "ref",
            "tabIndex",
            "onClickCapture",
            "onMouseDownCapture",
            "onMouseDown",
            "onKeyPressCapture",
            "style"
        ]);
        var ref = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
        var onClickCaptureRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnClickCapture);
        var onMouseDownCaptureRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnMouseDownCapture);
        var onMouseDownRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnMouseDown);
        var onKeyPressCaptureRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnKeyPressCapture);
        var trulyDisabled = !!options.disabled && !options.focusable;
        var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(true), nativeTabbable = _React$useState[0], setNativeTabbable = _React$useState[1];
        var _React$useState2 = (0, $57da6a40a504e45b$export$60241385465d0a34)(true), supportsDisabled = _React$useState2[0], setSupportsDisabled = _React$useState2[1];
        var style = options.disabled ? (0, $d71074b92e18808d$export$407448d2b89b1813)({
            pointerEvents: "none"
        }, htmlStyle) : htmlStyle;
        (0, $55d7e61099d95834$export$363c9f3eb56bbdbe)(function() {
            var tabbable = ref.current;
            if (!tabbable) return;
            if (!$d0165fcee407dc86$var$isNativeTabbable(tabbable)) setNativeTabbable(false);
            if (!$d0165fcee407dc86$var$supportsDisabledAttribute(tabbable)) setSupportsDisabled(false);
        }, []);
        var onClickCapture = $d0165fcee407dc86$var$useDisableEvent(onClickCaptureRef, options.disabled);
        var onMouseDownCapture = $d0165fcee407dc86$var$useDisableEvent(onMouseDownCaptureRef, options.disabled);
        var onKeyPressCapture = $d0165fcee407dc86$var$useDisableEvent(onKeyPressCaptureRef, options.disabled);
        var onMouseDown = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onMouseDownRef$curre;
            (_onMouseDownRef$curre = onMouseDownRef.current) === null || _onMouseDownRef$curre === void 0 || _onMouseDownRef$curre.call(onMouseDownRef, event);
            var element = event.currentTarget;
            if (event.defaultPrevented) return; // Safari and Firefox on MacOS don't focus on buttons on mouse down
            // like other browsers/platforms. Instead, they focus on the closest
            // focusable ancestor element, which is ultimately the body element. So
            // we make sure to give focus to the tabbable element on mouse down so
            // it works consistently across browsers.
            if (!$d0165fcee407dc86$var$isSafariOrFirefoxOnMac) return;
            if ((0, $fb6a1f3bf7908434$export$af57ec5ec914349c)(event)) return;
            if (!(0, $62d22d716c62d21c$export$35a0171ee384c875)(element)) return; // We can't focus right away after on mouse down, otherwise it would
            // prevent drag events from happening. So we schedule the focus to the
            // next animation frame.
            var raf = requestAnimationFrame(function() {
                element.removeEventListener("mouseup", focusImmediately, true);
                $d0165fcee407dc86$var$focusIfNeeded(element);
            }); // If mouseUp happens before the next animation frame (which is common
            // on touch screens or by just tapping the trackpad on MacBook's), we
            // cancel the animation frame and immediately focus on the element.
            var focusImmediately = function focusImmediately() {
                cancelAnimationFrame(raf);
                $d0165fcee407dc86$var$focusIfNeeded(element);
            }; // By listening to the event in the capture phase, we make sure the
            // focus event is fired before the onMouseUp and onMouseUpCapture React
            // events, which is aligned with the default browser behavior.
            element.addEventListener("mouseup", focusImmediately, {
                once: true,
                capture: true
            });
        }, []);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            ref: (0, $f08be812be5c38c7$export$ebc1e1560c2dffa5)(ref, htmlRef),
            style: style,
            tabIndex: $d0165fcee407dc86$var$getTabIndex(trulyDisabled, nativeTabbable, supportsDisabled, htmlTabIndex),
            disabled: trulyDisabled && supportsDisabled ? true : undefined,
            "aria-disabled": options.disabled ? true : undefined,
            onClickCapture: onClickCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseDown: onMouseDown,
            onKeyPressCapture: onKeyPressCapture
        }, htmlProps);
    }
});
var $d0165fcee407dc86$export$7307f988e145082f = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "div",
    useHook: $d0165fcee407dc86$export$1f2f0004dd086edb
});







/**
 * Creates an `Event` in a way that also works on IE 11.
 *
 * @example
 * import { createEvent } from "reakit-utils";
 *
 * const el = document.getElementById("id");
 * el.dispatchEvent(createEvent(el, "blur", { bubbles: false }));
 */ function $f63dd635c742cc29$export$c30017717ce2168e(element, type, eventInit) {
    if (typeof Event === "function") return new Event(type, eventInit);
     // IE 11 doesn't support Event constructors
    var event = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(element).createEvent("Event");
    event.initEvent(type, eventInit === null || eventInit === void 0 ? void 0 : eventInit.bubbles, eventInit === null || eventInit === void 0 ? void 0 : eventInit.cancelable);
    return event;
}


function $1aae2411f2afb694$var$createFocusEvent(element, type, eventInit) {
    if (eventInit === void 0) eventInit = {};
    if (typeof FocusEvent === "function") return new FocusEvent(type, eventInit);
    return (0, $f63dd635c742cc29$export$c30017717ce2168e)(element, type, eventInit);
}
/**
 * Creates and dispatches a blur event in a way that also works on IE 11.
 *
 * @example
 * import { fireBlurEvent } from "reakit-utils";
 *
 * fireBlurEvent(document.getElementById("id"));
 */ function $1aae2411f2afb694$export$7017b330269bb60a(element, eventInit) {
    var event = $1aae2411f2afb694$var$createFocusEvent(element, "blur", eventInit);
    var defaultAllowed = element.dispatchEvent(event);
    var bubbleInit = (0, $59a074d174b882e5$export$407448d2b89b1813)((0, $59a074d174b882e5$export$407448d2b89b1813)({}, eventInit), {}, {
        bubbles: true
    });
    element.dispatchEvent($1aae2411f2afb694$var$createFocusEvent(element, "focusout", bubbleInit));
    return defaultAllowed;
}




function $45834b4fab4d6c15$var$createKeyboardEvent(element, type, eventInit) {
    if (eventInit === void 0) eventInit = {};
    if (typeof KeyboardEvent === "function") return new KeyboardEvent(type, eventInit);
     // IE 11 doesn't support Event constructors
    var event = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(element).createEvent("KeyboardEvent");
    event.initKeyboardEvent(type, eventInit.bubbles, eventInit.cancelable, (0, $e2bcac3b3b53ce44$export$38b2d434cce3ea22)(element), eventInit.key, eventInit.location, eventInit.ctrlKey, eventInit.altKey, eventInit.shiftKey, eventInit.metaKey);
    return event;
}
/**
 * Creates and dispatches `KeyboardEvent` in a way that also works on IE 11.
 *
 * @example
 * import { fireKeyboardEvent } from "reakit-utils";
 *
 * fireKeyboardEvent(document.getElementById("id"), "keydown", {
 *   key: "ArrowDown",
 *   shiftKey: true,
 * });
 */ function $45834b4fab4d6c15$export$d23d807e6c464ee0(element, type, eventInit) {
    return element.dispatchEvent($45834b4fab4d6c15$var$createKeyboardEvent(element, type, eventInit));
}





function $57b7264df03bb3c2$export$39b482c5e57630a8(items) {
    var groups = [
        []
    ];
    var _loop = function _loop() {
        var item = _step.value;
        var group = groups.find(function(g) {
            return !g[0] || g[0].groupId === item.groupId;
        });
        if (group) group.push(item);
        else groups.push([
            item
        ]);
    };
    for(var _iterator = (0, $d71074b92e18808d$export$8b22cf2602fb60ce)(items), _step; !(_step = _iterator()).done;)_loop();
    return groups;
}
function $57b7264df03bb3c2$export$2d1720544b23b823(grid) {
    var flattened = [];
    for(var _iterator = (0, $d71074b92e18808d$export$8b22cf2602fb60ce)(grid), _step; !(_step = _iterator()).done;){
        var row = _step.value;
        flattened.push.apply(flattened, row);
    }
    return flattened;
}
function $57b7264df03bb3c2$export$43caf9889c228507(array) {
    return array.slice().reverse();
}


function $079cd58daa882f47$export$2d1720544b23b823(items, excludeId) {
    if (excludeId) return items.find(function(item) {
        return !item.disabled && item.id !== excludeId;
    });
    return items.find(function(item) {
        return !item.disabled;
    });
}
function $079cd58daa882f47$export$39b482c5e57630a8(options, passedId) {
    var _findFirstEnabledItem;
    if (passedId || passedId === null) return passedId;
    if (options.currentId || options.currentId === null) return options.currentId;
    return (_findFirstEnabledItem = $079cd58daa882f47$export$2d1720544b23b823(options.items || [])) === null || _findFirstEnabledItem === void 0 ? void 0 : _findFirstEnabledItem.id;
}


function $460fa4df69bd7eee$export$2d1720544b23b823(items, id) {
    if (!id) return undefined;
    return items === null || items === void 0 ? void 0 : items.find(function(item) {
        return item.id === id && !item.disabled;
    });
}


// Automatically generated
var $460ef8f3a85a9f7f$var$COMPOSITE_STATE_KEYS = [
    "baseId",
    "unstable_idCountRef",
    "setBaseId",
    "unstable_virtual",
    "rtl",
    "orientation",
    "items",
    "groups",
    "currentId",
    "loop",
    "wrap",
    "shift",
    "unstable_moves",
    "unstable_hasActiveWidget",
    "unstable_includesBaseElement",
    "registerItem",
    "unregisterItem",
    "registerGroup",
    "unregisterGroup",
    "move",
    "next",
    "previous",
    "up",
    "down",
    "first",
    "last",
    "sort",
    "unstable_setVirtual",
    "setRTL",
    "setOrientation",
    "setCurrentId",
    "setLoop",
    "setWrap",
    "setShift",
    "reset",
    "unstable_setIncludesBaseElement",
    "unstable_setHasActiveWidget"
];
var $460ef8f3a85a9f7f$export$e7094788287c5e9b = $460ef8f3a85a9f7f$var$COMPOSITE_STATE_KEYS;
var $460ef8f3a85a9f7f$export$407448d2b89b1813 = $460ef8f3a85a9f7f$export$e7094788287c5e9b;
var $460ef8f3a85a9f7f$export$8b22cf2602fb60ce = $460ef8f3a85a9f7f$export$407448d2b89b1813;
var $460ef8f3a85a9f7f$export$db3b6bfb95261072 = $460ef8f3a85a9f7f$export$8b22cf2602fb60ce;


function $f5942c630e2b5a42$export$3b14a55fb2447963(element) {
    element.userFocus = true;
    element.focus();
    element.userFocus = false;
}
function $f5942c630e2b5a42$export$dda1d9f60106f0e9(element) {
    return !!element.userFocus;
}
function $f5942c630e2b5a42$export$2408f22a0fab9ae5(element, value) {
    element.userFocus = value;
}


var $6628363f570e9230$var$isIE11 = (0, $a20c9196f0a7adc9$export$71594e8a50f746f4) && "msCrypto" in window;
function $6628363f570e9230$var$canProxyKeyboardEvent(event) {
    if (!(0, $71809a9b946920fa$export$7bced8f45c53f2f)(event)) return false;
    if (event.metaKey) return false;
    if (event.key === "Tab") return false;
    return true;
}
function $6628363f570e9230$var$useKeyboardEventProxy(virtual, currentItem, htmlEventHandler) {
    var eventHandlerRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlEventHandler);
    return (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
        var _eventHandlerRef$curr;
        (_eventHandlerRef$curr = eventHandlerRef.current) === null || _eventHandlerRef$curr === void 0 || _eventHandlerRef$curr.call(eventHandlerRef, event);
        if (event.defaultPrevented) return;
        if (virtual && $6628363f570e9230$var$canProxyKeyboardEvent(event)) {
            var currentElement = currentItem === null || currentItem === void 0 ? void 0 : currentItem.ref.current;
            if (currentElement) {
                if (!(0, $45834b4fab4d6c15$export$d23d807e6c464ee0)(currentElement, event.type, event)) event.preventDefault();
                 // The event will be triggered on the composite item and then
                // propagated up to this composite element again, so we can pretend
                // that it wasn't called on this component in the first place.
                if (event.currentTarget.contains(currentElement)) event.stopPropagation();
            }
        }
    }, [
        virtual,
        currentItem
    ]);
} // istanbul ignore next
function $6628363f570e9230$var$useActiveElementRef(elementRef) {
    var activeElementRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var document = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(elementRef.current);
        var onFocus = function onFocus(event) {
            var target = event.target;
            activeElementRef.current = target;
        };
        document.addEventListener("focus", onFocus, true);
        return function() {
            document.removeEventListener("focus", onFocus, true);
        };
    }, []);
    return activeElementRef;
}
function $6628363f570e9230$var$findFirstEnabledItemInTheLastRow(items) {
    return (0, $079cd58daa882f47$export$2d1720544b23b823)((0, $57b7264df03bb3c2$export$2d1720544b23b823)((0, $57b7264df03bb3c2$export$43caf9889c228507)((0, $57b7264df03bb3c2$export$39b482c5e57630a8)(items))));
}
function $6628363f570e9230$var$isItem(items, element) {
    return items === null || items === void 0 ? void 0 : items.some(function(item) {
        return !!element && item.ref.current === element;
    });
}
function $6628363f570e9230$var$useScheduleUserFocus(currentItem) {
    var currentItemRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(currentItem);
    var _React$useReducer = (0, $57da6a40a504e45b$export$13e3392192263954)(function(n) {
        return n + 1;
    }, 0), scheduled = _React$useReducer[0], schedule = _React$useReducer[1];
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var _currentItemRef$curre;
        var currentElement = (_currentItemRef$curre = currentItemRef.current) === null || _currentItemRef$curre === void 0 ? void 0 : _currentItemRef$curre.ref.current;
        if (scheduled && currentElement) (0, $f5942c630e2b5a42$export$3b14a55fb2447963)(currentElement);
    }, [
        scheduled
    ]);
    return schedule;
}
var $6628363f570e9230$export$5deb711daaf91600 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "Composite",
    compose: [
        (0, $d0165fcee407dc86$export$1f2f0004dd086edb)
    ],
    keys: (0, $460ef8f3a85a9f7f$export$e7094788287c5e9b),
    useOptions: function useOptions(options) {
        return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, options), {}, {
            currentId: (0, $079cd58daa882f47$export$39b482c5e57630a8)(options)
        });
    },
    useProps: function useProps(options, _ref) {
        var htmlRef = _ref.ref, htmlOnFocusCapture = _ref.onFocusCapture, htmlOnFocus = _ref.onFocus, htmlOnBlurCapture = _ref.onBlurCapture, htmlOnKeyDown = _ref.onKeyDown, htmlOnKeyDownCapture = _ref.onKeyDownCapture, htmlOnKeyUpCapture = _ref.onKeyUpCapture, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "ref",
            "onFocusCapture",
            "onFocus",
            "onBlurCapture",
            "onKeyDown",
            "onKeyDownCapture",
            "onKeyUpCapture"
        ]);
        var ref = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
        var currentItem = (0, $460fa4df69bd7eee$export$2d1720544b23b823)(options.items, options.currentId);
        var previousElementRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
        var onFocusCaptureRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnFocusCapture);
        var onFocusRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnFocus);
        var onBlurCaptureRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnBlurCapture);
        var onKeyDownRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnKeyDown);
        var scheduleUserFocus = $6628363f570e9230$var$useScheduleUserFocus(currentItem); // IE 11 doesn't support event.relatedTarget, so we use the active element
        // ref instead.
        var activeElementRef = $6628363f570e9230$var$isIE11 ? $6628363f570e9230$var$useActiveElementRef(ref) : undefined;
        (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
            var element = ref.current;
            if (options.unstable_moves && !currentItem) // will receive focus.
            element === null || element === void 0 || element.focus();
        }, [
            options.unstable_moves,
            currentItem
        ]);
        var onKeyDownCapture = $6628363f570e9230$var$useKeyboardEventProxy(options.unstable_virtual, currentItem, htmlOnKeyDownCapture);
        var onKeyUpCapture = $6628363f570e9230$var$useKeyboardEventProxy(options.unstable_virtual, currentItem, htmlOnKeyUpCapture);
        var onFocusCapture = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onFocusCaptureRef$cu;
            (_onFocusCaptureRef$cu = onFocusCaptureRef.current) === null || _onFocusCaptureRef$cu === void 0 || _onFocusCaptureRef$cu.call(onFocusCaptureRef, event);
            if (event.defaultPrevented) return;
            if (!options.unstable_virtual) return; // IE11 doesn't support event.relatedTarget, so we use the active
            // element ref instead.
            var previousActiveElement = (activeElementRef === null || activeElementRef === void 0 ? void 0 : activeElementRef.current) || event.relatedTarget;
            var previousActiveElementWasItem = $6628363f570e9230$var$isItem(options.items, previousActiveElement);
            if ((0, $71809a9b946920fa$export$7bced8f45c53f2f)(event) && previousActiveElementWasItem) {
                // Composite has been focused as a result of an item receiving focus.
                // The composite item will move focus back to the composite
                // container. In this case, we don't want to propagate this
                // additional event nor call the onFocus handler passed to
                // <Composite onFocus={...} />.
                event.stopPropagation(); // We keep track of the previous active item element so we can
                // manually fire a blur event on it later when the focus is moved to
                // another item on the onBlurCapture event below.
                previousElementRef.current = previousActiveElement;
            }
        }, [
            options.unstable_virtual,
            options.items
        ]);
        var onFocus = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onFocusRef$current;
            (_onFocusRef$current = onFocusRef.current) === null || _onFocusRef$current === void 0 || _onFocusRef$current.call(onFocusRef, event);
            if (event.defaultPrevented) return;
            if (options.unstable_virtual) {
                if ((0, $71809a9b946920fa$export$7bced8f45c53f2f)(event)) // This means that the composite element has been focused while the
                // composite item has not. For example, by clicking on the
                // composite element without touching any item, or by tabbing into
                // the composite element. In this case, we want to trigger focus on
                // the item, just like it would happen with roving tabindex.
                // When it receives focus, the composite item will put focus back
                // on the composite element, in which case hasItemWithFocus will be
                // true.
                scheduleUserFocus();
            } else if ((0, $71809a9b946920fa$export$7bced8f45c53f2f)(event)) {
                var _options$setCurrentId;
                // When the roving tabindex composite gets intentionally focused (for
                // example, by clicking directly on it, and not on an item), we make
                // sure to set the current id to null (which means the composite
                // itself is focused).
                (_options$setCurrentId = options.setCurrentId) === null || _options$setCurrentId === void 0 || _options$setCurrentId.call(options, null);
            }
        }, [
            options.unstable_virtual,
            options.setCurrentId
        ]);
        var onBlurCapture = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onBlurCaptureRef$cur;
            (_onBlurCaptureRef$cur = onBlurCaptureRef.current) === null || _onBlurCaptureRef$cur === void 0 || _onBlurCaptureRef$cur.call(onBlurCaptureRef, event);
            if (event.defaultPrevented) return;
            if (!options.unstable_virtual) return; // When virtual is set to true, we move focus from the composite
            // container (this component) to the composite item that is being
            // selected. Then we move focus back to the composite container. This
            // is so we can provide the same API as the roving tabindex method,
            // which means people can attach onFocus/onBlur handlers on the
            // CompositeItem component regardless of whether it's virtual or not.
            // This sequence of blurring and focusing items and composite may be
            // confusing, so we ignore intermediate focus and blurs by stopping its
            // propagation and not calling the passed onBlur handler (htmlOnBlur).
            var currentElement = (currentItem === null || currentItem === void 0 ? void 0 : currentItem.ref.current) || null;
            var nextActiveElement = (0, $b9e9b492c14d338e$export$e56b097fab4b0a4f)(event);
            var nextActiveElementIsItem = $6628363f570e9230$var$isItem(options.items, nextActiveElement);
            if ((0, $71809a9b946920fa$export$7bced8f45c53f2f)(event) && nextActiveElementIsItem) {
                // This is an intermediate blur event: blurring the composite
                // container to focus an item (nextActiveElement).
                if (nextActiveElement === currentElement) // The next active element will be the same as the current item in
                // the state in two scenarios:
                //   - Moving focus with keyboard: the state is updated before the
                // blur event is triggered, so here the current item is already
                // pointing to the next active element.
                //   - Clicking on the current active item with a pointer: this
                // will trigger blur on the composite element and then the next
                // active element will be the same as the current item. Clicking on
                // an item other than the current one doesn't end up here as the
                // currentItem state will be updated only after it.
                {
                    if (previousElementRef.current && previousElementRef.current !== nextActiveElement) // If there's a previous active item and it's not a click action,
                    // then we fire a blur event on it so it will work just like if
                    // it had DOM focus before (like when using roving tabindex).
                    (0, $1aae2411f2afb694$export$7017b330269bb60a)(previousElementRef.current, event);
                } else if (currentElement) // This will be true when the next active element is not the
                // current element, but there's a current item. This will only
                // happen when clicking with a pointer on a different item, when
                // there's already an item selected, in which case currentElement
                // is the item that is getting blurred, and nextActiveElement is
                // the item that is being clicked.
                (0, $1aae2411f2afb694$export$7017b330269bb60a)(currentElement, event);
                 // We want to ignore intermediate blur events, so we stop its
                // propagation and return early so onFocus will not be called.
                event.stopPropagation();
            } else {
                var targetIsItem = $6628363f570e9230$var$isItem(options.items, event.target);
                if (!targetIsItem && currentElement) // If target is not a composite item, it may be the composite
                // element itself (isSelfTarget) or a tabbable element inside the
                // composite widget. This may be triggered by clicking outside the
                // composite widget or by tabbing out of it. In either cases we
                // want to fire a blur event on the current item.
                (0, $1aae2411f2afb694$export$7017b330269bb60a)(currentElement, event);
            }
        }, [
            options.unstable_virtual,
            options.items,
            currentItem
        ]);
        var onKeyDown = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onKeyDownRef$current, _options$groups;
            (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 || _onKeyDownRef$current.call(onKeyDownRef, event);
            if (event.defaultPrevented) return;
            if (options.currentId !== null) return;
            if (!(0, $71809a9b946920fa$export$7bced8f45c53f2f)(event)) return;
            var isVertical = options.orientation !== "horizontal";
            var isHorizontal = options.orientation !== "vertical";
            var isGrid = !!((_options$groups = options.groups) !== null && _options$groups !== void 0 && _options$groups.length);
            var up = function up() {
                if (isGrid) {
                    var item = $6628363f570e9230$var$findFirstEnabledItemInTheLastRow(options.items);
                    if (item !== null && item !== void 0 && item.id) {
                        var _options$move;
                        (_options$move = options.move) === null || _options$move === void 0 || _options$move.call(options, item.id);
                    }
                } else {
                    var _options$last;
                    (_options$last = options.last) === null || _options$last === void 0 || _options$last.call(options);
                }
            };
            var keyMap = {
                ArrowUp: (isGrid || isVertical) && up,
                ArrowRight: (isGrid || isHorizontal) && options.first,
                ArrowDown: (isGrid || isVertical) && options.first,
                ArrowLeft: (isGrid || isHorizontal) && options.last,
                Home: options.first,
                End: options.last,
                PageUp: options.first,
                PageDown: options.last
            };
            var action = keyMap[event.key];
            if (action) {
                event.preventDefault();
                action();
            }
        }, [
            options.currentId,
            options.orientation,
            options.groups,
            options.items,
            options.move,
            options.last,
            options.first
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            ref: (0, $f08be812be5c38c7$export$ebc1e1560c2dffa5)(ref, htmlRef),
            id: options.baseId,
            onFocus: onFocus,
            onFocusCapture: onFocusCapture,
            onBlurCapture: onBlurCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyDown: onKeyDown,
            onKeyUpCapture: onKeyUpCapture,
            "aria-activedescendant": options.unstable_virtual ? (currentItem === null || currentItem === void 0 ? void 0 : currentItem.id) || undefined : undefined
        }, htmlProps);
    },
    useComposeProps: function useComposeProps(options, htmlProps) {
        htmlProps = (0, $75cc27f4cc989769$export$f66572793fa256a1)(options, htmlProps, true);
        var tabbableHTMLProps = (0, $d0165fcee407dc86$export$1f2f0004dd086edb)(options, htmlProps, true);
        if (options.unstable_virtual || options.currentId === null) // Composite will only be tabbable by default if the focus is managed
        // using aria-activedescendant, which requires DOM focus on the container
        // element (the composite)
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            tabIndex: 0
        }, tabbableHTMLProps);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, htmlProps), {}, {
            ref: tabbableHTMLProps.ref
        });
    }
});
var $6628363f570e9230$export$43586241d9db0c6d = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "div",
    useHook: $6628363f570e9230$export$5deb711daaf91600,
    useCreateElement: function useCreateElement$1(type, props, children) {
        return (0, $1ab3ad06070c6ba8$export$cfb2bb2ead21514)(type, props, children);
    }
});





// Automatically generated
var $b46c80dbb89593eb$var$MENU_BAR_STATE_KEYS = [
    "baseId",
    "unstable_idCountRef",
    "unstable_virtual",
    "rtl",
    "orientation",
    "items",
    "groups",
    "currentId",
    "loop",
    "wrap",
    "shift",
    "unstable_moves",
    "unstable_hasActiveWidget",
    "unstable_includesBaseElement",
    "unstable_values",
    "setBaseId",
    "registerItem",
    "unregisterItem",
    "registerGroup",
    "unregisterGroup",
    "move",
    "next",
    "previous",
    "up",
    "down",
    "first",
    "last",
    "sort",
    "unstable_setVirtual",
    "setRTL",
    "setOrientation",
    "setCurrentId",
    "setLoop",
    "setWrap",
    "setShift",
    "reset",
    "unstable_setIncludesBaseElement",
    "unstable_setHasActiveWidget",
    "unstable_setValue"
];
var $b46c80dbb89593eb$var$MENU_STATE_KEYS = [].concat($b46c80dbb89593eb$var$MENU_BAR_STATE_KEYS, [
    "visible",
    "animated",
    "animating",
    "show",
    "hide",
    "toggle",
    "setVisible",
    "setAnimated",
    "stopAnimation",
    "modal",
    "unstable_disclosureRef",
    "setModal",
    "unstable_referenceRef",
    "unstable_popoverRef",
    "unstable_arrowRef",
    "unstable_popoverStyles",
    "unstable_arrowStyles",
    "unstable_originalPlacement",
    "unstable_update",
    "placement",
    "place"
]);
var $b46c80dbb89593eb$export$3a1a48c8f6ef640e = $b46c80dbb89593eb$var$MENU_STATE_KEYS;
var $b46c80dbb89593eb$export$407448d2b89b1813 = $b46c80dbb89593eb$export$3a1a48c8f6ef640e;
var $b46c80dbb89593eb$export$8b22cf2602fb60ce = $b46c80dbb89593eb$export$407448d2b89b1813;
var $b46c80dbb89593eb$export$db3b6bfb95261072 = $b46c80dbb89593eb$export$8b22cf2602fb60ce;
var $b46c80dbb89593eb$var$MENU_DISCLOSURE_KEYS = $b46c80dbb89593eb$export$db3b6bfb95261072;
var $b46c80dbb89593eb$export$4368d992c4eafac0 = $b46c80dbb89593eb$var$MENU_DISCLOSURE_KEYS;
var $b46c80dbb89593eb$export$f1e1789686576879 = $b46c80dbb89593eb$export$4368d992c4eafac0;
var $b46c80dbb89593eb$export$2d1720544b23b823 = [].concat($b46c80dbb89593eb$export$f1e1789686576879, [
    "name"
]);
var $b46c80dbb89593eb$export$39b482c5e57630a8 = $b46c80dbb89593eb$export$2d1720544b23b823;
var $b46c80dbb89593eb$export$dda1d9f60106f0e9 = $b46c80dbb89593eb$export$f1e1789686576879;


function $692184f1d0b2ec42$var$useShortcuts(menuRef, _ref, timeout) {
    var _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items, move = _ref.move;
    if (timeout === void 0) timeout = 500;
    var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(""), keys = _React$useState[0], setKeys = _React$useState[1];
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (!keys) return undefined;
        var timeoutId = setTimeout(function() {
            return setKeys("");
        }, timeout);
        var stop = items.find(function(s) {
            return Boolean(s.ref.current && s.ref.current.textContent && s.ref.current.textContent.toLowerCase().startsWith(keys));
        });
        if (stop) move(stop.id);
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        keys,
        items,
        move,
        timeout
    ]);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var menu = menuRef.current;
        if (!menu) return undefined;
        var onKeyDown = function onKeyDown(event) {
            var _target$getAttribute;
            if (event.key.length > 1) return;
            if (event.shiftKey) return;
            if (event.metaKey) return;
            if (event.ctrlKey) return;
            if (event.altKey) return;
            var target = event.target;
            var role = (_target$getAttribute = target.getAttribute) === null || _target$getAttribute === void 0 ? void 0 : _target$getAttribute.call(target, "role");
            var targetIsMenu = target === menu;
            var targetIsMenuItem = role && role.indexOf("menuitem") !== -1 && (0, $0072e8bbe9b36c2e$export$ff7f7c97cdce86e)(target, "[role=menu],[role=menubar]") === menu;
            if (!targetIsMenu && !targetIsMenuItem) return;
            if (/^[a-z0-9_-]$/i.test(event.key)) {
                event.stopPropagation();
                event.preventDefault();
                setKeys(function(k) {
                    return "" + k + event.key;
                });
            }
        }; // https://github.com/facebook/react/issues/11387#issuecomment-524113945
        menu.addEventListener("keydown", onKeyDown);
        return function() {
            return menu.removeEventListener("keydown", onKeyDown);
        };
    }, [
        menuRef,
        setKeys
    ]);
}
var $692184f1d0b2ec42$export$df42c372629b35c7 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "MenuBar",
    compose: (0, $6628363f570e9230$export$5deb711daaf91600),
    keys: (0, $b46c80dbb89593eb$export$8b22cf2602fb60ce),
    useProps: function useProps(options, _ref) {
        var htmlRef = _ref.ref, htmlWrapElement = _ref.wrapElement, _ref$role = _ref.role, role = _ref$role === void 0 ? "menubar" : _ref$role, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "ref",
            "wrapElement",
            "role"
        ]);
        var ref = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
        var wrap = (0, $dfdde098fbc56812$export$3b14a55fb2447963)(ref, role, options);
        $692184f1d0b2ec42$var$useShortcuts(ref, options);
        var wrapElement = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(element) {
            element = wrap(element);
            if (htmlWrapElement) return htmlWrapElement(element);
            return element;
        }, [
            wrap,
            htmlWrapElement
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            ref: (0, $f08be812be5c38c7$export$ebc1e1560c2dffa5)(ref, htmlRef),
            role: role,
            "aria-orientation": options.orientation,
            wrapElement: wrapElement
        }, htmlProps);
    }
});
var $692184f1d0b2ec42$export$11a6fe490bbc4873 = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "div",
    useHook: $692184f1d0b2ec42$export$df42c372629b35c7,
    useCreateElement: function useCreateElement$1(type, props, children) {
        return (0, $1ab3ad06070c6ba8$export$cfb2bb2ead21514)(type, props, children);
    }
});



function $14a25f98aaedb6a7$var$usePlacementDir(placement) {
    return (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        var _placement$split;
        return placement === null || placement === void 0 ? void 0 : (_placement$split = placement.split("-")) === null || _placement$split === void 0 ? void 0 : _placement$split[0];
    }, [
        placement
    ]);
}
var $14a25f98aaedb6a7$export$38eaa17faae8f579 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "Menu",
    compose: [
        (0, $692184f1d0b2ec42$export$df42c372629b35c7),
        (0, $d02f9b98b9975853$export$542a6fd13ac93354)
    ],
    keys: (0, $b46c80dbb89593eb$export$3a1a48c8f6ef640e),
    useOptions: function useOptions(options) {
        var parent = (0, $57da6a40a504e45b$export$fae74005e78b1a27)((0, $dfdde098fbc56812$export$3a1a48c8f6ef640e));
        var parentIsMenuBar = (parent === null || parent === void 0 ? void 0 : parent.role) === "menubar";
        return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({
            unstable_autoFocusOnHide: !parentIsMenuBar,
            modal: false
        }, options), {}, {
            // will be handled by MenuButton
            unstable_autoFocusOnShow: false,
            // will be handled differently from usePopover/useDialog
            hideOnEsc: false
        });
    },
    useProps: function useProps(options, _ref) {
        var htmlOnKeyDown = _ref.onKeyDown, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "onKeyDown"
        ]);
        var onKeyDownRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnKeyDown);
        var parent = (0, $57da6a40a504e45b$export$fae74005e78b1a27)((0, $dfdde098fbc56812$export$3a1a48c8f6ef640e));
        var hasParent = !!parent;
        var ancestorMenuBar = parent;
        while(ancestorMenuBar && ancestorMenuBar.role !== "menubar")ancestorMenuBar = ancestorMenuBar.parent;
        var _ref2 = ancestorMenuBar || {}, next = _ref2.next, previous = _ref2.previous, orientation = _ref2.orientation;
        var ancestorIsHorizontal = orientation === "horizontal";
        var dir = $14a25f98aaedb6a7$var$usePlacementDir(options.placement);
        var onKeyDown = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onKeyDownRef$current;
            (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 || _onKeyDownRef$current.call(onKeyDownRef, event);
            if (event.defaultPrevented) return;
            if (event.key === "Escape") {
                var _options$hide;
                if (!hasParent) // On Esc, only stop propagation if there's no parent menu.
                // Otherwise, pressing Esc should close all menus
                event.stopPropagation();
                (_options$hide = options.hide) === null || _options$hide === void 0 || _options$hide.call(options);
            } else if (hasParent && !(0, $fb6a1f3bf7908434$export$af57ec5ec914349c)(event)) {
                // Moves to the next menu button in a horizontal menu bar or close
                // the menu if it's a sub menu
                var ArrowRight = ancestorIsHorizontal && dir !== "left" ? next : dir === "left" && options.hide;
                var ArrowLeft = ancestorIsHorizontal && dir !== "right" ? previous : dir === "right" && options.hide;
                var keyMap = {
                    ArrowRight: ArrowRight,
                    ArrowLeft: ArrowLeft
                };
                var action = keyMap[event.key];
                if (action) {
                    event.preventDefault();
                    if (hasParent) event.stopPropagation();
                    action();
                }
            }
        }, [
            hasParent,
            ancestorIsHorizontal,
            next,
            previous,
            dir,
            options.hide
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            role: "menu",
            onKeyDown: onKeyDown
        }, htmlProps);
    }
});
var $14a25f98aaedb6a7$export$d9b273488cd8ce6f = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "div",
    useHook: $14a25f98aaedb6a7$export$38eaa17faae8f579,
    useCreateElement: function useCreateElement$1(type, props, children) {
        return (0, $1ab3ad06070c6ba8$export$cfb2bb2ead21514)(type, props, children);
    }
});




























































































































// Automatically generated
var $d9e89be7b38f2ae5$var$CLICKABLE_KEYS = [
    "unstable_clickOnEnter",
    "unstable_clickOnSpace"
];
function $d9e89be7b38f2ae5$var$isNativeClick(event) {
    var element = event.currentTarget;
    if (!event.isTrusted) return false; // istanbul ignore next: can't test trusted events yet
    return (0, $62d22d716c62d21c$export$35a0171ee384c875)(element) || element.tagName === "INPUT" || element.tagName === "TEXTAREA" || element.tagName === "A" || element.tagName === "SELECT";
}
var $d9e89be7b38f2ae5$export$ed213cc82e426b1a = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "Clickable",
    compose: (0, $d0165fcee407dc86$export$1f2f0004dd086edb),
    keys: $d9e89be7b38f2ae5$var$CLICKABLE_KEYS,
    useOptions: function useOptions(_ref) {
        var _ref$unstable_clickOn = _ref.unstable_clickOnEnter, unstable_clickOnEnter = _ref$unstable_clickOn === void 0 ? true : _ref$unstable_clickOn, _ref$unstable_clickOn2 = _ref.unstable_clickOnSpace, unstable_clickOnSpace = _ref$unstable_clickOn2 === void 0 ? true : _ref$unstable_clickOn2, options = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "unstable_clickOnEnter",
            "unstable_clickOnSpace"
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            unstable_clickOnEnter: unstable_clickOnEnter,
            unstable_clickOnSpace: unstable_clickOnSpace
        }, options);
    },
    useProps: function useProps(options, _ref2) {
        var htmlOnKeyDown = _ref2.onKeyDown, htmlOnKeyUp = _ref2.onKeyUp, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref2, [
            "onKeyDown",
            "onKeyUp"
        ]);
        var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(false), active = _React$useState[0], setActive = _React$useState[1];
        var onKeyDownRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnKeyDown);
        var onKeyUpRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnKeyUp);
        var onKeyDown = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onKeyDownRef$current;
            (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 || _onKeyDownRef$current.call(onKeyDownRef, event);
            if (event.defaultPrevented) return;
            if (options.disabled) return;
            if (event.metaKey) return;
            if (!(0, $71809a9b946920fa$export$7bced8f45c53f2f)(event)) return;
            var isEnter = options.unstable_clickOnEnter && event.key === "Enter";
            var isSpace = options.unstable_clickOnSpace && event.key === " ";
            if (isEnter || isSpace) {
                if ($d9e89be7b38f2ae5$var$isNativeClick(event)) return;
                event.preventDefault();
                if (isEnter) event.currentTarget.click();
                else if (isSpace) setActive(true);
            }
        }, [
            options.disabled,
            options.unstable_clickOnEnter,
            options.unstable_clickOnSpace
        ]);
        var onKeyUp = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onKeyUpRef$current;
            (_onKeyUpRef$current = onKeyUpRef.current) === null || _onKeyUpRef$current === void 0 || _onKeyUpRef$current.call(onKeyUpRef, event);
            if (event.defaultPrevented) return;
            if (options.disabled) return;
            if (event.metaKey) return;
            var isSpace = options.unstable_clickOnSpace && event.key === " ";
            if (active && isSpace) {
                setActive(false);
                event.currentTarget.click();
            }
        }, [
            options.disabled,
            options.unstable_clickOnSpace,
            active
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            "data-active": active || undefined,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        }, htmlProps);
    }
});
var $d9e89be7b38f2ae5$export$2f51d37476d4c437 = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "button",
    memo: true,
    useHook: $d9e89be7b38f2ae5$export$ed213cc82e426b1a
});


// Automatically generated
var $6b9225ff63429571$var$BUTTON_KEYS = [];
var $6b9225ff63429571$export$ea18c227d4417cc3 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "Button",
    compose: (0, $d9e89be7b38f2ae5$export$ed213cc82e426b1a),
    keys: $6b9225ff63429571$var$BUTTON_KEYS,
    useProps: function useProps(_, _ref) {
        var htmlRef = _ref.ref, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "ref"
        ]);
        var ref = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
        var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(undefined), role = _React$useState[0], setRole = _React$useState[1];
        var _React$useState2 = (0, $57da6a40a504e45b$export$60241385465d0a34)("button"), type = _React$useState2[0], setType = _React$useState2[1];
        (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
            var element = ref.current;
            if (!element) return;
            if (!(0, $62d22d716c62d21c$export$35a0171ee384c875)(element)) {
                if (element.tagName !== "A") setRole("button");
                setType(undefined);
            }
        }, []);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            ref: (0, $f08be812be5c38c7$export$ebc1e1560c2dffa5)(ref, htmlRef),
            role: role,
            type: type
        }, htmlProps);
    }
});
var $6b9225ff63429571$export$353f5b6fc5456de1 = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "button",
    memo: true,
    useHook: $6b9225ff63429571$export$ea18c227d4417cc3
});



var $29f3d047473252df$export$6e3e27031a30522f = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "Disclosure",
    compose: (0, $6b9225ff63429571$export$ea18c227d4417cc3),
    keys: (0, $4458ff88a70db458$export$96f57966bedc81b4),
    useProps: function useProps(options, _ref) {
        var htmlOnClick = _ref.onClick, ariaControls = _ref["aria-controls"], htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "onClick",
            "aria-controls"
        ]);
        var onClickRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnClick);
        var controls = ariaControls ? ariaControls + " " + options.baseId : options.baseId;
        var onClick = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onClickRef$current, _options$toggle;
            (_onClickRef$current = onClickRef.current) === null || _onClickRef$current === void 0 || _onClickRef$current.call(onClickRef, event);
            if (event.defaultPrevented) return;
            (_options$toggle = options.toggle) === null || _options$toggle === void 0 || _options$toggle.call(options);
        }, [
            options.toggle
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            "aria-expanded": !!options.visible,
            "aria-controls": controls,
            onClick: onClick
        }, htmlProps);
    }
});
var $29f3d047473252df$export$74a362b31437ec83 = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "button",
    memo: true,
    useHook: $29f3d047473252df$export$6e3e27031a30522f
});


var $1dce269c4ac4563c$export$cbb859caf4f7fc49 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "DialogDisclosure",
    compose: (0, $29f3d047473252df$export$6e3e27031a30522f),
    keys: (0, $a5992b00ce79720a$export$8b22cf2602fb60ce),
    useProps: function useProps(options, _ref) {
        var htmlRef = _ref.ref, htmlOnClick = _ref.onClick, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "ref",
            "onClick"
        ]);
        var ref = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
        var onClickRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnClick);
        var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(false), expanded = _React$useState[0], setExpanded = _React$useState[1];
        var disclosureRef = options.unstable_disclosureRef; // aria-expanded may be used for styling purposes, so we useLayoutEffect
        (0, $55d7e61099d95834$export$363c9f3eb56bbdbe)(function() {
            var element = ref.current;
            if (disclosureRef && !disclosureRef.current) disclosureRef.current = element;
            var isCurrentDisclosure = !(disclosureRef !== null && disclosureRef !== void 0 && disclosureRef.current) || disclosureRef.current === element;
            setExpanded(!!options.visible && isCurrentDisclosure);
        }, [
            options.visible,
            disclosureRef
        ]);
        var onClick = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onClickRef$current;
            (_onClickRef$current = onClickRef.current) === null || _onClickRef$current === void 0 || _onClickRef$current.call(onClickRef, event);
            if (event.defaultPrevented) return;
            if (disclosureRef) disclosureRef.current = event.currentTarget;
        }, [
            disclosureRef
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            ref: (0, $f08be812be5c38c7$export$ebc1e1560c2dffa5)(ref, htmlRef),
            "aria-haspopup": "dialog",
            "aria-expanded": expanded,
            onClick: onClick
        }, htmlProps);
    }
});
var $1dce269c4ac4563c$export$61fcc8e4f4f5b32c = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "button",
    memo: true,
    useHook: $1dce269c4ac4563c$export$cbb859caf4f7fc49
});


var $3887be7670672f61$export$490338b99d81a5a2 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "PopoverDisclosure",
    compose: (0, $1dce269c4ac4563c$export$cbb859caf4f7fc49),
    keys: (0, $1e705df99b3c8b2e$export$db3b6bfb95261072),
    useProps: function useProps(options, _ref) {
        var htmlRef = _ref.ref, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "ref"
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            ref: (0, $f08be812be5c38c7$export$ebc1e1560c2dffa5)(options.unstable_referenceRef, htmlRef)
        }, htmlProps);
    }
});
var $3887be7670672f61$export$5e401691c827e556 = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "button",
    memo: true,
    useHook: $3887be7670672f61$export$490338b99d81a5a2
});


function $b91a0b861a7c06c6$export$2d1720544b23b823(submenus) {
    var visibleSubmenu = submenus === null || submenus === void 0 ? void 0 : submenus.find(function(submenu) {
        return submenu.current && !submenu.current.hidden;
    });
    return visibleSubmenu === null || visibleSubmenu === void 0 ? void 0 : visibleSubmenu.current;
}


var $e4a61b85b145b055$var$noop = function noop() {};
var $e4a61b85b145b055$export$660510f872408795 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "MenuButton",
    compose: (0, $3887be7670672f61$export$490338b99d81a5a2),
    keys: (0, $b46c80dbb89593eb$export$db3b6bfb95261072),
    propsAreEqual: function propsAreEqual(prev, next) {
        var prevPopoverStyles = prev.unstable_popoverStyles, prevArrowStyles = prev.unstable_arrowStyles, prevCurrentId = prev.currentId, prevMoves = prev.unstable_moves, prevProps = (0, $d71074b92e18808d$export$71511d61b312f219)(prev, [
            "unstable_popoverStyles",
            "unstable_arrowStyles",
            "currentId",
            "unstable_moves"
        ]);
        var nextPopoverStyles = next.unstable_popoverStyles, nextArrowStyles = next.unstable_arrowStyles, nextCurrentId = next.currentId, nextMoves = next.unstable_moves, nextProps = (0, $d71074b92e18808d$export$71511d61b312f219)(next, [
            "unstable_popoverStyles",
            "unstable_arrowStyles",
            "currentId",
            "unstable_moves"
        ]);
        return (0, $3887be7670672f61$export$490338b99d81a5a2).unstable_propsAreEqual(prevProps, nextProps);
    },
    useProps: function useProps(options, _ref) {
        var htmlRef = _ref.ref, htmlOnClick = _ref.onClick, htmlOnKeyDown = _ref.onKeyDown, htmlOnFocus = _ref.onFocus, htmlOnMouseEnter = _ref.onMouseEnter, htmlOnMouseDown = _ref.onMouseDown, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "ref",
            "onClick",
            "onKeyDown",
            "onFocus",
            "onMouseEnter",
            "onMouseDown"
        ]);
        var parent = (0, $57da6a40a504e45b$export$fae74005e78b1a27)((0, $dfdde098fbc56812$export$3a1a48c8f6ef640e));
        var ref = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
        var hasPressedMouse = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(false);
        var _options$placement$sp = options.placement.split("-"), dir = _options$placement$sp[0];
        var hasParent = !!parent;
        var parentIsMenuBar = (parent === null || parent === void 0 ? void 0 : parent.role) === "menubar";
        var disabled = options.disabled || htmlProps["aria-disabled"];
        var onClickRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnClick);
        var onKeyDownRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnKeyDown);
        var onFocusRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnFocus);
        var onMouseEnterRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnMouseEnter);
        var onMouseDownRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnMouseDown);
        var onKeyDown = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onKeyDownRef$current;
            if (event.key === "Escape") {
                var _options$hide;
                // Doesn't prevent default on Escape, otherwise we can't close
                // dialogs when MenuButton is focused
                (_options$hide = options.hide) === null || _options$hide === void 0 || _options$hide.call(options);
            } else if (!disabled) {
                // setTimeout prevents scroll jump
                var first = options.first && function() {
                    return setTimeout(options.first);
                };
                var last = options.last && function() {
                    return setTimeout(options.last);
                };
                var keyMap = {
                    Enter: first,
                    " ": first,
                    ArrowUp: (dir === "top" || dir === "bottom") && last,
                    ArrowRight: dir === "right" && first,
                    ArrowDown: (dir === "bottom" || dir === "top") && first,
                    ArrowLeft: dir === "left" && first
                };
                var action = keyMap[event.key];
                if (action) {
                    var _options$show;
                    event.preventDefault();
                    event.stopPropagation();
                    (_options$show = options.show) === null || _options$show === void 0 || _options$show.call(options);
                    action();
                    return;
                }
            }
            (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 || _onKeyDownRef$current.call(onKeyDownRef, event);
        }, [
            disabled,
            options.hide,
            options.first,
            options.last,
            dir,
            options.show
        ]);
        var onMouseEnter = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onMouseEnterRef$curr;
            (_onMouseEnterRef$curr = onMouseEnterRef.current) === null || _onMouseEnterRef$curr === void 0 || _onMouseEnterRef$curr.call(onMouseEnterRef, event);
            if (event.defaultPrevented) return; // MenuButton's don't do anything on mouse over when they aren't
            // cointained within a Menu/MenuBar
            if (!parent) return;
            var element = event.currentTarget;
            if (parentIsMenuBar) // if MenuButton is an item inside a MenuBar, it'll only open
            // if there's already another sibling expanded MenuButton
            {
                if ((0, $b91a0b861a7c06c6$export$2d1720544b23b823)(parent.children)) element.focus();
            } else // If it's in a Menu, open after a short delay
            // TODO: Make the delay a prop?
            setTimeout(function() {
                if ((0, $1f8dcff49c1e0404$export$848589947316f680)(element)) {
                    var _options$show2;
                    (_options$show2 = options.show) === null || _options$show2 === void 0 || _options$show2.call(options);
                }
            }, 200);
        }, [
            parent,
            parentIsMenuBar,
            options.show
        ]);
        var onMouseDown = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onMouseDownRef$curre;
            // When in menu bar, the menu button can be activated either by focus
            // or click, but we don't want both to trigger sequentially.
            // Otherwise, onClick would toggle (hide) the menu right after it got
            // shown on focus.
            // This is also useful so we know if the menu button has been clicked
            // using mouse or keyboard. On mouse click, we don't automatically
            // focus the first menu item.
            hasPressedMouse.current = true;
            (_onMouseDownRef$curre = onMouseDownRef.current) === null || _onMouseDownRef$curre === void 0 || _onMouseDownRef$curre.call(onMouseDownRef, event);
        }, []);
        var onFocus = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onFocusRef$current;
            (_onFocusRef$current = onFocusRef.current) === null || _onFocusRef$current === void 0 || _onFocusRef$current.call(onFocusRef, event);
            if (event.defaultPrevented) return;
            if (disabled) return;
            if (parentIsMenuBar && !hasPressedMouse.current) {
                var _options$show3;
                (_options$show3 = options.show) === null || _options$show3 === void 0 || _options$show3.call(options);
            }
        }, [
            parentIsMenuBar,
            disabled,
            options.show
        ]); // If disclosure is rendered as a menu bar item, it's toggable
        // That is, you can click on the expanded disclosure to close its menu.
        var onClick = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onClickRef$current;
            (_onClickRef$current = onClickRef.current) === null || _onClickRef$current === void 0 || _onClickRef$current.call(onClickRef, event);
            if (event.defaultPrevented) return; // If menu button is a menu item inside a menu (not menu bar), you
            // can't close it by clicking on it again.
            if (hasParent && !parentIsMenuBar) {
                var _options$show4;
                (_options$show4 = options.show) === null || _options$show4 === void 0 || _options$show4.call(options);
            } else {
                var _options$toggle;
                // Otherwise, if menu button is a menu bar item or an orphan menu
                // button, it's toggable.
                (_options$toggle = options.toggle) === null || _options$toggle === void 0 || _options$toggle.call(options); // Focus the menu popover when it's opened with mouse click.
                if (hasPressedMouse.current && !parentIsMenuBar && !options.visible) {
                    var _options$move;
                    (_options$move = options.move) === null || _options$move === void 0 || _options$move.call(options, null);
                }
            }
            hasPressedMouse.current = false;
        }, [
            hasParent,
            parentIsMenuBar,
            options.show,
            options.toggle,
            options.visible,
            options.move
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            ref: (0, $f08be812be5c38c7$export$ebc1e1560c2dffa5)(ref, htmlRef),
            "aria-haspopup": "menu",
            onKeyDown: onKeyDown,
            onMouseEnter: onMouseEnter,
            onMouseDown: onMouseDown,
            onFocus: onFocus,
            onClick: onClick
        }, htmlProps);
    },
    useComposeOptions: function useComposeOptions(options) {
        return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, options), {}, {
            // Toggling is handled by MenuButton
            toggle: $e4a61b85b145b055$var$noop
        });
    }
});
var $e4a61b85b145b055$export$266a769812832828 = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "button",
    memo: true,
    useHook: $e4a61b85b145b055$export$660510f872408795
});



















































/**
 * Check whether the given element is a text field, where text field is defined
 * by the ability to select within the input, or that it is contenteditable.
 *
 * @example
 * import { isTextField } from "reakit-utils";
 *
 * isTextField(document.querySelector("div")); // false
 * isTextField(document.querySelector("input")); // true
 * isTextField(document.querySelector("input[type='button']")); // false
 * isTextField(document.querySelector("textarea")); // true
 * isTextField(document.querySelector("div[contenteditable='true']")); // true
 */ function $426d00310d64ef60$export$1cda748695867c48(element) {
    try {
        var isTextInput = element instanceof HTMLInputElement && element.selectionStart !== null;
        var isTextArea = element.tagName === "TEXTAREA";
        var isContentEditable = element.contentEditable === "true";
        return isTextInput || isTextArea || isContentEditable || false;
    } catch (error) {
        // Safari throws an exception when trying to get `selectionStart`
        // on non-text <input> elements (which, understandably, don't
        // have the text selection API). We catch this via a try/catch
        // block, as opposed to a more explicit check of the element's
        // input types, because of Safari's non-standard behavior. This
        // also means we don't have to worry about the list of input
        // types that support `selectionStart` changing as the HTML spec
        // evolves over time.
        return false;
    }
}









var $162421c70abe592f$var$defaultPrefix = "id";
function $162421c70abe592f$var$generateRandomString(prefix) {
    if (prefix === void 0) prefix = $162421c70abe592f$var$defaultPrefix;
    return "" + (prefix ? prefix + "-" : "") + Math.random().toString(32).substr(2, 6);
}
var $162421c70abe592f$export$e478069c421a4465 = /*#__PURE__*/ (0, $ea42db622452d33d$export$fd42f52fd3ae1109)($162421c70abe592f$var$generateRandomString);
function $162421c70abe592f$export$6d6c93b015c224e1(_ref) {
    var children = _ref.children, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? $162421c70abe592f$var$defaultPrefix : _ref$prefix;
    var count = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(0);
    var generateId = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(localPrefix) {
        if (localPrefix === void 0) localPrefix = prefix;
        return "" + (localPrefix ? localPrefix + "-" : "") + ++count.current;
    }, [
        prefix
    ]);
    return /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)($162421c70abe592f$export$e478069c421a4465.Provider, {
        value: generateId
    }, children);
}


// Automatically generated
var $d0687fd5e9a7382b$var$ID_STATE_KEYS = [
    "baseId",
    "unstable_idCountRef",
    "setBaseId"
];
var $d0687fd5e9a7382b$var$ID_KEYS = [].concat($d0687fd5e9a7382b$var$ID_STATE_KEYS, [
    "id"
]);
var $d0687fd5e9a7382b$export$b9ece12b5747e206 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    keys: $d0687fd5e9a7382b$var$ID_KEYS,
    useOptions: function useOptions(options, htmlProps) {
        var generateId = (0, $57da6a40a504e45b$export$fae74005e78b1a27)((0, $162421c70abe592f$export$e478069c421a4465));
        var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(function() {
            // This comes from useIdState
            if (options.unstable_idCountRef) {
                options.unstable_idCountRef.current += 1;
                return "-" + options.unstable_idCountRef.current;
            } // If there's no useIdState, we check if `baseId` was passed (as a prop,
            // not from useIdState).
            if (options.baseId) return "-" + generateId("");
            return "";
        }), suffix = _React$useState[0]; // `baseId` will be the prop passed directly as a prop or via useIdState.
        // If there's neither, then it'll fallback to Context's generateId.
        // This generateId can result in a sequential ID (if there's a Provider)
        // or a random string (without Provider).
        var baseId = (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
            return options.baseId || generateId();
        }, [
            options.baseId,
            generateId
        ]);
        var id = htmlProps.id || options.id || "" + baseId + suffix;
        return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, options), {}, {
            id: id
        });
    },
    useProps: function useProps(options, htmlProps) {
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            id: options.id
        }, htmlProps);
    }
});
var $d0687fd5e9a7382b$export$3a448e76673cbfbe = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "div",
    useHook: $d0687fd5e9a7382b$export$b9ece12b5747e206
});





/**
 * Creates and dispatches `Event` in a way that also works on IE 11.
 *
 * @example
 * import { fireEvent } from "reakit-utils";
 *
 * fireEvent(document.getElementById("id"), "blur", {
 *   bubbles: true,
 *   cancelable: true,
 * });
 */ function $55ffc8029757b6e3$export$43835e9acf248a15(element, type, eventInit) {
    return element.dispatchEvent((0, $f63dd635c742cc29$export$c30017717ce2168e)(element, type, eventInit));
}


function $820a2fa4c53c85c7$export$2408f22a0fab9ae5(element, value) {
    if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
        var _Object$getOwnPropert;
        var proto = Object.getPrototypeOf(element);
        var setValue = (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(proto, "value")) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.set;
        if (setValue) {
            setValue.call(element, value);
            (0, $55ffc8029757b6e3$export$43835e9acf248a15)(element, "input", {
                bubbles: true
            });
        }
    }
}


function $cf1bae67834fc2dd$var$getWidget(itemElement) {
    return itemElement.querySelector("[data-composite-item-widget]");
}
function $cf1bae67834fc2dd$var$useItem(options) {
    return (0, $57da6a40a504e45b$export$1538c33de8887b59)(function() {
        var _options$items;
        return (_options$items = options.items) === null || _options$items === void 0 ? void 0 : _options$items.find(function(item) {
            return options.id && item.id === options.id;
        });
    }, [
        options.items,
        options.id
    ]);
}
function $cf1bae67834fc2dd$var$targetIsAnotherItem(event, items) {
    if ((0, $71809a9b946920fa$export$7bced8f45c53f2f)(event)) return false;
    for(var _iterator = (0, $d71074b92e18808d$export$8b22cf2602fb60ce)(items), _step; !(_step = _iterator()).done;){
        var item = _step.value;
        if (item.ref.current === event.target) return true;
    }
    return false;
}
var $cf1bae67834fc2dd$export$5d135041cfe9980 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "CompositeItem",
    compose: [
        (0, $d9e89be7b38f2ae5$export$ed213cc82e426b1a),
        (0, $d0687fd5e9a7382b$export$b9ece12b5747e206)
    ],
    keys: (0, $460ef8f3a85a9f7f$export$8b22cf2602fb60ce),
    propsAreEqual: function propsAreEqual(prev, next) {
        if (!next.id || prev.id !== next.id) return (0, $d9e89be7b38f2ae5$export$ed213cc82e426b1a).unstable_propsAreEqual(prev, next);
        var prevCurrentId = prev.currentId, prevMoves = prev.unstable_moves, prevProps = (0, $d71074b92e18808d$export$71511d61b312f219)(prev, [
            "currentId",
            "unstable_moves"
        ]);
        var nextCurrentId = next.currentId, nextMoves = next.unstable_moves, nextProps = (0, $d71074b92e18808d$export$71511d61b312f219)(next, [
            "currentId",
            "unstable_moves"
        ]);
        if (nextCurrentId !== prevCurrentId) {
            if (next.id === nextCurrentId || next.id === prevCurrentId) return false;
        } else if (prevMoves !== nextMoves) return false;
        return (0, $d9e89be7b38f2ae5$export$ed213cc82e426b1a).unstable_propsAreEqual(prevProps, nextProps);
    },
    useOptions: function useOptions(options) {
        return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, options), {}, {
            id: options.id,
            currentId: (0, $079cd58daa882f47$export$39b482c5e57630a8)(options),
            unstable_clickOnSpace: options.unstable_hasActiveWidget ? false : options.unstable_clickOnSpace
        });
    },
    useProps: function useProps(options, _ref) {
        var _options$items2;
        var htmlRef = _ref.ref, _ref$tabIndex = _ref.tabIndex, htmlTabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex, htmlOnMouseDown = _ref.onMouseDown, htmlOnFocus = _ref.onFocus, htmlOnBlurCapture = _ref.onBlurCapture, htmlOnKeyDown = _ref.onKeyDown, htmlOnClick = _ref.onClick, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "ref",
            "tabIndex",
            "onMouseDown",
            "onFocus",
            "onBlurCapture",
            "onKeyDown",
            "onClick"
        ]);
        var ref = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
        var id = options.id;
        var trulyDisabled = options.disabled && !options.focusable;
        var isCurrentItem = options.currentId === id;
        var isCurrentItemRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(isCurrentItem);
        var hasFocusedComposite = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(false);
        var item = $cf1bae67834fc2dd$var$useItem(options);
        var onMouseDownRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnMouseDown);
        var onFocusRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnFocus);
        var onBlurCaptureRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnBlurCapture);
        var onKeyDownRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnKeyDown);
        var onClickRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnClick);
        var shouldTabIndex = !options.unstable_virtual && !options.unstable_hasActiveWidget && isCurrentItem || // We don't want to set tabIndex="-1" when using CompositeItem as a
        // standalone component, without state props.
        !((_options$items2 = options.items) !== null && _options$items2 !== void 0 && _options$items2.length);
        (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
            var _options$registerItem;
            if (!id) return undefined;
            (_options$registerItem = options.registerItem) === null || _options$registerItem === void 0 || _options$registerItem.call(options, {
                id: id,
                ref: ref,
                disabled: !!trulyDisabled
            });
            return function() {
                var _options$unregisterIt;
                (_options$unregisterIt = options.unregisterItem) === null || _options$unregisterIt === void 0 || _options$unregisterIt.call(options, id);
            };
        }, [
            id,
            trulyDisabled,
            options.registerItem,
            options.unregisterItem
        ]);
        (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
            var element = ref.current;
            if (!element) return;
             // `moves` will be incremented whenever next, previous, up, down, first,
            // last or move have been called. This means that the composite item will
            // be focused whenever some of these functions are called. We're using
            // isCurrentItemRef instead of isCurrentItem because we don't want to
            // focus the item if isCurrentItem changes (and options.moves doesn't).
            if (options.unstable_moves && isCurrentItemRef.current) (0, $f5942c630e2b5a42$export$3b14a55fb2447963)(element);
        }, [
            options.unstable_moves
        ]);
        var onMouseDown = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onMouseDownRef$curre;
            (_onMouseDownRef$curre = onMouseDownRef.current) === null || _onMouseDownRef$curre === void 0 || _onMouseDownRef$curre.call(onMouseDownRef, event);
            (0, $f5942c630e2b5a42$export$2408f22a0fab9ae5)(event.currentTarget, true);
        }, []);
        var onFocus = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onFocusRef$current, _options$setCurrentId;
            var shouldFocusComposite = (0, $f5942c630e2b5a42$export$dda1d9f60106f0e9)(event.currentTarget);
            (0, $f5942c630e2b5a42$export$2408f22a0fab9ae5)(event.currentTarget, false);
            (_onFocusRef$current = onFocusRef.current) === null || _onFocusRef$current === void 0 || _onFocusRef$current.call(onFocusRef, event);
            if (event.defaultPrevented) return;
            if ((0, $fb6a1f3bf7908434$export$af57ec5ec914349c)(event)) return;
            if (!id) return;
            if ($cf1bae67834fc2dd$var$targetIsAnotherItem(event, options.items)) return;
            (_options$setCurrentId = options.setCurrentId) === null || _options$setCurrentId === void 0 || _options$setCurrentId.call(options, id); // When using aria-activedescendant, we want to make sure that the
            // composite container receives focus, not the composite item.
            // But we don't want to do this if the target is another focusable
            // element inside the composite item, such as CompositeItemWidget.
            if (shouldFocusComposite && options.unstable_virtual && options.baseId && (0, $71809a9b946920fa$export$7bced8f45c53f2f)(event)) {
                var target = event.target;
                var composite = (0, $2e594f29f3297da7$export$f65ca476c09acec0)(target).getElementById(options.baseId);
                if (composite) {
                    hasFocusedComposite.current = true;
                    (0, $2feaa9579ddfa1c6$export$f324b2d22fd95a05)(composite);
                }
            }
        }, [
            id,
            options.items,
            options.setCurrentId,
            options.unstable_virtual,
            options.baseId
        ]);
        var onBlurCapture = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onBlurCaptureRef$cur;
            (_onBlurCaptureRef$cur = onBlurCaptureRef.current) === null || _onBlurCaptureRef$cur === void 0 || _onBlurCaptureRef$cur.call(onBlurCaptureRef, event);
            if (event.defaultPrevented) return;
            if (options.unstable_virtual && hasFocusedComposite.current) {
                // When hasFocusedComposite is true, composite has been focused right
                // after focusing this item. This is an intermediate blur event, so
                // we ignore it.
                hasFocusedComposite.current = false;
                event.preventDefault();
                event.stopPropagation();
            }
        }, [
            options.unstable_virtual
        ]);
        var onKeyDown = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onKeyDownRef$current;
            if (!(0, $71809a9b946920fa$export$7bced8f45c53f2f)(event)) return;
            var isVertical = options.orientation !== "horizontal";
            var isHorizontal = options.orientation !== "vertical";
            var isGrid = !!(item !== null && item !== void 0 && item.groupId);
            var keyMap = {
                ArrowUp: (isGrid || isVertical) && options.up,
                ArrowRight: (isGrid || isHorizontal) && options.next,
                ArrowDown: (isGrid || isVertical) && options.down,
                ArrowLeft: (isGrid || isHorizontal) && options.previous,
                Home: function Home() {
                    if (!isGrid || event.ctrlKey) {
                        var _options$first;
                        (_options$first = options.first) === null || _options$first === void 0 || _options$first.call(options);
                    } else {
                        var _options$previous;
                        (_options$previous = options.previous) === null || _options$previous === void 0 || _options$previous.call(options, true);
                    }
                },
                End: function End() {
                    if (!isGrid || event.ctrlKey) {
                        var _options$last;
                        (_options$last = options.last) === null || _options$last === void 0 || _options$last.call(options);
                    } else {
                        var _options$next;
                        (_options$next = options.next) === null || _options$next === void 0 || _options$next.call(options, true);
                    }
                },
                PageUp: function PageUp() {
                    if (isGrid) {
                        var _options$up;
                        (_options$up = options.up) === null || _options$up === void 0 || _options$up.call(options, true);
                    } else {
                        var _options$first2;
                        (_options$first2 = options.first) === null || _options$first2 === void 0 || _options$first2.call(options);
                    }
                },
                PageDown: function PageDown() {
                    if (isGrid) {
                        var _options$down;
                        (_options$down = options.down) === null || _options$down === void 0 || _options$down.call(options, true);
                    } else {
                        var _options$last2;
                        (_options$last2 = options.last) === null || _options$last2 === void 0 || _options$last2.call(options);
                    }
                }
            };
            var action = keyMap[event.key];
            if (action) {
                event.preventDefault();
                action();
                return;
            }
            (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 || _onKeyDownRef$current.call(onKeyDownRef, event);
            if (event.defaultPrevented) return;
            if (event.key.length === 1 && event.key !== " ") {
                var widget = $cf1bae67834fc2dd$var$getWidget(event.currentTarget);
                if (widget && (0, $426d00310d64ef60$export$1cda748695867c48)(widget)) {
                    widget.focus();
                    (0, $820a2fa4c53c85c7$export$2408f22a0fab9ae5)(widget, "");
                }
            } else if (event.key === "Delete" || event.key === "Backspace") {
                var _widget = $cf1bae67834fc2dd$var$getWidget(event.currentTarget);
                if (_widget && (0, $426d00310d64ef60$export$1cda748695867c48)(_widget)) {
                    event.preventDefault();
                    (0, $820a2fa4c53c85c7$export$2408f22a0fab9ae5)(_widget, "");
                }
            }
        }, [
            options.orientation,
            item,
            options.up,
            options.next,
            options.down,
            options.previous,
            options.first,
            options.last
        ]);
        var onClick = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onClickRef$current;
            (_onClickRef$current = onClickRef.current) === null || _onClickRef$current === void 0 || _onClickRef$current.call(onClickRef, event);
            if (event.defaultPrevented) return;
            var element = event.currentTarget;
            var widget = $cf1bae67834fc2dd$var$getWidget(element);
            if (widget && !(0, $1f8dcff49c1e0404$export$848589947316f680)(widget)) // If there's a widget inside the composite item, we make sure it's
            // focused when pressing enter, space or clicking on the composite item.
            widget.focus();
        }, []);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            ref: (0, $f08be812be5c38c7$export$ebc1e1560c2dffa5)(ref, htmlRef),
            id: id,
            tabIndex: shouldTabIndex ? htmlTabIndex : -1,
            "aria-selected": options.unstable_virtual && isCurrentItem ? true : undefined,
            onMouseDown: onMouseDown,
            onFocus: onFocus,
            onBlurCapture: onBlurCapture,
            onKeyDown: onKeyDown,
            onClick: onClick
        }, htmlProps);
    }
});
var $cf1bae67834fc2dd$export$ef1ef7a3a43ace8e = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "button",
    memo: true,
    useHook: $cf1bae67834fc2dd$export$5d135041cfe9980
});







function $b087b222001a3b73$var$getTriangleArea(a, b, c) {
    return Math.abs((a.x * (b.y - c.y) + b.x * (c.y - a.y) + c.x * (a.y - b.y)) / 2);
}
function $b087b222001a3b73$var$isPointInTriangle(point, a, b, c) {
    var A = $b087b222001a3b73$var$getTriangleArea(a, b, c);
    var A1 = $b087b222001a3b73$var$getTriangleArea(point, b, c);
    var A2 = $b087b222001a3b73$var$getTriangleArea(a, point, c);
    var A3 = $b087b222001a3b73$var$getTriangleArea(a, b, point);
    return A === A1 + A2 + A3;
}
function $b087b222001a3b73$var$getSubmenuAnchorPoints(event, visibleSubmenu) {
    var _visibleSubmenu$getBo = visibleSubmenu.getBoundingClientRect(), top = _visibleSubmenu$getBo.top, right = _visibleSubmenu$getBo.right, bottom = _visibleSubmenu$getBo.bottom, left = _visibleSubmenu$getBo.left; // If left is bigger than mouse's clientX, than the submenu is visible on
    // the left side
    var x = left > event.clientX ? left : right;
    return [
        {
            x: x,
            y: top
        },
        {
            x: x,
            y: bottom
        }
    ];
}
function $b087b222001a3b73$var$useTransitToSubmenu(menu, htmlOnMouseEnter) {
    var onMouseEnterRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnMouseEnter);
    var enterPointRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    var submenuTopPointRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    var submenuBottomPointRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    var previousClientX = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(0);
    var previousClientY = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(0);
    var assignSubmenuAnchorPoints = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
        if (!(menu !== null && menu !== void 0 && menu.children.length)) return;
        submenuTopPointRef.current = null;
        submenuBottomPointRef.current = null;
        var visibleSubmenu = (0, $b91a0b861a7c06c6$export$2d1720544b23b823)(menu.children);
        if (!visibleSubmenu) return;
        var _getSubmenuAnchorPoin = $b087b222001a3b73$var$getSubmenuAnchorPoints(event, visibleSubmenu);
        submenuTopPointRef.current = _getSubmenuAnchorPoin[0];
        submenuBottomPointRef.current = _getSubmenuAnchorPoin[1];
    }, [
        menu === null || menu === void 0 ? void 0 : menu.children
    ]);
    var isMouseInTransitToSubmenu = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
        var isMoving = previousClientX.current !== event.clientX || previousClientY.current !== event.clientY;
        if (event.isTrusted && !isMoving) // Safari sometimes triggers mousemove without a mouse movement
        return true;
        var movementX = Math.abs(previousClientX.current - event.clientX);
        previousClientX.current = event.clientX;
        previousClientY.current = event.clientY;
        var hasAnchorPoints = function hasAnchorPoints() {
            return submenuTopPointRef.current && submenuBottomPointRef.current;
        };
        if (event.type === "mouseleave" && !hasAnchorPoints()) assignSubmenuAnchorPoints(event);
        if (!hasAnchorPoints()) return false;
        return movementX && enterPointRef.current && $b087b222001a3b73$var$isPointInTriangle({
            x: event.clientX,
            y: event.clientY
        }, enterPointRef.current, submenuTopPointRef.current, submenuBottomPointRef.current);
    }, [
        assignSubmenuAnchorPoints
    ]);
    var onMouseEnter = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
        var _onMouseEnterRef$curr;
        (_onMouseEnterRef$curr = onMouseEnterRef.current) === null || _onMouseEnterRef$curr === void 0 || _onMouseEnterRef$curr.call(onMouseEnterRef, event);
        if (event.defaultPrevented) return;
        if ((menu === null || menu === void 0 ? void 0 : menu.role) === "menubar") return;
        enterPointRef.current = {
            x: event.clientX,
            y: event.clientY
        };
        assignSubmenuAnchorPoints(event);
    }, [
        menu === null || menu === void 0 ? void 0 : menu.role,
        assignSubmenuAnchorPoints
    ]);
    return {
        onMouseEnter: onMouseEnter,
        isMouseInTransitToSubmenu: isMouseInTransitToSubmenu
    };
}
function $b087b222001a3b73$var$getMouseDestination(event) {
    var relatedTarget = event.relatedTarget;
    if ((relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.nodeType) === Node.ELEMENT_NODE) return event.relatedTarget;
     // IE 11
    return event.toElement || null;
}
function $b087b222001a3b73$var$hoveringInside(event) {
    var nextElement = $b087b222001a3b73$var$getMouseDestination(event);
    if (!nextElement) return false;
    return (0, $28e71a18d15190f3$export$2344b14b097df817)(event.currentTarget, nextElement);
}
function $b087b222001a3b73$var$hoveringExpandedMenu(event, children) {
    if (!(children !== null && children !== void 0 && children.length)) return false;
    var nextElement = $b087b222001a3b73$var$getMouseDestination(event);
    if (!nextElement) return false;
    var visibleSubmenu = (0, $b91a0b861a7c06c6$export$2d1720544b23b823)(children);
    return visibleSubmenu && (0, $28e71a18d15190f3$export$2344b14b097df817)(visibleSubmenu, nextElement);
}
function $b087b222001a3b73$var$hoveringAnotherMenuItem(event, items) {
    var nextElement = $b087b222001a3b73$var$getMouseDestination(event);
    if (!nextElement) return false;
    return items === null || items === void 0 ? void 0 : items.some(function(item) {
        return item.ref.current && (0, $28e71a18d15190f3$export$2344b14b097df817)(item.ref.current, nextElement);
    });
}
var $b087b222001a3b73$export$9d32628fc2aea7da = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "MenuItem",
    compose: (0, $cf1bae67834fc2dd$export$5d135041cfe9980),
    keys: (0, $b46c80dbb89593eb$export$f1e1789686576879),
    propsAreEqual: function propsAreEqual(prev, next) {
        var prevPopoverStyles = prev.unstable_popoverStyles, prevArrowStyles = prev.unstable_arrowStyles, prevVisible = prev.visible, prevProps = (0, $d71074b92e18808d$export$71511d61b312f219)(prev, [
            "unstable_popoverStyles",
            "unstable_arrowStyles",
            "visible"
        ]);
        var nextPopoverStyles = next.unstable_popoverStyles, nextArrowStyles = next.unstable_arrowStyles, nextVisible = next.visible, nextProps = (0, $d71074b92e18808d$export$71511d61b312f219)(next, [
            "unstable_popoverStyles",
            "unstable_arrowStyles",
            "visible"
        ]);
        return (0, $cf1bae67834fc2dd$export$5d135041cfe9980).unstable_propsAreEqual(prevProps, nextProps);
    },
    useProps: function useProps(options, _ref) {
        var htmlOnMouseEnter = _ref.onMouseEnter, htmlOnMouseMove = _ref.onMouseMove, htmlOnMouseLeave = _ref.onMouseLeave, htmlProps = (0, $d71074b92e18808d$export$71511d61b312f219)(_ref, [
            "onMouseEnter",
            "onMouseMove",
            "onMouseLeave"
        ]);
        var menu = (0, $57da6a40a504e45b$export$fae74005e78b1a27)((0, $dfdde098fbc56812$export$3a1a48c8f6ef640e));
        var onMouseMoveRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnMouseMove);
        var onMouseLeaveRef = (0, $b40e9b06f925db37$export$43b4ce1c76a790d1)(htmlOnMouseLeave);
        var _useTransitToSubmenu = $b087b222001a3b73$var$useTransitToSubmenu(menu, htmlOnMouseEnter), onMouseEnter = _useTransitToSubmenu.onMouseEnter, isMouseInTransitToSubmenu = _useTransitToSubmenu.isMouseInTransitToSubmenu;
        var onMouseMove = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onMouseMoveRef$curre, _options$move;
            (_onMouseMoveRef$curre = onMouseMoveRef.current) === null || _onMouseMoveRef$curre === void 0 || _onMouseMoveRef$curre.call(onMouseMoveRef, event);
            if (event.defaultPrevented) return;
            if ((menu === null || menu === void 0 ? void 0 : menu.role) === "menubar") return;
            if (isMouseInTransitToSubmenu(event)) return;
            if ((0, $1f8dcff49c1e0404$export$848589947316f680)(event.currentTarget)) return;
            (_options$move = options.move) === null || _options$move === void 0 || _options$move.call(options, event.currentTarget.id);
        }, [
            options.move
        ]);
        var onMouseLeave = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(event) {
            var _onMouseLeaveRef$curr;
            (_onMouseLeaveRef$curr = onMouseLeaveRef.current) === null || _onMouseLeaveRef$curr === void 0 || _onMouseLeaveRef$curr.call(onMouseLeaveRef, event);
            if (event.defaultPrevented) return;
            if ((menu === null || menu === void 0 ? void 0 : menu.role) === "menubar") return;
            if ($b087b222001a3b73$var$hoveringInside(event)) return; // If this item is a menu disclosure and mouse is leaving it to focus
            // its respective submenu, we don't want to do anything.
            if ($b087b222001a3b73$var$hoveringExpandedMenu(event, menu === null || menu === void 0 ? void 0 : menu.children)) return; // Move focus to menu after blurring
            if (!$b087b222001a3b73$var$hoveringAnotherMenuItem(event, options.items)) {
                var _options$move2;
                if (isMouseInTransitToSubmenu(event)) return;
                (_options$move2 = options.move) === null || _options$move2 === void 0 || _options$move2.call(options, null);
            }
        }, [
            menu === null || menu === void 0 ? void 0 : menu.role,
            menu === null || menu === void 0 ? void 0 : menu.children,
            options.items,
            options.move
        ]);
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            role: "menuitem",
            onMouseEnter: onMouseEnter,
            onMouseMove: onMouseMove,
            onMouseLeave: onMouseLeave
        }, htmlProps);
    }
});
var $b087b222001a3b73$export$2ce376c2cc3355c8 = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "button",
    memo: true,
    useHook: $b087b222001a3b73$export$9d32628fc2aea7da
});
































// Automatically generated
var $b3119babc25e3d4d$var$TOOLBAR_STATE_KEYS = [
    "baseId",
    "unstable_idCountRef",
    "unstable_virtual",
    "rtl",
    "orientation",
    "items",
    "groups",
    "currentId",
    "loop",
    "wrap",
    "shift",
    "unstable_moves",
    "unstable_hasActiveWidget",
    "unstable_includesBaseElement",
    "setBaseId",
    "registerItem",
    "unregisterItem",
    "registerGroup",
    "unregisterGroup",
    "move",
    "next",
    "previous",
    "up",
    "down",
    "first",
    "last",
    "sort",
    "unstable_setVirtual",
    "setRTL",
    "setOrientation",
    "setCurrentId",
    "setLoop",
    "setWrap",
    "setShift",
    "reset",
    "unstable_setIncludesBaseElement",
    "unstable_setHasActiveWidget"
];
var $b3119babc25e3d4d$export$971d5caa766a69d7 = $b3119babc25e3d4d$var$TOOLBAR_STATE_KEYS;
var $b3119babc25e3d4d$export$407448d2b89b1813 = $b3119babc25e3d4d$export$971d5caa766a69d7;
var $b3119babc25e3d4d$export$8b22cf2602fb60ce = $b3119babc25e3d4d$export$407448d2b89b1813;


var $4988e5a9a393386c$export$fa142eb1681c520 = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "Toolbar",
    compose: (0, $6628363f570e9230$export$5deb711daaf91600),
    keys: (0, $b3119babc25e3d4d$export$971d5caa766a69d7),
    useProps: function useProps(options, htmlProps) {
        return (0, $d71074b92e18808d$export$407448d2b89b1813)({
            role: "toolbar",
            "aria-orientation": options.orientation
        }, htmlProps);
    }
});
var $4988e5a9a393386c$export$4c260019440d418f = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "div",
    useHook: $4988e5a9a393386c$export$fa142eb1681c520,
    useCreateElement: function useCreateElement$1(type, props, children) {
        return (0, $1ab3ad06070c6ba8$export$cfb2bb2ead21514)(type, props, children);
    }
});



var $cbd453931a929850$export$f3f426abf36f8c0 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039)((0, $4988e5a9a393386c$export$4c260019440d418f)).withConfig({
    displayName: "Headerstyled__StyledToolbar"
})([
    "width:100%;&& > *:not(:first-child){font-size:14px;margin:0;}"
]);
var $cbd453931a929850$export$28be41ac4e8a64c4 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).button.withConfig({
    displayName: "Headerstyled__StyledLogo"
})([
    "margin:16px 24px;padding:0;border:none;background:transparent;cursor:pointer;"
]);
var $cbd453931a929850$export$579a1e9bab103f15 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Headerstyled__StyledHeader"
})([
    "display:flex;max-height:64px;width:100%;"
]);
var $cbd453931a929850$export$961affb606ed6923 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).hr.withConfig({
    displayName: "Headerstyled__VerticalSeparator"
})([
    "height:64px;border:0;border-left:1px solid;border-color:#dedede;margin:0;padding:0;width:1px;"
]);
var $cbd453931a929850$export$e762fcbbbfd48835 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039)((0, $e4a61b85b145b055$export$266a769812832828)).withConfig({
    displayName: "Headerstyled__StyledMenuButton"
})([
    "&&{border-radius:0;font-size:14px;padding:0 24px;}&&&:active{background-color:#f5f5f5;outline:none;}&&&:focus{color:#303030;outline:0;}&&&:hover,&&:not([aria-disabled='true'])[aria-expanded='true'],&&[aria-expanded='true']{background-color:#fff;border-color:#fff;color:#303030;}&& svg{fill:#303030;height:0.5em;width:0.5em;}"
]);
var $cbd453931a929850$export$116ce745fe9423aa = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039)((0, $6b9225ff63429571$export$353f5b6fc5456de1)).withConfig({
    displayName: "Headerstyled__StyledToolbarItemButton"
})([
    "&&{background-color:#f5f5f5;border-color:#f5f5f5;border-radius:4px;font-size:14px;font-weight:500;margin:0 8px;padding:0 24px;}&&&:not([aria-selected='true']){background-color:#f5f5f5;}&&&:active{background-color:#f5f5f5;outline:none;}&&&:focus{color:#303030;outline:0;}&&&:hover,&&[aria-expanded='true']{background-color:#f5f5f5;border-color:#f5f5f5;color:#303030;}"
]);
var $cbd453931a929850$export$962a80781251da57 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).button.withConfig({
    displayName: "Headerstyled__StyledDraftButton"
})([
    "&&{cursor:default;border:none;background-color:RGB(254,242,235);color:RGB(235,100,53);}"
]);
var $cbd453931a929850$export$6a23e5b86d8f0768 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).button.withConfig({
    displayName: "Headerstyled__StyledPreviewButton"
})([
    "&&{cursor:default;border:none;background-color:RGBA(0,69,165,0.08);color:RGBA(0,69,165,1);}"
]);
var $cbd453931a929850$export$ea86631f73ac0500 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Headerstyled__StyledOptionsWrapper"
})([
    "display:flex;padding:16px 24px;"
]);
var $cbd453931a929850$export$a4b5f32e41b83d00 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039)($cbd453931a929850$export$ea86631f73ac0500).withConfig({
    displayName: "Headerstyled__StyledPreviewWrapper"
})([
    "margin-left:auto !important;"
]);
var $cbd453931a929850$export$9279730d9a710a01 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Headerstyled__StyledOptionsLabel"
})([
    "line-height:32px;margin-right:8px;"
]);
var $cbd453931a929850$export$53cb3e9006a6cf07 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Headerstyled__MoreItemsWrapper"
})([
    "display:flex;position:relative;"
]);
var $cbd453931a929850$export$f48bda32bee484ec = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039)((0, $14a25f98aaedb6a7$export$d9b273488cd8ce6f)).withConfig({
    displayName: "Headerstyled__StyledMenu"
})([
    "&&{border:0;border-radius:0 0 4px 4px;box-shadow:0px 10px 20px 3px rgba(0,0,0,0.3) !important;position:relative;right:0 !important;min-width:max-content;width:100%;}&&[aria-orientation='vertical']{padding:5px 0;}&&::before{border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:8px solid #fff;content:'';height:0px;left:50%;position:absolute;top:-8px;width:0px;transform:translateX(-50%);}"
]);
var $cbd453931a929850$export$cae703c457e46f23 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039)((0, $b087b222001a3b73$export$2ce376c2cc3355c8)).withConfig({
    displayName: "Headerstyled__StyledMenuItem"
})([
    "&&&&{font-size:14px;font-weight:400;padding:19px 12px;}&&&[aria-expanded='true'],&&&&:hover,&&&&:focus{background-color:#f5f5f5;color:#303030;cursor:pointer;}"
]);
var $cbd453931a929850$export$69fdf448548da677 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).span.withConfig({
    displayName: "Headerstyled__StyledMenuItemText"
})([
    "vertical-align:top;display:inline-block;line-height:20px;white-space:nowrap;"
]);
var $cbd453931a929850$export$afc87062fd6d79c3 = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).span.withConfig({
    displayName: "Headerstyled__StyledMenuItemIcon"
})([
    "vertical-align:middle;display:inline-block;margin-right:8px;"
]);

































var $d6705f2562fe396f$export$20a432f7e5c4d8cd = (0, $7478c93f949c3a40$export$e7f733c8fc2b8a24)({
    name: "ToolbarItem",
    compose: (0, $cf1bae67834fc2dd$export$5d135041cfe9980),
    keys: (0, $b3119babc25e3d4d$export$407448d2b89b1813)
});
var $d6705f2562fe396f$export$cb67beb212e92bbd = (0, $adedf304b009a45c$export$60e54eaca7e7fb38)({
    as: "button",
    memo: true,
    useHook: $d6705f2562fe396f$export$20a432f7e5c4d8cd
});





/**
 * React custom hook that returns the very first value passed to `initialState`,
 * even if it changes between re-renders.
 */ function $b15e19c34b818be5$export$6717f1738e226a4a(initialState) {
    var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(initialState), sealed = _React$useState[0];
    return sealed;
}










var $8Bufz = parcelRequire("8Bufz");









function $2c47f2487758d6df$var$isUpdater(argument) {
    return typeof argument === "function";
}
/**
 * Receives a `setState` argument and calls it with `currentValue` if it's a
 * function. Otherwise return the argument as the new value.
 *
 * @example
 * import { applyState } from "reakit-utils";
 *
 * applyState((value) => value + 1, 1); // 2
 * applyState(2, 1); // 2
 */ function $2c47f2487758d6df$export$737b28574842fc14(argument, currentValue) {
    if ($2c47f2487758d6df$var$isUpdater(argument)) return argument(currentValue);
    return argument;
}





function $d80ebc5349e07a80$export$d007c6b0739b4daa(initialState) {
    if (initialState === void 0) initialState = {};
    var _useSealedState = (0, $b15e19c34b818be5$export$6717f1738e226a4a)(initialState), initialBaseId = _useSealedState.baseId;
    var generateId = (0, $57da6a40a504e45b$export$fae74005e78b1a27)((0, $162421c70abe592f$export$e478069c421a4465));
    var idCountRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(0);
    var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(function() {
        return initialBaseId || generateId();
    }), baseId = _React$useState[0], setBaseId = _React$useState[1];
    return {
        baseId: baseId,
        setBaseId: setBaseId,
        unstable_idCountRef: idCountRef
    };
}


function $8378ccc27f180b80$var$isElementPreceding(element1, element2) {
    return Boolean(element2.compareDocumentPosition(element1) & Node.DOCUMENT_POSITION_PRECEDING);
}
function $8378ccc27f180b80$var$findDOMIndex(items, item) {
    return items.findIndex(function(currentItem) {
        if (!currentItem.ref.current || !item.ref.current) return false;
        return $8378ccc27f180b80$var$isElementPreceding(item.ref.current, currentItem.ref.current);
    });
}
function $8378ccc27f180b80$var$getMaxLength(rows) {
    var maxLength = 0;
    for(var _iterator = (0, $d71074b92e18808d$export$8b22cf2602fb60ce)(rows), _step; !(_step = _iterator()).done;){
        var length = _step.value.length;
        if (length > maxLength) maxLength = length;
    }
    return maxLength;
}
/**
 * Turns [row1, row1, row2, row2] into [row1, row2, row1, row2]
 */ function $8378ccc27f180b80$var$verticalizeItems(items) {
    var groups = (0, $57b7264df03bb3c2$export$39b482c5e57630a8)(items);
    var maxLength = $8378ccc27f180b80$var$getMaxLength(groups);
    var verticalized = [];
    for(var i = 0; i < maxLength; i += 1)for(var _iterator = (0, $d71074b92e18808d$export$8b22cf2602fb60ce)(groups), _step; !(_step = _iterator()).done;){
        var group = _step.value;
        if (group[i]) verticalized.push((0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, group[i]), {}, {
            // If there's no groupId, it means that it's not a grid composite,
            // but a single row instead. So, instead of verticalizing it, that
            // is, assigning a different groupId based on the column index, we
            // keep it undefined so they will be part of the same group.
            // It's useful when using up/down on one-dimensional composites.
            groupId: group[i].groupId ? "" + i : undefined
        }));
    }
    return verticalized;
}
function $8378ccc27f180b80$var$createEmptyItem(groupId) {
    return {
        id: "__EMPTY_ITEM__",
        disabled: true,
        ref: {
            current: null
        },
        groupId: groupId
    };
}
/**
 * Turns [[row1, row1], [row2]] into [[row1, row1], [row2, row2]]
 */ function $8378ccc27f180b80$var$fillGroups(groups, currentId, shift) {
    var maxLength = $8378ccc27f180b80$var$getMaxLength(groups);
    for(var _iterator = (0, $d71074b92e18808d$export$8b22cf2602fb60ce)(groups), _step; !(_step = _iterator()).done;){
        var group = _step.value;
        for(var i = 0; i < maxLength; i += 1){
            var item = group[i];
            if (!item || shift && item.disabled) {
                var isFrist = i === 0;
                var previousItem = isFrist && shift ? (0, $079cd58daa882f47$export$2d1720544b23b823)(group) : group[i - 1];
                group[i] = previousItem && currentId !== (previousItem === null || previousItem === void 0 ? void 0 : previousItem.id) && shift ? previousItem : $8378ccc27f180b80$var$createEmptyItem(previousItem === null || previousItem === void 0 ? void 0 : previousItem.groupId);
            }
        }
    }
    return groups;
}
var $8378ccc27f180b80$var$nullItem = {
    id: null,
    ref: {
        current: null
    }
};
function $8378ccc27f180b80$var$placeItemsAfter(items, id, shouldInsertNullItem) {
    var index = items.findIndex(function(item) {
        return item.id === id;
    });
    return [].concat(items.slice(index + 1), shouldInsertNullItem ? [
        $8378ccc27f180b80$var$nullItem
    ] : [], items.slice(0, index));
}
function $8378ccc27f180b80$var$getItemsInGroup(items, groupId) {
    return items.filter(function(item) {
        return item.groupId === groupId;
    });
}
var $8378ccc27f180b80$var$map = {
    horizontal: "vertical",
    vertical: "horizontal"
};
function $8378ccc27f180b80$var$getOppositeOrientation(orientation) {
    return orientation && $8378ccc27f180b80$var$map[orientation];
}
function $8378ccc27f180b80$var$addItemAtIndex(array, item, index) {
    if (!(index in array)) return [].concat(array, [
        item
    ]);
    return [].concat(array.slice(0, index), [
        item
    ], array.slice(index));
}
function $8378ccc27f180b80$var$sortBasedOnDOMPosition(items) {
    var pairs = items.map(function(item, index) {
        return [
            index,
            item
        ];
    });
    var isOrderDifferent = false;
    pairs.sort(function(_ref, _ref2) {
        var indexA = _ref[0], a = _ref[1];
        var indexB = _ref2[0], b = _ref2[1];
        var elementA = a.ref.current;
        var elementB = b.ref.current;
        if (!elementA || !elementB) return 0; // a before b
        if ($8378ccc27f180b80$var$isElementPreceding(elementA, elementB)) {
            if (indexA > indexB) isOrderDifferent = true;
            return -1;
        } // a after b
        if (indexA < indexB) isOrderDifferent = true;
        return 1;
    });
    if (isOrderDifferent) return pairs.map(function(_ref3) {
        var _ = _ref3[0], item = _ref3[1];
        return item;
    });
    return items;
}
function $8378ccc27f180b80$var$setItemsBasedOnDOMPosition(items, setItems) {
    var sortedItems = $8378ccc27f180b80$var$sortBasedOnDOMPosition(items);
    if (items !== sortedItems) setItems(sortedItems);
}
function $8378ccc27f180b80$var$getCommonParent(items) {
    var _firstItem$ref$curren;
    var firstItem = items[0], nextItems = items.slice(1);
    var parentElement = firstItem === null || firstItem === void 0 ? void 0 : (_firstItem$ref$curren = firstItem.ref.current) === null || _firstItem$ref$curren === void 0 ? void 0 : _firstItem$ref$curren.parentElement;
    var _loop = function _loop() {
        var parent = parentElement;
        if (nextItems.every(function(item) {
            return parent.contains(item.ref.current);
        })) return {
            v: parentElement
        };
        parentElement = parentElement.parentElement;
    };
    while(parentElement){
        var _ret = _loop();
        if ((typeof _ret === "undefined" ? "undefined" : (0, $8Bufz._)(_ret)) === "object") return _ret.v;
    }
    return (0, $2e594f29f3297da7$export$f65ca476c09acec0)(parentElement).body;
} // istanbul ignore next: JSDOM doesn't support IntersectionObverser
// See https://github.com/jsdom/jsdom/issues/2032
function $8378ccc27f180b80$var$useIntersectionObserver(items, setItems) {
    var previousItems = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)([]);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var callback = function callback() {
            var hasPreviousItems = !!previousItems.current.length; // We don't want to sort items if items have been just registered.
            if (hasPreviousItems) $8378ccc27f180b80$var$setItemsBasedOnDOMPosition(items, setItems);
            previousItems.current = items;
        };
        var root = $8378ccc27f180b80$var$getCommonParent(items);
        var observer = new IntersectionObserver(callback, {
            root: root
        });
        for(var _iterator = (0, $d71074b92e18808d$export$8b22cf2602fb60ce)(items), _step; !(_step = _iterator()).done;){
            var item = _step.value;
            if (item.ref.current) observer.observe(item.ref.current);
        }
        return function() {
            observer.disconnect();
        };
    }, [
        items
    ]);
}
function $8378ccc27f180b80$var$useTimeoutObserver(items, setItems) {
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var callback = function callback() {
            return $8378ccc27f180b80$var$setItemsBasedOnDOMPosition(items, setItems);
        };
        var timeout = setTimeout(callback, 250);
        return function() {
            return clearTimeout(timeout);
        };
    });
}
function $8378ccc27f180b80$var$useSortBasedOnDOMPosition(items, setItems) {
    if (typeof IntersectionObserver === "function") $8378ccc27f180b80$var$useIntersectionObserver(items, setItems);
    else $8378ccc27f180b80$var$useTimeoutObserver(items, setItems);
}
function $8378ccc27f180b80$var$reducer(state, action) {
    var virtual = state.unstable_virtual, rtl = state.rtl, orientation = state.orientation, items = state.items, groups = state.groups, currentId = state.currentId, loop = state.loop, wrap = state.wrap, pastIds = state.pastIds, shift = state.shift, moves = state.unstable_moves, includesBaseElement = state.unstable_includesBaseElement, initialVirtual = state.initialVirtual, initialRTL = state.initialRTL, initialOrientation = state.initialOrientation, initialCurrentId = state.initialCurrentId, initialLoop = state.initialLoop, initialWrap = state.initialWrap, initialShift = state.initialShift, hasSetCurrentId = state.hasSetCurrentId;
    switch(action.type){
        case "registerGroup":
            var _group = action.group; // If there are no groups yet, just add it as the first one
            if (groups.length === 0) return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                groups: [
                    _group
                ]
            });
             // Finds the group index based on DOM position
            var index = $8378ccc27f180b80$var$findDOMIndex(groups, _group);
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                groups: $8378ccc27f180b80$var$addItemAtIndex(groups, _group, index)
            });
        case "unregisterGroup":
            var _id = action.id;
            var nextGroups = groups.filter(function(group) {
                return group.id !== _id;
            }); // The group isn't registered, so do nothing
            if (nextGroups.length === groups.length) return state;
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                groups: nextGroups
            });
        case "registerItem":
            var _item = action.item; // Finds the item group based on the DOM hierarchy
            var _group2 = groups.find(function(r) {
                var _r$ref$current;
                return (_r$ref$current = r.ref.current) === null || _r$ref$current === void 0 ? void 0 : _r$ref$current.contains(_item.ref.current);
            }); // Group will be null if it's a one-dimensional composite
            var nextItem = (0, $d71074b92e18808d$export$407448d2b89b1813)({
                groupId: _group2 === null || _group2 === void 0 ? void 0 : _group2.id
            }, _item);
            var _index = $8378ccc27f180b80$var$findDOMIndex(items, nextItem);
            var nextState = (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                items: $8378ccc27f180b80$var$addItemAtIndex(items, nextItem, _index)
            });
            if (!hasSetCurrentId && !moves && initialCurrentId === undefined) {
                var _findFirstEnabledItem;
                // Sets currentId to the first enabled item. This runs whenever an item
                // is registered because the first enabled item may be registered
                // asynchronously.
                return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, nextState), {}, {
                    currentId: (_findFirstEnabledItem = (0, $079cd58daa882f47$export$2d1720544b23b823)(nextState.items)) === null || _findFirstEnabledItem === void 0 ? void 0 : _findFirstEnabledItem.id
                });
            }
            return nextState;
        case "unregisterItem":
            var _id2 = action.id;
            var nextItems = items.filter(function(item) {
                return item.id !== _id2;
            }); // The item isn't registered, so do nothing
            if (nextItems.length === items.length) return state;
             // Filters out the item that is being removed from the pastIds list
            var nextPastIds = pastIds.filter(function(pastId) {
                return pastId !== _id2;
            });
            var _nextState = (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                pastIds: nextPastIds,
                items: nextItems
            }); // If the current item is the item that is being removed, focus pastId
            if (currentId && currentId === _id2) {
                var nextId = includesBaseElement ? null : (0, $079cd58daa882f47$export$39b482c5e57630a8)((0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, _nextState), {}, {
                    currentId: nextPastIds[0]
                }));
                return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, _nextState), {}, {
                    currentId: nextId
                });
            }
            return _nextState;
        case "move":
            var _id3 = action.id; // move() does nothing
            if (_id3 === undefined) return state;
             // Removes the current item and the item that is receiving focus from the
            // pastIds list
            var filteredPastIds = pastIds.filter(function(pastId) {
                return pastId !== currentId && pastId !== _id3;
            }); // If there's a currentId, add it to the pastIds list so it can be focused
            // if the new item gets removed or disabled
            var _nextPastIds = currentId ? [
                currentId
            ].concat(filteredPastIds) : filteredPastIds;
            var _nextState2 = (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                pastIds: _nextPastIds
            }); // move(null) will focus the composite element itself, not an item
            if (_id3 === null) return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, _nextState2), {}, {
                unstable_moves: moves + 1,
                currentId: (0, $079cd58daa882f47$export$39b482c5e57630a8)(_nextState2, _id3)
            });
            var _item2 = (0, $460fa4df69bd7eee$export$2d1720544b23b823)(items, _id3);
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, _nextState2), {}, {
                unstable_moves: _item2 ? moves + 1 : moves,
                currentId: (0, $079cd58daa882f47$export$39b482c5e57630a8)(_nextState2, _item2 === null || _item2 === void 0 ? void 0 : _item2.id)
            });
        case "next":
            // If there's no item focused, we just move the first one
            if (currentId == null) return $8378ccc27f180b80$var$reducer(state, (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, action), {}, {
                type: "first"
            }));
             // RTL doesn't make sense on vertical navigation
            var isHorizontal = orientation !== "vertical";
            var isRTL = rtl && isHorizontal;
            var allItems = isRTL ? (0, $57b7264df03bb3c2$export$43caf9889c228507)(items) : items;
            var currentItem = allItems.find(function(item) {
                return item.id === currentId;
            }); // If there's no item focused, we just move the first one
            if (!currentItem) return $8378ccc27f180b80$var$reducer(state, (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, action), {}, {
                type: "first"
            }));
            var isGrid = !!currentItem.groupId;
            var currentIndex = allItems.indexOf(currentItem);
            var _nextItems = allItems.slice(currentIndex + 1);
            var nextItemsInGroup = $8378ccc27f180b80$var$getItemsInGroup(_nextItems, currentItem.groupId); // Home, End
            if (action.allTheWay) {
                // We reverse so we can get the last enabled item in the group. If it's
                // RTL, nextItems and nextItemsInGroup are already reversed and don't
                // have the items before the current one anymore. So we have to get
                // items in group again with allItems.
                var _nextItem2 = (0, $079cd58daa882f47$export$2d1720544b23b823)(isRTL ? $8378ccc27f180b80$var$getItemsInGroup(allItems, currentItem.groupId) : (0, $57b7264df03bb3c2$export$43caf9889c228507)(nextItemsInGroup));
                return $8378ccc27f180b80$var$reducer(state, (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, action), {}, {
                    type: "move",
                    id: _nextItem2 === null || _nextItem2 === void 0 ? void 0 : _nextItem2.id
                }));
            }
            var oppositeOrientation = $8378ccc27f180b80$var$getOppositeOrientation(// call, which is inherently horizontal. up/down will call next with
            // orientation set to vertical by default (see below on up/down cases).
            isGrid ? orientation || "horizontal" : orientation);
            var canLoop = loop && loop !== oppositeOrientation;
            var canWrap = isGrid && wrap && wrap !== oppositeOrientation;
            var hasNullItem = // next directly, hasNullItem will only be true if it's not a grid and
            // loop is set to true, which means that pressing right or down keys on
            // grids will never focus the composite element. On one-dimensional
            // composites that don't loop, pressing right or down keys also doesn't
            // focus the composite element.
            action.hasNullItem || !isGrid && canLoop && includesBaseElement;
            if (canLoop) {
                var loopItems = canWrap && !hasNullItem ? allItems : $8378ccc27f180b80$var$getItemsInGroup(allItems, currentItem.groupId); // Turns [0, 1, current, 3, 4] into [3, 4, 0, 1]
                var sortedItems = $8378ccc27f180b80$var$placeItemsAfter(loopItems, currentId, hasNullItem);
                var _nextItem3 = (0, $079cd58daa882f47$export$2d1720544b23b823)(sortedItems, currentId);
                return $8378ccc27f180b80$var$reducer(state, (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, action), {}, {
                    type: "move",
                    id: _nextItem3 === null || _nextItem3 === void 0 ? void 0 : _nextItem3.id
                }));
            }
            if (canWrap) {
                var _nextItem4 = (0, $079cd58daa882f47$export$2d1720544b23b823)(// items from other groups, to wrap between groups. However, if there
                // is a null item (the composite element), we'll only use the next
                // items in the group. So moving next from the last item will focus
                // the composite element (null). On grid composites, horizontal
                // navigation never focuses the composite element, only vertical.
                hasNullItem ? nextItemsInGroup : _nextItems, currentId);
                var _nextId = hasNullItem ? (_nextItem4 === null || _nextItem4 === void 0 ? void 0 : _nextItem4.id) || null : _nextItem4 === null || _nextItem4 === void 0 ? void 0 : _nextItem4.id;
                return $8378ccc27f180b80$var$reducer(state, (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, action), {}, {
                    type: "move",
                    id: _nextId
                }));
            }
            var _nextItem = (0, $079cd58daa882f47$export$2d1720544b23b823)(nextItemsInGroup, currentId);
            if (!_nextItem && hasNullItem) return $8378ccc27f180b80$var$reducer(state, (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, action), {}, {
                type: "move",
                id: null
            }));
            return $8378ccc27f180b80$var$reducer(state, (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, action), {}, {
                type: "move",
                id: _nextItem === null || _nextItem === void 0 ? void 0 : _nextItem.id
            }));
        case "previous":
            // If currentId is initially set to null, the composite element will be
            // focusable while navigating with arrow keys. But, if it's a grid, we
            // don't want to focus the composite element with horizontal navigation.
            var _isGrid = !!groups.length;
            var _hasNullItem = !_isGrid && includesBaseElement;
            var _nextState3 = $8378ccc27f180b80$var$reducer((0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                items: (0, $57b7264df03bb3c2$export$43caf9889c228507)(items)
            }), (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, action), {}, {
                type: "next",
                hasNullItem: _hasNullItem
            }));
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, _nextState3), {}, {
                items: items
            });
        case "down":
            var shouldShift = shift && !action.allTheWay; // First, we make sure groups have the same number of items by filling it
            // with disabled fake items. Then, we reorganize the items list so
            // [1-1, 1-2, 2-1, 2-2] becomes [1-1, 2-1, 1-2, 2-2].
            var verticalItems = $8378ccc27f180b80$var$verticalizeItems((0, $57b7264df03bb3c2$export$2d1720544b23b823)($8378ccc27f180b80$var$fillGroups((0, $57b7264df03bb3c2$export$39b482c5e57630a8)(items), currentId, shouldShift)));
            var _canLoop = loop && loop !== "horizontal"; // Pressing down arrow key will only focus the composite element if loop
            // is true or vertical.
            var _hasNullItem2 = _canLoop && includesBaseElement;
            var _nextState4 = $8378ccc27f180b80$var$reducer((0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                orientation: "vertical",
                items: verticalItems
            }), (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, action), {}, {
                type: "next",
                hasNullItem: _hasNullItem2
            }));
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, _nextState4), {}, {
                orientation: orientation,
                items: items
            });
        case "up":
            var _shouldShift = shift && !action.allTheWay;
            var _verticalItems = $8378ccc27f180b80$var$verticalizeItems((0, $57b7264df03bb3c2$export$43caf9889c228507)((0, $57b7264df03bb3c2$export$2d1720544b23b823)($8378ccc27f180b80$var$fillGroups((0, $57b7264df03bb3c2$export$39b482c5e57630a8)(items), currentId, _shouldShift)))); // If currentId is initially set to null, we'll always focus the
            // composite element when the up arrow key is pressed in the first row.
            var _hasNullItem3 = includesBaseElement;
            var _nextState5 = $8378ccc27f180b80$var$reducer((0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                orientation: "vertical",
                items: _verticalItems
            }), (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, action), {}, {
                type: "next",
                hasNullItem: _hasNullItem3
            }));
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, _nextState5), {}, {
                orientation: orientation,
                items: items
            });
        case "first":
            var firstItem = (0, $079cd58daa882f47$export$2d1720544b23b823)(items);
            return $8378ccc27f180b80$var$reducer(state, (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, action), {}, {
                type: "move",
                id: firstItem === null || firstItem === void 0 ? void 0 : firstItem.id
            }));
        case "last":
            var _nextState6 = $8378ccc27f180b80$var$reducer((0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                items: (0, $57b7264df03bb3c2$export$43caf9889c228507)(items)
            }), (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, action), {}, {
                type: "first"
            }));
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, _nextState6), {}, {
                items: items
            });
        case "sort":
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                items: $8378ccc27f180b80$var$sortBasedOnDOMPosition(items),
                groups: $8378ccc27f180b80$var$sortBasedOnDOMPosition(groups)
            });
        case "setVirtual":
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                unstable_virtual: (0, $2c47f2487758d6df$export$737b28574842fc14)(action.virtual, virtual)
            });
        case "setRTL":
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                rtl: (0, $2c47f2487758d6df$export$737b28574842fc14)(action.rtl, rtl)
            });
        case "setOrientation":
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                orientation: (0, $2c47f2487758d6df$export$737b28574842fc14)(action.orientation, orientation)
            });
        case "setCurrentId":
            var nextCurrentId = (0, $079cd58daa882f47$export$39b482c5e57630a8)((0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                currentId: (0, $2c47f2487758d6df$export$737b28574842fc14)(action.currentId, currentId)
            }));
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                currentId: nextCurrentId,
                hasSetCurrentId: true
            });
        case "setLoop":
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                loop: (0, $2c47f2487758d6df$export$737b28574842fc14)(action.loop, loop)
            });
        case "setWrap":
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                wrap: (0, $2c47f2487758d6df$export$737b28574842fc14)(action.wrap, wrap)
            });
        case "setShift":
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                shift: (0, $2c47f2487758d6df$export$737b28574842fc14)(action.shift, shift)
            });
        case "setIncludesBaseElement":
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                unstable_includesBaseElement: (0, $2c47f2487758d6df$export$737b28574842fc14)(action.includesBaseElement, includesBaseElement)
            });
        case "reset":
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                unstable_virtual: initialVirtual,
                rtl: initialRTL,
                orientation: initialOrientation,
                currentId: (0, $079cd58daa882f47$export$39b482c5e57630a8)((0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                    currentId: initialCurrentId
                })),
                loop: initialLoop,
                wrap: initialWrap,
                shift: initialShift,
                unstable_moves: 0,
                pastIds: []
            });
        case "setItems":
            return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, state), {}, {
                items: action.items
            });
        default:
            throw new Error();
    }
}
function $8378ccc27f180b80$var$useAction(fn) {
    return (0, $57da6a40a504e45b$export$35808ee640e87ca7)(fn, []);
}
function $8378ccc27f180b80$var$useIsUnmountedRef() {
    var isUnmountedRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(false);
    (0, $55d7e61099d95834$export$363c9f3eb56bbdbe)(function() {
        return function() {
            isUnmountedRef.current = true;
        };
    }, []);
    return isUnmountedRef;
}
function $8378ccc27f180b80$export$341d2d2d28400ea1(initialState) {
    if (initialState === void 0) initialState = {};
    var _useSealedState = (0, $b15e19c34b818be5$export$6717f1738e226a4a)(initialState), _useSealedState$unsta = _useSealedState.unstable_virtual, virtual = _useSealedState$unsta === void 0 ? false : _useSealedState$unsta, _useSealedState$rtl = _useSealedState.rtl, rtl = _useSealedState$rtl === void 0 ? false : _useSealedState$rtl, orientation = _useSealedState.orientation, currentId = _useSealedState.currentId, _useSealedState$loop = _useSealedState.loop, loop = _useSealedState$loop === void 0 ? false : _useSealedState$loop, _useSealedState$wrap = _useSealedState.wrap, wrap = _useSealedState$wrap === void 0 ? false : _useSealedState$wrap, _useSealedState$shift = _useSealedState.shift, shift = _useSealedState$shift === void 0 ? false : _useSealedState$shift, unstable_includesBaseElement = _useSealedState.unstable_includesBaseElement, sealed = (0, $d71074b92e18808d$export$71511d61b312f219)(_useSealedState, [
        "unstable_virtual",
        "rtl",
        "orientation",
        "currentId",
        "loop",
        "wrap",
        "shift",
        "unstable_includesBaseElement"
    ]);
    var idState = (0, $d80ebc5349e07a80$export$d007c6b0739b4daa)(sealed);
    var _React$useReducer = (0, $57da6a40a504e45b$export$13e3392192263954)($8378ccc27f180b80$var$reducer, {
        unstable_virtual: virtual,
        rtl: rtl,
        orientation: orientation,
        items: [],
        groups: [],
        currentId: currentId,
        loop: loop,
        wrap: wrap,
        shift: shift,
        unstable_moves: 0,
        pastIds: [],
        unstable_includesBaseElement: unstable_includesBaseElement != null ? unstable_includesBaseElement : currentId === null,
        initialVirtual: virtual,
        initialRTL: rtl,
        initialOrientation: orientation,
        initialCurrentId: currentId,
        initialLoop: loop,
        initialWrap: wrap,
        initialShift: shift
    }), _React$useReducer$ = _React$useReducer[0], pastIds = _React$useReducer$.pastIds, initialVirtual = _React$useReducer$.initialVirtual, initialRTL = _React$useReducer$.initialRTL, initialOrientation = _React$useReducer$.initialOrientation, initialCurrentId = _React$useReducer$.initialCurrentId, initialLoop = _React$useReducer$.initialLoop, initialWrap = _React$useReducer$.initialWrap, initialShift = _React$useReducer$.initialShift, hasSetCurrentId = _React$useReducer$.hasSetCurrentId, state = (0, $d71074b92e18808d$export$71511d61b312f219)(_React$useReducer$, [
        "pastIds",
        "initialVirtual",
        "initialRTL",
        "initialOrientation",
        "initialCurrentId",
        "initialLoop",
        "initialWrap",
        "initialShift",
        "hasSetCurrentId"
    ]), dispatch = _React$useReducer[1];
    var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(false), hasActiveWidget = _React$useState[0], setHasActiveWidget = _React$useState[1]; // register/unregister may be called when this component is unmounted. We
    // store the unmounted state here so we don't update the state if it's true.
    // This only happens in a very specific situation.
    // See https://github.com/reakit/reakit/issues/650
    var isUnmountedRef = $8378ccc27f180b80$var$useIsUnmountedRef();
    var setItems = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(items) {
        return dispatch({
            type: "setItems",
            items: items
        });
    }, []);
    $8378ccc27f180b80$var$useSortBasedOnDOMPosition(state.items, setItems);
    return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, idState), state), {}, {
        unstable_hasActiveWidget: hasActiveWidget,
        unstable_setHasActiveWidget: setHasActiveWidget,
        registerItem: $8378ccc27f180b80$var$useAction(function(item) {
            if (isUnmountedRef.current) return;
            dispatch({
                type: "registerItem",
                item: item
            });
        }),
        unregisterItem: $8378ccc27f180b80$var$useAction(function(id) {
            if (isUnmountedRef.current) return;
            dispatch({
                type: "unregisterItem",
                id: id
            });
        }),
        registerGroup: $8378ccc27f180b80$var$useAction(function(group) {
            if (isUnmountedRef.current) return;
            dispatch({
                type: "registerGroup",
                group: group
            });
        }),
        unregisterGroup: $8378ccc27f180b80$var$useAction(function(id) {
            if (isUnmountedRef.current) return;
            dispatch({
                type: "unregisterGroup",
                id: id
            });
        }),
        move: $8378ccc27f180b80$var$useAction(function(id) {
            return dispatch({
                type: "move",
                id: id
            });
        }),
        next: $8378ccc27f180b80$var$useAction(function(allTheWay) {
            return dispatch({
                type: "next",
                allTheWay: allTheWay
            });
        }),
        previous: $8378ccc27f180b80$var$useAction(function(allTheWay) {
            return dispatch({
                type: "previous",
                allTheWay: allTheWay
            });
        }),
        up: $8378ccc27f180b80$var$useAction(function(allTheWay) {
            return dispatch({
                type: "up",
                allTheWay: allTheWay
            });
        }),
        down: $8378ccc27f180b80$var$useAction(function(allTheWay) {
            return dispatch({
                type: "down",
                allTheWay: allTheWay
            });
        }),
        first: $8378ccc27f180b80$var$useAction(function() {
            return dispatch({
                type: "first"
            });
        }),
        last: $8378ccc27f180b80$var$useAction(function() {
            return dispatch({
                type: "last"
            });
        }),
        sort: $8378ccc27f180b80$var$useAction(function() {
            return dispatch({
                type: "sort"
            });
        }),
        unstable_setVirtual: $8378ccc27f180b80$var$useAction(function(value) {
            return dispatch({
                type: "setVirtual",
                virtual: value
            });
        }),
        setRTL: $8378ccc27f180b80$var$useAction(function(value) {
            return dispatch({
                type: "setRTL",
                rtl: value
            });
        }),
        setOrientation: $8378ccc27f180b80$var$useAction(function(value) {
            return dispatch({
                type: "setOrientation",
                orientation: value
            });
        }),
        setCurrentId: $8378ccc27f180b80$var$useAction(function(value) {
            return dispatch({
                type: "setCurrentId",
                currentId: value
            });
        }),
        setLoop: $8378ccc27f180b80$var$useAction(function(value) {
            return dispatch({
                type: "setLoop",
                loop: value
            });
        }),
        setWrap: $8378ccc27f180b80$var$useAction(function(value) {
            return dispatch({
                type: "setWrap",
                wrap: value
            });
        }),
        setShift: $8378ccc27f180b80$var$useAction(function(value) {
            return dispatch({
                type: "setShift",
                shift: value
            });
        }),
        unstable_setIncludesBaseElement: $8378ccc27f180b80$var$useAction(function(value) {
            return dispatch({
                type: "setIncludesBaseElement",
                includesBaseElement: value
            });
        }),
        reset: $8378ccc27f180b80$var$useAction(function() {
            return dispatch({
                type: "reset"
            });
        })
    });
}


function $aa6a4034253433d1$export$d16ee687393f6214(initialState) {
    if (initialState === void 0) initialState = {};
    var _useSealedState = (0, $b15e19c34b818be5$export$6717f1738e226a4a)(initialState), _useSealedState$orien = _useSealedState.orientation, orientation = _useSealedState$orien === void 0 ? "horizontal" : _useSealedState$orien, sealed = (0, $d71074b92e18808d$export$71511d61b312f219)(_useSealedState, [
        "orientation"
    ]);
    return (0, $8378ccc27f180b80$export$341d2d2d28400ea1)((0, $d71074b92e18808d$export$407448d2b89b1813)({
        orientation: orientation
    }, sealed));
}


var $8ccf1558ffdbbc40$exports = {};
$8ccf1558ffdbbc40$exports = $parcel$resolve("dTpI4");


var $7ec530b826d8abce$exports = {};
$7ec530b826d8abce$exports = $parcel$resolve("dVjnx");




var $a88060f0945cc60e$var$Background = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).div.withConfig({
    displayName: "LoadingBackground__Background"
})([
    "display:inline-block;height:100%;width:100%;background:linear-gradient(-90deg,#f0f0f0 0%,#f8f8f8 50%,#f0f0f0 100%);background-size:400% 400%;animation:pulse 1.2s ease-in-out infinite;@keyframes pulse{0%{background-position:0% 0%;}100%{background-position:-135% 0%;}}"
]);
var $a88060f0945cc60e$var$LoadingBackgroundLine = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039)($a88060f0945cc60e$var$Background).withConfig({
    displayName: "LoadingBackground__LoadingBackgroundLine"
})([
    "null"
]);
var $a88060f0945cc60e$var$Wrapper = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).div.withConfig({
    displayName: "LoadingBackground__Wrapper"
})([
    "width:100%;"
]);
var $a88060f0945cc60e$var$LoadingBackground = function() {
    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)($a88060f0945cc60e$var$Wrapper, {
        children: (0, $9c980878b5c974fe$export$34b9dba7ce09269b)($a88060f0945cc60e$var$LoadingBackgroundLine, {})
    });
};
var $a88060f0945cc60e$export$2e2bcd8739ae039 = $a88060f0945cc60e$var$LoadingBackground;


var $5380b115589b3837$exports = {};
$5380b115589b3837$exports = $parcel$resolve("bPGQk");


var $29e741da0080981c$exports = {};
$29e741da0080981c$exports = $parcel$resolve("dFYO4");





























function $2388ef85f24bd247$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $ed2db46af83f5833$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $ed2db46af83f5833$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $ed2db46af83f5833$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $9f87da4b549daf1a$export$8960430cfd85939f = Math.max;
var $9f87da4b549daf1a$export$96ec731ed4dcb222 = Math.min;
var $9f87da4b549daf1a$export$2077e0241d6afd3c = Math.round;



function $44d10be7ec7ceaf7$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $ae8f535de75ca197$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $44d10be7ec7ceaf7$export$2e2bcd8739ae039)());
}


function $7ded444e65c07363$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $ed2db46af83f5833$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $9f87da4b549daf1a$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $9f87da4b549daf1a$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $ed2db46af83f5833$export$45a5e7f76e0caa8d)(element) ? (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $ae8f535de75ca197$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $b65e87f75333c1fb$export$2e2bcd8739ae039(node) {
    var win = (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $65d220c6af49a241$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $fd61cb01776f9f93$export$2e2bcd8739ae039(node) {
    if (node === (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(node) || !(0, $ed2db46af83f5833$export$1b3bfaa9684536aa)(node)) return (0, $b65e87f75333c1fb$export$2e2bcd8739ae039)(node);
    else return (0, $65d220c6af49a241$export$2e2bcd8739ae039)(node);
}


function $0212fe39445d8dd6$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $2d464f517a7d9c5d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $ed2db46af83f5833$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $56623e50487d7153$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $7ded444e65c07363$export$2e2bcd8739ae039)((0, $2d464f517a7d9c5d$export$2e2bcd8739ae039)(element)).left + (0, $b65e87f75333c1fb$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $b26fff29392e180a$export$2e2bcd8739ae039(element) {
    return (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $4588d2bff33d608b$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $b26fff29392e180a$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $1b9859f8680a3bd1$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $9f87da4b549daf1a$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $9f87da4b549daf1a$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1b9859f8680a3bd1$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $ed2db46af83f5833$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $ed2db46af83f5833$export$1b3bfaa9684536aa)(offsetParent) && $1b9859f8680a3bd1$var$isElementScaled(offsetParent);
    var documentElement = (0, $2d464f517a7d9c5d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $7ded444e65c07363$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $0212fe39445d8dd6$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $4588d2bff33d608b$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $fd61cb01776f9f93$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $ed2db46af83f5833$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $7ded444e65c07363$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $56623e50487d7153$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $e1edde097f07c4aa$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $7ded444e65c07363$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $db481f498e7d9c55$export$2e2bcd8739ae039(element) {
    if ((0, $0212fe39445d8dd6$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $ed2db46af83f5833$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $2d464f517a7d9c5d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $d353198d8358469e$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $0212fe39445d8dd6$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $ed2db46af83f5833$export$1b3bfaa9684536aa)(node) && (0, $4588d2bff33d608b$export$2e2bcd8739ae039)(node)) return node;
    return $d353198d8358469e$export$2e2bcd8739ae039((0, $db481f498e7d9c55$export$2e2bcd8739ae039)(node));
}





function $215114d8ac988a21$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $d353198d8358469e$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $4588d2bff33d608b$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($215114d8ac988a21$export$2e2bcd8739ae039((0, $db481f498e7d9c55$export$2e2bcd8739ae039)(target)));
}







function $7d420d1a224b2c86$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $0212fe39445d8dd6$export$2e2bcd8739ae039)(element)) >= 0;
}




function $8514b2844e9a8d0b$var$getTrueOffsetParent(element) {
    if (!(0, $ed2db46af83f5833$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $b26fff29392e180a$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $8514b2844e9a8d0b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $44d10be7ec7ceaf7$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $44d10be7ec7ceaf7$export$2e2bcd8739ae039)());
    if (isIE && (0, $ed2db46af83f5833$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $b26fff29392e180a$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $db481f498e7d9c55$export$2e2bcd8739ae039)(element);
    if ((0, $ed2db46af83f5833$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $ed2db46af83f5833$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $0212fe39445d8dd6$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $b26fff29392e180a$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $8514b2844e9a8d0b$export$2e2bcd8739ae039(element) {
    var window = (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(element);
    var offsetParent = $8514b2844e9a8d0b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $7d420d1a224b2c86$export$2e2bcd8739ae039)(offsetParent) && (0, $b26fff29392e180a$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $8514b2844e9a8d0b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $0212fe39445d8dd6$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $0212fe39445d8dd6$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $b26fff29392e180a$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $8514b2844e9a8d0b$var$getContainingBlock(element) || window;
}


var $02e902993d8bea67$export$1e95b668f3b82d = 'top';
var $02e902993d8bea67$export$40e543e69a8b3fbb = 'bottom';
var $02e902993d8bea67$export$79ffe56a765070d2 = 'right';
var $02e902993d8bea67$export$eabcd2c8791e7bf4 = 'left';
var $02e902993d8bea67$export$dfb5619354ba860 = 'auto';
var $02e902993d8bea67$export$aec2ce47c367b8c3 = [
    $02e902993d8bea67$export$1e95b668f3b82d,
    $02e902993d8bea67$export$40e543e69a8b3fbb,
    $02e902993d8bea67$export$79ffe56a765070d2,
    $02e902993d8bea67$export$eabcd2c8791e7bf4
];
var $02e902993d8bea67$export$b3571188c770cc5a = 'start';
var $02e902993d8bea67$export$bd5df0f255a350f8 = 'end';
var $02e902993d8bea67$export$390fd549c5303b4d = 'clippingParents';
var $02e902993d8bea67$export$d7b7311ec04a3e8f = 'viewport';
var $02e902993d8bea67$export$ae5ab1c730825774 = 'popper';
var $02e902993d8bea67$export$ca50aac9f3ba507f = 'reference';
var $02e902993d8bea67$export$368f9a87e87fa4e1 = /*#__PURE__*/ $02e902993d8bea67$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $02e902993d8bea67$export$b3571188c770cc5a,
        placement + "-" + $02e902993d8bea67$export$bd5df0f255a350f8
    ]);
}, []);
var $02e902993d8bea67$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($02e902993d8bea67$export$aec2ce47c367b8c3, [
    $02e902993d8bea67$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $02e902993d8bea67$export$b3571188c770cc5a,
        placement + "-" + $02e902993d8bea67$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $02e902993d8bea67$export$421679a7c3d56e = 'beforeRead';
var $02e902993d8bea67$export$aafa59e2e03f2942 = 'read';
var $02e902993d8bea67$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $02e902993d8bea67$export$c65e99957a05207c = 'beforeMain';
var $02e902993d8bea67$export$f22da7240b7add18 = 'main';
var $02e902993d8bea67$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $02e902993d8bea67$export$8d4d2d70e7d46032 = 'beforeWrite';
var $02e902993d8bea67$export$68d8715fc104d294 = 'write';
var $02e902993d8bea67$export$70a6e5159acce2e6 = 'afterWrite';
var $02e902993d8bea67$export$d087d3878fdf71d5 = [
    $02e902993d8bea67$export$421679a7c3d56e,
    $02e902993d8bea67$export$aafa59e2e03f2942,
    $02e902993d8bea67$export$6964f6c886723980,
    $02e902993d8bea67$export$c65e99957a05207c,
    $02e902993d8bea67$export$f22da7240b7add18,
    $02e902993d8bea67$export$bab79516f2d662fe,
    $02e902993d8bea67$export$8d4d2d70e7d46032,
    $02e902993d8bea67$export$68d8715fc104d294,
    $02e902993d8bea67$export$70a6e5159acce2e6
];


function $f743ea21d102ec7e$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $f743ea21d102ec7e$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $f743ea21d102ec7e$var$order(modifiers); // order based on phase
    return (0, $02e902993d8bea67$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $d84fe255f53129b7$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $228ce39b774b944b$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $2afabfa2e2a8b2c3$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $2afabfa2e2a8b2c3$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $2afabfa2e2a8b2c3$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $2afabfa2e2a8b2c3$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $2afabfa2e2a8b2c3$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $ed2db46af83f5833$export$45a5e7f76e0caa8d)(reference) ? (0, $215114d8ac988a21$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $215114d8ac988a21$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $215114d8ac988a21$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $f743ea21d102ec7e$export$2e2bcd8739ae039)((0, $228ce39b774b944b$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$2afabfa2e2a8b2c3$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $1b9859f8680a3bd1$export$2e2bcd8739ae039)(_$reference, (0, $8514b2844e9a8d0b$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $e1edde097f07c4aa$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $d84fe255f53129b7$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$2afabfa2e2a8b2c3$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $2afabfa2e2a8b2c3$export$8f7491d57c8f97a9 = /*#__PURE__*/ $2afabfa2e2a8b2c3$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $aaf1bfdc416ba53c$var$passive = {
    passive: true
};
function $aaf1bfdc416ba53c$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $aaf1bfdc416ba53c$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $aaf1bfdc416ba53c$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $aaf1bfdc416ba53c$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $aaf1bfdc416ba53c$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $aaf1bfdc416ba53c$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $aaf1bfdc416ba53c$var$effect,
    data: {}
};



function $5eef75ddba48c5b1$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $f94be443da845110$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $f568b90edcd78f0e$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $ab161fef18a9aaea$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $5eef75ddba48c5b1$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $f94be443da845110$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $02e902993d8bea67$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $02e902993d8bea67$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $02e902993d8bea67$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $02e902993d8bea67$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $f568b90edcd78f0e$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $02e902993d8bea67$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $02e902993d8bea67$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $dece740d1d9f43df$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $ab161fef18a9aaea$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dece740d1d9f43df$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $dece740d1d9f43df$var$popperOffsets,
    data: {}
};










var $a9fad3f9966e999d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $a9fad3f9966e999d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $9f87da4b549daf1a$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $9f87da4b549daf1a$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $a9fad3f9966e999d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $02e902993d8bea67$export$eabcd2c8791e7bf4);
    var sideY = (0, $02e902993d8bea67$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $8514b2844e9a8d0b$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $2d464f517a7d9c5d$export$2e2bcd8739ae039)(popper);
            if ((0, $b26fff29392e180a$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $02e902993d8bea67$export$1e95b668f3b82d) || (placement === (0, $02e902993d8bea67$export$eabcd2c8791e7bf4) || placement === (0, $02e902993d8bea67$export$79ffe56a765070d2)) && variation === (0, $02e902993d8bea67$export$bd5df0f255a350f8)) {
            sideY = (0, $02e902993d8bea67$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $02e902993d8bea67$export$eabcd2c8791e7bf4) || (placement === (0, $02e902993d8bea67$export$1e95b668f3b82d) || placement === (0, $02e902993d8bea67$export$40e543e69a8b3fbb)) && variation === (0, $02e902993d8bea67$export$bd5df0f255a350f8)) {
            sideX = (0, $02e902993d8bea67$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $a9fad3f9966e999d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $a9fad3f9966e999d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $a9fad3f9966e999d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $5eef75ddba48c5b1$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $f94be443da845110$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $a9fad3f9966e999d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $a9fad3f9966e999d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $a9fad3f9966e999d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $a9fad3f9966e999d$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $cab798a8906c5c0f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $ed2db46af83f5833$export$1b3bfaa9684536aa)(element) || !(0, $0212fe39445d8dd6$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $cab798a8906c5c0f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $ed2db46af83f5833$export$1b3bfaa9684536aa)(element) || !(0, $0212fe39445d8dd6$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $cab798a8906c5c0f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $cab798a8906c5c0f$var$applyStyles,
    effect: $cab798a8906c5c0f$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $843f6713bdacb0e0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $5eef75ddba48c5b1$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $02e902993d8bea67$export$eabcd2c8791e7bf4),
        (0, $02e902993d8bea67$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $02e902993d8bea67$export$eabcd2c8791e7bf4),
        (0, $02e902993d8bea67$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $843f6713bdacb0e0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $02e902993d8bea67$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $843f6713bdacb0e0$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $843f6713bdacb0e0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $843f6713bdacb0e0$var$offset
};


var $22da10005b3f2592$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $22da10005b3f2592$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $22da10005b3f2592$var$hash[matched];
    });
}



var $bda8bbe0717556a8$var$hash = {
    start: 'end',
    end: 'start'
};
function $bda8bbe0717556a8$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $bda8bbe0717556a8$var$hash[matched];
    });
}







function $178b8586ecf05d50$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2388ef85f24bd247$export$2e2bcd8739ae039)(element);
    var html = (0, $2d464f517a7d9c5d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $ae8f535de75ca197$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $56623e50487d7153$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $21ab9f52c0ce216e$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $2d464f517a7d9c5d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $b65e87f75333c1fb$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $9f87da4b549daf1a$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $9f87da4b549daf1a$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $56623e50487d7153$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $b26fff29392e180a$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $9f87da4b549daf1a$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $4199326c09df96fe$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $ed2db46af83f5833$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $b51a066454174b38$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $2e354aa08390e2b7$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $7ded444e65c07363$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $2e354aa08390e2b7$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $02e902993d8bea67$export$d7b7311ec04a3e8f) ? (0, $b51a066454174b38$export$2e2bcd8739ae039)((0, $178b8586ecf05d50$export$2e2bcd8739ae039)(element, strategy)) : (0, $ed2db46af83f5833$export$45a5e7f76e0caa8d)(clippingParent) ? $2e354aa08390e2b7$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b51a066454174b38$export$2e2bcd8739ae039)((0, $21ab9f52c0ce216e$export$2e2bcd8739ae039)((0, $2d464f517a7d9c5d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $2e354aa08390e2b7$var$getClippingParents(element) {
    var clippingParents = (0, $215114d8ac988a21$export$2e2bcd8739ae039)((0, $db481f498e7d9c55$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $b26fff29392e180a$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $ed2db46af83f5833$export$1b3bfaa9684536aa)(element) ? (0, $8514b2844e9a8d0b$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $ed2db46af83f5833$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $ed2db46af83f5833$export$45a5e7f76e0caa8d)(clippingParent) && (0, $4199326c09df96fe$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $0212fe39445d8dd6$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $2e354aa08390e2b7$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $2e354aa08390e2b7$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $2e354aa08390e2b7$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $9f87da4b549daf1a$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $9f87da4b549daf1a$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $9f87da4b549daf1a$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9f87da4b549daf1a$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $2e354aa08390e2b7$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $d78084ab0fcd070c$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $e00cdfed07a86fd1$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $d78084ab0fcd070c$export$2e2bcd8739ae039)(), paddingObject);
}


function $29e73c3cc5013e13$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $245f7aadb52d7260$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $02e902993d8bea67$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $02e902993d8bea67$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $02e902993d8bea67$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $e00cdfed07a86fd1$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $29e73c3cc5013e13$export$2e2bcd8739ae039)(padding, (0, $02e902993d8bea67$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $02e902993d8bea67$export$ae5ab1c730825774) ? (0, $02e902993d8bea67$export$ca50aac9f3ba507f) : (0, $02e902993d8bea67$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $2e354aa08390e2b7$export$2e2bcd8739ae039)((0, $ed2db46af83f5833$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $2d464f517a7d9c5d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $7ded444e65c07363$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $ab161fef18a9aaea$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $b51a066454174b38$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $02e902993d8bea67$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $02e902993d8bea67$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $02e902993d8bea67$export$79ffe56a765070d2),
                (0, $02e902993d8bea67$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $02e902993d8bea67$export$1e95b668f3b82d),
                (0, $02e902993d8bea67$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $a77ac1bcdd453823$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $02e902993d8bea67$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $f94be443da845110$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $02e902993d8bea67$export$368f9a87e87fa4e1) : (0, $02e902993d8bea67$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $f94be443da845110$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $02e902993d8bea67$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $245f7aadb52d7260$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $5eef75ddba48c5b1$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $808686eb556ab4e4$var$getExpandedFallbackPlacements(placement) {
    if ((0, $5eef75ddba48c5b1$export$2e2bcd8739ae039)(placement) === (0, $02e902993d8bea67$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $22da10005b3f2592$export$2e2bcd8739ae039)(placement);
    return [
        (0, $bda8bbe0717556a8$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $bda8bbe0717556a8$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $808686eb556ab4e4$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $5eef75ddba48c5b1$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $22da10005b3f2592$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $808686eb556ab4e4$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $5eef75ddba48c5b1$export$2e2bcd8739ae039)(placement) === (0, $02e902993d8bea67$export$dfb5619354ba860) ? (0, $a77ac1bcdd453823$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $5eef75ddba48c5b1$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $f94be443da845110$export$2e2bcd8739ae039)(placement) === (0, $02e902993d8bea67$export$b3571188c770cc5a);
        var isVertical = [
            (0, $02e902993d8bea67$export$1e95b668f3b82d),
            (0, $02e902993d8bea67$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $245f7aadb52d7260$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $02e902993d8bea67$export$79ffe56a765070d2) : (0, $02e902993d8bea67$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $02e902993d8bea67$export$40e543e69a8b3fbb) : (0, $02e902993d8bea67$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $22da10005b3f2592$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $22da10005b3f2592$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $808686eb556ab4e4$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $808686eb556ab4e4$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $1033266e0a75f044$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $535f9475cbe97ae3$export$f28d906d67a997f3(min, value, max) {
    return (0, $9f87da4b549daf1a$export$8960430cfd85939f)(min, (0, $9f87da4b549daf1a$export$96ec731ed4dcb222)(value, max));
}
function $535f9475cbe97ae3$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $535f9475cbe97ae3$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $d439ec523927c400$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $245f7aadb52d7260$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $5eef75ddba48c5b1$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $f94be443da845110$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $f568b90edcd78f0e$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $1033266e0a75f044$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $02e902993d8bea67$export$1e95b668f3b82d) : (0, $02e902993d8bea67$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $02e902993d8bea67$export$40e543e69a8b3fbb) : (0, $02e902993d8bea67$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $02e902993d8bea67$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $02e902993d8bea67$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $e1edde097f07c4aa$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $d78084ab0fcd070c$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $535f9475cbe97ae3$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $8514b2844e9a8d0b$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $535f9475cbe97ae3$export$f28d906d67a997f3)(tether ? (0, $9f87da4b549daf1a$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $9f87da4b549daf1a$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $02e902993d8bea67$export$1e95b668f3b82d) : (0, $02e902993d8bea67$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $02e902993d8bea67$export$40e543e69a8b3fbb) : (0, $02e902993d8bea67$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $02e902993d8bea67$export$1e95b668f3b82d),
            (0, $02e902993d8bea67$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $535f9475cbe97ae3$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $535f9475cbe97ae3$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d439ec523927c400$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $d439ec523927c400$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $90806da3103e8f41$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $e00cdfed07a86fd1$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $29e73c3cc5013e13$export$2e2bcd8739ae039)(padding, (0, $02e902993d8bea67$export$aec2ce47c367b8c3)));
};
function $90806da3103e8f41$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $5eef75ddba48c5b1$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $f568b90edcd78f0e$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $02e902993d8bea67$export$eabcd2c8791e7bf4),
        (0, $02e902993d8bea67$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $90806da3103e8f41$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $e1edde097f07c4aa$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $02e902993d8bea67$export$1e95b668f3b82d) : (0, $02e902993d8bea67$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $02e902993d8bea67$export$40e543e69a8b3fbb) : (0, $02e902993d8bea67$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $8514b2844e9a8d0b$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $535f9475cbe97ae3$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $90806da3103e8f41$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4199326c09df96fe$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $90806da3103e8f41$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $90806da3103e8f41$var$arrow,
    effect: $90806da3103e8f41$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $03506c4d4faa7554$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $03506c4d4faa7554$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $02e902993d8bea67$export$1e95b668f3b82d),
        (0, $02e902993d8bea67$export$79ffe56a765070d2),
        (0, $02e902993d8bea67$export$40e543e69a8b3fbb),
        (0, $02e902993d8bea67$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $03506c4d4faa7554$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $245f7aadb52d7260$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $245f7aadb52d7260$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $03506c4d4faa7554$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $03506c4d4faa7554$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $03506c4d4faa7554$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $03506c4d4faa7554$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $03506c4d4faa7554$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $03506c4d4faa7554$var$hide
};




var $b7917bdf2866836a$export$d34966752335dd47 = [
    (0, $aaf1bfdc416ba53c$export$2e2bcd8739ae039),
    (0, $dece740d1d9f43df$export$2e2bcd8739ae039),
    (0, $a9fad3f9966e999d$export$2e2bcd8739ae039),
    (0, $cab798a8906c5c0f$export$2e2bcd8739ae039),
    (0, $843f6713bdacb0e0$export$2e2bcd8739ae039),
    (0, $808686eb556ab4e4$export$2e2bcd8739ae039),
    (0, $d439ec523927c400$export$2e2bcd8739ae039),
    (0, $90806da3103e8f41$export$2e2bcd8739ae039),
    (0, $03506c4d4faa7554$export$2e2bcd8739ae039)
];
var $b7917bdf2866836a$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $2afabfa2e2a8b2c3$export$ed5e13716264f202)({
    defaultModifiers: $b7917bdf2866836a$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

















function $49052e0e58bd971c$var$useLastValue(value) {
    var lastValue = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    (0, $55d7e61099d95834$export$363c9f3eb56bbdbe)(function() {
        lastValue.current = value;
    }, [
        value
    ]);
    return lastValue;
}
function $49052e0e58bd971c$export$3fcbf6e4407997e0(initialState) {
    if (initialState === void 0) initialState = {};
    var _useSealedState = (0, $b15e19c34b818be5$export$6717f1738e226a4a)(initialState), _useSealedState$visib = _useSealedState.visible, initialVisible = _useSealedState$visib === void 0 ? false : _useSealedState$visib, _useSealedState$anima = _useSealedState.animated, initialAnimated = _useSealedState$anima === void 0 ? false : _useSealedState$anima, sealed = (0, $d71074b92e18808d$export$71511d61b312f219)(_useSealedState, [
        "visible",
        "animated"
    ]);
    var id = (0, $d80ebc5349e07a80$export$d007c6b0739b4daa)(sealed);
    var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(initialVisible), visible = _React$useState[0], setVisible = _React$useState[1];
    var _React$useState2 = (0, $57da6a40a504e45b$export$60241385465d0a34)(initialAnimated), animated = _React$useState2[0], setAnimated = _React$useState2[1];
    var _React$useState3 = (0, $57da6a40a504e45b$export$60241385465d0a34)(false), animating = _React$useState3[0], setAnimating = _React$useState3[1];
    var lastVisible = $49052e0e58bd971c$var$useLastValue(visible);
    var visibleHasChanged = lastVisible.current != null && lastVisible.current !== visible;
    if (animated && !animating && visibleHasChanged) // Sets animating to true when when visible is updated
    setAnimating(true);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (typeof animated === "number" && animating) {
            var timeout = setTimeout(function() {
                return setAnimating(false);
            }, animated);
            return function() {
                clearTimeout(timeout);
            };
        }
        animated && animating;
        var _timeout;
        return function() {};
    }, [
        animated,
        animating
    ]);
    var show = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function() {
        return setVisible(true);
    }, []);
    var hide = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function() {
        return setVisible(false);
    }, []);
    var toggle = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function() {
        return setVisible(function(v) {
            return !v;
        });
    }, []);
    var stopAnimation = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function() {
        return setAnimating(false);
    }, []);
    return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, id), {}, {
        visible: visible,
        animated: animated,
        animating: animating,
        show: show,
        hide: hide,
        toggle: toggle,
        setVisible: setVisible,
        setAnimated: setAnimated,
        stopAnimation: stopAnimation
    });
}


function $005a4225a2b24b88$export$573903f1c655c034(initialState) {
    if (initialState === void 0) initialState = {};
    var _useSealedState = (0, $b15e19c34b818be5$export$6717f1738e226a4a)(initialState), _useSealedState$modal = _useSealedState.modal, initialModal = _useSealedState$modal === void 0 ? true : _useSealedState$modal, sealed = (0, $d71074b92e18808d$export$71511d61b312f219)(_useSealedState, [
        "modal"
    ]);
    var disclosure = (0, $49052e0e58bd971c$export$3fcbf6e4407997e0)(sealed);
    var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(initialModal), modal = _React$useState[0], setModal = _React$useState[1];
    var disclosureRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, disclosure), {}, {
        modal: modal,
        setModal: setModal,
        unstable_disclosureRef: disclosureRef
    });
}


var $18f89298f3434323$var$isSafari = (0, $bebe121caf466eee$export$c6c808688353c659)("Mac") && !(0, $bebe121caf466eee$export$c6c808688353c659)("Chrome") && (0, $bebe121caf466eee$export$c6c808688353c659)("Safari");
function $18f89298f3434323$var$applyStyles(styles) {
    return function(prevStyles) {
        if (styles && !(0, $4d4017bd96518208$export$d36bdfa510afb180)(prevStyles, styles)) return styles;
        return prevStyles;
    };
}
function $18f89298f3434323$export$5396bc663d6e322c(initialState) {
    if (initialState === void 0) initialState = {};
    var _useSealedState = (0, $b15e19c34b818be5$export$6717f1738e226a4a)(initialState), _useSealedState$gutte = _useSealedState.gutter, gutter = _useSealedState$gutte === void 0 ? 12 : _useSealedState$gutte, _useSealedState$place = _useSealedState.placement, sealedPlacement = _useSealedState$place === void 0 ? "bottom" : _useSealedState$place, _useSealedState$unsta = _useSealedState.unstable_flip, flip = _useSealedState$unsta === void 0 ? true : _useSealedState$unsta, sealedOffset = _useSealedState.unstable_offset, _useSealedState$unsta2 = _useSealedState.unstable_preventOverflow, preventOverflow = _useSealedState$unsta2 === void 0 ? true : _useSealedState$unsta2, _useSealedState$unsta3 = _useSealedState.unstable_fixed, fixed = _useSealedState$unsta3 === void 0 ? false : _useSealedState$unsta3, _useSealedState$modal = _useSealedState.modal, modal = _useSealedState$modal === void 0 ? false : _useSealedState$modal, sealed = (0, $d71074b92e18808d$export$71511d61b312f219)(_useSealedState, [
        "gutter",
        "placement",
        "unstable_flip",
        "unstable_offset",
        "unstable_preventOverflow",
        "unstable_fixed",
        "modal"
    ]);
    var popper = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    var referenceRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    var popoverRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    var arrowRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(null);
    var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(sealedPlacement), originalPlacement = _React$useState[0], place = _React$useState[1];
    var _React$useState2 = (0, $57da6a40a504e45b$export$60241385465d0a34)(sealedPlacement), placement = _React$useState2[0], setPlacement = _React$useState2[1];
    var _React$useState3 = (0, $57da6a40a504e45b$export$60241385465d0a34)(sealedOffset || [
        0,
        gutter
    ]), offset = _React$useState3[0];
    var _React$useState4 = (0, $57da6a40a504e45b$export$60241385465d0a34)({
        position: "fixed",
        left: "100%",
        top: "100%"
    }), popoverStyles = _React$useState4[0], setPopoverStyles = _React$useState4[1];
    var _React$useState5 = (0, $57da6a40a504e45b$export$60241385465d0a34)({}), arrowStyles = _React$useState5[0], setArrowStyles = _React$useState5[1];
    var dialog = (0, $005a4225a2b24b88$export$573903f1c655c034)((0, $d71074b92e18808d$export$407448d2b89b1813)({
        modal: modal
    }, sealed));
    var update = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function() {
        if (popper.current) {
            popper.current.forceUpdate();
            return true;
        }
        return false;
    }, []);
    var updateState = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(state) {
        if (state.placement) setPlacement(state.placement);
        if (state.styles) {
            setPopoverStyles($18f89298f3434323$var$applyStyles(state.styles.popper));
            if (arrowRef.current) setArrowStyles($18f89298f3434323$var$applyStyles(state.styles.arrow));
        }
    }, []);
    (0, $55d7e61099d95834$export$363c9f3eb56bbdbe)(function() {
        if (referenceRef.current && popoverRef.current) popper.current = (0, $b7917bdf2866836a$export$8f7491d57c8f97a9)(referenceRef.current, popoverRef.current, {
            // https://popper.js.org/docs/v2/constructors/#options
            placement: originalPlacement,
            strategy: fixed ? "fixed" : "absolute",
            // Safari needs styles to be applied in the first render, otherwise
            // hovering over the popover when it gets visible for the first time
            // will change its dimensions unexpectedly.
            onFirstUpdate: $18f89298f3434323$var$isSafari ? updateState : undefined,
            modifiers: [
                {
                    // https://popper.js.org/docs/v2/modifiers/event-listeners/
                    name: "eventListeners",
                    enabled: dialog.visible
                },
                {
                    // https://popper.js.org/docs/v2/modifiers/apply-styles/
                    name: "applyStyles",
                    enabled: false
                },
                {
                    // https://popper.js.org/docs/v2/modifiers/flip/
                    name: "flip",
                    enabled: flip,
                    options: {
                        padding: 8
                    }
                },
                {
                    // https://popper.js.org/docs/v2/modifiers/offset/
                    name: "offset",
                    options: {
                        offset: offset
                    }
                },
                {
                    // https://popper.js.org/docs/v2/modifiers/prevent-overflow/
                    name: "preventOverflow",
                    enabled: preventOverflow,
                    options: {
                        tetherOffset: function tetherOffset() {
                            var _arrowRef$current;
                            return ((_arrowRef$current = arrowRef.current) === null || _arrowRef$current === void 0 ? void 0 : _arrowRef$current.clientWidth) || 0;
                        }
                    }
                },
                {
                    // https://popper.js.org/docs/v2/modifiers/arrow/
                    name: "arrow",
                    enabled: !!arrowRef.current,
                    options: {
                        element: arrowRef.current
                    }
                },
                {
                    // https://popper.js.org/docs/v2/modifiers/#custom-modifiers
                    name: "updateState",
                    phase: "write",
                    requires: [
                        "computeStyles"
                    ],
                    enabled: dialog.visible && true,
                    fn: function fn(_ref) {
                        var state = _ref.state;
                        return updateState(state);
                    }
                }
            ]
        });
        return function() {
            if (popper.current) {
                popper.current.destroy();
                popper.current = null;
            }
        };
    }, [
        originalPlacement,
        fixed,
        dialog.visible,
        flip,
        offset,
        preventOverflow
    ]); // Ensure that the popover will be correctly positioned with an additional
    // update.
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (!dialog.visible) return undefined;
        var id = window.requestAnimationFrame(function() {
            var _popper$current;
            (_popper$current = popper.current) === null || _popper$current === void 0 || _popper$current.forceUpdate();
        });
        return function() {
            window.cancelAnimationFrame(id);
        };
    }, [
        dialog.visible
    ]);
    return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, dialog), {}, {
        unstable_referenceRef: referenceRef,
        unstable_popoverRef: popoverRef,
        unstable_arrowRef: arrowRef,
        unstable_popoverStyles: popoverStyles,
        unstable_arrowStyles: arrowStyles,
        unstable_update: update,
        unstable_originalPlacement: originalPlacement,
        placement: placement,
        place: place
    });
}
















function $fabaf29040bf654f$export$bd7b6af6aa16550c(initialState) {
    if (initialState === void 0) initialState = {};
    var _useSealedState = (0, $b15e19c34b818be5$export$6717f1738e226a4a)(initialState), _useSealedState$orien = _useSealedState.orientation, orientation = _useSealedState$orien === void 0 ? "horizontal" : _useSealedState$orien, _useSealedState$unsta = _useSealedState.unstable_values, initialValues = _useSealedState$unsta === void 0 ? {} : _useSealedState$unsta, sealed = (0, $d71074b92e18808d$export$71511d61b312f219)(_useSealedState, [
        "orientation",
        "unstable_values"
    ]);
    var _React$useState = (0, $57da6a40a504e45b$export$60241385465d0a34)(initialValues), values = _React$useState[0], setValues = _React$useState[1];
    var composite = (0, $8378ccc27f180b80$export$341d2d2d28400ea1)((0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, sealed), {}, {
        orientation: orientation
    }));
    return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, composite), {}, {
        unstable_values: values,
        unstable_setValue: (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function(name, value) {
            setValues(function(vals) {
                var _objectSpread2$1;
                return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, vals), {}, (_objectSpread2$1 = {}, _objectSpread2$1[name] = typeof value === "function" ? value(vals) : value, _objectSpread2$1));
            });
        }, [])
    });
}


function $a71308e6184d7893$export$8091e3849c182a6(initialState) {
    if (initialState === void 0) initialState = {};
    var parent = (0, $57da6a40a504e45b$export$fae74005e78b1a27)((0, $dfdde098fbc56812$export$3a1a48c8f6ef640e));
    var _useSealedState = (0, $b15e19c34b818be5$export$6717f1738e226a4a)(initialState), _useSealedState$orien = _useSealedState.orientation, orientation = _useSealedState$orien === void 0 ? "vertical" : _useSealedState$orien, _useSealedState$gutte = _useSealedState.gutter, gutter = _useSealedState$gutte === void 0 ? 0 : _useSealedState$gutte, sealed = (0, $d71074b92e18808d$export$71511d61b312f219)(_useSealedState, [
        "orientation",
        "gutter"
    ]);
    var placement = sealed.placement || (parent && parent.orientation === "vertical" ? "right-start" : "bottom-start");
    var menuBar = (0, $fabaf29040bf654f$export$bd7b6af6aa16550c)((0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, sealed), {}, {
        orientation: orientation
    }));
    var popover = (0, $18f89298f3434323$export$5396bc663d6e322c)((0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, sealed), {}, {
        placement: placement,
        gutter: gutter
    }));
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (!popover.visible) menuBar.reset();
    }, [
        popover.visible,
        menuBar.reset
    ]);
    return (0, $d71074b92e18808d$export$407448d2b89b1813)((0, $d71074b92e18808d$export$407448d2b89b1813)({}, menuBar), popover);
}



var $9215097c4ab5d2f9$var$MoreItems = (0, $bdfb41ef79315c14$export$257a8862b851cb5b)(function(props, ref) {
    var menu = (0, $a71308e6184d7893$export$8091e3849c182a6)({
        placement: 'bottom-end'
    });
    var availableItems = props.availableItems, availableItemIcons = props.availableItemIcons, onItemChange = props.onItemChange, currentItem = props.currentItem, suffix = props.suffix;
    var currentIndex = currentItem ? availableItems.indexOf(currentItem) : -1;
    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$53cb3e9006a6cf07), {
        children: [
            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$e762fcbbbfd48835), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, menu, props), {
                ref: ref,
                "aria-label": currentItem ? "".concat(currentItem, " ").concat(suffix) : "".concat(suffix),
                children: [
                    availableItemIcons && (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$afc87062fd6d79c3), {
                        children: availableItemIcons[currentIndex]
                    }),
                    (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$69fdf448548da677), {
                        children: currentItem ? "".concat(currentItem, " ").concat(suffix) : "".concat(suffix)
                    })
                ]
            })),
            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$f48bda32bee484ec), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, menu), {
                "aria-label": "More Items",
                children: availableItems && availableItems.length > 0 && availableItems.map(function(item, index) {
                    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$cae703c457e46f23), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({
                        value: item,
                        "aria-label": item
                    }, menu), {
                        onClick: function() {
                            return onItemChange(item);
                        },
                        children: [
                            availableItemIcons && (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$afc87062fd6d79c3), {
                                children: availableItemIcons[index]
                            }),
                            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$69fdf448548da677), {
                                children: "".concat(item, " ").concat(suffix)
                            })
                        ]
                    }));
                })
            }))
        ]
    });
});
var $9215097c4ab5d2f9$var$Header = function(param) {
    var availableVariants = param.availableVariants, availableViews = param.availableViews, currentView = param.currentView, currentVariant = param.currentVariant, device = param.device, version = param.version, availableCmpVersions = param.availableCmpVersions, cmpVersion = param.cmpVersion, isInitialized = param.isInitialized, isAgeVerificationEnabled = param.isAgeVerificationEnabled, isDsrEnabled = param.isDsrEnabled, onChangeDevice = param.onChangeDevice, onCmpVersionChange = param.onCmpVersionChange, onLogoClick = param.onLogoClick, onVariantChange = param.onVariantChange, onShowFirstLayer = param.onShowFirstLayer, onShowSecondLayer = param.onShowSecondLayer, onRefreshPreview = param.onRefreshPreview, onShowAVGate = param.onShowAVGate, onOpenDsrForm = param.onOpenDsrForm, onTryOtherDevices = param.onTryOtherDevices, onViewChange = param.onViewChange;
    var toolbar = (0, $aa6a4034253433d1$export$d16ee687393f6214)();
    var _useState = (0, $eb67fc0d0f63c453$export$71511d61b312f219)((0, $57da6a40a504e45b$export$60241385465d0a34)('Desktop'), 2), deviceType = _useState[0], setDeviceType = _useState[1];
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        switch(device){
            case (0, $507cba0b3ff2a038$export$c03ebfdd78bca91c).DESKTOP:
                setDeviceType('Desktop');
                break;
            default:
                setDeviceType('Mobile');
                break;
        }
    }, [
        device
    ]);
    var setDevice = function(value) {
        if (value === 'Desktop') {
            onChangeDevice((0, $507cba0b3ff2a038$export$c03ebfdd78bca91c).DESKTOP);
            setDeviceType(value);
        } else if (value === 'Mobile') {
            onChangeDevice((0, $507cba0b3ff2a038$export$c03ebfdd78bca91c).IOS);
            setDeviceType(value);
        }
    };
    var setMobile = function(value) {
        if (value === 'iOS') onChangeDevice((0, $507cba0b3ff2a038$export$c03ebfdd78bca91c).IOS);
        else onChangeDevice((0, $507cba0b3ff2a038$export$c03ebfdd78bca91c).ANDROID);
    };
    var setCmpVersion = function(value) {
        switch(value){
            case "CMP V3":
                onCmpVersionChange((0, $507cba0b3ff2a038$export$4b7c063c7c318025).V3);
                break;
            case "CMP V2":
            default:
                onCmpVersionChange((0, $507cba0b3ff2a038$export$4b7c063c7c318025).V2);
                break;
        }
    };
    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$579a1e9bab103f15), {
        children: [
            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$28be41ac4e8a64c4), {
                onClick: onLogoClick,
                children: (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5380b115589b3837$exports))),
                    alt: "Usercentrics"
                })
            }),
            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$961affb606ed6923), {}),
            !isInitialized && (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $a88060f0945cc60e$export$2e2bcd8739ae039), {}),
            isInitialized && (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$f3f426abf36f8c0), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, toolbar), {
                "aria-label": "Header Toolbar",
                children: [
                    availableCmpVersions.includes((0, $507cba0b3ff2a038$export$4b7c063c7c318025).V2) && cmpVersion && (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $ea42db622452d33d$export$ffb0004e005737fa), {
                        children: [
                            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $d6705f2562fe396f$export$cb67beb212e92bbd), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, toolbar), {
                                children: function(props) {
                                    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)($9215097c4ab5d2f9$var$MoreItems, (0, $785ab81358d75c36$export$71511d61b312f219)({
                                        availableItems: availableCmpVersions.map(function(version) {
                                            return "CMP V".concat(version.toString());
                                        }),
                                        onItemChange: setCmpVersion,
                                        currentItem: "CMP V".concat(cmpVersion),
                                        suffix: ""
                                    }, props));
                                }
                            })),
                            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$961affb606ed6923), {})
                        ]
                    }),
                    (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $d6705f2562fe396f$export$cb67beb212e92bbd), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, toolbar), {
                        children: function(props) {
                            return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)($9215097c4ab5d2f9$var$MoreItems, (0, $785ab81358d75c36$export$71511d61b312f219)({
                                availableItems: [
                                    'Desktop',
                                    'Mobile'
                                ],
                                availableItemIcons: [
                                    (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($29e741da0080981c$exports))),
                                        alt: "Web"
                                    }),
                                    (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8ccf1558ffdbbc40$exports))),
                                        alt: "App"
                                    })
                                ],
                                onItemChange: setDevice,
                                currentItem: deviceType,
                                suffix: ""
                            }, props));
                        }
                    })),
                    deviceType === 'Mobile' && (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $ea42db622452d33d$export$ffb0004e005737fa), {
                        children: [
                            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$961affb606ed6923), {}),
                            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $d6705f2562fe396f$export$cb67beb212e92bbd), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, toolbar), {
                                children: function(props) {
                                    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)($9215097c4ab5d2f9$var$MoreItems, (0, $785ab81358d75c36$export$71511d61b312f219)({
                                        availableItems: [
                                            'iOS',
                                            'Android'
                                        ],
                                        onItemChange: setMobile,
                                        currentItem: device === (0, $507cba0b3ff2a038$export$c03ebfdd78bca91c).IOS ? 'iOS' : 'Android',
                                        suffix: ""
                                    }, props));
                                }
                            }))
                        ]
                    }),
                    (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$961affb606ed6923), {}),
                    (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $d6705f2562fe396f$export$cb67beb212e92bbd), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, toolbar), {
                        children: function(props) {
                            return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)($9215097c4ab5d2f9$var$MoreItems, (0, $785ab81358d75c36$export$71511d61b312f219)({
                                availableItems: availableViews.map(function(view) {
                                    return view.toUpperCase();
                                }),
                                onItemChange: onViewChange,
                                currentItem: currentView === null || currentView === void 0 ? void 0 : currentView.toUpperCase(),
                                suffix: "Configuration"
                            }, props));
                        }
                    })),
                    (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$961affb606ed6923), {}),
                    deviceType === 'Desktop' && availableVariants.length > 0 && (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $ea42db622452d33d$export$ffb0004e005737fa), {
                        children: [
                            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $d6705f2562fe396f$export$cb67beb212e92bbd), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, toolbar), {
                                children: function(props) {
                                    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)($9215097c4ab5d2f9$var$MoreItems, (0, $785ab81358d75c36$export$71511d61b312f219)({
                                        availableItems: [
                                            'A/B Test Variant'
                                        ].concat((0, $cded5aad1f5c707c$export$71511d61b312f219)(availableVariants)),
                                        onItemChange: onVariantChange,
                                        currentItem: currentVariant !== null && currentVariant !== void 0 ? currentVariant : 'A/B Test Variant',
                                        suffix: ""
                                    }, props));
                                }
                            })),
                            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$961affb606ed6923), {})
                        ]
                    }),
                    deviceType === 'Desktop' ? (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$ea86631f73ac0500), {
                        children: [
                            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $d6705f2562fe396f$export$cb67beb212e92bbd), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, toolbar), {
                                children: function(props) {
                                    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$116ce745fe9423aa), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, props), {
                                        onClick: onShowFirstLayer,
                                        children: "Show First Layer"
                                    }));
                                }
                            })),
                            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $d6705f2562fe396f$export$cb67beb212e92bbd), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, toolbar), {
                                children: function(props) {
                                    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$116ce745fe9423aa), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, props), {
                                        onClick: onShowSecondLayer,
                                        children: "Show Second Layer"
                                    }));
                                }
                            })),
                            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $d6705f2562fe396f$export$cb67beb212e92bbd), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, toolbar), {
                                children: function(props) {
                                    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$116ce745fe9423aa), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, props), {
                                        onClick: onRefreshPreview,
                                        children: "Refresh Preview"
                                    }));
                                }
                            })),
                            isAgeVerificationEnabled && (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $d6705f2562fe396f$export$cb67beb212e92bbd), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, toolbar), {
                                children: function(props) {
                                    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$116ce745fe9423aa), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, props), {
                                        onClick: onShowAVGate,
                                        children: "Show Age Verification"
                                    }));
                                }
                            })),
                            isDsrEnabled && (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $d6705f2562fe396f$export$cb67beb212e92bbd), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, toolbar), {
                                children: function(props) {
                                    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$116ce745fe9423aa), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, props), {
                                        onClick: onOpenDsrForm,
                                        children: "Data Subject Request"
                                    }));
                                }
                            }))
                        ]
                    }) : (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$ea86631f73ac0500), {
                        children: (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $d6705f2562fe396f$export$cb67beb212e92bbd), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, toolbar), {
                            children: function(props) {
                                return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$116ce745fe9423aa), (0, $e9407c6bafa4dcc7$export$71511d61b312f219)((0, $785ab81358d75c36$export$71511d61b312f219)({}, props), {
                                    onClick: onTryOtherDevices,
                                    children: [
                                        "Try on other devices\xA0\xA0",
                                        (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7ec530b826d8abce$exports))),
                                            alt: "link"
                                        })
                                    ]
                                }));
                            }
                        }))
                    }),
                    (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$a4b5f32e41b83d00), {
                        children: version === 'preview' ? (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$962a80781251da57), {
                            children: "Draft Preview"
                        }) : (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cbd453931a929850$export$6a23e5b86d8f0768), {
                            children: "Live Preview"
                        })
                    })
                ]
            }))
        ]
    });
};
var $9215097c4ab5d2f9$export$2e2bcd8739ae039 = $9215097c4ab5d2f9$var$Header;


var $c5f2c0a2c70f68d7$export$2e2bcd8739ae039 = (0, $9215097c4ab5d2f9$export$2e2bcd8739ae039);




var $ec68ef36775c511b$exports = {};
$ec68ef36775c511b$exports = $parcel$resolve("fgQ4j");



var $6bf4b1b8f09b9ce5$export$832475ccec19b9be = (0, $65d8fecb296fd70d$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MobileDevicestyled__WrapperDiv"
})([
    "display:table-cell;text-align:center;height:calc(100vh - 100px);width:100vw;vertical-align:middle;background-image:url(",
    ");background-repeat:no-repeat;background-size:contain;"
], (0, (/*@__PURE__*/$parcel$interopDefault($ec68ef36775c511b$exports))));



var $cb71ad15fbc9f5ec$var$MobileDevice = function(param) {
    var device = param.device, urlParams = param.urlParams, useSandbox = param.useSandbox;
    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $6bf4b1b8f09b9ce5$export$832475ccec19b9be), {
        children: (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("iframe", {
            id: "preview-app",
            src: (0, $8e6349c485e59683$export$c9f1b5f3243eb744)(device, urlParams, useSandbox),
            frameBorder: "0",
            scrolling: "no",
            width: device === (0, $507cba0b3ff2a038$export$c03ebfdd78bca91c).IOS ? 345 : 305,
            height: 680,
            title: "preview-app"
        })
    });
};
var $cb71ad15fbc9f5ec$export$2e2bcd8739ae039 = $cb71ad15fbc9f5ec$var$MobileDevice;



var $507cba0b3ff2a038$export$397e49c56ae84012 = /*#__PURE__*/ function(VIEW) {
    VIEW["CPRA"] = "cpra";
    // California Privacy Rights Act
    VIEW["VCDPA"] = "vcdpa";
    // Virginia Consumer Data Protection Act
    VIEW["CPA"] = "cpa";
    // Colorado Privacy Act
    VIEW["CIPA"] = "cipa";
    // California Information Privacy Act
    VIEW["CTDPA"] = "ctdpa";
    // Connecticut Data Privacy Act
    VIEW["UCPA"] = "ucpa";
    // Utah Consumer Privacy Act
    VIEW["CCPA"] = "ccpa";
    VIEW["GDPR"] = "gdpr";
    VIEW["TCF"] = "tcf";
    VIEW["TCF2"] = "tcf2";
    VIEW["MSPL"] = "mspl";
    VIEW["PIPEDA"] = "pipeda";
    // Personal Information Protection and Electronic Documents Act
    VIEW["DPDPA"] = "dpdpa";
    VIEW["ICDPA"] = "icdpa";
    VIEW["MCDP"] = "mcdp";
    VIEW["MCDPA"] = "mcdpa";
    VIEW["NDPA"] = "ndpa";
    VIEW["OCPA"] = "ocpa";
    VIEW["TIPA"] = "tipa";
    VIEW["NJDPA"] = "njdpa";
    VIEW["NHDPA"] = "nhdpa";
    VIEW["TDPSA"] = "tdpsa";
    VIEW["FDBR"] = "fdbr";
    VIEW["MODPA"] = "modpa";
    return VIEW;
}({});
/** Views that are shown using the GDPR UI variant */ var $507cba0b3ff2a038$var$GDPR_FALLBACK_VIEWS = new Set([
    "cipa",
    "pipeda"
]);
/** Views that are shown using the CCPA UI variant */ var $507cba0b3ff2a038$var$CCPA_FALLBACK_VIEWS = new Set([
    "mspl",
    "dpdpa",
    "icdpa",
    "mcdp",
    "mcdpa",
    "ndpa",
    "ocpa",
    "tipa",
    "njdpa",
    "nhdpa",
    "tdpsa",
    "fdbr",
    "modpa"
]);
/** Maps a display view to the script view the CMP loader expects */ var $507cba0b3ff2a038$var$toScriptView = function(view) {
    if (!view) return undefined;
    if (view === "tcf2") return "tcf";
    if ($507cba0b3ff2a038$var$CCPA_FALLBACK_VIEWS.has(view)) return "ccpa";
    if ($507cba0b3ff2a038$var$GDPR_FALLBACK_VIEWS.has(view)) return "gdpr";
    return view;
};
var $507cba0b3ff2a038$export$c03ebfdd78bca91c = /*#__PURE__*/ function(DEVICE) {
    DEVICE["DESKTOP"] = "desktop";
    DEVICE["IOS"] = "ios";
    DEVICE["ANDROID"] = "android";
    return DEVICE;
}({});
var $507cba0b3ff2a038$export$4b7c063c7c318025 = /*#__PURE__*/ function(CMP_VERSION) {
    CMP_VERSION["V2"] = "2";
    CMP_VERSION["V3"] = "3";
    return CMP_VERSION;
}({});
var $507cba0b3ff2a038$var$Preview = function(param) {
    var abVariant = param.abVariant, bundleSource = param.bundleSource, _param_device = param.device, device = _param_device === void 0 ? "desktop" : _param_device, cmpVersion = param.cmpVersion, _param_sandbox = param.sandbox, sandbox = _param_sandbox === void 0 ? false : _param_sandbox, _param_settingsId = param.settingsId, settingsId = _param_settingsId === void 0 ? '' : _param_settingsId, legacy = param.legacy, view = param.view, _param_version = param.version, version = _param_version === void 0 ? 'latest' : _param_version;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var globalThis = $parcel$global;
    var _useState = (0, $eb67fc0d0f63c453$export$71511d61b312f219)((0, $57da6a40a504e45b$export$60241385465d0a34)({
        isCcpaEnabled: false,
        showOnlyCcpa: false,
        isTcfEnabled: false,
        selectedSettingsAppVersion: 'V2',
        variants: [],
        dsrConfigurationId: undefined
    }), 2), settings = _useState[0], setSettings = _useState[1];
    var passedView = view === null || view === void 0 ? void 0 : view.toLowerCase();
    var initialView = passedView;
    if (passedView === "tcf2") initialView = "tcf";
    var _useState1 = (0, $eb67fc0d0f63c453$export$71511d61b312f219)((0, $57da6a40a504e45b$export$60241385465d0a34)([]), 2), availableViews = _useState1[0], setAvailableViews = _useState1[1];
    var _useState2 = (0, $eb67fc0d0f63c453$export$71511d61b312f219)((0, $57da6a40a504e45b$export$60241385465d0a34)([]), 2), availableCmpVersions = _useState2[0], setAvailableCmpVersions = _useState2[1];
    var _useState3 = (0, $eb67fc0d0f63c453$export$71511d61b312f219)((0, $57da6a40a504e45b$export$60241385465d0a34)(false), 2), isInitialized = _useState3[0], setIsInitialized = _useState3[1];
    var _useState4 = (0, $eb67fc0d0f63c453$export$71511d61b312f219)((0, $57da6a40a504e45b$export$60241385465d0a34)({
        view: initialView
    }), 2), currentView = _useState4[0], setCurrentView = _useState4[1];
    var _useState5 = (0, $eb67fc0d0f63c453$export$71511d61b312f219)((0, $57da6a40a504e45b$export$60241385465d0a34)(device), 2), currentDevice = _useState5[0], setCurrentDevice = _useState5[1];
    var _useState6 = (0, $eb67fc0d0f63c453$export$71511d61b312f219)((0, $57da6a40a504e45b$export$60241385465d0a34)(cmpVersion), 2), currentCmpVersion = _useState6[0], setCurrentCmpVersion = _useState6[1];
    var _useState7 = (0, $eb67fc0d0f63c453$export$71511d61b312f219)((0, $57da6a40a504e45b$export$60241385465d0a34)(abVariant), 2), currentAbVariant = _useState7[0], setCurrentAbVariant = _useState7[1];
    var _useState8 = (0, $eb67fc0d0f63c453$export$71511d61b312f219)((0, $57da6a40a504e45b$export$60241385465d0a34)(false), 2), isAgeVerificationEnabled = _useState8[0], setIsAgeVerificationEnabled = _useState8[1];
    var isEdge = window.navigator.userAgent.indexOf('Edge') !== -1;
    var isIE = window.navigator.userAgent.indexOf('Trident') !== -1 && !isEdge;
    var isLegacy = legacy || isIE;
    var scriptPath = 'https://app.usercentrics.eu/browser-ui/latest/';
    var useSandbox = sandbox;
    var href = window.location.href;
    if (bundleSource === 'integration') useSandbox = true;
    else if (bundleSource === 'local') scriptPath = 'http://localhost:1111/';
    else {
        var urlMatchRegex = new RegExp('/(develop|staging|test/EUD-[0-9]+|pr/[0-9]+)/');
        var bundleSourceRegex = new RegExp('^(develop|staging|test/EUD-[0-9]+|pr/[0-9]+)$');
        var domainSource = bundleSource === 'staging' ? 'staging' : 'develop';
        if (!bundleSource && urlMatchRegex.test(href)) {
            var env = href.match(urlMatchRegex);
            if (env) scriptPath = "https://app.usercentrics-".concat(domainSource, ".eu/").concat(env[1], "/");
        } else if (bundleSource && bundleSourceRegex.test(bundleSource)) scriptPath = "https://app.usercentrics-".concat(domainSource, ".eu/").concat(bundleSource, "/");
    }
    var updateUrlParam = function(param, value, remove) {
        var searchParams = new URLSearchParams(window.location.search);
        if (remove) searchParams.delete(param);
        else searchParams.set(param, value);
        window.location.replace("?".concat(searchParams.toString()));
    };
    var navigateToView = function(viewParam) {
        updateUrlParam('view', viewParam);
    };
    /**
   * INIT FUNCTIONS
   */ (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (isInitialized) {
            var updatedAvailableViews = [];
            if (settings.framework) {
                var framework = settings.framework.toLowerCase();
                updatedAvailableViews.push(framework === "tcf2" ? "tcf" : framework);
            } else if (settings.isTcfEnabled) updatedAvailableViews.push("tcf");
            else {
                if (settings.isCcpaEnabled) updatedAvailableViews.push("ccpa");
                if (!settings.showOnlyCcpa) updatedAvailableViews.push("gdpr");
            }
            setAvailableViews(updatedAvailableViews);
            var updatedCmpVersions = [];
            if (settings.selectedSettingsAppVersion === 'V2') updatedCmpVersions.push("2", "3");
            else updatedCmpVersions.push("3");
            setAvailableCmpVersions(updatedCmpVersions);
            if (!currentView.view) setCurrentView({
                view: updatedAvailableViews[0]
            });
            if (!currentCmpVersion) setCurrentCmpVersion(updatedCmpVersions[0]);
        }
    }, [
        settings,
        settingsId,
        isInitialized
    ]);
    var initPreview = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function() {
        if (typeof globalThis.UC_UI !== 'undefined' && globalThis.UC_UI && globalThis.UC_UI.isInitialized) {
            if (document.referrer.includes('admin.usercentrics.com')) globalThis.UC_UI.clearStorage();
        }
        (0, $8e6349c485e59683$export$b93ad78d273bf598)(settingsId, version, 'en', useSandbox).then(function(data) {
            setSettings({
                isCcpaEnabled: data.ccpa.isActive,
                isTcfEnabled: data.tcf2Enabled,
                framework: data.framework || undefined,
                variants: data && data.variants ? (0, $8e6349c485e59683$export$80f8884b65d948e1)(data.variants) : [],
                showOnlyCcpa: data.ccpa.isActive && data.ccpa.region === 'ALL',
                selectedSettingsAppVersion: data.selectedSettingsAppVersion || 'V2',
                dsrConfigurationId: data.dsrConfigurationId
            });
            setIsInitialized(true);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        globalThis.UC_UI,
        settingsId,
        version
    ]);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (!isInitialized) initPreview();
    }, [
        device,
        initPreview,
        isInitialized
    ]);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (device !== currentDevice) updateUrlParam('device', currentDevice);
    }, [
        device,
        currentDevice
    ]);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        if (isInitialized && currentCmpVersion && cmpVersion !== currentCmpVersion) {
            try {
                var _window___ucCmp, _window_UC_UI;
                if (currentCmpVersion === "3") (_window___ucCmp = window['__ucCmp']) === null || _window___ucCmp === void 0 ? void 0 : _window___ucCmp.clearUserSession();
                else (_window_UC_UI = window['UC_UI']) === null || _window_UC_UI === void 0 ? void 0 : _window_UC_UI.clearStorage();
            } catch (error) {
                console.warn('Not able to clean user session', error);
            }
            updateUrlParam('cmpVersion', currentCmpVersion);
        }
    }, [
        cmpVersion,
        currentCmpVersion,
        isInitialized
    ]);
    var applyAgeVerificationStatusRef = (0, $57da6a40a504e45b$export$b8f5890fc79d6aca)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $04b844fceb04b9e9$export$71511d61b312f219)(function() {
            return (0, $5412342bd99c3e4e$export$71511d61b312f219)(this, function(_state) {
                return [
                    2
                ];
            });
        })();
    });
    var stableHandler = (0, $57da6a40a504e45b$export$35808ee640e87ca7)(function() {
        applyAgeVerificationStatusRef.current();
    }, []);
    (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
        var _window___ucCmp;
        if (!isInitialized || currentCmpVersion !== "3") {
            setIsAgeVerificationEnabled(false);
            return;
        }
        var cancelled = false;
        var applyAgeVerificationStatus = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $04b844fceb04b9e9$export$71511d61b312f219)(function() {
                var _window___ucCmp_isAgeVerificationEnabled, _window___ucCmp, required, e;
                return (0, $5412342bd99c3e4e$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (cancelled) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (_window___ucCmp = window.__ucCmp) === null || _window___ucCmp === void 0 ? void 0 : (_window___ucCmp_isAgeVerificationEnabled = _window___ucCmp.isAgeVerificationEnabled) === null || _window___ucCmp_isAgeVerificationEnabled === void 0 ? void 0 : _window___ucCmp_isAgeVerificationEnabled.call(_window___ucCmp)
                            ];
                        case 2:
                            required = _state.sent();
                            if (!cancelled) setIsAgeVerificationEnabled(!!required);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            if (!cancelled) setIsAgeVerificationEnabled(false);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        applyAgeVerificationStatusRef.current = applyAgeVerificationStatus;
        if ((_window___ucCmp = window.__ucCmp) === null || _window___ucCmp === void 0 ? void 0 : _window___ucCmp.isAgeVerificationEnabled) applyAgeVerificationStatus();
        window.addEventListener('UC_UI_INITIALIZED', stableHandler);
        return function() {
            cancelled = true;
            window.removeEventListener('UC_UI_INITIALIZED', stableHandler);
        };
    }, [
        isInitialized,
        currentCmpVersion,
        stableHandler
    ]);
    /**
   * UI HANDLERS
   */ var onViewChange = function(v) {
        if (v && Object.values($507cba0b3ff2a038$export$397e49c56ae84012).includes(v.toLowerCase())) navigateToView(v.toLowerCase());
    };
    var onTryOtherDevices = function() {
        if (device !== "desktop") {
            var scriptView = $507cba0b3ff2a038$var$toScriptView(currentView.view);
            window.open((0, $8e6349c485e59683$export$c9f1b5f3243eb744)(device, {
                location: scriptView !== "gdpr" && scriptView !== "tcf" ? 'US-CA' : 'DE-BY',
                settingsId: settingsId,
                version: version
            }, useSandbox, 'app'), '_blank');
        }
    };
    var onShowFirstLayer = function() {
        if (device === "desktop") globalThis.UC_UI.showFirstLayer();
    };
    var onShowSecondLayer = function() {
        if (device === "desktop") globalThis.UC_UI.showSecondLayer();
    };
    var onRefreshPreview = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $04b844fceb04b9e9$export$71511d61b312f219)(function() {
            return (0, $5412342bd99c3e4e$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(device === "desktop")) return [
                            3,
                            2
                        ];
                        globalThis.localStorage.removeItem('uc_ab_variant');
                        return [
                            4,
                            globalThis.UC_UI.clearStorage()
                        ];
                    case 1:
                        _state.sent();
                        window.location.reload();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var onShowAVGate = function() {
        var _window___ucCmp;
        if (device === "desktop" && isAgeVerificationEnabled) (_window___ucCmp = window.__ucCmp) === null || _window___ucCmp === void 0 ? void 0 : _window___ucCmp.clearUserSession().then(function() {
            var _globalThis_UC_UI;
            (_globalThis_UC_UI = globalThis.UC_UI) === null || _globalThis_UC_UI === void 0 ? void 0 : _globalThis_UC_UI.showFirstLayer();
        }).catch(function(err) {
            console.error('[AV gate] clearUserSession failed:', err);
        });
    };
    var onOpenDsrForm = function() {
        if (!settings.dsrConfigurationId) return;
        var baseUrl = useSandbox ? 'https://dsr.usercentrics-dev.io' : 'https://dsr.usercentrics.eu';
        var isDraft = version === 'preview';
        var url = "".concat(baseUrl, "/dsr/").concat(settings.dsrConfigurationId).concat(isDraft ? '?draft=true' : '');
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    var onVariantChange = function(abVariant) {
        if (abVariant === 'A/B Test Variant') {
            setCurrentAbVariant(undefined);
            delete globalThis.UC_AB_VARIANT;
            localStorage.removeItem('uc_ab_variant');
            updateUrlParam('abVariant', '', true);
            return;
        }
        setCurrentAbVariant(abVariant);
        globalThis.UC_AB_VARIANT = abVariant;
        localStorage.setItem('uc_ab_variant', abVariant);
        updateUrlParam('abVariant', abVariant);
    };
    var onLogoClick = function() {
        window.location.reload();
    };
    if (!currentView.view) return null;
    var scriptView = $507cba0b3ff2a038$var$toScriptView(currentView.view);
    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("div", {
        id: "preview",
        children: [
            scriptView !== "gdpr" && scriptView !== "tcf" ? (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("script", {
                children: "\n            window.UC_UI_USER_COUNTRY_DATA = {\n              code: 'US',\n              name: 'United States of America',\n              regionCode: 'CA'\n            }\n          "
            }) : (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("script", {
                children: "\n            window.UC_UI_USER_COUNTRY_DATA = {\n              code: 'DE',\n              name: 'Germany',\n              regionCode: 'BY'\n            }\n        "
            }),
            device === "desktop" && currentCmpVersion === "2" && (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("script", (0, $785ab81358d75c36$export$71511d61b312f219)({
                id: "usercentrics-cmp",
                "data-disable-tracking": true,
                "data-settings-id": settingsId,
                "data-settings-cache": Date.now(),
                "data-version": version,
                src: "".concat(scriptPath, "bundle").concat(isLegacy ? '_legacy' : '', ".js")
            }, useSandbox && {
                'data-sandbox': true
            }, scriptView === "tcf" && {
                'data-tcf-enabled': true
            })),
            device === "desktop" && currentCmpVersion === "3" && (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("script", (0, $785ab81358d75c36$export$71511d61b312f219)({
                id: "usercentrics-cmp",
                "data-disable-tracking": true,
                "data-legislation-view": scriptView,
                "data-settings-id": settingsId,
                src: bundleSource === 'local' ? "".concat(scriptPath, "loader.js") : useSandbox ? 'https://web.cmp.usercentrics-sandbox.eu/ui/loader.js' : 'https://web.cmp.usercentrics.eu/ui/loader.js'
            }, useSandbox && {
                'data-sandbox': true
            }, version === 'preview' && {
                'data-draft': true
            }, abVariant && {
                'data-ab-variant': abVariant
            })),
            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $c5f2c0a2c70f68d7$export$2e2bcd8739ae039), {
                availableVariants: settings.variants,
                availableViews: availableViews,
                currentView: currentView.view,
                currentVariant: currentAbVariant,
                device: device,
                version: version,
                availableCmpVersions: availableCmpVersions,
                cmpVersion: currentCmpVersion,
                isInitialized: isInitialized,
                isAgeVerificationEnabled: isAgeVerificationEnabled,
                isDsrEnabled: !!settings.dsrConfigurationId,
                onChangeDevice: setCurrentDevice,
                onCmpVersionChange: setCurrentCmpVersion,
                onLogoClick: onLogoClick,
                onShowFirstLayer: onShowFirstLayer,
                onShowSecondLayer: onShowSecondLayer,
                onRefreshPreview: onRefreshPreview,
                onShowAVGate: onShowAVGate,
                onOpenDsrForm: onOpenDsrForm,
                onVariantChange: onVariantChange,
                onViewChange: onViewChange,
                onTryOtherDevices: onTryOtherDevices
            }),
            device === "desktop" ? (0, $9c980878b5c974fe$export$34b9dba7ce09269b)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($0bb72fe6210266cc$exports))),
                alt: "preview",
                style: {
                    width: '100vw'
                }
            }) : (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $cb71ad15fbc9f5ec$export$2e2bcd8739ae039), {
                useSandbox: useSandbox,
                device: device,
                urlParams: {
                    location: scriptView !== "gdpr" && scriptView !== "tcf" ? 'US-CA' : 'DE-BY',
                    settingsId: settingsId,
                    version: version
                }
            })
        ]
    });
};
var $507cba0b3ff2a038$export$2e2bcd8739ae039 = $507cba0b3ff2a038$var$Preview;






/**
 * Provider component that is used by `reakit`'s `Provider` underneath.
 *
 * @example
 * // instead of using
 * import { Provider } from "reakit";
 * // you can use this
 * import { SystemProvider } from "reakit-system";
 * // reakit's Provider has more features, such as ID generation
 * import * as system from "reakit-system-bootstrap";
 *
 * function App() {
 *   return (
 *     <SystemProvider unstable_system={system}>
 *       <div>App</div>
 *     </SystemProvider>
 *   );
 * }
 *
 * @param props
 */ function $9bc0c5a0bfa10965$export$c56dc62931d24573(_ref) {
    var children = _ref.children, system = _ref.unstable_system;
    return /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)((0, $3baa482d3c4e6797$export$dc3d8cb49dcee267).Provider, {
        value: system
    }, children);
}


var $ed0a6a7cea577669$var$defaultSystem = {};
function $ed0a6a7cea577669$export$2881499e37b75b9a(_ref) {
    var prefix = _ref.unstable_prefix, _ref$unstable_system = _ref.unstable_system, system = _ref$unstable_system === void 0 ? $ed0a6a7cea577669$var$defaultSystem : _ref$unstable_system, children = _ref.children;
    return /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)((0, $162421c70abe592f$export$6d6c93b015c224e1), {
        prefix: prefix
    }, /*#__PURE__*/ (0, $ea42db622452d33d$export$c8a8987d4410bf2d)((0, $9bc0c5a0bfa10965$export$c56dc62931d24573), {
        unstable_system: system
    }, children));
}




var $188446765e7e082b$var$a = {};
function $188446765e7e082b$var$c(n, t) {
    for(var r in t)n[r] = t[r];
    return n;
}
function $188446765e7e082b$export$78e3044358792147(n, t, r) {
    var i, o = /(?:\?([^#]*))?(#.*)?$/, e = n.match(o), u = {};
    if (e && e[1]) for(var f = e[1].split("&"), _$c = 0; _$c < f.length; _$c++){
        var s = f[_$c].split("=");
        u[decodeURIComponent(s[0])] = decodeURIComponent(s.slice(1).join("="));
    }
    n = $188446765e7e082b$var$d(n.replace(o, "")), t = $188446765e7e082b$var$d(t || "");
    for(var h = Math.max(n.length, t.length), v = 0; v < h; v++)if (t[v] && ":" === t[v].charAt(0)) {
        var l = t[v].replace(/(^:|[+*?]+$)/g, ""), p = (t[v].match(/[+*?]+$/) || $188446765e7e082b$var$a)[0] || "", m = ~p.indexOf("+"), y = ~p.indexOf("*"), U = n[v] || "";
        if (!U && !y && (p.indexOf("?") < 0 || m)) {
            i = !1;
            break;
        }
        if (u[l] = decodeURIComponent(U), m || y) {
            u[l] = n.slice(v).map(decodeURIComponent).join("/");
            break;
        }
    } else if (t[v] !== n[v]) {
        i = !1;
        break;
    }
    return (!0 === r.default || !1 !== i) && u;
}
function $188446765e7e082b$var$h(n, t) {
    return n.rank < t.rank ? 1 : n.rank > t.rank ? -1 : n.index - t.index;
}
function $188446765e7e082b$var$v(n, t) {
    return n.index = t, n.rank = function(n) {
        return n.props.default ? 0 : $188446765e7e082b$var$d(n.props.path).map($188446765e7e082b$var$l).join("");
    }(n), n.props;
}
function $188446765e7e082b$var$d(n) {
    return n.replace(/(^\/+|\/+$)/g, "").split("/");
}
function $188446765e7e082b$var$l(n) {
    return ":" == n.charAt(0) ? 1 + "*+?".indexOf(n.charAt(n.length - 1)) || 4 : 5;
}
var $188446765e7e082b$var$p = {}, $188446765e7e082b$var$m = [], $188446765e7e082b$var$y = [], $188446765e7e082b$var$U = null, $188446765e7e082b$var$g = {
    url: $188446765e7e082b$export$dc90482e4ef07afd()
}, $188446765e7e082b$var$k = (0, $ea42db622452d33d$export$fd42f52fd3ae1109)($188446765e7e082b$var$g);
function $188446765e7e082b$export$9a302a45f65d0572() {
    var _$n = (0, $57da6a40a504e45b$export$fae74005e78b1a27)($188446765e7e082b$var$k);
    if (_$n === $188446765e7e082b$var$g) {
        var _$t = (0, $57da6a40a504e45b$export$60241385465d0a34)()[1];
        (0, $57da6a40a504e45b$export$6d9c69b0de29b591)(function() {
            return $188446765e7e082b$var$y.push(_$t), function() {
                return $188446765e7e082b$var$y.splice($188446765e7e082b$var$y.indexOf(_$t), 1);
            };
        }, []);
    }
    return [
        _$n,
        $188446765e7e082b$export$4cb887bfde2d34ca
    ];
}
function $188446765e7e082b$export$dc90482e4ef07afd() {
    var _$n;
    return "" + ((_$n = $188446765e7e082b$var$U && $188446765e7e082b$var$U.location ? $188446765e7e082b$var$U.location : $188446765e7e082b$var$U && $188446765e7e082b$var$U.getCurrentLocation ? $188446765e7e082b$var$U.getCurrentLocation() : "undefined" != typeof location ? location : $188446765e7e082b$var$p).pathname || "") + (_$n.search || "");
}
function $188446765e7e082b$export$4cb887bfde2d34ca(n, t) {
    return void 0 === t && (t = !1), "string" != typeof n && n.url && (t = n.replace, n = n.url), function(n) {
        for(var _$t = $188446765e7e082b$var$m.length; _$t--;)if ($188446765e7e082b$var$m[_$t].canRoute(n)) return !0;
        return !1;
    }(n) && function(n, t) {
        void 0 === t && (t = "push"), $188446765e7e082b$var$U && $188446765e7e082b$var$U[t] ? $188446765e7e082b$var$U[t](n) : "undefined" != typeof history && history[t + "State"] && history[t + "State"](null, null, n);
    }(n, t ? "replace" : "push"), $188446765e7e082b$var$I(n);
}
function $188446765e7e082b$var$I(n) {
    for(var _$t = !1, r = 0; r < $188446765e7e082b$var$m.length; r++)$188446765e7e082b$var$m[r].routeTo(n) && (_$t = !0);
    return _$t;
}
function $188446765e7e082b$var$M(n) {
    if (n && n.getAttribute) {
        var _$t = n.getAttribute("href"), r = n.getAttribute("target");
        if (_$t && _$t.match(/^\//g) && (!r || r.match(/^_?self$/i))) return $188446765e7e082b$export$4cb887bfde2d34ca(_$t);
    }
}
function $188446765e7e082b$var$b(n) {
    return n.stopImmediatePropagation && n.stopImmediatePropagation(), n.stopPropagation && n.stopPropagation(), n.preventDefault(), !1;
}
function $188446765e7e082b$var$W(n) {
    if (!(n.ctrlKey || n.metaKey || n.altKey || n.shiftKey || n.button)) {
        var _$t = n.target;
        do if ("a" === _$t.localName && _$t.getAttribute("href")) {
            if (_$t.hasAttribute("data-native") || _$t.hasAttribute("native")) return;
            if ($188446765e7e082b$var$M(_$t)) return $188446765e7e082b$var$b(n);
        }
        while (_$t = _$t.parentNode);
    }
}
var $188446765e7e082b$var$w = !1;
function $188446765e7e082b$export$55185c17a0fcbe46(n) {
    n.history && ($188446765e7e082b$var$U = n.history), this.state = {
        url: n.url || $188446765e7e082b$export$dc90482e4ef07afd()
    };
}
$188446765e7e082b$var$c($188446765e7e082b$export$55185c17a0fcbe46.prototype = new (0, $ea42db622452d33d$export$16fa2f45be04daa8), {
    shouldComponentUpdate: function shouldComponentUpdate(n) {
        return !0 !== n.static || n.url !== this.props.url || n.onChange !== this.props.onChange;
    },
    canRoute: function canRoute(n) {
        var _$t = (0, $ea42db622452d33d$export$47e4c5b300681277)(this.props.children);
        return void 0 !== this.g(_$t, n);
    },
    routeTo: function routeTo(n) {
        this.setState({
            url: n
        });
        var _$t = this.canRoute(n);
        return this.p || this.forceUpdate(), _$t;
    },
    componentWillMount: function componentWillMount() {
        this.p = !0;
    },
    componentDidMount: function componentDidMount() {
        var _$n = this;
        $188446765e7e082b$var$w || ($188446765e7e082b$var$w = !0, $188446765e7e082b$var$U || addEventListener("popstate", function() {
            $188446765e7e082b$var$I($188446765e7e082b$export$dc90482e4ef07afd());
        }), addEventListener("click", $188446765e7e082b$var$W)), $188446765e7e082b$var$m.push(this), $188446765e7e082b$var$U && (this.u = $188446765e7e082b$var$U.listen(function(t) {
            var r = t.location || t;
            _$n.routeTo("" + (r.pathname || "") + (r.search || ""));
        })), this.p = !1;
    },
    componentWillUnmount: function componentWillUnmount() {
        "function" == typeof this.u && this.u(), $188446765e7e082b$var$m.splice($188446765e7e082b$var$m.indexOf(this), 1);
    },
    componentWillUpdate: function componentWillUpdate() {
        this.p = !0;
    },
    componentDidUpdate: function componentDidUpdate() {
        this.p = !1;
    },
    g: function g(n, t) {
        n = n.filter($188446765e7e082b$var$v).sort($188446765e7e082b$var$h);
        for(var r = 0; r < n.length; r++){
            var i = n[r], o = $188446765e7e082b$export$78e3044358792147(t, i.props.path, i.props);
            if (o) return [
                i,
                o
            ];
        }
    },
    render: function render(n, t) {
        var e, u, f = n.onChange, a = t.url, s = this.c, h = this.g((0, $ea42db622452d33d$export$47e4c5b300681277)(n.children), a);
        if (h && (u = (0, $ea42db622452d33d$export$e530037191fcd5d7)(h[0], $188446765e7e082b$var$c($188446765e7e082b$var$c({
            url: a,
            matches: e = h[1]
        }, e), {
            key: void 0,
            ref: void 0
        }))), a !== (s && s.url)) {
            $188446765e7e082b$var$c($188446765e7e082b$var$g, s = this.c = {
                url: a,
                previous: s && s.url,
                current: u,
                path: u ? u.props.path : null,
                matches: e
            }), s.router = this, s.active = u ? [
                u
            ] : [];
            for(var v = $188446765e7e082b$var$y.length; v--;)$188446765e7e082b$var$y[v]({});
            "function" == typeof f && f(s);
        }
        return (0, $ea42db622452d33d$export$c8a8987d4410bf2d)($188446765e7e082b$var$k.Provider, {
            value: s
        }, u);
    }
});
var $188446765e7e082b$export$a6c7ac8248d6e38a = function E(n) {
    return (0, $ea42db622452d33d$export$c8a8987d4410bf2d)("a", $188446765e7e082b$var$c({
        onClick: $188446765e7e082b$var$W
    }, n));
}, $188446765e7e082b$export$e7b0ac011bb776c6 = function L(n) {
    return (0, $ea42db622452d33d$export$c8a8987d4410bf2d)(n.component, n);
};



var $078d3c677d7b5076$var$root = document.getElementById('root');
var $078d3c677d7b5076$var$Main = function() {
    return (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $ed0a6a7cea577669$export$2881499e37b75b9a), {
        unstable_system: $3f23f3a8e36491d9$exports,
        children: [
            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $1c0ec2afc2d69abf$export$2e2bcd8739ae039), {}),
            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $482592a00a451062$export$2e2bcd8739ae039), {
                title: "Usercentrics preview"
            }),
            (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $188446765e7e082b$export$55185c17a0fcbe46), {
                children: [
                    (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $507cba0b3ff2a038$export$2e2bcd8739ae039), {
                        path: "".concat(window.location.pathname.replace('index.html', ''), ":settingsId?sandbox?legacy?view?bundleSource?version?device?cmpVersion?abVariant?")
                    }),
                    (0, $9c980878b5c974fe$export$34b9dba7ce09269b)((0, $2e9ef8b5d0fd4f80$export$2e2bcd8739ae039), {
                        type: "404",
                        default: true
                    })
                ]
            })
        ]
    });
};
if ($078d3c677d7b5076$var$root) (0, $ea42db622452d33d$export$b3890eb0ae9dca99)((0, $9c980878b5c974fe$export$34b9dba7ce09269b)($078d3c677d7b5076$var$Main, {}), $078d3c677d7b5076$var$root);
else throw new Error("The element #root wasn't found");

})();
//# sourceMappingURL=build.4c27dc6a.js.map
